/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/IAFTours/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(331);
	module.exports = __webpack_require__(149);


/***/ },
/* 1 */
/***/ function(module, exports) {

	"use strict";
	var accordionContent = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "accordion-item-content" }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	};
	exports.VueAccordionContent = accordionContent;
	var accordionItem = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "accordion-item", on: { "accordion:open": _vm.onOpen, "accordion:opened": _vm.onOpened, "accordion:close": _vm.onClose, "accordion:closed": _vm.onClosed } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    methods: {
	        onOpen: function (event) {
	            this.$emit('accordion:open', event);
	        },
	        onOpened: function (event) {
	            this.$emit('accordion:opened', event);
	        },
	        onClose: function (event) {
	            this.$emit('accordion:close', event);
	        },
	        onClosed: function (event) {
	            this.$emit('accordion:closed', event);
	        }
	    }
	};
	exports.VueAccordionItem = accordionItem;
	var accordionToggle = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "accordion-item-toggle" }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	};
	exports.VueAccordionToggle = accordionToggle;
	var accordion = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "accordion-list" }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	};
	exports.VueAccordion = accordion;
	var actionsButton = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "actions-modal-button", class: _vm.classesObject, on: { "click": _vm.onClick } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'color': String,
	        'bold': Boolean,
	        'close': {
	            type: Boolean,
	            default: true
	        }
	    },
	    computed: {
	        classesObject: function () {
	            var self = this;
	            var co = {
	                'actions-modal-button-bold': self.bold
	            };
	            if (self.color) {
	                co['color-' + self.color] = true;
	            }
	            return co;
	        }
	    },
	    methods: {
	        onClick: function (event) {
	            if (this.close && this.$f7) {
	                this.$f7.closeModal(this.$parent.$parent.$el);
	            }
	            this.$emit('click', event);
	        }
	    }
	};
	exports.VueActionsButton = actionsButton;
	var actionsGroup = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "actions-modal-group" }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	};
	exports.VueActionsGroup = actionsGroup;
	var actionsLabel = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "actions-modal-label", class: _vm.classesObject, on: { "click": _vm.onClick } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        color: String,
	        bold: Boolean
	    },
	    computed: {
	        classesObject: function () {
	            var self = this;
	            var co = {
	                'actions-modal-button-bold': self.bold
	            };
	            if (self.color) {
	                co['color-' + self.color] = true;
	            }
	            return co;
	        }
	    },
	    methods: {
	        onClick: function (event) {
	            this.$emit('click', event);
	        }
	    }
	};
	exports.VueActionsLabel = actionsLabel;
	var actions = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "actions-modal keep-on-close", class: { 'modal-in': _vm.opened }, on: { "actions:open": _vm.onOpen, "actions:opened": _vm.onOpened, "actions:close": _vm.onClose, "actions:closed": _vm.onClosed } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    mounted: function () {
	        var self = this;
	        if (self.opened) {
	            self.$el.style.display = 'block';
	        }
	    },
	    watch: {
	        opened: function (opened) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            if (opened) {
	                self.$f7.openModal(self.$el);
	            }
	            else {
	                self.$f7.closeModal(self.$el);
	            }
	        }
	    },
	    props: {
	        opened: Boolean
	    },
	    methods: {
	        onOpen: function (event) {
	            this.$emit('actions:open', event);
	        },
	        onOpened: function (event) {
	            this.$emit('actions:opened', event);
	        },
	        onClose: function (event) {
	            this.$emit('actions:close', event);
	        },
	        onClosed: function (event) {
	            this.$emit('actions:closed', event);
	        },
	        onF7Init: function () {
	            var $$ = this.$$;
	            if (!$$) {
	                return;
	            }
	            if ($$('.modal-overlay').length === 0) {
	                $$('<div class="modal-overlay' + (this.opened ? ' modal-overlay-visible' : '') + '"></div>').insertBefore(this.$el);
	            }
	        },
	        open: function (animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.openModal(self.$el, animated);
	        },
	        close: function (animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.closeModal(self.$el, animated);
	        }
	    }
	};
	exports.VueActions = actions;
	var badge = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('span', { staticClass: "badge", class: _vm.color ? 'color-' + _vm.color : '' }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'color': String
	    }
	};
	exports.VueBadge = badge;
	var LinkMixin = {
	    data: function () {
	        return {
	            routeInfo: {
	                activeTab: this.$route && this.$route.route.tab
	            }
	        };
	    },
	    props: {
	        noLinkClass: Boolean,
	        noFastclick: Boolean,
	        external: Boolean,
	        color: String,
	        bg: String,
	        theme: String,
	        text: String,
	        iconOnly: Boolean,
	        icon: String,
	        iconMaterial: String,
	        iconIon: String,
	        iconFa: String,
	        iconF7: String,
	        iconIfMaterial: String,
	        iconIfIos: String,
	        iconSize: [String, Number],
	        rippleColor: String,
	        href: {
	            type: String,
	            default: '#'
	        },
	        // Button
	        round: Boolean,
	        fill: Boolean,
	        big: Boolean,
	        raised: Boolean,
	        // Router
	        force: Boolean,
	        reload: Boolean,
	        animatePages: Boolean,
	        ignoreCache: Boolean,
	        pageName: String,
	        template: String,
	        // View
	        view: String,
	        // Panel
	        openPanel: [Boolean, String],
	        closePanel: [Boolean, String],
	        // Popup
	        openPopup: [Boolean, String],
	        closePopup: [Boolean, String],
	        // Popover
	        openPopover: [Boolean, String],
	        closePopover: [Boolean, String],
	        // Login Screen
	        openLoginScreen: [Boolean, String],
	        closeLoginScreen: [Boolean, String],
	        // Picker
	        openPicker: [Boolean, String],
	        closePicker: [Boolean, String],
	        // Tab
	        tabLink: [Boolean, String],
	        routeTabLink: [Boolean, String],
	        // Sortable
	        openSortable: [Boolean, String],
	        closeSortable: [Boolean, String],
	        toggleSortable: [Boolean, String],
	        // Active
	        active: Boolean,
	        // Badge
	        badge: [String, Number],
	        iconBadge: [String, Number],
	        badgeColor: [String],
	        // Back Link
	        back: Boolean
	    },
	    computed: {
	        attrsObject: function () {
	            var self = this;
	            var ao = {
	                href: self.href
	            };
	            var pd = self.$options.propsData;
	            if ('force' in pd) {
	                ao['data-force'] = self.force;
	            }
	            if ('reload' in pd) {
	                ao['data-reload'] = 'true';
	            }
	            if ('animatePages' in pd && typeof pd.animatePages === 'boolean') {
	                ao['data-animate-pages'] = pd.animatePages.toString();
	            }
	            if ('ignoreCache' in pd) {
	                ao['data-ignore-cache'] = 'true';
	            }
	            if (self.pageName) {
	                ao['data-page-name'] = self.pageName;
	            }
	            if (self.template) {
	                ao['data-template'] = self.template;
	            }
	            if (self.view) {
	                ao['data-view'] = self.view;
	            }
	            function trustyString(s) {
	                if (typeof s === 'string' && s !== '') {
	                    return true;
	                }
	                return false;
	            }
	            if (trustyString(self.openPanel)) {
	                ao['data-panel'] = self.openPanel;
	            }
	            if (trustyString(self.openPopup)) {
	                ao['data-popup'] = self.openPopup;
	            }
	            if (trustyString(self.openPopover)) {
	                ao['data-popover'] = self.openPopover;
	            }
	            if (trustyString(self.openPicker)) {
	                ao['data-picker'] = self.openPicker;
	            }
	            if (trustyString(self.openLoginScreen)) {
	                ao['data-login-screen'] = self.openLoginScreen;
	            }
	            if (trustyString(self.openSortable)) {
	                ao['data-sortable'] = self.openSortable;
	            }
	            if (trustyString(self.toggleSortable)) {
	                ao['data-sortable'] = self.toggleSortable;
	            }
	            if (trustyString(self.closePopup)) {
	                ao['data-popup'] = self.closePopup;
	            }
	            if (trustyString(self.closePopover)) {
	                ao['data-popover'] = self.closePopover;
	            }
	            if (trustyString(self.closePicker)) {
	                ao['data-picker'] = self.closePicker;
	            }
	            if (trustyString(self.closeLoginScreen)) {
	                ao['data-login-screen'] = self.closeLoginScreen;
	            }
	            if (trustyString(self.closeSortable)) {
	                ao['data-sortable'] = self.closeSortable;
	            }
	            if (trustyString(self.tabLink)) {
	                ao['data-tab'] = self.tabLink;
	            }
	            return ao;
	        },
	        classesObject: function () {
	            var self = this;
	            var co = {};
	            var pd = self.$options.propsData;
	            if (self.rippleColor) {
	                co['ripple-color-' + self.rippleColor] = true;
	            }
	            if (self.color) {
	                co['color-' + self.color] = true;
	            }
	            if (self.theme) {
	                co['theme-' + self.theme] = true;
	            }
	            if (self.bg) {
	                co['bg-' + self.bg] = true;
	            }
	            co['back'] = self.back;
	            co['external'] = self.external;
	            co['no-fastclick'] = self.noFastclick;
	            // Button
	            ['round', 'fill', 'big', 'raised'].forEach(function (prop, index) {
	                if (self[prop]) {
	                    co['button-' + prop] = true;
	                }
	            });
	            // Active
	            if (self.routeInfo.activeTab) {
	                var isActiveTab = self.routeTabLink && self.routeTabLink.replace('#', '') === self.routeInfo.activeTab.tabId;
	                co['active'] = isActiveTab;
	            }
	            else {
	                co['active'] = self.active;
	            }
	            function trustyBoolean(b) {
	                if (b || b === '') {
	                    return true;
	                }
	                return false;
	            }
	            // Panel
	            if (trustyBoolean(self.closePanel)) {
	                co['close-panel'] = true;
	            }
	            if (self.openPanel || self.openPanel === '') {
	                co['open-panel'] = true;
	            }
	            // Popup
	            if (trustyBoolean(self.closePopup)) {
	                co['close-popup'] = true;
	            }
	            if (self.openPopup || self.openPopup === '') {
	                co['open-popup'] = true;
	            }
	            // Popover
	            if (trustyBoolean(self.closePopover)) {
	                co['close-popover'] = true;
	            }
	            if (self.openPopover || self.openPopover === '') {
	                co['open-popover'] = true;
	            }
	            // Picker
	            if (trustyBoolean(self.closePicker)) {
	                co['close-picker'] = true;
	            }
	            if (self.openPicker || self.openPicker === '') {
	                co['open-picker'] = true;
	            }
	            // Login Screen
	            if (trustyBoolean(self.closeLoginScreen)) {
	                co['close-login-screen'] = true;
	            }
	            if (self.openLoginScreen || self.openLoginScreen === '') {
	                co['open-login-screen'] = true;
	            }
	            // Sortable
	            if (trustyBoolean(self.closeSortable)) {
	                co['close-sortable'] = true;
	            }
	            if (self.openSortable || self.openSortable === '') {
	                co['open-sortable'] = true;
	            }
	            if (self.toggleSortable || self.toggleSortable === '') {
	                co['toggle-sortable'] = true;
	            }
	            // Tab
	            if (self.tabLink || self.tabLink === '') {
	                co['tab-link'] = true;
	            }
	            return co;
	        }
	    },
	    methods: {
	        onClick: function (event) {
	            this.$emit('click', event);
	        },
	        onRouteChange: function (e) {
	            if (e.route.tab) {
	                this.$set(this.routeInfo, 'activeTab', e.route.tab);
	            }
	        }
	    }
	};
	exports.VueLinkMixin = LinkMixin;
	var button = {
	    render: function (c) {
	        var iconEl, textEl, self = this;
	        if (self.text) {
	            textEl = c('span', {}, self.text);
	        }
	        if (self.icon || self.iconMaterial || self.iconIon || self.iconFa || self.iconF7 || self.iconIfMaterial || self.iconIfIos) {
	            iconEl = c('f7-icon', { props: {
	                    material: self.iconMaterial,
	                    ion: self.iconIon,
	                    fa: self.iconFa,
	                    f7: self.iconF7,
	                    icon: self.icon,
	                    ifMaterial: self.iconIfMaterial,
	                    ifIos: self.iconIfIos,
	                    size: self.iconSize
	                } });
	        }
	        self.classesObject['button'] = true;
	        var linkEl = c('a', {
	            class: self.classesObject,
	            attrs: self.attrsObject,
	            on: {
	                click: self.onClick
	            }
	        }, [iconEl, textEl, self.$slots.default]);
	        return linkEl;
	    },
	    mixins: [LinkMixin],
	    methods: {
	        onClick: function (event) {
	            this.$emit('click', event);
	        }
	    }
	};
	exports.VueButton = button;
	var buttonsSegmented = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "buttons-row", class: (_vm.colorComputed ? 'theme-' + _vm.colorComputed : '') }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'color': String,
	        'theme': String,
	        'bg': String
	    },
	    computed: {
	        colorComputed: function () {
	            return this.color || this.theme || this.bg;
	        }
	    }
	};
	exports.VueButtonsSegmented = buttonsSegmented;
	var cardContent = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "card-content" }, [(_vm.inner) ? _c('div', { staticClass: "card-content-inner" }, [_vm._t("default")], 2) : _vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        inner: {
	            type: Boolean,
	            default: true
	        }
	    }
	};
	exports.VueCardContent = cardContent;
	var cardFooter = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "card-footer" }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	};
	exports.VueCardFooter = cardFooter;
	var cardHeader = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "card-header" }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	};
	exports.VueCardHeader = cardHeader;
	var card = {
	    render: function (c) {
	        var self = this;
	        var headerEl, contentEl, contentChildEl, footerEl;
	        if (self.title) {
	            headerEl = c('f7-card-header', { domProps: { innerHTML: self.title } });
	        }
	        if (self.content) {
	            contentChildEl = c('div', { domProps: { innerHTML: self.content } });
	            contentEl = c('f7-card-content', { props: { inner: self.inner } }, [contentChildEl]);
	        }
	        if (self.footer) {
	            footerEl = c('f7-card-footer', { domProps: { innerHTML: self.footer } });
	        }
	        return c('div', { staticClass: 'card' }, [headerEl, contentEl, footerEl, self.$slots.default]);
	    },
	    props: {
	        'title': [String, Number],
	        'content': [String, Number],
	        'footer': [String, Number],
	        'inner': {
	            type: Boolean,
	            default: true
	        }
	    }
	};
	exports.VueCard = card;
	var chip = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('span', { staticClass: "chip", class: _vm.chipClassObject, on: { "click": _vm.onClick } }, [(_vm.media) ? _c('span', { staticClass: "chip-media", class: _vm.mediaClassObject, domProps: { "innerHTML": _vm._s(_vm.media) } }) : _vm._e(), _vm._v(" "), (_vm.text) ? _c('span', { staticClass: "chip-label", domProps: { "innerHTML": _vm._s(_vm.text) } }) : _vm._e(), _vm._v(" "), (_vm.deleteable) ? _c('a', { staticClass: "chip-delete", attrs: { "href": "#" }, on: { "click": _vm.onDeleteClick } }) : _vm._e()]); },
	    staticRenderFns: [],
	    props: {
	        media: String,
	        text: [String, Number],
	        deleteable: Boolean,
	        color: String,
	        bg: String,
	        mediaBg: String,
	        mediaColor: String
	    },
	    computed: {
	        mediaClassObject: function () {
	            var c = {};
	            if (this.mediaColor) {
	                c['color-' + this.mediaColor] = true;
	            }
	            if (this.mediaBg) {
	                c['color-' + this.mediaBg] = true;
	            }
	            return c;
	        },
	        chipClassObject: function () {
	            var c = {};
	            if (this.color) {
	                c['color-' + this.color] = true;
	            }
	            if (this.bg) {
	                c['bg-' + this.bg] = true;
	            }
	            return c;
	        }
	    },
	    methods: {
	        onClick: function (event) {
	            this.$emit('click', event);
	        },
	        onDeleteClick: function (event) {
	            this.$emit('delete', event);
	        }
	    }
	};
	exports.VueChip = chip;
	var contentBlockTitle = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "content-block-title" }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	};
	exports.VueContentBlockTitle = contentBlockTitle;
	var contentBlock = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "content-block", class: _vm.classesObject, on: { "tab:show": _vm.onTabShow, "tab:hide": _vm.onTabHide } }, [(_vm.inner) ? _c('div', { staticClass: "content-block-inner" }, [_vm._t("default")], 2) : _vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'inset': Boolean,
	        'tablet-inset': Boolean,
	        'inner': Boolean,
	        'tabs': Boolean,
	        'tab': Boolean,
	        'active': Boolean,
	        'no-hairlines': Boolean,
	        'no-hairlines-between': Boolean,
	    },
	    computed: {
	        classesObject: function () {
	            var self = this;
	            return {
	                'inset': self.inset,
	                'tablet-inset': self.tabletInset,
	                'tabs': self.tabs,
	                'tab': self.tab,
	                'active': self.active,
	                'no-hairlines': self.noHairlines,
	                'no-hairlines-between': self.noHairlinesBetween,
	            };
	        }
	    },
	    methods: {
	        onTabShow: function (e) {
	            this.$emit('tab:show', e);
	        },
	        onTabHide: function (e) {
	            this.$emit('tab:hide', e);
	        }
	    }
	};
	exports.VueContentBlock = contentBlock;
	var fabSpeedDialAction = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('a', { class: _vm.classesObject, attrs: { "href": "#" }, on: { "click": _vm.onClick } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'color': String,
	        'closeSpeedDial': Boolean
	    },
	    computed: {
	        classesObject: function () {
	            var co = {};
	            if (this.color) {
	                co['color-' + this.color] = true;
	            }
	            if (this.closeSpeedDial) {
	                co['close-speed-dial'] = true;
	            }
	            return co;
	        }
	    },
	    methods: {
	        onClick: function (event) {
	            this.$emit('click', event);
	        }
	    }
	};
	exports.VueFabSpeedDialAction = fabSpeedDialAction;
	var fabSpeedDialActions = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "speed-dial-buttons", class: _vm.theme ? 'theme-' + _vm.theme : false }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        theme: String
	    }
	};
	exports.VueFabSpeedDialActions = fabSpeedDialActions;
	var fabSpeedDial = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "speed-dial", class: _vm.theme ? 'theme-' + _vm.theme : false }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        theme: String
	    }
	};
	exports.VueFabSpeedDial = fabSpeedDial;
	var fab = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('a', { staticClass: "floating-button", class: _vm.color ? 'color-' + _vm.color : false, attrs: { "href": "#" }, on: { "click": _vm.onClick } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        color: String
	    },
	    methods: {
	        onClick: function (event) {
	            this.$emit('click', event);
	        }
	    }
	};
	exports.VueFab = fab;
	var formInput = {
	    render: function (c) {
	        var inputEl;
	        var self = this;
	        var attrs = {
	            name: self.name,
	            type: self.type,
	            placeholder: self.placeholder,
	            id: self.id,
	            value: self.valueComputed,
	            size: self.size,
	            accept: self.accept,
	            autocomplete: self.autocomplete,
	            autocorrect: self.autocorrect,
	            autocapitalize: self.autocapitalize,
	            spellcheck: self.spellcheck,
	            autofocus: self.autofocus,
	            autosave: self.autosave,
	            checked: self.checkedComputed,
	            disabled: self.disabled,
	            max: self.max,
	            maxlength: self.maxlength,
	            min: self.min,
	            minlength: self.minlength,
	            step: self.step,
	            multiple: self.multiple,
	            readonly: self.readonly,
	            required: self.required,
	            style: self.style,
	            color: self.color,
	            pattern: self.pattern
	        };
	        var on = {
	            focus: self.onFocus,
	            blur: self.onBlur,
	            input: self.onInput,
	            change: self.onChange,
	            click: self.onClick,
	            keypress: self.onKeyPress,
	            keyup: self.onKeyUp,
	            keydown: self.onKeyDown,
	            beforeinput: self.onBeforeInput,
	            compositionstart: self.onCompositionStart,
	            compositionupdate: self.onCompositionUpdate,
	            compositionend: self.onCompositionEnd,
	            focusin: self.onFocusIn,
	            focusout: self.onFocusOut,
	            dblclick: self.onDblClick,
	            mousedown: self.onMouseDown,
	            mouseenter: self.onMouseEnter,
	            mouseleave: self.onMouseLeave,
	            mousemove: self.onMouseMove,
	            mouseout: self.onMouseOut,
	            mouseover: self.onMouseOver,
	            mouseup: self.onMouseUp,
	            wheel: self.onWheel,
	            select: self.onSelect
	        };
	        if (self.type === 'select' || self.type === 'textarea' || self.type === 'file') {
	            delete attrs.value;
	            if (self.type === 'select') {
	                if (self.hasSelectModel) {
	                    inputEl = c('select', { attrs: attrs, on: on }, self.$slots.default);
	                }
	                else {
	                    inputEl = c('select', { attrs: attrs, on: on, domProps: { value: self.valueComputed } }, self.$slots.default);
	                }
	            }
	            else if (self.type === 'file') {
	                inputEl = c('input', { attrs: attrs, on: on }, self.$slots.default);
	            }
	            else {
	                inputEl = c('textarea', { attrs: attrs, on: on, domProps: { value: self.valueComputed } }, self.$slots.default);
	            }
	        }
	        else {
	            if (self.$slots.default && self.$slots.default.length > 0 || !self.type) {
	                inputEl = self.$slots.default;
	            }
	            else {
	                if (self.type === 'switch') {
	                    inputEl = c('f7-switch', { props: attrs, on: on });
	                }
	                else if (self.type === 'range') {
	                    inputEl = c('f7-range', { props: attrs, on: on });
	                }
	                else {
	                    inputEl = c('input', { attrs: attrs, on: on, domProps: { value: self.valueComputed, checked: self.checkedComputed } });
	                }
	            }
	        }
	        var itemInput = self.wrap ? c('div', { staticClass: 'item-input' }, [inputEl]) : inputEl;
	        return itemInput;
	    },
	    watch: {
	        value: function () {
	            var self = this;
	            if (!self.hasSelectModel) {
	                return;
	            }
	            var $$ = self.$$;
	            $$(self.$el).find('option').each(function (index, option) {
	                if (self.value.indexOf(option.value) >= 0) {
	                    option.selected = true;
	                }
	                else {
	                    option.selected = false;
	                }
	            });
	        }
	    },
	    mounted: function () {
	        var self = this;
	        if (!self.hasSelectModel) {
	            return;
	        }
	        var $$ = self.$$;
	        $$(self.$el).find('option').each(function (index, option) {
	            if (self.value.indexOf(option.value) >= 0) {
	                option.selected = true;
	            }
	            else {
	                option.selected = false;
	            }
	        });
	    },
	    props: {
	        // Inputs
	        type: String,
	        name: String,
	        placeholder: String,
	        id: String,
	        value: [String, Number, Boolean, Array, Object],
	        inputValue: [String, Number],
	        size: [String, Number],
	        accept: [String, Number],
	        autocomplete: [String],
	        autocorrect: [String],
	        autocapitalize: [String],
	        spellcheck: [String],
	        autofocus: Boolean,
	        autosave: String,
	        checked: Boolean,
	        disabled: Boolean,
	        max: [String, Number],
	        min: [String, Number],
	        step: [String, Number],
	        maxlength: [String, Number],
	        minlength: [String, Number],
	        multiple: Boolean,
	        readonly: Boolean,
	        required: Boolean,
	        style: String,
	        pattern: String,
	        // Components
	        color: String,
	        wrap: {
	            "type": Boolean,
	            "default": true
	        }
	    },
	    computed: {
	        hasCheckboxModel: function () {
	            var self = this;
	            return (self.type === 'checkbox' || self.type === 'switch') && (typeof self.$options.propsData.value !== 'undefined' && typeof self.value === 'boolean' || Array.isArray(self.value));
	        },
	        hasRadioModel: function () {
	            var self = this;
	            return self.type === 'radio' && typeof self.inputValue !== 'undefined';
	        },
	        hasSelectModel: function () {
	            var self = this;
	            return self.type === 'select' && Array.isArray(self.value);
	        },
	        valueComputed: function () {
	            var self = this;
	            if (self.inputValue) {
	                return self.inputValue;
	            }
	            else if (self.hasCheckboxModel) {
	                return undefined;
	            }
	            else if (self.$options.propsData && self.$options.propsData.value !== undefined) {
	                return self.value;
	            }
	            else if (!self.hasCheckboxModel && !self.hasRadioModel && !self.hasSelectModel && 'value' in self.$options.propsData) {
	                return self.value;
	            }
	            return undefined;
	        },
	        checkedComputed: function () {
	            var self = this;
	            if (self.hasCheckboxModel) {
	                if (self.inputValue && Array.isArray(self.value)) {
	                    return self.value.indexOf(self.inputValue) >= 0;
	                }
	                return self.value;
	            }
	            else if (self.hasRadioModel) {
	                if (typeof self.value !== typeof self.inputValue) {
	                    return self.value.toString() === self.inputValue.toString();
	                }
	                return self.value === self.inputValue;
	            }
	            else {
	                return self.checked;
	            }
	        }
	    },
	    methods: {
	        onInput: function (event) {
	            if (this.hasSelectModel) {
	                return;
	            }
	            if (event && event.type && event.type === 'input') {
	                this.$emit('input', event.target.value);
	            }
	            else {
	                this.$emit('input', event);
	            }
	        },
	        onFocus: function (event) {
	            this.$emit('focus', event);
	        },
	        onBlur: function (event) {
	            this.$emit('blur', event);
	        },
	        onChange: function (event) {
	            var self = this;
	            if (self.hasCheckboxModel) {
	                if (Array.isArray(self.value)) {
	                    if (event.target.checked) {
	                        self.value.push(event.target.value);
	                    }
	                    else {
	                        self.value.splice(self.value.indexOf(event.target.value), 1);
	                    }
	                }
	                else {
	                    self.$emit('input', event.target.checked);
	                }
	                self.$emit('change', event);
	            }
	            else if (self.hasRadioModel) {
	                self.$emit('input', event.target.value);
	            }
	            else if (self.hasSelectModel) {
	                var values = Array.prototype.filter.call(event.target.options, function (option) {
	                    return option.selected;
	                }).map(function (option) {
	                    var val = "_value" in option ? option._value : option.value;
	                    return val;
	                });
	                self.$emit('input', values);
	            }
	            else {
	                self.$emit('change', event);
	            }
	        },
	        onClick: function (event) {
	            this.$emit('click', event);
	        },
	        onKeyPress: function (event) {
	            this.$emit('keypress', event);
	        },
	        onKeyUp: function (event) {
	            this.$emit('keyup', event);
	        },
	        onKeyDown: function (event) {
	            this.$emit('keydown', event);
	        },
	        onBeforeInput: function (event) {
	            this.$emit('beforeinput', event);
	        },
	        onCompositionStart: function (event) {
	            this.$emit('compositionstart', event);
	        },
	        onCompositionUpdate: function (event) {
	            this.$emit('compositionupdate', event);
	        },
	        onCompositionEnd: function (event) {
	            this.$emit('compositionend', event);
	        },
	        onFocusIn: function (event) {
	            this.$emit('focusin', event);
	        },
	        onFocusOut: function (event) {
	            this.$emit('focusout', event);
	        },
	        onDblClick: function (event) {
	            this.$emit('dblclick', event);
	        },
	        onMouseDown: function (event) {
	            this.$emit('mousedown', event);
	        },
	        onMouseEnter: function (event) {
	            this.$emit('mouseenter', event);
	        },
	        onMouseLeave: function (event) {
	            this.$emit('mouseleave', event);
	        },
	        onMouseMove: function (event) {
	            this.$emit('mousemove', event);
	        },
	        onMouseOut: function (event) {
	            this.$emit('mouseout', event);
	        },
	        onMouseOver: function (event) {
	            this.$emit('mouseover', event);
	        },
	        onMouseUp: function (event) {
	            this.$emit('mouseup', event);
	        },
	        onWheel: function (event) {
	            this.$emit('wheel', event);
	        },
	        onSelect: function (event) {
	            this.$emit('select', event);
	        }
	    }
	};
	exports.VueFormInput = formInput;
	var formLabel = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "item-title", class: { 'label': !_vm.floating, 'floating-label': _vm.floating } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        floating: Boolean
	    }
	};
	exports.VueFormLabel = formLabel;
	var formRange = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "range-slider", class: _vm.color ? 'color-' + _vm.color : '' }, [_c('input', { style: (_vm.style), attrs: { "type": "range", "name": _vm.name, "id": _vm.id, "disabled": _vm.disabled, "readonly": _vm.readonly, "required": _vm.required, "max": _vm.max, "min": _vm.min, "step": _vm.step }, domProps: { "value": _vm.value }, on: { "input": _vm.onInput, "change": _vm.onChange, "click": _vm.onClick } })]); },
	    staticRenderFns: [],
	    props: {
	        name: String,
	        id: String,
	        value: [String, Number],
	        disabled: Boolean,
	        readonly: Boolean,
	        required: Boolean,
	        style: String,
	        max: [String, Number],
	        min: [String, Number],
	        step: [String, Number],
	        color: String
	    },
	    methods: {
	        onInput: function (event) {
	            this.$emit('input', event.target.value);
	        },
	        onChange: function (event) {
	            this.$emit('change', event);
	        },
	        onClick: function (event) {
	            this.$emit('click', event);
	        }
	    }
	};
	exports.VueFormRange = formRange;
	var formSwitch = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('label', { staticClass: "label-switch", class: _vm.color ? 'color-' + _vm.color : '', on: { "click": _vm.onClick } }, [_c('input', { style: (_vm.style), attrs: { "type": "checkbox", "name": _vm.name, "id": _vm.id, "disabled": _vm.disabled, "readonly": _vm.readonly, "required": _vm.required }, domProps: { "value": _vm.valueComputed, "checked": _vm.checkedComputed }, on: { "input": _vm.onInput, "change": _vm.onChange } }), _vm._v(" "), _c('div', { staticClass: "checkbox" })]); },
	    staticRenderFns: [],
	    props: {
	        name: String,
	        id: String,
	        value: [String, Number, Boolean, Array],
	        inputValue: [String, Number],
	        checked: Boolean,
	        disabled: Boolean,
	        readonly: Boolean,
	        required: Boolean,
	        style: String,
	        color: String
	    },
	    computed: {
	        hasCheckboxModel: function () {
	            return typeof this.value === 'boolean' || Array.isArray(this.value);
	        },
	        valueComputed: function () {
	            var self = this;
	            if (self.inputValue) {
	                return self.inputValue;
	            }
	            else if (self.hasCheckboxModel) {
	                return undefined;
	            }
	            else if (self.$options.propsData && self.$options.propsData.value) {
	                return self.value;
	            }
	            return undefined;
	        },
	        checkedComputed: function () {
	            var self = this;
	            if (self.hasCheckboxModel) {
	                if (self.inputValue && Array.isArray(self.value)) {
	                    return self.value.indexOf(self.inputValue) >= 0;
	                }
	                return self.value;
	            }
	            else {
	                return self.checked;
	            }
	        }
	    },
	    methods: {
	        onInput: function (event) {
	            this.$emit('input', event);
	        },
	        onChange: function (event) {
	            var self = this;
	            if (self.hasCheckboxModel) {
	                if (Array.isArray(self.value)) {
	                    if (event.target.checked) {
	                        self.value.push(event.target.value);
	                    }
	                    else {
	                        self.value.splice(self.value.indexOf(event.target.value), 1);
	                    }
	                    self.$emit('change', event);
	                }
	                else {
	                    self.$emit('input', event.target.checked);
	                }
	            }
	            else {
	                self.$emit('change', event);
	            }
	        },
	        onClick: function (event) {
	            this.$emit('click', event);
	        }
	    }
	};
	exports.VueFormSwitch = formSwitch;
	var gridCol = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { class: ('col-' + _vm.width) + (_vm.tabletWidth ? ' tablet-' + _vm.tabletWidth : '') }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'width': {
	            type: [Number, String],
	            default: 'auto'
	        },
	        'tablet-width': {
	            type: [Number, String]
	        }
	    },
	    data: function () {
	        return {};
	    }
	};
	exports.VueGridCol = gridCol;
	var gridRow = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "row", class: { 'no-gutter': _vm.noGutter } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'no-gutter': Boolean
	    },
	    data: function () {
	        return {};
	    }
	};
	exports.VueGridRow = gridRow;
	var icon = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('i', { staticClass: "icon", class: _vm.classesObject, style: ({ 'font-size': _vm.sizeComputed }) }, [_vm._v(_vm._s(_vm.iconTextComputed)), _vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'color': String,
	        'material': String,
	        'f7': String,
	        'ion': String,
	        'fa': String,
	        'icon': String,
	        'if-material': String,
	        'if-ios': String,
	        'size': [String, Number]
	    },
	    computed: {
	        sizeComputed: function () {
	            var self = this;
	            var size = self.size;
	            if (typeof size === 'number' || parseFloat(size) === size * 1) {
	                size = size + 'px';
	            }
	            return size;
	        },
	        iconTextComputed: function () {
	            var self = this;
	            var text = self.material || self.f7;
	            if (self.ifMaterial && self.$theme.material && (self.ifMaterial.indexOf('material:') >= 0 || self.ifMaterial.indexOf('f7:') >= 0)) {
	                text = self.ifMaterial.split(':')[1];
	            }
	            else if (self.ifIos && self.$theme.ios && (self.ifIos.indexOf('material:') >= 0 || self.ifIos.indexOf('f7:') >= 0)) {
	                text = self.ifIos.split(':')[1];
	            }
	            return text;
	        },
	        classesObject: function () {
	            var co = {};
	            var self = this;
	            if (self.ifMaterial || self.ifIos) {
	                var parts = self[self.$theme.material ? 'ifMaterial' : 'ifIos'].split(':');
	                var prop = parts[0];
	                var value = parts[1];
	                if (prop === 'material' || prop === 'fa' || prop === 'f7') {
	                    co['fa'] = prop === 'fa';
	                    co['material-icons'] = prop === 'material';
	                    co['f7-icons'] = prop === 'f7';
	                }
	                if (prop === 'fa' || prop === 'ion') {
	                    co[prop + '-' + value] = true;
	                }
	                if (prop === 'icon') {
	                    co[value] = true;
	                }
	            }
	            else {
	                co = {
	                    'material-icons': this.material,
	                    'f7-icons': this.f7,
	                    'fa': this.fa
	                };
	                if (this.ion) {
	                    co['ion-' + this.ion] = true;
	                }
	                if (this.fa) {
	                    co['fa-' + this.fa] = true;
	                }
	                if (this.icon) {
	                    co[this.icon] = true;
	                }
	            }
	            if (this.color) {
	                co['color-' + this.color] = true;
	            }
	            return co;
	        }
	    }
	};
	exports.VueIcon = icon;
	var link = {
	    mixins: [LinkMixin],
	    render: function (c) {
	        var iconEl, textEl, isTabbarLabel, badgeEl, iconBadgeEl, self = this;
	        isTabbarLabel = (self.tabLink || self.tabLink === '') && self.$parent && self.$parent.tabbar && self.$parent.labels;
	        if (self.text) {
	            if (self.badge) {
	                badgeEl = c('f7-badge', { props: { color: self.badgeColor } }, self.badge);
	            }
	            textEl = c('span', { class: { 'tabbar-label': isTabbarLabel } }, [self.text, badgeEl]);
	        }
	        if (self.icon || self.iconMaterial || self.iconIon || self.iconFa || self.iconF7 || self.iconIfMaterial || self.iconIfIos) {
	            if (self.iconBadge) {
	                iconBadgeEl = c('f7-badge', { props: { color: self.badgeColor } }, self.iconBadge);
	            }
	            iconEl = c('f7-icon', { props: {
	                    material: self.iconMaterial,
	                    ion: self.iconIon,
	                    fa: self.iconFa,
	                    f7: self.iconF7,
	                    icon: self.icon,
	                    ifMaterial: self.iconIfMaterial,
	                    ifIos: self.iconIfIos,
	                    size: self.iconSize
	                } }, [iconBadgeEl]);
	        }
	        if (!self.text && self.$slots.default && self.$slots.default.length === 0 || self.iconOnly || !self.text && !self.$slots.default) {
	            self.classesObject['icon-only'] = true;
	        }
	        self.classesObject.link = self.noLinkClass || isTabbarLabel ? false : true;
	        var linkEl = c('a', {
	            class: self.classesObject,
	            attrs: self.attrsObject,
	            on: {
	                click: self.onClick
	            }
	        }, [iconEl, textEl, self.$slots.default]);
	        return linkEl;
	    },
	    methods: {
	        onClick: function (event) {
	            this.$emit('click', event);
	        }
	    }
	};
	exports.VueLink = link;
	var listButton = {
	    render: function (c) {
	        var self = this;
	        var linkEl;
	        if (self.title) {
	            linkEl = c('a', {
	                staticClass: 'item-link list-button',
	                attrs: self.attrsObject,
	                class: self.classesObject,
	                domProps: {
	                    innerHTML: self.title
	                },
	                on: {
	                    click: self.onClick
	                }
	            });
	        }
	        else {
	            linkEl = c('a', {
	                staticClass: 'item-link list-button',
	                attrs: self.attrsObject,
	                class: self.classesObject,
	                on: {
	                    click: self.onClick
	                }
	            }, [self.$slots.default]);
	        }
	        return c('li', {}, [linkEl]);
	    },
	    props: {
	        'title': [String, Number],
	        'link': [Boolean, String],
	        'href': [Boolean, String],
	        'external': Boolean,
	        'link-external': Boolean,
	        'back': Boolean,
	        'link-back': Boolean,
	        'no-fastclick': Boolean,
	        'link-no-fastlick': Boolean,
	        color: String,
	        // Router
	        force: Boolean,
	        reload: Boolean,
	        animatePages: Boolean,
	        ignoreCache: Boolean,
	        pageName: String,
	        template: String,
	        // View
	        view: String,
	        // Panel
	        openPanel: [Boolean, String],
	        closePanel: [Boolean, String],
	        // Popup
	        openPopup: [Boolean, String],
	        closePopup: [Boolean, String],
	        // Popover
	        openPopover: [Boolean, String],
	        closePopover: [Boolean, String],
	        // Login Screen
	        openLoginScreen: [Boolean, String],
	        closeLoginScreen: [Boolean, String],
	        // Picker
	        openPicker: [Boolean, String],
	        closePicker: [Boolean, String],
	        // Tab
	        tabLink: [Boolean, String],
	        // Sortable
	        openSortable: [Boolean, String],
	        closeSortable: [Boolean, String],
	        toggleSortable: [Boolean, String],
	    },
	    computed: {
	        attrsObject: function () {
	            var self = this;
	            var ao = {
	                href: ((typeof self.link === 'boolean' && typeof self.href === 'boolean') ? '#' : (self.link || self.href))
	            };
	            var pd = self.$options.propsData;
	            if ('force' in pd) {
	                ao['data-force'] = self.force;
	            }
	            if ('reload' in pd) {
	                ao['data-reload'] = 'true';
	            }
	            if ('animatePages' in pd && typeof pd.animatePages === 'boolean') {
	                ao['data-animate-pages'] = pd.animatePages.toString();
	            }
	            if ('ignoreCache' in pd) {
	                ao['data-ignore-cache'] = 'true';
	            }
	            if (self.pageName) {
	                ao['data-page-name'] = self.pageName;
	            }
	            if (self.template) {
	                ao['data-template'] = self.template;
	            }
	            if (self.view) {
	                ao['data-view'] = self.view;
	            }
	            function trustyString(s) {
	                if (typeof s === 'string' && s !== '') {
	                    return true;
	                }
	                return false;
	            }
	            if (trustyString(self.openPanel)) {
	                ao['data-panel'] = self.openPanel;
	            }
	            if (trustyString(self.openPopup)) {
	                ao['data-popup'] = self.openPopup;
	            }
	            if (trustyString(self.openPopover)) {
	                ao['data-popover'] = self.openPopover;
	            }
	            if (trustyString(self.openPicker)) {
	                ao['data-picker'] = self.openPicker;
	            }
	            if (trustyString(self.openLoginScreen)) {
	                ao['data-login-screen'] = self.openLoginScreen;
	            }
	            if (trustyString(self.openSortable)) {
	                ao['data-sortable'] = self.openSortable;
	            }
	            if (trustyString(self.toggleSortable)) {
	                ao['data-sortable'] = self.toggleSortable;
	            }
	            if (trustyString(self.closePopup)) {
	                ao['data-popup'] = self.closePopup;
	            }
	            if (trustyString(self.closePopover)) {
	                ao['data-popover'] = self.closePopover;
	            }
	            if (trustyString(self.closePicker)) {
	                ao['data-picker'] = self.closePicker;
	            }
	            if (trustyString(self.closeLoginScreen)) {
	                ao['data-login-screen'] = self.closeLoginScreen;
	            }
	            if (trustyString(self.closeSortable)) {
	                ao['data-sortable'] = self.closeSortable;
	            }
	            if (trustyString(self.tabLink)) {
	                ao['data-tab'] = self.tabLink;
	            }
	            return ao;
	        },
	        classesObject: function () {
	            var self = this;
	            var co = {
	                'external': self.external || self.linkExternal,
	                'back': self.back || self.linkBack,
	                'no-fastclick': self.noFastclick || self.linkNoFastclick
	            };
	            function trustyBoolean(b) {
	                if (b || b === '') {
	                    return true;
	                }
	                return false;
	            }
	            // Panel
	            if (trustyBoolean(self.closePanel)) {
	                co['close-panel'] = true;
	            }
	            if (self.openPanel || self.openPanel === '') {
	                co['open-panel'] = true;
	            }
	            // Popup
	            if (trustyBoolean(self.closePopup)) {
	                co['close-popup'] = true;
	            }
	            if (self.openPopup || self.openPopup === '') {
	                co['open-popup'] = true;
	            }
	            // Popover
	            if (trustyBoolean(self.closePopover)) {
	                co['close-popover'] = true;
	            }
	            if (self.openPopover || self.openPopover === '') {
	                co['open-popover'] = true;
	            }
	            // Picker
	            if (trustyBoolean(self.closePicker)) {
	                co['close-picker'] = true;
	            }
	            if (self.openPicker || self.openPicker === '') {
	                co['open-picker'] = true;
	            }
	            // Login Screen
	            if (trustyBoolean(self.closeLoginScreen)) {
	                co['close-login-screen'] = true;
	            }
	            if (self.openLoginScreen || self.openLoginScreen === '') {
	                co['open-login-screen'] = true;
	            }
	            // Sortable
	            if (trustyBoolean(self.closeSortable)) {
	                co['close-sortable'] = true;
	            }
	            if (self.openSortable || self.openSortable === '') {
	                co['open-sortable'] = true;
	            }
	            if (self.toggleSortable || self.toggleSortable === '') {
	                co['toggle-sortable'] = true;
	            }
	            // Tab
	            if (trustyBoolean(self.tabLink)) {
	                co['tab-link'] = true;
	            }
	            // Color
	            if (self.color) {
	                co['color-' + self.color] = true;
	            }
	            return co;
	        }
	    },
	    methods: {
	        onClick: function (event) {
	            this.$emit('click', event);
	        }
	    }
	};
	exports.VueListButton = listButton;
	var listGroup = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "list-block-group" }, [_c('ul', [_vm._t("default")], 2)]); },
	    staticRenderFns: [],
	    props: {
	        'media-list': Boolean,
	        'sortable': Boolean,
	    },
	    computed: {
	        sortableComputed: function () {
	            return this.sortable || this.$parent.sortable;
	        },
	        mediaListComputed: function () {
	            return this.mediaList || this.$parent.mediaList;
	        }
	    },
	    data: function () {
	        return {};
	    }
	};
	exports.VueListGroup = listGroup;
	var listItemContent = {
	    render: function (c) {
	        var titleEl, afterWrapEl, afterEl, badgeEl, innerEl, titleRowEl, subtitleEl, textEl, mediaEl, inputEl, inputIconEl;
	        var self = this;
	        var slotsContentStart = [], slotsContent = [], slotsInnerStart = [], slotsInner = [], slotsAfterStart = [], slotsAfter = [], slotsMediaStart = [], slotsMedia = [];
	        if (self.$slots.default && self.$slots.default.length > 0) {
	            for (var i = 0; i < self.$slots.default.length; i++) {
	                var slotName = self.$slots.default[i].data ? self.$slots.default[i].data.slot : undefined;
	                if (slotName && slotName === 'content-start') {
	                    slotsContentStart.push(self.$slots.default[i]);
	                }
	                if (slotName && slotName === 'content') {
	                    slotsContent.push(self.$slots.default[i]);
	                }
	                if (slotName && slotName === 'after-start') {
	                    slotsAfterStart.push(self.$slots.default[i]);
	                }
	                if (slotName && slotName === 'after') {
	                    slotsAfter.push(self.$slots.default[i]);
	                }
	                if (slotName && slotName === 'media-start') {
	                    slotsMediaStart.push(self.$slots.default[i]);
	                }
	                if (slotName && slotName === 'media') {
	                    slotsMedia.push(self.$slots.default[i]);
	                }
	                if (slotName && slotName === 'inner-start') {
	                    slotsInnerStart.push(self.$slots.default[i]);
	                }
	                if (!slotName || slotName && slotName === 'inner') {
	                    slotsInner.push(self.$slots.default[i]);
	                }
	            }
	        }
	        // Input
	        if (self.radio || self.checkbox) {
	            inputEl = c('input', {
	                attrs: {
	                    value: self.value,
	                    name: self.name,
	                    checked: self.checked,
	                    readonly: self.readonly,
	                    disabled: self.disabled,
	                    required: self.required,
	                    type: self.radio ? 'radio' : 'checkbox'
	                },
	                on: {
	                    change: self.onChange
	                },
	                domProps: {
	                    checked: self.checked
	                }
	            });
	        }
	        // Media
	        if (self.media || self.checkbox || self.radio && self.$theme.material || slotsMediaStart.length || slotsMedia.length) {
	            if (self.checkbox || self.radio && self.$theme.material) {
	                if (self.media) {
	                    inputIconEl = '<i class="icon icon-form-' + (self.radio ? 'radio' : 'checkbox') + '"></i>';
	                    mediaEl = c('div', { 'class': { 'item-media': true }, domProps: { innerHTML: inputIconEl + (self.media ? self.media : '') } });
	                }
	                else {
	                    var iconClasses = { 'icon': true };
	                    iconClasses['icon-form-' + (self.radio ? 'radio' : 'checkbox')] = true;
	                    inputIconEl = c('i', { 'class': iconClasses });
	                    mediaEl = c('div', { 'class': { 'item-media': true } }, [slotsMediaStart, inputIconEl, slotsMedia]);
	                }
	            }
	            else {
	                if (self.media) {
	                    mediaEl = c('div', { staticClass: 'item-media', domProps: { innerHTML: self.media } });
	                }
	                else {
	                    mediaEl = c('div', { staticClass: 'item-media' }, [slotsMediaStart, slotsMedia]);
	                }
	            }
	        }
	        // Inner Elements
	        if (self.title) {
	            titleEl = c('div', { staticClass: 'item-title', domProps: { innerHTML: self.title } }, [self.title]);
	        }
	        if (self.subtitle) {
	            subtitleEl = c('div', { staticClass: 'item-subtitle', domProps: { innerHTML: self.subtitle } }, [self.subtitle]);
	        }
	        if (self.text) {
	            textEl = c('div', { staticClass: 'item-text', domProps: { innerHTML: self.text } });
	        }
	        if (self.after || self.badge || slotsAfter.length) {
	            if (self.after) {
	                afterEl = c('span', { domProps: { innerHTML: self.after } });
	            }
	            if (self.badge) {
	                badgeEl = c('f7-badge', { props: { color: self.badgeColor } }, [self.badge]);
	            }
	            afterWrapEl = c('div', { staticClass: 'item-after' }, [slotsAfterStart, afterEl, badgeEl, slotsAfter]);
	        }
	        if (self.mediaList) {
	            titleRowEl = c('div', { staticClass: 'item-title-row' }, [titleEl, afterWrapEl]);
	        }
	        innerEl = c('div', { staticClass: 'item-inner' }, self.mediaList ? [slotsInnerStart, titleRowEl, subtitleEl, textEl, slotsInner] : [slotsInnerStart, titleEl, afterWrapEl, slotsInner]);
	        // Finalize
	        return c((self.checkbox || self.radio) ? 'label' : 'div', { staticClass: 'item-content', 'class': { 'label-checkbox': self.checkbox, 'label-radio': self.radio }, on: { click: self.onClick } }, [slotsContentStart, inputEl, mediaEl, innerEl, slotsContent]);
	    },
	    props: {
	        'title': [String, Number],
	        'text': [String, Number],
	        'media': String,
	        'subtitle': [String, Number],
	        'after': [String, Number],
	        'badge': [String, Number],
	        'badge-color': String,
	        'media-list': Boolean,
	        'checkbox': Boolean,
	        'checked': Boolean,
	        'radio': Boolean,
	        'name': String,
	        'value': [String, Number, Boolean, Array],
	        'input-value': [String, Number],
	        'readonly': Boolean,
	        'required': Boolean,
	        'disabled': Boolean
	    },
	    methods: {
	        onClick: function (event) {
	            this.$emit('click', event);
	        },
	        onChange: function (event) {
	            this.$emit('change', event);
	        }
	    }
	};
	exports.VueListItemContent = listItemContent;
	var listItemSwipeoutActions = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { class: 'swipeout-actions-' + _vm.sideComputed }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'left': Boolean,
	        'right': Boolean,
	        'side': String
	    },
	    computed: {
	        sideComputed: function () {
	            if (!this.side) {
	                if (this.left) {
	                    return 'left';
	                }
	                if (this.right) {
	                    return 'right';
	                }
	                return 'right';
	            }
	            return this.side;
	        }
	    },
	    data: function () {
	        return {};
	    }
	};
	exports.VueListItemSwipeoutActions = listItemSwipeoutActions;
	var listItemSwipeoutButton = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('a', { class: _vm.classObject, attrs: { "href": "#" }, on: { "click": _vm.onClick } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'overswipe': Boolean,
	        'close': Boolean,
	        'delete': Boolean,
	        'color': String,
	        'bg': String
	    },
	    computed: {
	        classObject: function () {
	            var co = {
	                'swipeout-overswipe': this.overswipe,
	                'swipeout-delete': this.delete,
	                'swipeout-close': this.close
	            };
	            if (this.color) {
	                co['bg-' + this.color] = true;
	            }
	            if (this.bg) {
	                co['bg-' + this.bg] = true;
	            }
	            return co;
	        }
	    },
	    data: function () {
	        return {};
	    },
	    methods: {
	        onClick: function (event) {
	            this.$emit('click', event);
	        }
	    }
	};
	exports.VueListItemSwipeoutButton = listItemSwipeoutButton;
	var listItem = {
	    render: function (c) {
	        var liChildren, linkEl, itemContentEl;
	        var self = this;
	        function trustyBoolean(b) {
	            if (b || b === '') {
	                return true;
	            }
	            return false;
	        }
	        function trustyString(s) {
	            if (typeof s === 'string' && s !== '') {
	                return true;
	            }
	            return false;
	        }
	        // Item Content
	        itemContentEl = c('f7-list-item-content', {
	            props: {
	                'title': self.title,
	                'text': self.text,
	                'media': self.media,
	                'subtitle': self.subtitle,
	                'after': self.after,
	                'badge': self.badge,
	                'badge-color': self.badgeColor,
	                'media-list': self.mediaListComputed,
	                'accordion-item': self.accordionItem,
	                'checkbox': self.checkbox,
	                'checked': self.checkedComputed,
	                'radio': self.radio,
	                'name': self.name,
	                'value': self.valueComputed,
	                'readonly': self.readonly,
	                'required': self.required,
	                'disabled': self.disabled
	            },
	            on: (self.link || self.accordionItem || self.smartSelect) ? {} : { click: self.onClick, change: self.onChange }
	        }, [self.$slots['content-start'], self.$slots.content, self.$slots['media-start'], self.$slots.media, self.$slots['inner-start'], self.$slots.inner, self.$slots['after-start'], self.$slots.after, (self.swipeout || self.accordionItem ? [] : self.$slots.default)]);
	        // Link
	        if (self.link || self.accordionItem || self.smartSelect) {
	            linkEl = c('a', {
	                attrs: {
	                    href: self.link === true || self.accordionItem || self.smartSelect ? '#' : self.link,
	                    'target': self.linkTarget,
	                    'data-searchbar': self.smartSelectSearchbar,
	                    'data-searchbar-placeholder': self.smartSelectSearchbarPlaceholder,
	                    'data-searchbar-cancel': self.smartSelectSearchbarCancel,
	                    'data-page-title': self.smartSelectPageTitle,
	                    'data-back-text': self.smartSelectBackText,
	                    'data-back-on-select': self.smartSelectBackOnSelect,
	                    'data-virtual-list': self.smartSelectVirtualList,
	                    'data-virtual-list-height': self.smartSelectVirtualListHeight,
	                    'data-open-in': self.smartSelectOpenIn,
	                    'data-navbar-theme': self.smartSelectNavbarTheme,
	                    'data-form-theme': self.smartSelectFormTheme,
	                    'data-view': trustyString(self.linkView) ? self.linkView : false,
	                    'data-panel': trustyString(self.linkOpenPanel) ? self.linkOpenPanel : false,
	                    'data-popup': trustyString(self.linkOpenPopup) ? self.linkOpenPopup : false,
	                    'data-popover': trustyString(self.linkOpenPopover) ? self.linkOpenPopover : false,
	                    'data-picker': trustyString(self.linkOpenPicker) ? self.linkOpenPicker : false,
	                    'data-login-screen': trustyString(self.linkOpenLoginScreen) ? self.linkOpenLoginScreen : false,
	                    'data-sortable': trustyString(self.linkOpenSortable) ? self.linkOpenSortable : (trustyString(self.linkToggleSortable) ? self.linkToggleSortable : false),
	                    'data-force': self.linkForce,
	                    'data-reload': self.linkReload,
	                    'data-animate-pages': ('linkAnimatePages' in self.$options.propsData) ? self.linkAnimatePages.toString() : undefined,
	                    'data-ignore-cache': self.linkIgnoreCache,
	                    'data-page-name': typeof self.linkPageName === 'string' ? self.linkPageName : false,
	                    'data-template': typeof self.linkTemplate === 'string' ? self.linkTemplate : false,
	                },
	                'class': {
	                    'item-link': true,
	                    'external': self.linkExternal,
	                    'back': self.linkBack,
	                    'no-fastclick': self.linkNoFastclick,
	                    'smart-select': self.smartSelect,
	                    'close-panel': trustyBoolean(self.linkClosePanel),
	                    'open-panel': self.linkOpenPanel || self.linkOpenPanel === '',
	                    'close-popup': trustyBoolean(self.linkClosePopup),
	                    'open-popup': self.linkOpenPopup || self.linkOpenPopup === '',
	                    'close-popover': trustyBoolean(self.linkClosePopover),
	                    'open-popover': self.linkOpenPopover || self.linkOpenPopover === '',
	                    'close-picker': trustyBoolean(self.linkClosePicker),
	                    'open-picker': self.linkOpenPicker || self.linkOpenPicker === '',
	                    'close-login-screen': trustyBoolean(self.linkCloseLoginScreen),
	                    'open-login-screen': self.linkOpenLoginScreen || self.linkOpenLoginScreen === '',
	                    'close-sortable': trustyBoolean(self.linkCloseSortable),
	                    'open-sortable': self.linkOpenSortable || self.linkOpenSortable === '',
	                    'toggle-sortable': self.linkToggleSortable || self.linkToggleSortable === '',
	                },
	                on: {
	                    click: self.onClick
	                }
	            }, [itemContentEl]);
	        }
	        if (self.dividerOrGroupTitle) {
	            liChildren = [c('span', self.$slots.default || self.title)];
	        }
	        else {
	            var linkItemEl = (self.link || self.smartSelect || self.accordionItem) ? linkEl : itemContentEl;
	            if (self.swipeout) {
	                liChildren = [c('div', { 'class': { 'swipeout-content': true } }, [linkItemEl])];
	            }
	            else {
	                liChildren = [linkItemEl];
	            }
	            if (self.sortableComputed) {
	                liChildren.push(c('div', { 'class': { 'sortable-handler': true } }));
	            }
	            if (self.swipeout || self.accordionItem) {
	                liChildren.push(self.$slots.default);
	            }
	            liChildren.unshift(self.$slots['root-start']);
	            liChildren.push(self.$slots.root);
	        }
	        return c('li', {
	            'class': {
	                'item-divider': self.divider,
	                'list-group-title': self.groupTitle,
	                'swipeout': self.swipeout,
	                'accordion-item': self.accordionItem
	            },
	            on: {
	                'swipeout:open': self.onSwipeoutOpen,
	                'swipeout:opened': self.onSwipeoutOpened,
	                'swipeout:close': self.onSwipeoutClose,
	                'swipeout:closed': self.onSwipeoutClosed,
	                'swipeout:delete': self.onSwipeoutDelete,
	                'swipeout:deleted': self.onSwipeoutDeleted,
	                'swipeout': self.onSwipeout,
	                'accordion:open': self.onAccOpen,
	                'accordion:opened': self.onAccOpened,
	                'accordion:close': self.onAccClose,
	                'accordion:closed': self.onAccClosed,
	            }
	        }, liChildren);
	    },
	    props: {
	        'title': [String, Number],
	        'text': [String, Number],
	        'media': String,
	        'subtitle': [String, Number],
	        // Link Props
	        'link': [Boolean, String],
	        'link-external': Boolean,
	        'link-back': Boolean,
	        'link-no-fastclick': Boolean,
	        'link-force': Boolean,
	        'link-reload': Boolean,
	        'link-animate-pages': Boolean,
	        'link-ignore-cache': Boolean,
	        'link-page-name': String,
	        'link-template': String,
	        'link-target': String,
	        'link-view': String,
	        'link-open-panel': [Boolean, String],
	        'link-close-panel': [Boolean, String],
	        'link-open-popup': [Boolean, String],
	        'link-close-popup': [Boolean, String],
	        'link-open-popover': [Boolean, String],
	        'link-close-popover': [Boolean, String],
	        'link-open-login-screen': [Boolean, String],
	        'link-close-login-screen': [Boolean, String],
	        'link-open-picker': [Boolean, String],
	        'link-close-picker': [Boolean, String],
	        'after': [String, Number],
	        'badge': [String, Number],
	        'badge-color': String,
	        'media-item': Boolean,
	        'media-list-item': Boolean,
	        'media-list': Boolean,
	        'divider': Boolean,
	        'group-title': Boolean,
	        'swipeout': Boolean,
	        'sortable': Boolean,
	        'accordion-item': Boolean,
	        // Smart Select
	        'smart-select': Boolean,
	        'smart-select-searchbar': Boolean,
	        'smart-select-searchbar-placeholder': String,
	        'smart-select-searchbar-cancel': String,
	        'smart-select-page-title': String,
	        'smart-select-back-text': String,
	        'smart-select-back-on-select': Boolean,
	        'smart-select-virtual-list': Boolean,
	        'smart-select-virtual-list-height': Number,
	        'smart-select-open-in': String,
	        'smart-select-navbar-theme': String,
	        'smart-select-form-theme': String,
	        // Inputs
	        'checkbox': Boolean,
	        'checked': Boolean,
	        'radio': Boolean,
	        'name': String,
	        'value': [String, Number, Boolean, Array],
	        'input-value': [String, Number],
	        'readonly': Boolean,
	        'required': Boolean,
	        'disabled': Boolean
	    },
	    computed: {
	        dividerOrGroupTitle: function () {
	            return this.divider || this.groupTitle;
	        },
	        sortableComputed: function () {
	            return this.sortable || this.$parent.sortable || this.$parent.sortableComputed;
	        },
	        mediaListComputed: function () {
	            return this.mediaList || this.mediaItem || this.$parent.mediaList || this.$parent.mediaListComputed;
	        },
	        hasCheckboxModel: function () {
	            var self = this;
	            return self.checkbox && (typeof self.$options.propsData.value !== 'undefined' && typeof self.value === 'boolean' || Array.isArray(self.value));
	        },
	        hasRadioModel: function () {
	            var self = this;
	            return self.radio && typeof self.inputValue !== 'undefined';
	        },
	        valueComputed: function () {
	            var self = this;
	            if (self.inputValue) {
	                return self.inputValue;
	            }
	            else if (self.hasCheckboxModel) {
	                return undefined;
	            }
	            else {
	                return self.value;
	            }
	        },
	        checkedComputed: function () {
	            var self = this;
	            if (self.hasCheckboxModel) {
	                if (self.inputValue && Array.isArray(self.value)) {
	                    return self.value.indexOf(self.inputValue) >= 0;
	                }
	                return self.value;
	            }
	            else if (self.hasRadioModel) {
	                if (typeof self.value !== typeof self.inputValue) {
	                    return self.value.toString() === self.inputValue.toString();
	                }
	                return self.value === self.inputValue;
	            }
	            else {
	                return self.checked;
	            }
	        }
	    },
	    methods: {
	        onClick: function (event) {
	            if (event.target.tagName.toLowerCase() !== 'input') {
	                this.$emit('click', event);
	            }
	        },
	        onSwipeoutDeleted: function (event) {
	            this.$emit('swipeout:deleted', event);
	        },
	        onSwipeoutDelete: function (event) {
	            this.$emit('swipeout:delete', event);
	        },
	        onSwipeoutClose: function (event) {
	            this.$emit('swipeout:close', event);
	        },
	        onSwipeoutClosed: function (event) {
	            this.$emit('swipeout:closed', event);
	        },
	        onSwipeoutOpen: function (event) {
	            this.$emit('swipeout:open', event);
	        },
	        onSwipeoutOpened: function (event) {
	            this.$emit('swipeout:opened', event);
	        },
	        onSwipeout: function (event) {
	            this.$emit('swipeout', event);
	        },
	        onAccClose: function (event) {
	            this.$emit('accordion:close', event);
	        },
	        onAccClosed: function (event) {
	            this.$emit('accordion:closed', event);
	        },
	        onAccOpen: function (event) {
	            this.$emit('accordion:open', event);
	        },
	        onAccOpened: function (event) {
	            this.$emit('accordion:opened', event);
	        },
	        onChange: function (event) {
	            var self = this;
	            if (self.hasCheckboxModel) {
	                if (Array.isArray(self.value)) {
	                    if (event.target.checked) {
	                        self.value.push(event.target.value);
	                    }
	                    else {
	                        self.value.splice(self.value.indexOf(event.target.value), 1);
	                    }
	                }
	                else {
	                    self.$emit('input', event.target.checked);
	                }
	                self.$emit('change', event);
	            }
	            else if (self.hasRadioModel) {
	                self.$emit('input', event.target.value);
	            }
	            else {
	                self.$emit('change', event);
	            }
	        }
	    }
	};
	exports.VueListItem = listItem;
	var listLabel = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "list-block-label" }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	};
	exports.VueListLabel = listLabel;
	var list = {
	    beforeDestroy: function () {
	        var self = this;
	        if (!(self.virtual && self.virtualInit && self.f7VirtualList)) {
	            return;
	        }
	        if (self.f7VirtualList.destroy) {
	            self.f7VirtualList.destroy();
	        }
	    },
	    watch: {
	        virtualItems: function () {
	            // Items Updated
	            var self = this;
	            if (!(self.virtual && self.virtualInit && self.f7VirtualList)) {
	                return;
	            }
	            self.f7VirtualList.replaceAllItems(self.virtualItems);
	        },
	    },
	    render: function (c) {
	        var blockEl, blockChildren;
	        var self = this;
	        blockChildren = self.grouped ? self.$slots.default : c('ul', {}, self.$slots.default);
	        var outOfList = [], ulSlots = [];
	        if (self.$slots.default) {
	            for (var i = 0; i < self.$slots.default.length; i++) {
	                var tag = self.$slots.default[i].tag;
	                if (tag && !(tag == 'li' || tag.indexOf('list-item') >= 0 || tag.indexOf('list-button') >= 0)) {
	                    outOfList.push(self.$slots.default[i]);
	                }
	                else {
	                    ulSlots.push(self.$slots.default[i]);
	                }
	            }
	        }
	        blockEl = c(self.form ? 'form' : 'div', {
	            staticClass: 'list-block',
	            'class': {
	                'inset': self.inset,
	                'tablet-inset': self.tabletInset,
	                'media-list': self.mediaList,
	                'sortable': self.sortable,
	                'accordion-list': self.accordion,
	                'contacts-block': self.contacts,
	                'virtual-list': self.virtual,
	                'tab': self.tab,
	                'active': self.active,
	                'no-hairlines': self.noHairlines,
	                'no-hairlines-between': self.noHairlinesBetween,
	                'store-data': self.storeData
	            },
	            on: {
	                'sortable:open': self.onSortableOpen,
	                'sortable:close': self.onSortableClose,
	                'sortable:sort': self.onSortableSort,
	                'tab:show': self.onTabShow,
	                'tab:hide': self.onTabHide
	            }
	        }, [
	            ulSlots.length > 0 ? [c('ul', {}, ulSlots), outOfList] : outOfList
	        ]);
	        return blockEl;
	    },
	    props: {
	        'inset': Boolean,
	        'tablet-inset': Boolean,
	        'media-list': Boolean,
	        'grouped': Boolean,
	        'sortable': Boolean,
	        'label': String,
	        'accordion': Boolean,
	        'contacts': Boolean,
	        'no-hairlines': Boolean,
	        'no-hairlines-between': Boolean,
	        // Tab
	        'tab': Boolean,
	        'active': Boolean,
	        // Form
	        'form': Boolean,
	        'store-data': Boolean,
	        // Virtual List
	        'virtual': Boolean,
	        'virtual-init': {
	            type: Boolean,
	            default: true
	        },
	        'virtual-items': [Array, Object],
	        'virtual-height': [Number, Function],
	        'virtual-rows-before': Number,
	        'virtual-rows-after': Number,
	        'virtual-cols': {
	            type: Number,
	            default: 1
	        },
	        'virtual-cache': {
	            type: Boolean,
	            default: true
	        },
	        'virtual-filtered-only': {
	            type: Boolean,
	            default: false
	        },
	        'virtual-search-by-item': Function,
	        'virtual-search-all': Function,
	        'virtual-render-item': Function,
	        'virtual-empty-template': String
	    },
	    methods: {
	        onSortableOpen: function (event) {
	            this.$emit('sortable:open', event);
	        },
	        onSortableClose: function (event) {
	            this.$emit('sortable:close', event);
	        },
	        onSortableSort: function (event) {
	            this.$emit('sortable:sort', event, event.detail);
	        },
	        onTabShow: function (e) {
	            this.$emit('tab:show', e);
	        },
	        onTabHide: function (e) {
	            this.$emit('tab:hide', e);
	        },
	        onF7Init: function (f7) {
	            var self = this;
	            // Init Virtual List
	            if (!(self.virtual && self.virtualInit)) {
	                return;
	            }
	            var $$ = self.$$;
	            var template = $$(self.$el).find('script').html();
	            if (!template && !self.virtualRenderItem) {
	                return;
	            }
	            if (template) {
	                template = self.$t7.compile(template);
	            }
	            self.f7VirtualList = f7.virtualList(self.$el, {
	                items: self.virtualItems || [],
	                template: template,
	                height: self.virtualHeight || undefined,
	                cols: self.virtualCols,
	                rowsBefore: self.virtualRowsBefore || undefined,
	                rowsAfter: self.virtualRowsAfter || undefined,
	                showFilteredItemsOnly: self.virtualFilteredOnly,
	                searchByItem: self.virtualSearchByItem,
	                searchAll: self.virtualSearchAll,
	                renderItem: self.virtualRenderItem,
	                emptyTemplate: self.virtualEmptyTemplate,
	                onItemBeforeInsert: function (list, item) {
	                    self.$emit('virtual:itembeforeinsert', list, item);
	                },
	                onBeforeClear: function (list, fragment) {
	                    self.$emit('virtual:beforeclear', list, fragment);
	                },
	                onItemsBeforeInsert: function (list, fragment) {
	                    self.$emit('virtual:itemsbeforeinsert', list, fragment);
	                },
	                onItemsAfterInsert: function (list, fragment) {
	                    self.$emit('virtual:itemsafterinsert', list, fragment);
	                },
	            });
	        }
	    }
	};
	exports.VueList = list;
	var loginScreenTitle = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "login-screen-title" }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	};
	exports.VueLoginScreenTitle = loginScreenTitle;
	var loginScreen = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "login-screen", class: _vm.classesObject, on: { "loginscreen:open": _vm.onOpen, "loginscreen:opened": _vm.onOpened, "loginscreen:close": _vm.onClose, "loginscreen:closed": _vm.onClosed } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    mounted: function () {
	        var self = this;
	        if (self.opened) {
	            self.$el.style.display = 'block';
	        }
	    },
	    watch: {
	        opened: function (opened) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            var $$ = self.$$;
	            if (opened) {
	                self.$f7.loginScreen(self.$el);
	            }
	            else {
	                if (!$$(self.$el).hasClass('modal-in')) {
	                    return;
	                }
	                self.$f7.closeModal(self.$el);
	            }
	        }
	    },
	    props: {
	        theme: String,
	        layout: String,
	        opened: Boolean
	    },
	    computed: {
	        classesObject: function () {
	            var co = {
	                'modal-in': this.opened,
	                'modal-out': !this.opened
	            };
	            if (this.theme) {
	                co['theme-' + this.theme] = true;
	            }
	            if (this.layout) {
	                co['layout-' + this.layout] = true;
	            }
	            return co;
	        }
	    },
	    methods: {
	        onOpen: function (event) {
	            this.$emit('loginscreen:open', event);
	        },
	        onOpened: function (event) {
	            this.$emit('loginscreen:opened', event);
	        },
	        onClose: function (event) {
	            this.$emit('loginscreen:close', event);
	        },
	        onClosed: function (event) {
	            this.$emit('loginscreen:closed', event);
	        },
	        open: function (animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.loginScreen(self.$el, animated);
	        },
	        close: function (animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.closeModal(self.$el, animated);
	        }
	    }
	};
	exports.VueLoginScreen = loginScreen;
	var message = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { class: _vm.classesObject, on: { "click": _vm.onClick } }, [_vm._v("\n  " + _vm._s(_vm.day) + " "), (_vm.time) ? _c('span', [_vm._v(_vm._s(_vm.time))]) : _vm._e(), _vm._v(" "), _vm._t("start"), _vm._v(" "), (_vm.name) ? _c('div', { staticClass: "message-name", on: { "click": _vm.onNameClick } }, [_vm._v(_vm._s(_vm.name))]) : _vm._e(), _vm._v(" "), _c('div', { staticClass: "message-text", on: { "click": _vm.onTextClick } }, [_vm._t("default", [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), (_vm.date) ? _c('div', { staticClass: "message-date" }, [_vm._v(_vm._s(_vm.date))]) : _vm._e()], 2), _vm._v(" "), (_vm.avatar) ? _c('div', { staticClass: "message-avatar", style: ({ 'background-image': 'url(' + _vm.avatar + ')' }), on: { "click": _vm.onAvatarClick } }) : _vm._e(), _vm._v(" "), (_vm.label) ? _c('div', { staticClass: "message-label" }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _vm._t("end")], 2); },
	    staticRenderFns: [],
	    props: {
	        text: String,
	        name: String,
	        avatar: String,
	        type: {
	            type: String,
	            default: 'sent'
	        },
	        label: String,
	        day: String,
	        date: String,
	        time: String,
	        last: {
	            type: Boolean,
	            default: true
	        },
	        first: {
	            type: Boolean,
	            default: true
	        }
	    },
	    computed: {
	        classesObject: function () {
	            var co = {};
	            var self = this;
	            if (self.day || self.time) {
	                co['messages-date'] = self.day || self.time;
	            }
	            else {
	                var newPosition = 'bottom';
	                if (self.$parent.newFirst) {
	                    newPosition = 'top';
	                }
	                // co['message-appear-from-' + newPosition] = true;
	                co['message-date'] = self.day || self.time;
	                co['message'] = !(self.day || self.time);
	                co['message-' + self.type] = true;
	                co['message-with-avatar'] = self.avatar;
	                co['message-first'] = self.first;
	                co['message-last'] = self.last;
	                co['message-with-tail'] = self.last;
	            }
	            return co;
	        },
	    },
	    methods: {
	        onClick: function (event) {
	            this.$emit('click', event);
	        },
	        onNameClick: function (event) {
	            this.$emit('click:name', event);
	        },
	        onTextClick: function (event) {
	            this.$emit('click:text', event);
	        },
	        onAvatarClick: function (event) {
	            this.$emit('click:avatar', event);
	        },
	    }
	};
	exports.VueMessage = message;
	var messagebar = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "toolbar messagebar" }, [_vm._t("before-inner"), _vm._v(" "), _c('div', { staticClass: "toolbar-inner" }, [_vm._t("before-textarea"), _vm._v(" "), _c('textarea', { ref: "area", attrs: { "placeholder": _vm.placeholder, "disabled": _vm.disabled, "name": _vm.name, "readonly": _vm.readonly }, on: { "input": _vm.onInput, "change": _vm.onChange, "focus": _vm.onFocus, "blur": _vm.onBlur } }, [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), _vm._t("after-textarea"), _vm._v(" "), (_vm.sendLink && _vm.sendLink.indexOf('<') >= 0) ? _c('f7-link', { domProps: { "innerHTML": _vm._s(_vm.sendLink) }, on: { "click": _vm.onClick } }) : _c('f7-link', { on: { "click": _vm.onClick } }, [_vm._t("send-link", [_vm._v(_vm._s(_vm.sendLink))])], 2), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _vm._t("after-inner")], 2); },
	    staticRenderFns: [],
	    beforeDestroy: function () {
	        if (this.f7Messagebar && this.f7Messagebar.destroy) {
	            this.f7Messagebar.destroy();
	        }
	    },
	    props: {
	        placeholder: {
	            type: String,
	            default: 'Message'
	        },
	        init: {
	            type: Boolean,
	            default: true
	        },
	        maxHeight: Number,
	        sendLink: String,
	        value: [String, Number],
	        disabled: Boolean,
	        readonly: Boolean,
	        name: String
	    },
	    methods: {
	        getValue: function () {
	            if (!this.f7Messagebar) {
	                return;
	            }
	            return this.f7Messagebar.value();
	        },
	        setValue: function (newValue) {
	            if (!this.f7Messagebar) {
	                return;
	            }
	            return this.f7Messagebar.value(newValue);
	        },
	        clear: function () {
	            if (!this.f7Messagebar) {
	                return;
	            }
	            return this.f7Messagebar.clear();
	        },
	        onChange: function (event) {
	            this.$emit('change', event);
	        },
	        onInput: function (event) {
	            this.$emit('input', event.target.value);
	        },
	        onFocus: function (event) {
	            this.$emit('focus', event);
	        },
	        onBlur: function (event) {
	            this.$emit('blur', event);
	        },
	        onClick: function (event) {
	            var value = this.$refs.area.value;
	            var clear = this.f7Messagebar ? this.f7Messagebar.clear : function () { };
	            this.$emit('submit', value, clear);
	            this.$emit('click', event);
	        },
	        onF7Init: function () {
	            var self = this;
	            if (!self.init) {
	                return;
	            }
	            self.f7Messagebar = self.$f7.messagebar(self.$el, {
	                maxHeight: self.maxHeight
	            });
	        }
	    }
	};
	exports.VueMessagebar = messagebar;
	var messages = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "messages" }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    beforeDestroy: function () {
	        if (this.f7Messages && this.f7Messages.destroy) {
	            this.f7Messages.destroy();
	        }
	    },
	    beforeUpdate: function (a, b) {
	        var self = this;
	        if (!self.init) {
	            return;
	        }
	        self.$children.forEach(function (el) {
	            self.$$(el.$el).addClass('message-appeared');
	        });
	    },
	    updated: function (a, b) {
	        var self = this;
	        if (!self.init) {
	            return;
	        }
	        self.$children.forEach(function (el) {
	            var $el = self.$$(el.$el);
	            if (!$el.hasClass('message-appeared')) {
	                $el.addClass('message-appear-from-bottom');
	            }
	        });
	        if (this.f7Messages && this.f7Messages.layout && this.autoLayout) {
	            this.f7Messages.layout();
	        }
	        if (this.f7Messages && this.f7Messages.layout && this.autoLayout) {
	            this.f7Messages.scrollMessages();
	        }
	    },
	    props: {
	        autoLayout: {
	            type: Boolean,
	            default: true
	        },
	        newMessagesFirst: Boolean,
	        messages: Array,
	        scrollMessages: {
	            type: Boolean,
	            default: true
	        },
	        scrollMessagesOnlyOnEdge: Boolean,
	        init: {
	            type: Boolean,
	            default: true
	        }
	    },
	    methods: {
	        addMessage: function (messageParameters, method, animate) {
	            if (!this.f7Messages) {
	                return;
	            }
	            return this.f7Messages.addMessage(messageParameters, method, animate);
	        },
	        appendMessage: function (messageParameters, animate) {
	            if (!this.f7Messages) {
	                return;
	            }
	            return this.f7Messages.appendMessage(messageParameters, animate);
	        },
	        prependMessage: function (messageParameters, animate) {
	            if (!this.f7Messages) {
	                return;
	            }
	            return this.f7Messages.prependMessage(messageParameters, animate);
	        },
	        addMessages: function (messages, method, animate) {
	            if (!this.f7Messages) {
	                return;
	            }
	            return this.f7Messages.addMessages(messages, method, animate);
	        },
	        removeMessage: function (message) {
	            if (!this.f7Messages) {
	                return;
	            }
	            return this.f7Messages.removeMessage(message);
	        },
	        removeMessages: function (messages) {
	            if (!this.f7Messages) {
	                return;
	            }
	            return this.f7Messages.removeMessages(messages);
	        },
	        scroll: function () {
	            if (!this.f7Messages) {
	                return;
	            }
	            return this.f7Messages.scrollMessages();
	        },
	        layout: function () {
	            if (!this.f7Messages) {
	                return;
	            }
	            return this.f7Messages.layout();
	        },
	        clean: function () {
	            if (!this.f7Messages) {
	                return;
	            }
	            return this.f7Messages.clean();
	        },
	        onF7Init: function (f7) {
	            var self = this;
	            if (!self.init) {
	                return;
	            }
	            self.f7Messages = f7.messages(self.$el, {
	                autoLayout: self.autoLayout,
	                newMessagesFirst: self.newMessagesFirst,
	                messages: self.messages,
	                scrollMessages: self.scrollMessages,
	                scrollMessagesOnlyOnEdge: self.scrollMessagesOnlyOnEdge,
	            });
	        }
	    }
	};
	exports.VueMessages = messages;
	var navCenter = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "center", class: { sliding: _vm.sliding } }, [_vm._t("default", [_vm._v(_vm._s(_vm.title))])], 2); },
	    staticRenderFns: [],
	    props: {
	        sliding: Boolean,
	        title: String
	    }
	};
	exports.VueNavCenter = navCenter;
	var navLeft = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "left", class: { sliding: _vm.sliding } }, [(_vm.backLink) ? _c('f7-link', { class: { 'icon-only': (_vm.backLink === true || _vm.backLink && _vm.$theme.material) }, attrs: { "href": _vm.backLinkUrl || _vm.backLinkHref || '#', "back": "", "icon": "icon-back", "text": _vm.backLink !== true && !_vm.$theme.material ? _vm.backLink : undefined }, on: { "click": _vm.onBackClick } }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        backLink: [Boolean, String],
	        backLinkUrl: String,
	        backLinkHref: String,
	        sliding: Boolean
	    },
	    methods: {
	        onBackClick: function (e) {
	            this.$emit('back-click', e);
	            this.$emit('click:back', e);
	        }
	    }
	};
	exports.VueNavLeft = navLeft;
	var navRight = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "right", class: { sliding: _vm.sliding } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        sliding: Boolean
	    }
	};
	exports.VueNavRight = navRight;
	var navbar = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "navbar", class: _vm.classesObject, on: { "navbar:beforeinit": _vm.onBeforeInit, "navbar:init": _vm.onInit, "navbar:reinit": _vm.onReinit, "navbar:beforeremove": _vm.onBeforeRemove } }, [_vm._t("before-inner"), _vm._v(" "), _c('div', { staticClass: "navbar-inner" }, [(_vm.backLink) ? _c('f7-nav-left', { attrs: { "back-link": _vm.backLink, "sliding": _vm.sliding, "back-link-href": _vm.backLinkUrl || _vm.backLinkHref }, on: { "back-click": _vm.onBackClick } }) : _vm._e(), _vm._v(" "), (_vm.title) ? _c('f7-nav-center', { attrs: { "title": _vm.title, "sliding": _vm.sliding } }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _vm._t("after-inner")], 2); },
	    staticRenderFns: [],
	    updated: function () {
	        var self = this;
	        self.$nextTick(function () {
	            self.$f7.sizeNavbars();
	        });
	    },
	    props: {
	        backLink: [Boolean, String],
	        backLinkUrl: String,
	        backLinkHref: String,
	        sliding: Boolean,
	        title: String,
	        theme: String,
	        layout: String,
	        hidden: Boolean
	    },
	    computed: {
	        classesObject: function () {
	            var co = {
	                'navbar-hidden': this.hidden
	            };
	            if (this.theme) {
	                co['theme-' + this.theme] = true;
	            }
	            if (this.layout) {
	                co['layout-' + this.layout] = true;
	            }
	            return co;
	        }
	    },
	    methods: {
	        hide: function (animated) {
	            if (!this.$f7) {
	                return;
	            }
	            return this.$f7.hideNavbar(this.$el, animated);
	        },
	        show: function (animated) {
	            if (!this.$f7) {
	                return;
	            }
	            return this.$f7.showNavbar(this.$el, animated);
	        },
	        size: function () {
	            if (!this.$f7 || this.$theme.material) {
	                return;
	            }
	            return this.$f7.sizeNavbars();
	        },
	        onBeforeInit: function (e) {
	            this.$emit('navbar:beforeinit', e);
	        },
	        onInit: function (e) {
	            this.$emit('navbar:init', e);
	        },
	        onReinit: function (e) {
	            this.$emit('navbar:reinit', e);
	        },
	        onBeforeRemove: function (e) {
	            this.$emit('navbar:beforeremove', e);
	        },
	        onBackClick: function (e) {
	            this.$emit('back-click', e);
	            this.$emit('click:back', e);
	        }
	    }
	};
	exports.VueNavbar = navbar;
	var pageContent = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "page-content", class: _vm.classesObject, on: { "tab:show": _vm.onTabShow, "tab:hide": _vm.onTabHide } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'tab': Boolean,
	        'active': Boolean
	    },
	    computed: {
	        classesObject: function () {
	            var self = this;
	            return {
	                'tab': self.tab,
	                'active': self.active
	            };
	        }
	    },
	    methods: {
	        onTabShow: function (e) {
	            this.$emit('tab:show', e);
	        },
	        onTabHide: function (e) {
	            this.$emit('tab:hide', e);
	        }
	    }
	};
	exports.VuePageContent = pageContent;
	var page = {
	    render: function (c) {
	        var pageEl, pageContentEl, ptrEl, infiniteEl, fixedList = [], staticList = [];
	        var self = this;
	        if (self.pullToRefresh && (self.ptrLayer && self.pullToRefreshLayer)) {
	            ptrEl = c('div', { class: { 'pull-to-refresh-layer': true } }, [
	                c('div', { class: { 'preloader': true } }),
	                c('div', { class: { 'pull-to-refresh-arrow': true } })
	            ]);
	        }
	        if ((self.infiniteScroll || self.infiniteScroll === '') && self.infiniteScrollPreloader) {
	            infiniteEl = c('div', { class: { 'infinite-scroll-preloader': true } }, [
	                c('div', { class: { 'preloader': true } })
	            ]);
	        }
	        var fixedTags = ('navbar toolbar tabbar subnavbar searchbar messagebar fab speed-dial floating-button').split(' ');
	        var tag, child, withSubnavbar, withMessages, withSearchbar;
	        var i, j;
	        if (self.$slots.default) {
	            for (i = 0; i < self.$slots.default.length; i++) {
	                child = self.$slots.default[i];
	                tag = child.tag;
	                if (!tag) {
	                    staticList.push(child);
	                    continue;
	                }
	                var isFixed = false;
	                if (tag.indexOf('messages') >= 0) {
	                    withMessages = true;
	                }
	                if (tag.indexOf('subnavbar') >= 0) {
	                    withSubnavbar = true;
	                }
	                if (tag.indexOf('searchbar') >= 0) {
	                    withSearchbar = true;
	                }
	                for (j = 0; j < fixedTags.length; j++) {
	                    if (tag.indexOf(fixedTags[j]) >= 0) {
	                        isFixed = true;
	                    }
	                }
	                if (isFixed) {
	                    fixedList.push(child);
	                }
	                else {
	                    staticList.push(child);
	                }
	            }
	        }
	        if (fixedList.length > 0 && withSearchbar) {
	            fixedList.push(c('div', { class: { 'searchbar-overlay': true } }));
	        }
	        if (withMessages) {
	            self.classesObjectPageContent['messages-content'] = true;
	        }
	        if (!self.noPageContent) {
	            pageContentEl = c('div', {
	                staticClass: 'page-content',
	                class: self.classesObjectPageContent,
	                attrs: {
	                    'data-ptr-distance': self.pullToRefreshDistance || self.ptrDistance,
	                    'data-distance': self.infiniteScrollDistance
	                },
	                on: {
	                    'ptr:pullstart': self.onPtrPullstart,
	                    'ptr:pullmove': self.onPtrPullmove,
	                    'ptr:pullend': self.onPtrPullend,
	                    'ptr:refresh': self.onPtrRefresh,
	                    'ptr:done': self.onPtrRefreshdone,
	                    'infinite': self.onInfinite
	                },
	            }, (self.infiniteScroll === 'top' ? [ptrEl, infiniteEl, self.$slots.static, staticList] : [ptrEl, self.$slots.static, staticList, infiniteEl]));
	        }
	        else {
	            pageContentEl = [];
	            if (self.$slots.default && fixedList.length > 0) {
	                for (i = 0; i < self.$slots.default.length; i++) {
	                    if (fixedList.indexOf(self.$slots.default[i]) < 0) {
	                        pageContentEl.push(self.$slots.default[i]);
	                    }
	                }
	            }
	            else {
	                pageContentEl = [self.$slots.default];
	            }
	        }
	        fixedList.push(self.$slots.fixed);
	        if (withSubnavbar) {
	            self.classesObjectPage['with-subnavbar'] = true;
	        }
	        pageEl = c('div', {
	            staticClass: 'page',
	            class: self.classesObjectPage,
	            attrs: {
	                'data-page': self.name
	            },
	            on: {
	                'page:beforeinit': self.onPageBeforeInit,
	                'page:init': self.onPageInit,
	                'page:reinit': self.onPageReinit,
	                'page:beforeanimation': self.onPageBeforeAnimation,
	                'page:afteranimation': self.onPageAfterAnimation,
	                'page:beforeremove': self.onPageBeforeRemove,
	                'page:back': self.onPageBack,
	                'page:afterback': self.onPageAfterBack
	            }
	        }, [fixedList, pageContentEl]);
	        return pageEl;
	    },
	    props: {
	        'name': String,
	        'cached': Boolean,
	        'navbar-fixed': Boolean,
	        'navbar-through': Boolean,
	        'toolbar-fixed': Boolean,
	        'toolbar-through': Boolean,
	        'tabbar-fixed': Boolean,
	        'tabbar-through': Boolean,
	        'tabbar-labels-fixed': Boolean,
	        'tabbar-labels-through': Boolean,
	        'with-subnavbar': Boolean,
	        'subnavbar': Boolean,
	        'no-navbar': Boolean,
	        'no-toolbar': Boolean,
	        'no-tabbar': Boolean,
	        'pull-to-refresh': Boolean,
	        'pull-to-refresh-distance': Number,
	        'ptr-distance': Number,
	        'pull-to-refresh-layer': {
	            type: Boolean,
	            default: true
	        },
	        'ptr-layer': {
	            type: Boolean,
	            default: true
	        },
	        'infinite-scroll': [Boolean, String],
	        'infinite-scroll-distance': Number,
	        'infinite-scroll-preloader': {
	            type: Boolean,
	            default: true
	        },
	        'hide-bars-on-scroll': Boolean,
	        'hide-navbar-on-scroll': Boolean,
	        'hide-toolbar-on-scroll': Boolean,
	        'hide-tabbar-on-scroll': Boolean,
	        'messages': Boolean,
	        'tabs': Boolean,
	        'no-page-content': Boolean,
	        'login-screen': Boolean,
	        'theme': String,
	        'layout': String,
	        'no-swipeback': Boolean
	    },
	    computed: {
	        classesObjectPage: function () {
	            var co = {
	                'cached': this.cached,
	                'navbar-fixed': this.navbarFixed || this.navbarThrough && this.$theme.material,
	                'navbar-through': this.navbarThrough,
	                'toolbar-fixed': this.toolbarFixed,
	                'toolbar-through': this.toolbarThrough,
	                'tabbar-fixed': this.tabbarFixed,
	                'tabbar-through': this.tabbarThrough,
	                'tabbar-labels-fixed': this.tabbarLabelsFixed,
	                'tabbar-labels-through': this.tabbarLabelsThrough,
	                'with-subnavbar': this.subnavbar || this.withSubnavbar,
	                'no-navbar': this.noNavbar,
	                'no-toolbar': this.noToolbar,
	                'no-tabbar': this.noTabbar,
	                'tabs': this.tabs,
	                'no-swipeback': this.noSwipeBack
	            };
	            if (this.theme) {
	                co['theme-' + this.theme] = true;
	            }
	            if (this.layout) {
	                co['layout-' + this.layout] = true;
	            }
	            return co;
	        },
	        classesObjectPageContent: function () {
	            return {
	                'pull-to-refresh-content': this.pullToRefresh,
	                'infinite-scroll': this.infiniteScroll || this.infiniteScroll === '',
	                'infinite-scroll-top': this.infiniteScroll === 'top',
	                'hide-bars-on-scroll': this.hideBarsOnScroll,
	                'hide-navbar-on-scroll': this.hideNavbarOnScroll,
	                'hide-toolbar-on-scroll': this.hideToolbarOnScroll,
	                'hide-tabbar-on-scroll': this.hideTabbarOnScroll,
	                'messages-content': this.messages,
	                'login-screen-content': this.loginScreen
	            };
	        }
	    },
	    methods: {
	        onPtrPullstart: function (event) {
	            this.$emit('ptr:pullstart', event);
	        },
	        onPtrPullmove: function (event) {
	            this.$emit('ptr:pullmove', event);
	        },
	        onPtrPullend: function (event) {
	            this.$emit('ptr:pullend', event);
	        },
	        onPtrRefresh: function (event) {
	            this.$emit('ptr:refresh', event, event.detail.done);
	        },
	        onPtrRefreshdone: function (event) {
	            this.$emit('ptr:done', event);
	        },
	        onInfinite: function (event) {
	            this.$emit('infinite', event);
	        },
	        onPageBeforeInit: function (event) {
	            this.f7PageData = event.detail.page;
	            this.$emit('page:beforeinit', event, event.detail.page);
	        },
	        onPageInit: function (event) {
	            this.$emit('page:init', event, event.detail.page);
	        },
	        onPageReinit: function (event) {
	            this.$emit('page:reinit', event, event.detail.page);
	        },
	        onPageBeforeAnimation: function (event) {
	            this.$emit('page:beforeanimation', event, event.detail.page);
	        },
	        onPageAfterAnimation: function (event) {
	            this.$emit('page:afteranimation', event, event.detail.page);
	        },
	        onPageBeforeRemove: function (event) {
	            this.$emit('page:beforeremove', event, event.detail.page);
	        },
	        onPageBack: function (event) {
	            this.$emit('page:back', event, event.detail.page);
	        },
	        onPageAfterBack: function (event) {
	            this.$emit('page:afterback', event, event.detail.page);
	        }
	    }
	};
	exports.VuePage = page;
	var pages = {
	    render: function (c) {
	        var self = this;
	        var pages = [];
	        for (var pageId in self.pages) {
	            var page = self.pages[pageId];
	            pages.push(c(page.component, { tag: 'component', props: self.$route.params, key: pageId }));
	        }
	        return c('div', {
	            staticClass: 'pages',
	            ref: 'pages',
	            class: self.classesObject,
	            on: {
	                'page:beforeremove': self.onPageBeforeRemove
	            }
	        }, [
	            self.$slots.default,
	            pages
	        ]);
	    },
	    props: {
	        'navbar-fixed': Boolean,
	        'navbar-through': Boolean,
	        'toolbar-fixed': Boolean,
	        'toolbar-through': Boolean,
	        'tabbar-fixed': Boolean,
	        'tabbar-through': Boolean,
	        'tabbar-labels-fixed': Boolean,
	        'tabbar-labels-through': Boolean,
	        'theme': String,
	        'layout': String
	    },
	    data: function () {
	        return {
	            pages: {}
	        };
	    },
	    computed: {
	        classesObject: function () {
	            var co = {
	                'navbar-fixed': this.navbarFixed || this.navbarThrough && this.$theme.material,
	                'navbar-through': this.navbarThrough,
	                'toolbar-fixed': this.toolbarFixed,
	                'toolbar-through': this.toolbarThrough,
	                'tabbar-fixed': this.tabbarFixed,
	                'tabbar-through': this.tabbarThrough,
	                'tabbar-labels-fixed': this.tabbarLabelsFixed,
	                'tabbar-labels-through': this.tabbarLabesThrough
	            };
	            if (this.theme) {
	                co['theme-' + this.theme] = true;
	            }
	            if (this.layout) {
	                co['layout-' + this.layout] = true;
	            }
	            return co;
	        }
	    },
	    methods: {
	        onPageBeforeRemove: function (e) {
	            var this$1 = this;
	            var idToRemove;
	            for (var id in this$1.pages) {
	                if (e.target === this$1.pages[id].pageElement) {
	                    idToRemove = id;
	                    break;
	                }
	            }
	            if (idToRemove) {
	                this.$delete(this.pages, idToRemove);
	            }
	        },
	        onRouteChange: function (event) {
	            var self = this;
	            var pageComponent = event.route.component;
	            var view = event.view;
	            var currentView = self.$parent.f7View || self.$parent.$el.f7View;
	            if (view !== currentView) {
	                return;
	            }
	            var previousRoute = self.$route.router.findMatchingRoute(view.url) || { route: { path: '/', pagePath: '/' } };
	            var pageRouteChanged = previousRoute.route.pagePath !== event.route.pagePath;
	            var childRouteChanged = !pageRouteChanged && previousRoute.route.path !== event.route.path;
	            var shouldUpdatePages = pageRouteChanged || (!childRouteChanged && (event.options.reload || view.params.allowDuplicateUrls));
	            if (shouldUpdatePages) {
	                var id = new Date().getTime();
	                self.$set(self.pages, id, { component: pageComponent });
	                view.allowPageChange = false;
	                self.$nextTick(function () {
	                    var newPage = view.pagesContainer.querySelector('.page:last-child');
	                    self.pages[id].pageElement = newPage;
	                    view.allowPageChange = true;
	                    var options = Object.assign(event.options, {
	                        pageElement: newPage
	                    });
	                    if (options.isBack) {
	                        view.router.back(options);
	                    }
	                    else {
	                        view.router.load(options);
	                    }
	                });
	            }
	        }
	    }
	};
	exports.VuePages = pages;
	var panel = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "panel", class: _vm.classesObject, on: { "panel:open": _vm.onOpen, "panel:opened": _vm.onOpened, "panel:close": _vm.onClose, "panel:closed": _vm.onClosed, "panel:overlay-click": _vm.onOverlayClick, "panel:swipe": _vm.onPanelSwipe } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'side': String,
	        'effect': String,
	        'cover': Boolean,
	        'reveal': Boolean,
	        'left': Boolean,
	        'right': Boolean,
	        'theme': String,
	        'layout': String,
	        'opened': Boolean
	    },
	    computed: {
	        classesObject: function () {
	            var self = this;
	            var side = self.side || (self.left ? 'left' : 'right');
	            var effect = self.effect || (self.reveal ? 'reveal' : 'cover');
	            var co = {};
	            co['panel-' + side] = true;
	            co['panel-' + effect] = true;
	            if (self.layout) {
	                co['layout-' + self.layout] = true;
	            }
	            if (self.theme) {
	                co['theme-' + self.theme] = true;
	            }
	            co['active'] = self.opened;
	            return co;
	        }
	    },
	    watch: {
	        opened: function (opened) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            var side = self.side || (self.left ? 'left' : 'right');
	            if (opened) {
	                self.$f7.openPanel(side);
	            }
	            else {
	                self.$f7.closePanel(side);
	            }
	        }
	    },
	    mounted: function () {
	        var self = this;
	        if (self.opened) {
	            self.$el.style.display = 'block';
	        }
	        var $$ = self.$$;
	        if (!$$) {
	            return;
	        }
	        var side = self.side || (self.left ? 'left' : 'right');
	        var effect = self.effect || (self.reveal ? 'reveal' : 'cover');
	        if (self.opened) {
	            $$('body').addClass('with-panel-' + side + '-' + effect);
	        }
	    },
	    methods: {
	        onOpen: function (event) {
	            this.$emit('panel:open', event);
	        },
	        onOpened: function (event) {
	            this.$emit('panel:opened', event);
	        },
	        onClose: function (event) {
	            this.$emit('panel:open', event);
	        },
	        onClosed: function (event) {
	            this.$emit('panel:closed', event);
	        },
	        onOverlayClick: function onOverlayClick(event) {
	            this.$emit('panel:overlay-click', event);
	        },
	        onPanelSwipe: function onPanelSwipe(event) {
	            this.$emit('panel:swipe', event);
	        },
	        onF7Init: function () {
	            var $$ = this.$$;
	            if (!$$) {
	                return;
	            }
	            if ($$('.panel-overlay').length === 0) {
	                $$('<div class="panel-overlay"></div>').insertBefore(this.$el);
	            }
	        },
	        open: function (animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            var side = self.side || (self.left ? 'left' : 'right');
	            self.$f7.openPanel(side, animated);
	        },
	        close: function (animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            self.$f7.closePanel(animated);
	        }
	    }
	};
	exports.VuePanel = panel;
	var photoBrowser = {
	    render: function () { },
	    beforeDestroy: function () {
	        var self = this;
	        if (self.f7PhotoBrowser && self.f7PhotoBrowser.destroy) {
	            self.f7PhotoBrowser.destroy();
	        }
	    },
	    props: {
	        init: {
	            type: Boolean,
	            default: true
	        },
	        params: Object,
	        photos: Array,
	        initialSlide: Number,
	        spaceBetween: Number,
	        speed: Number,
	        zoom: Boolean,
	        zoomMax: Number,
	        zoomMin: Number,
	        exposition: Boolean,
	        expositionHideCaptions: Boolean,
	        type: String,
	        navbar: Boolean,
	        toolbar: Boolean,
	        theme: String,
	        captionsTheme: String,
	        swipeToClose: Boolean,
	        backLinkText: String,
	        ofText: String,
	        loop: Boolean,
	        lazyLoading: Boolean,
	        lazyLoadingInPrevNext: Boolean,
	        lazyLoadingOnTransitionStart: Boolean,
	    },
	    methods: {
	        open: function (index) {
	            return this.f7PhotoBrowser.open(index);
	        },
	        close: function () {
	            return this.f7PhotoBrowser.close();
	        },
	        toggleZoom: function () {
	            return this.f7PhotoBrowser.toggleZoom();
	        },
	        toggleExposition: function () {
	            return this.f7PhotoBrowser.toggleExposition();
	        },
	        enableExposition: function () {
	            return this.f7PhotoBrowser.enableExposition();
	        },
	        disableExposition: function () {
	            return this.f7PhotoBrowser.disableExposition();
	        },
	        onF7Init: function (f7) {
	            var self = this;
	            // Init Virtual List
	            if (!self.init) {
	                return;
	            }
	            var params = self.$options.propsData;
	            self.f7PhotoBrowser = f7.photoBrowser(self.params || {
	                photos: params.photos,
	                initialSlide: params.initialSlide,
	                spaceBetween: params.spaceBetween,
	                speed: params.speed,
	                zoom: params.zoom,
	                zoomMax: params.zoomMax,
	                zoomMin: params.zoomMin,
	                exposition: params.exposition,
	                expositionHideCaptions: params.expositionHideCaptions,
	                type: params.type,
	                navbar: params.navbar,
	                toolbar: params.toolbar,
	                theme: params.theme,
	                captionsTheme: params.captionsTheme,
	                swipeToClose: params.swipeToClose,
	                backLinkText: params.backLinkText,
	                ofText: params.ofText,
	                loop: params.loop,
	                lazyLoading: params.lazyLoading,
	                lazyLoadingInPrevNext: params.lazyLoadingInPrevNext,
	                lazyLoadingOnTransitionStart: params.lazyLoadingOnTransitionStart,
	                onOpen: function (pb) {
	                    self.$emit('open', pb);
	                },
	                onClose: function (pb) {
	                    self.$emit('close', pb);
	                },
	                onSwipeToClose: function (pb) {
	                    self.$emit('swipeToClose', pb);
	                },
	                onSlideChangeStart: function (swiper) {
	                    self.$emit('slideChangeStart', swiper);
	                },
	                onSlideChangeEnd: function (swiper) {
	                    self.$emit('slideChangeEnd', swiper);
	                },
	                onTransitionStart: function (swiper) {
	                    self.$emit('transitionStart', swiper);
	                },
	                onTransitionEnd: function (swiper) {
	                    self.$emit('transitionEnd', swiper);
	                },
	                onClick: function (swiper, event) {
	                    self.$emit('click', swiper, event);
	                },
	                onTap: function (swiper, event) {
	                    self.$emit('tap', swiper, event);
	                },
	                onDoubleTap: function (swiper, event) {
	                    self.$emit('doubleTap', swiper, event);
	                },
	                onLazyImageLoad: function (swiper, event) {
	                    self.$emit('lazyImageLoad', swiper, event);
	                },
	                onLazyImageReady: function (swiper, event) {
	                    self.$emit('lazyImageReady', swiper, event);
	                }
	            });
	        }
	    }
	};
	exports.VuePhotoBrowser = photoBrowser;
	var pickerModal = {
	    render: function (c) {
	        var pickerEl, innerEl, fixedList = [], staticList = [];
	        var self = this;
	        var fixedTags = ('navbar toolbar tabbar subnavbar searchbar messagebar fab speed-dial floating-button').split(' ');
	        var tag, child;
	        if (self.$slots.default) {
	            for (var i = 0; i < self.$slots.default.length; i++) {
	                child = self.$slots.default[i];
	                tag = child.tag;
	                if (!tag) {
	                    staticList.push(child);
	                    continue;
	                }
	                var isFixed = false;
	                for (var j = 0; j < fixedTags.length; j++) {
	                    if (tag.indexOf(fixedTags[j]) >= 0) {
	                        isFixed = true;
	                    }
	                }
	                if (isFixed) {
	                    fixedList.push(child);
	                }
	                else {
	                    staticList.push(child);
	                }
	            }
	        }
	        innerEl = c('div', {
	            staticClass: 'picker-modal-inner'
	        }, staticList);
	        return c('div', {
	            class: self.classesObject,
	            staticClass: 'picker-modal',
	            on: {
	                'picker:open': self.onOpen,
	                'picker:opened': self.onOpened,
	                'picker:close': self.onClose,
	                'picker:closed': self.onClosed
	            }
	        }, [fixedList, innerEl]);
	    },
	    mounted: function () {
	        var self = this;
	        if (self.opened) {
	            self.$el.style.display = 'block';
	        }
	    },
	    watch: {
	        opened: function (opened) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            if (opened) {
	                self.$f7.pickerModal(self.$el);
	            }
	            else {
	                self.$f7.closeModal(self.$el);
	            }
	        }
	    },
	    props: {
	        'opened': Boolean,
	        'theme': String,
	        'layout': String,
	        'overlay': Boolean
	    },
	    computed: {
	        classesObject: function () {
	            var co = {
	                'modal-in': this.opened,
	                'modal-out': !this.opened
	            };
	            if (this.theme) {
	                co['theme-' + this.theme] = true;
	            }
	            if (this.layout) {
	                co['layout-' + this.layout] = true;
	            }
	            return co;
	        }
	    },
	    methods: {
	        onOpen: function (event) {
	            if (this.overlay) {
	                this.$$('.picker-modal-overlay').addClass('modal-overlay-visible');
	            }
	            this.$emit('picker:open', event);
	        },
	        onOpened: function (event) {
	            this.$emit('picker:opened', event);
	        },
	        onClose: function (event) {
	            if (this.overlay) {
	                this.$$('.picker-modal-overlay').removeClass('modal-overlay-visible');
	            }
	            this.$emit('picker:close', event);
	        },
	        onClosed: function (event) {
	            this.$emit('picker:closed', event);
	        },
	        onF7Init: function () {
	            var $$ = this.$$;
	            if (!$$) {
	                return;
	            }
	            if ($$('.picker-modal-overlay').length === 0 && (this.$theme && this.$theme.material || this.overlay)) {
	                $$('<div class="picker-modal-overlay ' + (this.opened ? ' modal-overlay-visible' : '') + '"></div>').insertBefore(this.$el);
	            }
	        },
	        open: function (animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.pickerModal(self.$el, undefined, animated);
	        },
	        close: function (animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.closeModal(self.$el, animated);
	        }
	    }
	};
	exports.VuePickerModal = pickerModal;
	var popover = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "popover", on: { "popover:open": _vm.onOpen, "popover:opened": _vm.onOpened, "popover:close": _vm.onClose, "popover:closed": _vm.onClosed } }, [_c('div', { staticClass: "popover-angle" }), _vm._v(" "), _c('div', { staticClass: "popover-content" }, [_vm._t("default")], 2)]); },
	    staticRenderFns: [],
	    methods: {
	        onOpen: function (event) {
	            this.$emit('popover:open', event);
	        },
	        onOpened: function (event) {
	            this.$emit('popover:opened', event);
	        },
	        onClose: function (event) {
	            this.$emit('popover:close', event);
	        },
	        onClosed: function (event) {
	            this.$emit('popover:closed', event);
	        },
	        open: function (target, animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.popover(self.$el, target, undefined, animated);
	        },
	        close: function (animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.closeModal(self.$el, animated);
	        }
	    }
	};
	exports.VuePopover = popover;
	var popup = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "popup", class: _vm.classesObject, on: { "popup:open": _vm.onOpen, "popup:opened": _vm.onOpened, "popup:close": _vm.onClose, "popup:closed": _vm.onClosed } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    mounted: function () {
	        var self = this;
	        if (self.opened) {
	            self.$el.style.display = 'block';
	        }
	    },
	    watch: {
	        opened: function (opened) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            var $$ = self.$$;
	            if (opened) {
	                self.$f7.popup(self.$el);
	            }
	            else {
	                if (!$$(self.$el).hasClass('modal-in')) {
	                    return;
	                }
	                self.$f7.closeModal(self.$el);
	            }
	        }
	    },
	    props: {
	        'tablet-fullscreen': Boolean,
	        'theme': String,
	        'layout': String,
	        'opened': Boolean
	    },
	    computed: {
	        classesObject: function () {
	            var co = {
	                'tablet-fullscreen': this.tabletFullscreen,
	                'modal-in': this.opened,
	                'modal-out': !this.opened
	            };
	            if (this.theme) {
	                co['theme-' + this.theme] = true;
	            }
	            if (this.layout) {
	                co['layout-' + this.layout] = true;
	            }
	            return co;
	        }
	    },
	    methods: {
	        onOpen: function (event) {
	            this.$emit('popup:open', event);
	        },
	        onOpened: function (event) {
	            this.$emit('popup:opened', event);
	        },
	        onClose: function (event) {
	            this.$emit('popup:close', event);
	        },
	        onClosed: function (event) {
	            this.$emit('popup:closed', event);
	        },
	        onF7Init: function () {
	            var $$ = this.$$;
	            if (!$$) {
	                return;
	            }
	            if ($$('.popup-overlay').length === 0) {
	                $$('<div class="popup-overlay ' + (this.opened ? ' modal-overlay-visible' : '') + '"></div>').insertBefore(this.$el);
	            }
	        },
	        open: function (animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.popup(self.$el, undefined, animated);
	        },
	        close: function (animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.closeModal(self.$el, animated);
	        }
	    }
	};
	exports.VuePopup = popup;
	var preloader = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('span', { staticClass: "preloader", class: (_vm.color ? ('color-' + _vm.color + ' preloader-' + _vm.color) : ''), style: ({ 'width': (_vm.sizeComputed ? _vm.sizeComputed + 'px' : ''), 'height': (_vm.sizeComputed ? _vm.sizeComputed + 'px' : '') }) }, [(_vm.$theme.material) ? _c('span', { staticClass: "preloader-inner" }, [_c('span', { staticClass: "preloader-inner-gap" }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e()]); },
	    staticRenderFns: [function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('span', { staticClass: "preloader-inner-left" }, [_c('span', { staticClass: "preloader-inner-half-circle" })]); }, function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('span', { staticClass: "preloader-inner-right" }, [_c('span', { staticClass: "preloader-inner-half-circle" })]); }],
	    props: {
	        'color': String,
	        'size': [Number, String]
	    },
	    computed: {
	        sizeComputed: function () {
	            var s = this.size;
	            if (s && typeof s === 'string' && s.indexOf('px') >= 0) {
	                s = s.replace('px', '');
	            }
	            return s;
	        }
	    }
	};
	exports.VuePreloader = preloader;
	var progressbar = {
	    render: function (c) {
	        var self = this;
	        var color = self.color;
	        var progress = self.progress;
	        var infinite = self.infinite;
	        return c('span', {
	            staticClass: 'progressbar',
	            class: [(color ? ('color-' + color + ' progressbar-' + color) : ''), (infinite ? 'progressbar-infinite' : '')].join(' ')
	        }, [
	            c('span', {
	                style: {
	                    'transform': progress ? 'translate3d(' + (-100 + progress) + '%,0,0)' : ''
	                }
	            })
	        ]);
	    },
	    props: {
	        'color': String,
	        'progress': Number,
	        'infinite': Boolean
	    },
	    methods: {
	        set: function (progress, speed) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.setProgressbar(self.$el, progress, speed);
	        },
	        show: function (container, progress, color) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.showProgressbar(container, progress, color);
	        }
	    }
	};
	exports.VueProgressbar = progressbar;
	var searchbar = {
	    render: function (c) {
	        var self = this;
	        var clearEl, cancelEl, inputEl, inputWrapEl;
	        inputEl = c('input', {
	            attrs: {
	                'placeholder': self.placeholder,
	                'type': 'search'
	            },
	            on: {
	                input: self.onInput,
	                change: self.onChange,
	                focus: self.onFocus,
	                blur: self.onBlur
	            }
	        });
	        if (self.clearButtonComputed) {
	            clearEl = c('a', {
	                staticClass: 'searchbar-clear',
	                attrs: {
	                    'href': '#'
	                },
	                on: {
	                    click: self.onClearClick
	                }
	            });
	        }
	        if (self.cancelLink) {
	            cancelEl = c('a', {
	                staticClass: 'searchbar-cancel',
	                attrs: {
	                    'href': '#'
	                },
	                domProps: {
	                    innerHTML: self.cancelLink
	                },
	                on: {
	                    click: self.onCancelClick
	                }
	            });
	        }
	        inputWrapEl = c('div', { staticClass: 'searchbar-input' }, [inputEl, clearEl]);
	        return c(self.form ? 'form' : 'div', {
	            staticClass: 'searchbar',
	            on: {
	                'submit': self.onSubmit,
	                'searchbar:search': self.onSearch,
	                'searchbar:enable': self.onEnable,
	                'searchbar:disable': self.onDisable,
	                'searchbar:clear': self.onClear
	            }
	        }, [self.$slots['before-input'], inputWrapEl, self.$slots['after-input'], cancelEl, self.$slots.default]);
	    },
	    beforeDestroy: function () {
	        if (this.f7Searchbar && this.f7Searchbar.destroy) {
	            this.f7Searchbar.destroy();
	        }
	    },
	    props: {
	        form: {
	            type: Boolean,
	            default: true
	        },
	        placeholder: {
	            type: String,
	            default: 'Search'
	        },
	        cancelLink: String,
	        clear: Boolean,
	        clearButton: {
	            type: Boolean,
	            default: true
	        },
	        // SB Params
	        params: Object,
	        searchList: [String, Object],
	        searchIn: {
	            type: String,
	            default: '.item-title'
	        },
	        searchBy: String,
	        found: [String, Object],
	        notFound: [String, Object],
	        overlay: [String, Object],
	        ignore: {
	            type: String,
	            default: '.searchbar-ignore'
	        },
	        customSearch: {
	            type: Boolean,
	            default: false
	        },
	        removeDiacritics: {
	            type: Boolean,
	            default: false
	        },
	        hideDividers: {
	            type: Boolean,
	            default: true
	        },
	        hideGroups: {
	            type: Boolean,
	            default: true
	        },
	        init: {
	            type: Boolean,
	            default: true
	        }
	    },
	    computed: {
	        clearButtonComputed: function () {
	            var self = this;
	            var cb = self.clearButton;
	            if (self.$options.propsData.clear === false) {
	                cb = false;
	            }
	            return cb;
	        }
	    },
	    methods: {
	        search: function (query) {
	            if (!this.f7Searchbar) {
	                return;
	            }
	            return this.f7Searchbar.search(query);
	        },
	        enable: function () {
	            if (!this.f7Searchbar) {
	                return;
	            }
	            return this.f7Searchbar.enable();
	        },
	        disable: function () {
	            if (!this.f7Searchbar) {
	                return;
	            }
	            return this.f7Searchbar.disable();
	        },
	        empty: function () {
	            if (!this.f7Searchbar) {
	                return;
	            }
	            return this.f7Searchbar.clear();
	        },
	        onChange: function (event) {
	            this.$emit('change', event);
	        },
	        onInput: function (event) {
	            this.$emit('input', event.target.value);
	        },
	        onFocus: function (event) {
	            this.$emit('focus', event);
	        },
	        onBlur: function (event) {
	            this.$emit('blur', event);
	        },
	        onSubmit: function (event) {
	            this.$emit('submit', event);
	        },
	        onSearch: function (event) {
	            if (!event.detail) {
	                return;
	            }
	            this.$emit('searchbar:search', event.detail.query, event.detail.foundItems);
	        },
	        onClear: function (event) {
	            this.$emit('searchbar:clear', event);
	        },
	        onEnable: function (event) {
	            this.$emit('searchbar:enable', event);
	        },
	        onDisable: function (event) {
	            this.$emit('searchbar:disable', event);
	        },
	        onClearClick: function (event) {
	            this.$emit('click:clear', event);
	        },
	        onCancelClick: function (event) {
	            this.$emit('click:cancel', event);
	        },
	        onF7Init: function () {
	            var self = this;
	            if (!self.init) {
	                return;
	            }
	            self.f7Searchbar = self.$f7.searchbar(self.$el, self.params || {
	                searchList: self.searchList,
	                searchIn: self.searchIn,
	                searchBy: self.searchBy,
	                found: self.found,
	                notFound: self.notFound,
	                overlay: self.overlay,
	                ignore: self.ignore,
	                customSearch: self.customSearch,
	                removeDiacritics: self.removeDiacritics,
	                hideDividers: self.hideDividers,
	                hideGroups: self.hideGroups
	            });
	        }
	    }
	};
	exports.VueSearchbar = searchbar;
	var statusbar = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "statusbar-overlay" }); },
	    staticRenderFns: [],
	};
	exports.VueStatusbar = statusbar;
	var subnavbar = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "subnavbar", class: _vm.sliding ? 'sliding' : false }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        sliding: Boolean
	    }
	};
	exports.VueSubnavbar = subnavbar;
	var swiperSlide = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "swiper-slide" }, [(_vm.zoom) ? _c('div', { staticClass: "swiper-zoom-container" }, [_vm._t("default")], 2) : _vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'zoom': Boolean
	    }
	};
	exports.VueSwiperSlide = swiperSlide;
	var swiper = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "swiper-container" }, [_c('div', { staticClass: "swiper-wrapper" }, [_vm._t("default")], 2), _vm._v(" "), (_vm.paginationComputed === true) ? _c('div', { staticClass: "swiper-pagination" }) : _vm._e(), _vm._v(" "), (_vm.scrollbarComputed === true) ? _c('div', { staticClass: "swiper-scrollbar" }) : _vm._e(), _vm._v(" "), (_vm.nextButtonComputed === true) ? _c('div', { staticClass: "swiper-button-next" }) : _vm._e(), _vm._v(" "), (_vm.prevButtonComputed === true) ? _c('div', { staticClass: "swiper-button-prev" }) : _vm._e()]); },
	    staticRenderFns: [],
	    beforeDestroy: function () {
	        var self = this;
	        if (!self.init) {
	            return;
	        }
	        if (self.swiper && self.swiper.destroy) {
	            self.swiper.destroy();
	        }
	    },
	    props: {
	        'params': Object,
	        'pagination': [Boolean, String, Object],
	        'scrollbar': [Boolean, String, Object],
	        'next-button': [Boolean, String, Object],
	        'prev-button': [Boolean, String, Object],
	        init: {
	            type: Boolean,
	            default: true
	        }
	    },
	    computed: {
	        paramsComputed: function () {
	            return this.params || {};
	        },
	        paginationComputed: function () {
	            var self = this;
	            if (self.pagination === true || self.pagination === '') {
	                self.paramsComputed.pagination = '.swiper-pagination';
	                return true;
	            }
	            else if (typeof self.pagination === 'object' || typeof self.pagination === 'string') {
	                self.paramsComputed.pagination = self.pagination;
	                return true;
	            }
	            return false;
	        },
	        scrollbarComputed: function () {
	            var self = this;
	            if (self.scrollbar || self.scrollbar === '') {
	                self.paramsComputed.scrollbar = '.swiper-scrollbar';
	                return true;
	            }
	            else if (typeof self.scrollbar === 'object' || typeof self.scrollbar === 'string') {
	                self.paramsComputed.scrollbar = self.scrollbar;
	                return true;
	            }
	            return false;
	        },
	        nextButtonComputed: function () {
	            var self = this;
	            if (self.nextButton || self.nextButton === '') {
	                self.paramsComputed.nextButton = '.swiper-button-next';
	                return true;
	            }
	            else if (typeof self.nextButton === 'object' || typeof self.nextButton === 'string') {
	                self.paramsComputed.nextButton = self.nextButton;
	                return true;
	            }
	            return false;
	        },
	        prevButtonComputed: function () {
	            var self = this;
	            if (self.prevButton || self.prevButton === '') {
	                self.paramsComputed.prevButton = '.swiper-button-prev';
	                return true;
	            }
	            else if (typeof self.prevButton === 'object' || typeof self.prevButton === 'string') {
	                self.paramsComputed.prevButton = self.prevButton;
	                return true;
	            }
	            return false;
	        }
	    },
	    methods: {
	        onF7Init: function () {
	            if (!this.init) {
	                return;
	            }
	            this.swiper = new window.Swiper(this.$el, this.paramsComputed);
	        }
	    }
	};
	exports.VueSwiper = swiper;
	var tab = {
	    props: {
	        'active': Boolean,
	        'routeTabId': String
	    },
	    data: function () {
	        return {
	            routeInfo: {
	                activeTab: this.$route && this.$route.route.tab
	            }
	        };
	    },
	    render: function (c) {
	        var self = this;
	        var activeTab = self.routeInfo.activeTab;
	        return c('div', {
	            staticClass: 'tab',
	            class: {
	                'active': (activeTab) ? activeTab.tabId === self.routeTabId : self.active
	            },
	            on: {
	                'tab:show': self.onTabShow,
	                'tab:hide': self.onTabHide
	            }
	        }, [activeTab && activeTab.tabId === self.routeTabId ? c(activeTab.component, { tag: 'component', props: self.$route.params }) : self.$slots.default]);
	    },
	    methods: {
	        show: function (animated) {
	            if (!this.$f7) {
	                return;
	            }
	            this.$f7.showTab(this.$el, animated);
	        },
	        onTabShow: function (e) {
	            this.$emit('tab:show', e);
	        },
	        onTabHide: function (e) {
	            this.$emit('tab:hide', e);
	        },
	        onRouteChange: function (e) {
	            if (e.route.tab) {
	                var currentlyActiveTabId = this.routeInfo.activeTab && this.routeInfo.activeTab.tabId;
	                var nextActiveTabId = e.route.tab.tabId;
	                var thisTabId = this.routeTabId;
	                if (thisTabId === currentlyActiveTabId && nextActiveTabId !== thisTabId) {
	                    this.$$(this.$el).trigger('tab:hide');
	                }
	                else if (thisTabId !== currentlyActiveTabId && nextActiveTabId === thisTabId) {
	                    this.$$(this.$el).trigger('tab:show');
	                }
	                this.$set(this.routeInfo, 'activeTab', e.route.tab);
	            }
	        }
	    }
	};
	exports.VueTab = tab;
	var tabs = {
	    render: function (c) {
	        var self = this;
	        var tabs = c('div', { staticClass: 'tabs' }, [self.$slots.default]);
	        if (self.animated || self.swipeable) {
	            return c('div', { class: self.classesObject }, [tabs]);
	        }
	        else {
	            return tabs;
	        }
	    },
	    props: {
	        'animated': Boolean,
	        'swipeable': Boolean
	    },
	    computed: {
	        classesObject: function () {
	            return {
	                'tabs-animated-wrap': this.animated,
	                'tabs-swipeable-wrap': this.swipeable,
	            };
	        },
	    }
	};
	exports.VueTabs = tabs;
	var template7Template = {
	    render: function (c) {
	        return c('script', { attrs: { type: 'text/template7' } }, this.$slots.default);
	    }
	};
	exports.VueTemplate7Template = template7Template;
	var timelineItemChild = {
	    render: function (c) {
	        var self = this;
	        var timeEl, titleEl, subtitleEl, textEl;
	        if (self.time) {
	            timeEl = c('div', { staticClass: 'timeline-item-time', domProps: { innerHTML: self.time } });
	        }
	        if (self.title) {
	            titleEl = c('div', { staticClass: 'timeline-item-title', domProps: { innerHTML: self.title } });
	        }
	        if (self.subtitle) {
	            subtitleEl = c('div', { staticClass: 'timeline-item-subtitle', domProps: { innerHTML: self.subtitle } });
	        }
	        if (self.text) {
	            textEl = c('div', { staticClass: 'timeline-item-text', domProps: { innerHTML: self.text } });
	        }
	        if (self.content) {
	            return c('div', {
	                class: {
	                    'timeline-item-inner': self.inner,
	                    'timeline-item-child': !self.inner
	                },
	                domProps: {
	                    innerHTML: self.content
	                }
	            });
	        }
	        else {
	            return c('div', {
	                class: {
	                    'timeline-item-inner': self.inner,
	                    'timeline-item-child': !self.inner
	                }
	            }, [timeEl, titleEl, subtitleEl, textEl, self.$slots.default]);
	        }
	    },
	    props: {
	        inner: Boolean,
	        content: String,
	        time: String,
	        title: String,
	        subtitle: String,
	        text: String
	    }
	};
	exports.VueTimelineItemChild = timelineItemChild;
	var timelineItem = {
	    render: function (c) {
	        var self = this;
	        var timeEl, titleEl, subtitleEl, textEl, dateEl, dividerEl, contentEl, innerEl;
	        if (self.day || self.month) {
	            dateEl = c('div', { staticClass: 'timeline-item-date', domProps: { innerHTML: [self.day, '<small>' + self.month + '</small>'].join(' ') } });
	        }
	        else {
	            dateEl = c('div', { staticClass: 'timeline-item-date', domProps: { innerHTML: self.date } });
	        }
	        dividerEl = c('div', { staticClass: 'timeline-item-divider' });
	        if (self.time) {
	            timeEl = c('div', { staticClass: 'timeline-item-time', domProps: { innerHTML: self.time } });
	        }
	        if (self.title) {
	            titleEl = c('div', { staticClass: 'timeline-item-title', domProps: { innerHTML: self.title } });
	        }
	        if (self.subtitle) {
	            subtitleEl = c('div', { staticClass: 'timeline-item-subtitle', domProps: { innerHTML: self.subtitle } });
	        }
	        if (self.text) {
	            textEl = c('div', { staticClass: 'timeline-item-text', domProps: { innerHTML: self.text } });
	        }
	        if (self.inner) {
	            if (self.content) {
	                innerEl = c('div', { staticClass: 'timeline-item-inner', domProps: { innerHTML: self.content } });
	            }
	            else {
	                innerEl = c('div', { staticClass: 'timeline-item-inner' }, [timeEl, titleEl, subtitleEl, textEl, self.$slots.default]);
	            }
	        }
	        else {
	            innerEl = [timeEl, titleEl, subtitleEl, textEl, self.$slots.default];
	        }
	        if (self.content && !self.inner) {
	            contentEl = c('div', { staticClass: 'timeline-item-content', domProps: { innerHTML: self.content } });
	        }
	        else {
	            contentEl = c('div', { staticClass: 'timeline-item-content' }, [innerEl]);
	        }
	        return c('div', {
	            staticClass: 'timeline-item',
	            class: {
	                'timeline-item-left': self.side === 'left',
	                'timeline-item-right': self.side === 'right'
	            }
	        }, [dateEl, dividerEl, contentEl]);
	    },
	    props: {
	        date: [String, Number, Date],
	        day: [String, Number],
	        month: [String, Number],
	        inner: Boolean,
	        content: String,
	        side: String,
	        time: String,
	        title: String,
	        subtitle: String,
	        text: String
	    }
	};
	exports.VueTimelineItem = timelineItem;
	var timelineMonth = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "timeline-month" }, [(_vm.month || _vm.title) ? _c('div', { staticClass: "timeline-month-title" }, [_c('span', { domProps: { "innerHTML": _vm._s(_vm.month || _vm.title) } })]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        month: [Number, String],
	        title: [Number, String]
	    }
	};
	exports.VueTimelineMonth = timelineMonth;
	var timelineYear = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "timeline-year" }, [(_vm.year || _vm.title) ? _c('div', { staticClass: "timeline-year-title" }, [_c('span', { domProps: { "innerHTML": _vm._s(_vm.year || _vm.title) } })]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        year: [Number, String],
	        title: [Number, String]
	    }
	};
	exports.VueTimelineYear = timelineYear;
	var timeline = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "timeline", class: _vm.classesObject }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'sides': Boolean,
	        'tablet-sides': Boolean,
	        'col': [Number, String],
	        'tablet-col': [Number, String],
	        'horizontal': Boolean
	    },
	    computed: {
	        classesObject: function () {
	            var co = {};
	            var self = this;
	            if (self.sides) {
	                co['timeline-sides'] = true;
	            }
	            if (self.tabletSides) {
	                co['tablet-sides'] = true;
	            }
	            if (self.horizontal) {
	                co['timeline-horizontal'] = true;
	            }
	            if (self.col) {
	                co['col-' + self.col] = true;
	            }
	            if (self.tabletCol) {
	                co['tablet-' + self.tabletCol] = true;
	            }
	            return co;
	        }
	    }
	};
	exports.VueTimeline = timeline;
	var toolbar = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "toolbar", class: _vm.classesObject }, [_vm._t("before-inner"), _vm._v(" "), _c('div', { staticClass: "toolbar-inner" }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("after-inner")], 2); },
	    staticRenderFns: [],
	    props: {
	        bottom: Boolean,
	        tabbar: Boolean,
	        labels: Boolean,
	        scrollable: Boolean,
	        theme: String,
	        layout: String,
	        hidden: Boolean
	    },
	    computed: {
	        classesObject: function () {
	            var co = {
	                'toolbar-bottom': this.bottom,
	                'tabbar': this.tabbar,
	                'tabbar-labels': this.labels,
	                'tabbar-scrollable': this.scrollable,
	                'toolbar-hidden': this.hidden
	            };
	            if (this.theme) {
	                co['theme-' + this.theme] = true;
	            }
	            if (this.layout) {
	                co['layout-' + this.layout] = true;
	            }
	            return co;
	        }
	    },
	    methods: {
	        hide: function (animated) {
	            if (!this.$f7) {
	                return;
	            }
	            return this.$f7.hideToolbar(this.$el, animated);
	        },
	        show: function (animated) {
	            if (!this.$f7) {
	                return;
	            }
	            return this.$f7.showToolbar(this.$el, animated);
	        }
	    }
	};
	exports.VueToolbar = toolbar;
	var view = {
	    render: function (c) {
	        var hasNavbar, hasPages, pagesEl, navbarEl, self = this;
	        if (self.$slots.default) {
	            for (var i = 0; i < self.$slots.default.length; i++) {
	                var child = self.$slots.default[i];
	                if (child.tag && child.tag.indexOf('navbar') >= 0) {
	                    hasNavbar = true;
	                }
	                if (child.tag && child.tag.indexOf('pages') >= 0) {
	                    hasPages = true;
	                }
	            }
	        }
	        if (!hasPages) {
	            pagesEl = c('f7-pages');
	        }
	        if (!hasNavbar && self.$theme.ios && (self.dynamicNavbar || self.navbarThrough)) {
	            navbarEl = c('f7-navbar');
	        }
	        return c('div', {
	            class: self.classesObject,
	            on: {
	                'swipeback:move': self.onSwipeBackMove,
	                'swipeback:beforechange': self.onSwipeBackBeforeChange,
	                'swipeback:afterchange': self.onSwipeBackAfterChange,
	                'swipeback:beforereset': self.onSwipeBackBeforeReset,
	                'swipeback:afterreset': self.onSwipeBackAfterReset,
	                'tab:show': self.onTabShow,
	                'tab:hide': self.onTabHide
	            }
	        }, [navbarEl, pagesEl, self.$slots.default]);
	    },
	    beforeDestroy: function () {
	        var self = this;
	        if (self.f7View && self.f7View.destroy) {
	            self.f7View.destroy();
	        }
	    },
	    props: {
	        'main': Boolean,
	        'navbar-fixed': Boolean,
	        'navbar-through': Boolean,
	        'toolbar-fixed': Boolean,
	        'toolbar-through': Boolean,
	        'tabbar-fixed': Boolean,
	        'tabbar-through': Boolean,
	        'tabbar-labels-fixed': Boolean,
	        'tabbar-labels-through': Boolean,
	        'tab': Boolean,
	        'active': Boolean,
	        'dynamic-navbar': Boolean,
	        'dom-cache': Boolean,
	        'links-view': [String, Object],
	        'reload-pages': Boolean,
	        'unique-history': Boolean,
	        'unique-history-ignore-get-parameters': Boolean,
	        'allow-duplicate-urls': Boolean,
	        'swipe-back-page': Boolean,
	        'swipe-back-page-animate-shadow': Boolean,
	        'swipe-back-page-animate-opacity': Boolean,
	        'swipe-back-page-active-area': Boolean,
	        'swipe-back-page-threshold': Boolean,
	        'animate-pages': Boolean,
	        'preload-previous-page': Boolean,
	        'name': String,
	        'params': Object,
	        'url': String,
	        'init': {
	            type: Boolean,
	            default: true
	        },
	        'theme': String,
	        'layout': String
	    },
	    computed: {
	        classesObject: function () {
	            var co = {
	                'view': true,
	                'view-main': this.main,
	                'active': this.active,
	                'tab': this.tab,
	                'navbar-fixed': this.navbarFixed || this.navbarThrough && this.$theme.material,
	                'navbar-through': this.navbarThrough,
	                'toolbar-fixed': this.toolbarFixed,
	                'toolbar-through': this.toolbarThrough,
	                'tabbar-fixed': this.tabbarFixed,
	                'tabbar-through': this.tabbarThrough,
	                'tabbar-labels-fixed': this.tabbarLabelsFixed,
	                'tabbar-labels-through': this.tabbarLabesThrough,
	            };
	            if (this.theme) {
	                co['theme-' + this.theme] = true;
	            }
	            if (this.layout) {
	                co['layout-' + this.layout] = true;
	            }
	            return co;
	        },
	    },
	    methods: {
	        onF7Init: function (f7) {
	            var self = this;
	            if (!self.init) {
	                return;
	            }
	            var propsData = self.$options.propsData;
	            var params = self.params || {
	                name: self.name,
	                url: self.url,
	                dynamicNavbar: propsData.dynamicNavbar,
	                domCache: typeof propsData.domCache === 'undefined' ? true : propsData.domCache,
	                linksView: propsData.linksView,
	                reloadPages: propsData.reloadPages,
	                uniqueHistory: propsData.uniqueHistory,
	                uniqueHistoryIgnoreGetParameters: propsData.uniqueHistoryIgnoreGetParameters,
	                allowDuplicateUrls: propsData.allowDuplicateUrls,
	                swipeBackPage: propsData.swipeBackPage,
	                swipeBackPageAnimateShadow: propsData.swipeBackPageAnimateShadow,
	                swipeBackPageAnimateOpacity: propsData.swipeBackPageAnimateOpacity,
	                swipeBackPageActiveArea: propsData.swipeBackPageActiveArea,
	                swipeBackPageThreshold: propsData.swipeBackPageThreshold,
	                animatePages: propsData.animatePages,
	                preloadPreviousPage: propsData.preloadPreviousPage,
	            };
	            self.f7View = f7.addView(self.$el, params);
	            if (self.f7View && self.f7View.pagesContainer.querySelectorAll('.page').length === 0) {
	                self.f7View.router.load({ url: self.url, reload: true });
	            }
	        },
	        onSwipeBackMove: function (event) {
	            this.$emit('swipeback:move', event, event.detail);
	        },
	        onSwipeBackBeforeChange: function (event) {
	            this.$emit('swipeback:beforechange', event, event.detail);
	        },
	        onSwipeBackAfterChange: function (event) {
	            this.$emit('swipeback:afterchange', event, event.detail);
	        },
	        onSwipeBackBeforeReset: function (event) {
	            this.$emit('swipeback:beforereset', event, event.detail);
	        },
	        onSwipeBackAfterReset: function (event) {
	            this.$emit('swipeback:afterreset', event, event.detail);
	        },
	        onTabShow: function (e) {
	            this.$emit('tab:show', e);
	        },
	        onTabHide: function (e) {
	            this.$emit('tab:hide', e);
	        }
	    }
	};
	exports.VueView = view;
	var views = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "views", class: _vm.classObject }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'navbar-fixed': Boolean,
	        'navbar-through': Boolean,
	        'toolbar-fixed': Boolean,
	        'toolbar-through': Boolean,
	        'tabbar-fixed': Boolean,
	        'tabbar-through': Boolean,
	        'tabbar-labels-fixed': Boolean,
	        'tabbar-labels-through': Boolean,
	        'tabs': Boolean,
	        'theme': String,
	        'layout': String
	    },
	    computed: {
	        classObject: function () {
	            var co = {
	                'tabs': this.tabs,
	                'navbar-fixed': this.navbarFixed || this.navbarThrough && this.$theme.material,
	                'navbar-through': this.navbarThrough,
	                'toolbar-fixed': this.toolbarFixed,
	                'toolbar-through': this.toolbarThrough,
	                'tabbar-fixed': this.tabbarFixed,
	                'tabbar-through': this.tabbarThrough,
	                'tabbar-labels-fixed': this.tabbarLabelsFixed,
	                'tabbar-labels-through': this.tabbarLabelsThrough
	            };
	            if (this.theme) {
	                co['theme-' + this.theme] = true;
	            }
	            if (this.layout) {
	                co['layout-' + this.layout] = true;
	            }
	            return co;
	        }
	    }
	};
	exports.VueViews = views;
	//# sourceMappingURL=framework7-vue.js.map
	
	//# sourceMappingURL=framework7-vue.js.map


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var React = __webpack_require__(6);
	var change_case_1 = __webpack_require__(41);
	var ReactifyVue_1 = __webpack_require__(233);
	var Framework7_1 = __webpack_require__(34);
	var Framework7_2 = __webpack_require__(34);
	var nextComponentId = 0;
	exports.reactifyF7Vue = function (args) {
	    var innerComponent = ReactifyVue_1.reactifyVue({
	        component: args.component,
	        tag: args.tag,
	        slots: !args.slots ? null : args.slots.reduce(function (slotMap, currentSlotName) {
	            return __assign({}, slotMap, (_a = {}, _a[currentSlotName] = change_case_1.camelCase(currentSlotName) + 'Slot', _a));
	            var _a;
	        }, {}),
	        events: !args.events ? null : args.events.reduce(function (eventMap, currentEventName) {
	            return __assign({}, eventMap, (_a = {}, _a[currentEventName] = change_case_1.camelCase('on-' + currentEventName.split(':').join('-')), _a));
	            var _a;
	        }, {}),
	        instantiatedComponents: args.instantiatedComponents,
	        args: __assign({}, args.args, { $$: Framework7_1.Dom7, $t7: Framework7_2.Template7 }),
	        mixin: args.mixin
	    });
	    var reactClass = React.createClass({
	        getInitialState: function () {
	            var _this = this;
	            var framework7AppContext = this.context.framework7AppContext;
	            framework7AppContext.getFramework7(function (f7) {
	                _this.framework7 = f7;
	            });
	            Object.defineProperty(args.component, '$router', {
	                get: framework7AppContext.getRouter,
	                enumerable: true,
	                configurable: true
	            });
	            Object.defineProperty(args.component, '$route', {
	                get: framework7AppContext.getCurrentRoute,
	                enumerable: true,
	                configurable: true
	            });
	            Object.defineProperty(args.component, '$f7', {
	                get: function () { return _this.framework7; },
	                enumerable: true,
	                configurable: true
	            });
	            this.componentId = nextComponentId++;
	            return null;
	        },
	        componentWillUnmount: function () {
	            var framework7AppContext = this.context.framework7AppContext;
	            framework7AppContext.unregisterRouteChange(this.componentId);
	        },
	        render: function () {
	            var _this = this;
	            var props = this.props;
	            var framework7AppContext = this.context.framework7AppContext;
	            var innerEl = React.createElement(innerComponent, __assign({}, props, { $theme: framework7AppContext.theme, __onMount: function (self) {
	                    framework7AppContext.getFramework7(function (f7) {
	                        if (self.vueComponent.onF7Init) {
	                            self.vueComponent.onF7Init(f7);
	                        }
	                    });
	                    framework7AppContext.onRouteChange(_this.componentId, function (route) {
	                        if (self.vueComponent.onRouteChange) {
	                            self.vueComponent.onRouteChange(route);
	                        }
	                    });
	                } }));
	            return innerEl;
	        }
	    });
	    reactClass.tag = args.tag;
	    reactClass.vueComponent = args.component;
	    reactClass.contextTypes = {
	        framework7AppContext: React.PropTypes.object
	    };
	    return reactClass;
	};
	
	//# sourceMappingURL=ReactifyF7Vue.js.map


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(12);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;

/***/ },
/* 5 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(23);


/***/ },
/* 7 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var DOMProperty = __webpack_require__(21);
	var ReactDOMComponentFlags = __webpack_require__(94);
	
	var invariant = __webpack_require__(3);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 9 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(69);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Framework7App_1 = __webpack_require__(230);
	exports.Framework7App = Framework7App_1.Framework7App;
	var Framework7_1 = __webpack_require__(34);
	exports.Framework7 = Framework7_1.Framework7;
	var AccordionContent_1 = __webpack_require__(170);
	exports.AccordionContent = AccordionContent_1.AccordionContent;
	var AccordionItem_1 = __webpack_require__(171);
	exports.AccordionItem = AccordionItem_1.AccordionItem;
	var AccordionToggle_1 = __webpack_require__(172);
	exports.AccordionToggle = AccordionToggle_1.AccordionToggle;
	var Accordion_1 = __webpack_require__(169);
	exports.Accordion = Accordion_1.Accordion;
	var ActionsButton_1 = __webpack_require__(174);
	exports.ActionsButton = ActionsButton_1.ActionsButton;
	var ActionsGroup_1 = __webpack_require__(175);
	exports.ActionsGroup = ActionsGroup_1.ActionsGroup;
	var ActionsLabel_1 = __webpack_require__(176);
	exports.ActionsLabel = ActionsLabel_1.ActionsLabel;
	var Actions_1 = __webpack_require__(173);
	exports.Actions = Actions_1.Actions;
	var Badge_1 = __webpack_require__(42);
	exports.Badge = Badge_1.Badge;
	var Button_1 = __webpack_require__(177);
	exports.Button = Button_1.Button;
	var ButtonsSegmented_1 = __webpack_require__(178);
	exports.ButtonsSegmented = ButtonsSegmented_1.ButtonsSegmented;
	var CardContent_1 = __webpack_require__(74);
	exports.CardContent = CardContent_1.CardContent;
	var CardFooter_1 = __webpack_require__(75);
	exports.CardFooter = CardFooter_1.CardFooter;
	var CardHeader_1 = __webpack_require__(76);
	exports.CardHeader = CardHeader_1.CardHeader;
	var Card_1 = __webpack_require__(179);
	exports.Card = Card_1.Card;
	var Chip_1 = __webpack_require__(180);
	exports.Chip = Chip_1.Chip;
	var ContentBlockTitle_1 = __webpack_require__(182);
	exports.ContentBlockTitle = ContentBlockTitle_1.ContentBlockTitle;
	var ContentBlock_1 = __webpack_require__(181);
	exports.ContentBlock = ContentBlock_1.ContentBlock;
	var FabSpeedDialAction_1 = __webpack_require__(185);
	exports.FabSpeedDialAction = FabSpeedDialAction_1.FabSpeedDialAction;
	var FabSpeedDialActions_1 = __webpack_require__(186);
	exports.FabSpeedDialActions = FabSpeedDialActions_1.FabSpeedDialActions;
	var FabSpeedDial_1 = __webpack_require__(184);
	exports.FabSpeedDial = FabSpeedDial_1.FabSpeedDial;
	var Fab_1 = __webpack_require__(183);
	exports.Fab = Fab_1.Fab;
	var FormInput_1 = __webpack_require__(187);
	exports.FormInput = FormInput_1.FormInput;
	var FormLabel_1 = __webpack_require__(188);
	exports.FormLabel = FormLabel_1.FormLabel;
	var FormRange_1 = __webpack_require__(77);
	exports.FormRange = FormRange_1.FormRange;
	var FormSwitch_1 = __webpack_require__(78);
	exports.FormSwitch = FormSwitch_1.FormSwitch;
	var GridCol_1 = __webpack_require__(189);
	exports.GridCol = GridCol_1.GridCol;
	var GridRow_1 = __webpack_require__(190);
	exports.GridRow = GridRow_1.GridRow;
	var Icon_1 = __webpack_require__(43);
	exports.Icon = Icon_1.Icon;
	var Link_1 = __webpack_require__(44);
	exports.Link = Link_1.Link;
	var ListButton_1 = __webpack_require__(192);
	exports.ListButton = ListButton_1.ListButton;
	var ListGroup_1 = __webpack_require__(193);
	exports.ListGroup = ListGroup_1.ListGroup;
	var ListItemContent_1 = __webpack_require__(79);
	exports.ListItemContent = ListItemContent_1.ListItemContent;
	var ListItemSwipeoutActions_1 = __webpack_require__(195);
	exports.ListItemSwipeoutActions = ListItemSwipeoutActions_1.ListItemSwipeoutActions;
	var ListItemSwipeoutButton_1 = __webpack_require__(196);
	exports.ListItemSwipeoutButton = ListItemSwipeoutButton_1.ListItemSwipeoutButton;
	var ListItem_1 = __webpack_require__(194);
	exports.ListItem = ListItem_1.ListItem;
	var ListLabel_1 = __webpack_require__(197);
	exports.ListLabel = ListLabel_1.ListLabel;
	var List_1 = __webpack_require__(191);
	exports.List = List_1.List;
	var LoginScreenTitle_1 = __webpack_require__(199);
	exports.LoginScreenTitle = LoginScreenTitle_1.LoginScreenTitle;
	var LoginScreen_1 = __webpack_require__(198);
	exports.LoginScreen = LoginScreen_1.LoginScreen;
	var Message_1 = __webpack_require__(200);
	exports.Message = Message_1.Message;
	var Messagebar_1 = __webpack_require__(201);
	exports.Messagebar = Messagebar_1.Messagebar;
	var Messages_1 = __webpack_require__(202);
	exports.Messages = Messages_1.Messages;
	var NavCenter_1 = __webpack_require__(80);
	exports.NavCenter = NavCenter_1.NavCenter;
	var NavLeft_1 = __webpack_require__(81);
	exports.NavLeft = NavLeft_1.NavLeft;
	var NavRight_1 = __webpack_require__(203);
	exports.NavRight = NavRight_1.NavRight;
	var Navbar_1 = __webpack_require__(82);
	exports.Navbar = Navbar_1.Navbar;
	var PageContent_1 = __webpack_require__(205);
	exports.PageContent = PageContent_1.PageContent;
	var Page_1 = __webpack_require__(204);
	exports.Page = Page_1.Page;
	var Pages_1 = __webpack_require__(83);
	exports.Pages = Pages_1.Pages;
	var Panel_1 = __webpack_require__(206);
	exports.Panel = Panel_1.Panel;
	var PhotoBrowser_1 = __webpack_require__(207);
	exports.PhotoBrowser = PhotoBrowser_1.PhotoBrowser;
	var PickerModal_1 = __webpack_require__(208);
	exports.PickerModal = PickerModal_1.PickerModal;
	var Popover_1 = __webpack_require__(209);
	exports.Popover = Popover_1.Popover;
	var Popup_1 = __webpack_require__(210);
	exports.Popup = Popup_1.Popup;
	var Preloader_1 = __webpack_require__(211);
	exports.Preloader = Preloader_1.Preloader;
	var Progressbar_1 = __webpack_require__(212);
	exports.Progressbar = Progressbar_1.Progressbar;
	var Searchbar_1 = __webpack_require__(213);
	exports.Searchbar = Searchbar_1.Searchbar;
	var Statusbar_1 = __webpack_require__(214);
	exports.Statusbar = Statusbar_1.Statusbar;
	var Subnavbar_1 = __webpack_require__(215);
	exports.Subnavbar = Subnavbar_1.Subnavbar;
	var SwiperSlide_1 = __webpack_require__(217);
	exports.SwiperSlide = SwiperSlide_1.SwiperSlide;
	var Swiper_1 = __webpack_require__(216);
	exports.Swiper = Swiper_1.Swiper;
	var Tab_1 = __webpack_require__(218);
	exports.Tab = Tab_1.Tab;
	var Tabs_1 = __webpack_require__(219);
	exports.Tabs = Tabs_1.Tabs;
	var Template7Template_1 = __webpack_require__(220);
	exports.Template7Template = Template7Template_1.Template7Template;
	var TimelineItemChild_1 = __webpack_require__(223);
	exports.TimelineItemChild = TimelineItemChild_1.TimelineItemChild;
	var TimelineItem_1 = __webpack_require__(222);
	exports.TimelineItem = TimelineItem_1.TimelineItem;
	var TimelineMonth_1 = __webpack_require__(224);
	exports.TimelineMonth = TimelineMonth_1.TimelineMonth;
	var TimelineYear_1 = __webpack_require__(225);
	exports.TimelineYear = TimelineYear_1.TimelineYear;
	var Timeline_1 = __webpack_require__(221);
	exports.Timeline = Timeline_1.Timeline;
	var Toolbar_1 = __webpack_require__(226);
	exports.Toolbar = Toolbar_1.Toolbar;
	var View_1 = __webpack_require__(227);
	exports.View = View_1.View;
	var Views_1 = __webpack_require__(228);
	exports.Views = Views_1.Views;
	
	//# sourceMappingURL=index.js.map


/***/ },
/* 12 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(7);
	
	var CallbackQueue = __webpack_require__(92);
	var PooledClass = __webpack_require__(19);
	var ReactFeatureFlags = __webpack_require__(97);
	var ReactReconciler = __webpack_require__(22);
	var Transaction = __webpack_require__(37);
	
	var invariant = __webpack_require__(3);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var lowerCase = __webpack_require__(29)
	
	var NON_WORD_REGEXP = __webpack_require__(261)
	var CAMEL_CASE_REGEXP = __webpack_require__(259)
	var CAMEL_CASE_UPPER_REGEXP = __webpack_require__(260)
	
	/**
	 * Sentence case a string.
	 *
	 * @param  {string} str
	 * @param  {string} locale
	 * @param  {string} replacement
	 * @return {string}
	 */
	module.exports = function (str, locale, replacement) {
	  if (str == null) {
	    return ''
	  }
	
	  replacement = typeof replacement !== 'string' ? ' ' : replacement
	
	  function replace (match, index, value) {
	    if (index === 0 || index === (value.length - match.length)) {
	      return ''
	    }
	
	    return replacement
	  }
	
	  str = String(str)
	    // Support camel case ("camelCase" -> "camel Case").
	    .replace(CAMEL_CASE_REGEXP, '$1 $2')
	    // Support odd camel case ("CAMELCase" -> "CAMEL Case").
	    .replace(CAMEL_CASE_UPPER_REGEXP, '$1 $2')
	    // Remove all non-word characters and replace with a single space.
	    .replace(NON_WORD_REGEXP, replace)
	
	  // Lower case the entire string.
	  return lowerCase(str, locale)
	}


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(19);
	
	var emptyFunction = __webpack_require__(12);
	var warning = __webpack_require__(4);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 17 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 18 */
/***/ function(module, exports) {

	/**
	 * Special language-specific overrides.
	 *
	 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
	 *
	 * @type {Object}
	 */
	var LANGUAGES = {
	  tr: {
	    regexp: /[\u0069]/g,
	    map: {
	      '\u0069': '\u0130'
	    }
	  },
	  az: {
	    regexp: /[\u0069]/g,
	    map: {
	      '\u0069': '\u0130'
	    }
	  },
	  lt: {
	    regexp: /[\u0069\u006A\u012F]\u0307|\u0069\u0307[\u0300\u0301\u0303]/g,
	    map: {
	      '\u0069\u0307': '\u0049',
	      '\u006A\u0307': '\u004A',
	      '\u012F\u0307': '\u012E',
	      '\u0069\u0307\u0300': '\u00CC',
	      '\u0069\u0307\u0301': '\u00CD',
	      '\u0069\u0307\u0303': '\u0128'
	    }
	  }
	}
	
	/**
	 * Upper case a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  var lang = LANGUAGES[locale]
	
	  str = str == null ? '' : String(str)
	
	  if (lang) {
	    str = str.replace(lang.regexp, function (m) { return lang.map[m] })
	  }
	
	  return str.toUpperCase()
	}


/***/ },
/* 19 */
[348, 5],
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(47);
	var setInnerHTML = __webpack_require__(39);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(55);
	var setTextContent = __webpack_require__(109);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(3);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(303);
	var ReactInstrumentation = __webpack_require__(13);
	
	var warning = __webpack_require__(4);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactChildren = __webpack_require__(335);
	var ReactComponent = __webpack_require__(62);
	var ReactPureComponent = __webpack_require__(340);
	var ReactClass = __webpack_require__(336);
	var ReactDOMFactories = __webpack_require__(337);
	var ReactElement = __webpack_require__(24);
	var ReactPropTypes = __webpack_require__(338);
	var ReactVersion = __webpack_require__(341);
	
	var onlyChild = __webpack_require__(342);
	var warning = __webpack_require__(4);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactCurrentOwner = __webpack_require__(17);
	
	var warning = __webpack_require__(4);
	var canDefineProperty = __webpack_require__(114);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(112);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 25 */
5,
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.App = exports.getFramework7 = undefined;
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _framework7React = __webpack_require__(11);
	
	var _MainViews = __webpack_require__(139);
	
	var _MainViews2 = _interopRequireDefault(_MainViews);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var framework7 = void 0;
	var getFramework7 = exports.getFramework7 = function getFramework7() {
		return framework7;
	};
	
	/// Sets up Framework7 and creates the main views.
	///
	/// Change themeType to "material" to use the Material theme.
	var App = exports.App = function App() {
		return _react2.default.createElement(
			_framework7React.Framework7App,
			{ themeType: 'ios', swipeBackPage: false, routes: [], onFramework7Init: function onFramework7Init(f7) {
					framework7 = f7;
				} },
			_react2.default.createElement(_MainViews2.default, null)
		);
	};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 28 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 29 */
/***/ function(module, exports) {

	/**
	 * Special language-specific overrides.
	 *
	 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
	 *
	 * @type {Object}
	 */
	var LANGUAGES = {
	  tr: {
	    regexp: /\u0130|\u0049|\u0049\u0307/g,
	    map: {
	      '\u0130': '\u0069',
	      '\u0049': '\u0131',
	      '\u0049\u0307': '\u0069'
	    }
	  },
	  az: {
	    regexp: /[\u0130]/g,
	    map: {
	      '\u0130': '\u0069',
	      '\u0049': '\u0131',
	      '\u0049\u0307': '\u0069'
	    }
	  },
	  lt: {
	    regexp: /[\u0049\u004A\u012E\u00CC\u00CD\u0128]/g,
	    map: {
	      '\u0049': '\u0069\u0307',
	      '\u004A': '\u006A\u0307',
	      '\u012E': '\u012F\u0307',
	      '\u00CC': '\u0069\u0307\u0300',
	      '\u00CD': '\u0069\u0307\u0301',
	      '\u0128': '\u0069\u0307\u0303'
	    }
	  }
	}
	
	/**
	 * Lowercase a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  var lang = LANGUAGES[locale]
	
	  str = str == null ? '' : String(str)
	
	  if (lang) {
	    str = str.replace(lang.regexp, function (m) { return lang.map[m] })
	  }
	
	  return str.toLowerCase()
	}


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var EventPluginRegistry = __webpack_require__(48);
	var EventPluginUtils = __webpack_require__(49);
	var ReactErrorUtils = __webpack_require__(53);
	
	var accumulateInto = __webpack_require__(103);
	var forEachAccumulated = __webpack_require__(104);
	var invariant = __webpack_require__(3);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(30);
	var EventPluginUtils = __webpack_require__(49);
	
	var accumulateInto = __webpack_require__(103);
	var forEachAccumulated = __webpack_require__(104);
	var warning = __webpack_require__(4);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 32 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(16);
	
	var getEventTarget = __webpack_require__(58);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 34 */
/***/ function(module, exports) {

	(function () {
	
	'use strict';
	/*===========================
	Framework 7
	===========================*/
	window.Framework7 = module.exports.Framework7 = function (params) {
	    // App
	    var app = this;
	
	    // Version
	    app.version = '1.5.0';
	
	    // Default Parameters
	    app.params = {
	        //
	        root: 'body',
	        //
	        cache: true,
	        cacheIgnore: [],
	        cacheIgnoreGetParameters: false,
	        cacheDuration: 1000 * 60 * 10, // Ten minutes
	        preloadPreviousPage: true,
	        uniqueHistory: false,
	        uniqueHistoryIgnoreGetParameters: false,
	        dynamicPageUrl: 'content-{{index}}',
	        allowDuplicateUrls: false,
	        router: true,
	        routerRemoveTimeout: false,
	        routerRemoveWithTimeout: false,
	        // Push State
	        pushState: false,
	        pushStateRoot: undefined,
	        pushStateNoAnimation: false,
	        pushStateSeparator: '#!/',
	        pushStateOnLoad: true,
	        // Fast clicks
	        fastClicks: true,
	        fastClicksDistanceThreshold: 10,
	        fastClicksDelayBetweenClicks: 50,
	        fastClicksExclude: '', // CSS selector
	        // Tap Hold
	        tapHold: false,
	        tapHoldDelay: 750,
	        tapHoldPreventClicks: true,
	        // Active State
	        activeState: true,
	        activeStateElements: 'a, button, label, span',
	        // Animate Nav Back Icon
	        animateNavBackIcon: false,
	        // Swipe Back
	        swipeBackPage: true,
	        swipeBackPageThreshold: 0,
	        swipeBackPageActiveArea: 30,
	        swipeBackPageAnimateShadow: true,
	        swipeBackPageAnimateOpacity: true,
	        // Ajax
	        ajaxLinks: undefined, // or CSS selector
	        // External Links
	        externalLinks: '.external', // CSS selector
	        // Sortable
	        sortable: true,
	        // Scroll toolbars
	        hideNavbarOnPageScroll: false,
	        hideToolbarOnPageScroll: false,
	        hideTabbarOnPageScroll: false,
	        showBarsOnPageScrollEnd: true,
	        showBarsOnPageScrollTop: true,
	        // Swipeout
	        swipeout: true,
	        swipeoutActionsNoFold: false,
	        swipeoutNoFollow: false,
	        swipeoutRemoveWithTimeout: false,
	        // Smart Select Back link template
	        smartSelectOpenIn: 'page', // or 'popup' or 'picker'
	        smartSelectBackText: 'Back',
	        smartSelectPopupCloseText: 'Close',
	        smartSelectPickerCloseText: 'Done',
	        smartSelectSearchbar: false,
	        smartSelectBackOnSelect: false,
	        // Tap Navbar or Statusbar to scroll to top
	        scrollTopOnNavbarClick: false,
	        scrollTopOnStatusbarClick: false,
	        // Panels
	        swipePanel: false, // or 'left' or 'right'
	        swipePanelActiveArea: 0,
	        swipePanelCloseOpposite: true,
	        swipePanelOnlyClose: false,
	        swipePanelNoFollow: false,
	        swipePanelThreshold: 0,
	        panelsCloseByOutside: true,
	        // Modals
	        modalButtonOk: 'OK',
	        modalButtonCancel: 'Cancel',
	        modalUsernamePlaceholder: 'Username',
	        modalPasswordPlaceholder: 'Password',
	        modalTitle: 'Framework7',
	        modalCloseByOutside: false,
	        actionsCloseByOutside: true,
	        popupCloseByOutside: true,
	        modalPreloaderTitle: 'Loading... ',
	        modalStack: true,
	        modalsMoveToRoot: true,
	        // Lazy Load
	        imagesLazyLoadThreshold: 0,
	        imagesLazyLoadSequential: true,
	        // Name space
	        viewClass: 'view',
	        viewMainClass: 'view-main',
	        viewsClass: 'views',
	        // Notifications defaults
	        notificationCloseOnClick: false,
	        notificationCloseIcon: true,
	        notificationCloseButtonText: 'Close',
	        // Animate Pages
	        animatePages: true,
	        // Template7
	        templates: {},
	        template7Data: {},
	        template7Pages: false,
	        precompileTemplates: false,
	        // Material
	        material: false,
	        materialPageLoadDelay: 0,
	        materialPreloaderSvg: '<svg xmlns="http://www.w3.org/2000/svg" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="8"/></svg>',
	        materialPreloaderHtml:
	            '<span class="preloader-inner">' +
	                '<span class="preloader-inner-gap"></span>' +
	                '<span class="preloader-inner-left">' +
	                    '<span class="preloader-inner-half-circle"></span>' +
	                '</span>' +
	                '<span class="preloader-inner-right">' +
	                    '<span class="preloader-inner-half-circle"></span>' +
	                '</span>' +
	            '</span>',
	        materialRipple: true,
	        materialRippleElements: '.ripple, a.link, a.item-link, .button, .modal-button, .tab-link, .label-radio, .label-checkbox, .actions-modal-button, a.searchbar-clear, a.floating-button, .floating-button > a, .speed-dial-buttons a',
	        // Auto init
	        init: true,
	    };
	
	    // Extend defaults with parameters
	    for (var param in params) {
	        app.params[param] = params[param];
	    }
	
	    // DOM lib
	    var $ = Dom7;
	
	    // Template7 lib
	    var t7 = Template7;
	    app._compiledTemplates = {};
	
	    // App Root
	    app.root = $(app.params.root);
	    app.root.eq(0).addClass('framework7-root');
	
	    // Touch events
	    app.touchEvents = {
	        start: app.support.touch ? 'touchstart' : 'mousedown',
	        move: app.support.touch ? 'touchmove' : 'mousemove',
	        end: app.support.touch ? 'touchend' : 'mouseup'
	    };
	
	    // Link to local storage
	    app.ls = window.localStorage;
	
	    // RTL
	    app.rtl = $('body').css('direction') === 'rtl';
	    if (app.rtl) $('html').attr('dir', 'rtl');
	
	    // Overwrite statusbar overlay
	    if (typeof app.params.statusbarOverlay !== 'undefined') {
	        if (app.params.statusbarOverlay) $('html').addClass('with-statusbar-overlay');
	        else $('html').removeClass('with-statusbar-overlay');
	    }
	    else if (app.device.ios && (window.cordova || window.phonegap)) {
	        $(document).on('resume', function () {
	            if (app.device.needsStatusBar()) {
	                $('html').addClass('with-statusbar-overlay');
	            }
	        }, false);
	    }
	
	/*======================================================
	************   Views   ************
	======================================================*/
	app.views = [];
	var View = function (selector, params) {
	    var defaults = {
	        dynamicNavbar: false,
	        domCache: false,
	        linksView: undefined,
	        reloadPages: false,
	        uniqueHistory: app.params.uniqueHistory,
	        uniqueHistoryIgnoreGetParameters: app.params.uniqueHistoryIgnoreGetParameters,
	        allowDuplicateUrls: app.params.allowDuplicateUrls,
	        swipeBackPage: app.params.swipeBackPage,
	        swipeBackPageAnimateShadow: app.params.swipeBackPageAnimateShadow,
	        swipeBackPageAnimateOpacity: app.params.swipeBackPageAnimateOpacity,
	        swipeBackPageActiveArea: app.params.swipeBackPageActiveArea,
	        swipeBackPageThreshold: app.params.swipeBackPageThreshold,
	        animatePages: app.params.animatePages,
	        preloadPreviousPage: app.params.preloadPreviousPage
	    };
	    var i;
	
	    // Params
	    params = params || {};
	
	    // Disable dynamic navbar for material theme
	    if (params.dynamicNavbar && app.params.material) params.dynamicNavbar = false;
	
	    // Extend params with defaults
	    for (var def in defaults) {
	        if (typeof params[def] === 'undefined') {
	            params[def] = defaults[def];
	        }
	    }
	    // View
	    var view = this;
	    view.params = params;
	
	    // Selector
	    view.selector = selector;
	
	    // Container
	    var container = $(selector);
	    view.container = container[0];
	
	    // Fix Selector
	
	    if (typeof selector !== 'string') {
	        // Supposed to be HTMLElement or Dom7
	        selector = (container.attr('id') ? '#' + container.attr('id') : '') + (container.attr('class') ? '.' + container.attr('class').replace(/ /g, '.').replace('.active', '') : '');
	        view.selector = selector;
	    }
	
	    // Is main
	    view.main = container.hasClass(app.params.viewMainClass);
	
	    // Content cache
	    view.contentCache = {};
	
	    // Context cache
	    view.contextCache = {};
	
	    // Pages cache
	    view.pagesCache = {};
	    view.pageElementsCache = {};
	
	    // Store View in element for easy access
	    container[0].f7View = view;
	
	    // Pages
	    view.pagesContainer = container.find('.pages')[0];
	    view.initialPages = [];
	    view.initialPagesUrl = [];
	    view.initialNavbars = [];
	    if (view.params.domCache) {
	        var initialPages = container.find('.page');
	        for (i = 0; i < initialPages.length; i++) {
	            view.initialPages.push(initialPages[i]);
	            view.initialPagesUrl.push('#' + initialPages.eq(i).attr('data-page'));
	        }
	        if (view.params.dynamicNavbar) {
	            var initialNavbars = container.find('.navbar-inner');
	            for (i = 0; i < initialNavbars.length; i++) {
	                view.initialNavbars.push(initialNavbars[i]);
	            }
	        }
	
	    }
	
	    view.allowPageChange = true;
	
	    // Location
	    var docLocation = document.location.href;
	
	    // History
	    view.history = [];
	    var viewURL = docLocation;
	    var pushStateSeparator = app.params.pushStateSeparator;
	    var pushStateRoot = app.params.pushStateRoot;
	    if (app.params.pushState && view.main) {
	        if (pushStateRoot) {
	            viewURL = pushStateRoot;
	        }
	        else {
	            if (pushStateSeparator && viewURL.indexOf(pushStateSeparator) >= 0 && viewURL.indexOf(pushStateSeparator + '#') < 0) viewURL = viewURL.split(pushStateSeparator)[0];
	        }
	
	    }
	
	    // Active Page
	    var currentPage, currentPageData;
	    if (!view.activePage) {
	        currentPage = $(view.pagesContainer).find('.page-on-center');
	        if (currentPage.length === 0) {
	            currentPage = $(view.pagesContainer).find('.page:not(.cached)');
	            currentPage = currentPage.eq(currentPage.length - 1);
	        }
	        if (currentPage.length > 0) {
	            currentPageData = currentPage[0].f7PageData;
	        }
	    }
	
	    // View startup URL
	    if (view.params.domCache && currentPage) {
	        view.url = container.attr('data-url') || view.params.url || '#' + currentPage.attr('data-page');   
	        view.pagesCache[view.url] = currentPage.attr('data-page');
	    }
	    else view.url = container.attr('data-url') || view.params.url || viewURL;
	
	    // Update current page Data
	    if (currentPageData) {
	        currentPageData.view = view;
	        currentPageData.url = view.url;
	        if (view.params.domCache && view.params.dynamicNavbar && !currentPageData.navbarInnerContainer) {
	            currentPageData.navbarInnerContainer = view.initialNavbars[view.initialPages.indexOf(currentPageData.container)];
	        }
	        view.activePage = currentPageData;
	        currentPage[0].f7PageData = currentPageData;
	    }
	
	    // Store to history main view's url
	    if (view.url) {
	        view.history.push(view.url);
	    }
	
	    // Touch events
	    var isTouched = false,
	        isMoved = false,
	        touchesStart = {},
	        isScrolling,
	        activePage = [],
	        previousPage = [],
	        viewContainerWidth,
	        touchesDiff,
	        allowViewTouchMove = true,
	        touchStartTime,
	        activeNavbar = [],
	        previousNavbar = [],
	        activeNavElements,
	        previousNavElements,
	        activeNavBackIcon,
	        previousNavBackIcon,
	        dynamicNavbar,
	        pageShadow,
	        el;
	
	    view.handleTouchStart = function (e) {
	        if (!allowViewTouchMove || !view.params.swipeBackPage || isTouched || app.swipeoutOpenedEl || !view.allowPageChange) return;
	        isMoved = false;
	        isTouched = true;
	        isScrolling = undefined;
	        touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	        touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	        touchStartTime = (new Date()).getTime();
	        dynamicNavbar = view.params.dynamicNavbar && container.find('.navbar-inner').length > 1;
	    };
	
	    view.handleTouchMove = function (e) {
	        if (!isTouched) return;
	        var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	        var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	        if (typeof isScrolling === 'undefined') {
	            isScrolling = !!(isScrolling || Math.abs(pageY - touchesStart.y) > Math.abs(pageX - touchesStart.x));
	        }
	        if (isScrolling || e.f7PreventSwipeBack || app.preventSwipeBack) {
	            isTouched = false;
	            return;
	        }
	        if (!isMoved) {
	            var cancel = false;
	            // Calc values during first move fired
	            viewContainerWidth = container.width();
	            var target = $(e.target);
	            var swipeout = target.hasClass('swipeout') ? target : target.parents('.swipeout');
	            if (swipeout.length > 0) {
	                if (!app.rtl && swipeout.find('.swipeout-actions-left').length > 0) cancel = true;
	                if (app.rtl && swipeout.find('.swipeout-actions-right').length > 0) cancel = true;
	            }
	            activePage = target.is('.page') ? target : target.parents('.page');
	            if (activePage.hasClass('no-swipeback')) cancel = true;
	            previousPage = container.find('.page-on-left:not(.cached)');
	            var notFromBorder = touchesStart.x - container.offset().left > view.params.swipeBackPageActiveArea;
	            if (app.rtl) {
	                notFromBorder = touchesStart.x < container.offset().left - container[0].scrollLeft + viewContainerWidth - view.params.swipeBackPageActiveArea;
	            }
	            else {
	                notFromBorder = touchesStart.x - container.offset().left > view.params.swipeBackPageActiveArea;
	            }
	            if (notFromBorder) cancel = true;
	            if (previousPage.length === 0 || activePage.length === 0) cancel = true;
	            if (cancel) {
	                isTouched = false;
	                return;
	            }
	
	            if (view.params.swipeBackPageAnimateShadow && !app.device.android) {
	                pageShadow = activePage.find('.swipeback-page-shadow');
	                if (pageShadow.length === 0) {
	                    pageShadow = $('<div class="swipeback-page-shadow"></div>');
	                    activePage.append(pageShadow);
	                }
	            }
	
	            if (dynamicNavbar) {
	                activeNavbar = container.find('.navbar-on-center:not(.cached)');
	                previousNavbar = container.find('.navbar-on-left:not(.cached)');
	                activeNavElements = activeNavbar.find('.left, .center, .right, .subnavbar, .fading');
	                previousNavElements = previousNavbar.find('.left, .center, .right, .subnavbar, .fading');
	                if (app.params.animateNavBackIcon) {
	                    activeNavBackIcon = activeNavbar.find('.left.sliding .back .icon');
	                    previousNavBackIcon = previousNavbar.find('.left.sliding .back .icon');
	                }
	            }
	
	            // Close/Hide Any Picker
	            if ($('.picker-modal.modal-in').length > 0) {
	                app.closeModal($('.picker-modal.modal-in'));
	            }
	        }
	        e.f7PreventPanelSwipe = true;
	        isMoved = true;
	        e.preventDefault();
	
	        // RTL inverter
	        var inverter = app.rtl ? -1 : 1;
	
	        // Touches diff
	        touchesDiff = (pageX - touchesStart.x - view.params.swipeBackPageThreshold) * inverter;
	        if (touchesDiff < 0) touchesDiff = 0;
	        var percentage = touchesDiff / viewContainerWidth;
	
	        // Swipe Back Callback
	        var callbackData = {
	            percentage: percentage,
	            activePage: activePage[0],
	            previousPage: previousPage[0],
	            activeNavbar: activeNavbar[0],
	            previousNavbar: previousNavbar[0]
	        };
	        if (view.params.onSwipeBackMove) {
	            view.params.onSwipeBackMove(callbackData);
	        }
	        container.trigger('swipeBackMove swipeback:move', callbackData);
	
	        // Transform pages
	        var activePageTranslate = touchesDiff * inverter;
	        var previousPageTranslate = (touchesDiff / 5 - viewContainerWidth / 5) * inverter;
	        if (app.device.pixelRatio === 1) {
	            activePageTranslate = Math.round(activePageTranslate);
	            previousPageTranslate = Math.round(previousPageTranslate);
	        }
	
	        activePage.transform('translate3d(' + activePageTranslate + 'px,0,0)');
	        if (view.params.swipeBackPageAnimateShadow && !app.device.android) pageShadow[0].style.opacity = 1 - 1 * percentage;
	
	        previousPage.transform('translate3d(' + previousPageTranslate + 'px,0,0)');
	        if (view.params.swipeBackPageAnimateOpacity) previousPage[0].style.opacity = 0.9 + 0.1 * percentage;
	
	        // Dynamic Navbars Animation
	        if (dynamicNavbar) {
	            var i;
	            for (i = 0; i < activeNavElements.length; i++) {
	                el = $(activeNavElements[i]);
	                if (!el.is('.subnavbar.sliding')) el[0].style.opacity = (1 - percentage * 1.3);
	                if (el[0].className.indexOf('sliding') >= 0) {
	                    var activeNavTranslate = percentage * el[0].f7NavbarRightOffset;
	                    if (app.device.pixelRatio === 1) activeNavTranslate = Math.round(activeNavTranslate);
	                    el.transform('translate3d(' + activeNavTranslate + 'px,0,0)');
	                    if (app.params.animateNavBackIcon) {
	                        if (el[0].className.indexOf('left') >= 0 && activeNavBackIcon.length > 0) {
	                            activeNavBackIcon.transform('translate3d(' + -activeNavTranslate + 'px,0,0)');
	                        }
	                    }
	                }
	            }
	            for (i = 0; i < previousNavElements.length; i++) {
	                el = $(previousNavElements[i]);
	                if (!el.is('.subnavbar.sliding')) el[0].style.opacity = percentage * 1.3 - 0.3;
	                if (el[0].className.indexOf('sliding') >= 0) {
	                    var previousNavTranslate = el[0].f7NavbarLeftOffset * (1 - percentage);
	                    if (app.device.pixelRatio === 1) previousNavTranslate = Math.round(previousNavTranslate);
	                    el.transform('translate3d(' + previousNavTranslate + 'px,0,0)');
	                    if (app.params.animateNavBackIcon) {
	                        if (el[0].className.indexOf('left') >= 0 && previousNavBackIcon.length > 0) {
	                            previousNavBackIcon.transform('translate3d(' + -previousNavTranslate + 'px,0,0)');
	                        }
	                    }
	                }
	            }
	        }
	    };
	
	    view.handleTouchEnd = function (e) {
	        if (!isTouched || !isMoved) {
	            isTouched = false;
	            isMoved = false;
	            return;
	        }
	        isTouched = false;
	        isMoved = false;
	        if (touchesDiff === 0) {
	            $([activePage[0], previousPage[0]]).transform('').css({opacity: '', boxShadow: ''});
	            if (dynamicNavbar) {
	                activeNavElements.transform('').css({opacity: ''});
	                previousNavElements.transform('').css({opacity: ''});
	                if (activeNavBackIcon && activeNavBackIcon.length > 0) activeNavBackIcon.transform('');
	                if (previousNavBackIcon && activeNavBackIcon.length > 0) previousNavBackIcon.transform('');
	            }
	            return;
	        }
	        var timeDiff = (new Date()).getTime() - touchStartTime;
	        var pageChanged = false;
	        // Swipe back to previous page
	        if (
	                timeDiff < 300 && touchesDiff > 10 ||
	                timeDiff >= 300 && touchesDiff > viewContainerWidth / 2
	            ) {
	            activePage.removeClass('page-on-center').addClass('page-on-right');
	            previousPage.removeClass('page-on-left').addClass('page-on-center');
	            if (dynamicNavbar) {
	                activeNavbar.removeClass('navbar-on-center').addClass('navbar-on-right');
	                previousNavbar.removeClass('navbar-on-left').addClass('navbar-on-center');
	            }
	            pageChanged = true;
	        }
	        // Reset custom styles
	        // Add transitioning class for transition-duration
	        $([activePage[0], previousPage[0]]).transform('').css({opacity: '', boxShadow: ''}).addClass('page-transitioning');
	        if (dynamicNavbar) {
	            activeNavElements.css({opacity: ''})
	            .each(function () {
	                var translate = pageChanged ? this.f7NavbarRightOffset : 0;
	                var sliding = $(this);
	                sliding.transform('translate3d(' + translate + 'px,0,0)');
	                if (app.params.animateNavBackIcon) {
	                    if (sliding.hasClass('left') && activeNavBackIcon.length > 0) {
	                        activeNavBackIcon.addClass('page-transitioning').transform('translate3d(' + -translate + 'px,0,0)');
	                    }
	                }
	
	            }).addClass('page-transitioning');
	
	            previousNavElements.transform('').css({opacity: ''}).each(function () {
	                var translate = pageChanged ? 0 : this.f7NavbarLeftOffset;
	                var sliding = $(this);
	                sliding.transform('translate3d(' + translate + 'px,0,0)');
	                if (app.params.animateNavBackIcon) {
	                    if (sliding.hasClass('left') && previousNavBackIcon.length > 0) {
	                        previousNavBackIcon.addClass('page-transitioning').transform('translate3d(' + -translate + 'px,0,0)');
	                    }
	                }
	            }).addClass('page-transitioning');
	        }
	        allowViewTouchMove = false;
	        view.allowPageChange = false;
	        // Swipe Back Callback
	        var callbackData = {
	            activePage: activePage[0],
	            previousPage: previousPage[0],
	            activeNavbar: activeNavbar[0],
	            previousNavbar: previousNavbar[0]
	        };
	        if (pageChanged) {
	            // Update View's URL
	            var url = view.history[view.history.length - 2];
	            view.url = url;
	
	            // Page before animation callback
	            app.pageBackCallback('before', view, {pageContainer: activePage[0], url: url, position: 'center', newPage: previousPage, oldPage: activePage, swipeBack: true});
	            app.pageAnimCallback('before', view, {pageContainer: previousPage[0], url: url, position: 'left', newPage: previousPage, oldPage: activePage, swipeBack: true});
	
	            if (view.params.onSwipeBackBeforeChange) {
	                view.params.onSwipeBackBeforeChange(callbackData);
	            }
	            container.trigger('swipeBackBeforeChange swipeback:beforechange', callbackData);
	        }
	        else {
	            if (view.params.onSwipeBackBeforeReset) {
	                view.params.onSwipeBackBeforeReset(callbackData);
	            }
	            container.trigger('swipeBackBeforeReset swipeback:beforereset', callbackData);
	        }
	
	        activePage.transitionEnd(function () {
	            $([activePage[0], previousPage[0]]).removeClass('page-transitioning');
	            if (dynamicNavbar) {
	                activeNavElements.removeClass('page-transitioning').css({opacity: ''});
	                previousNavElements.removeClass('page-transitioning').css({opacity: ''});
	                if (activeNavBackIcon && activeNavBackIcon.length > 0) activeNavBackIcon.removeClass('page-transitioning');
	                if (previousNavBackIcon && previousNavBackIcon.length > 0) previousNavBackIcon.removeClass('page-transitioning');
	            }
	            allowViewTouchMove = true;
	            view.allowPageChange = true;
	            if (pageChanged) {
	                if (app.params.pushState && view.main) history.back();
	                // Page after animation callback
	                app.pageBackCallback('after', view, {pageContainer: activePage[0], url: url, position: 'center', newPage: previousPage, oldPage: activePage, swipeBack: true});
	                app.pageAnimCallback('after', view, {pageContainer: previousPage[0], url: url, position: 'left', newPage: previousPage, oldPage: activePage, swipeBack: true});
	                app.router.afterBack(view, activePage, previousPage);
	
	                if (view.params.onSwipeBackAfterChange) {
	                    view.params.onSwipeBackAfterChange(callbackData);
	                }
	                container.trigger('swipeBackAfterChange swipeback:afterchange', callbackData);
	            }
	            else {
	                if (view.params.onSwipeBackAfterReset) {
	                    view.params.onSwipeBackAfterReset(callbackData);
	                }
	                container.trigger('swipeBackAfterReset swipeback:afterreset', callbackData);
	            }
	            if (pageShadow && pageShadow.length > 0) pageShadow.remove();
	        });
	    };
	    view.attachEvents = function (detach) {
	        var action = detach ? 'off' : 'on';
	        var passiveListener = app.touchEvents.start === 'touchstart' && app.support.passiveListener ? {passive: true, capture: false} : false;
	        container[action](app.touchEvents.start, view.handleTouchStart, passiveListener);
	        container[action](app.touchEvents.move, view.handleTouchMove);
	        container[action](app.touchEvents.end, view.handleTouchEnd, passiveListener);
	    };
	    view.detachEvents = function () {
	        view.attachEvents(true);
	    };
	
	    // Init
	    if (view.params.swipeBackPage && !app.params.material) {
	        view.attachEvents();
	    }
	
	    // Check view name to delete unwanted characters
	    if (view.params.name) view.params.name = view.params.name.replace(/[^a-zA-Z]/g, '');
	  
	    // Add view to app
	    app.views.push(view);
	    if (view.main) {
	        app.mainView = view;
	        app.views.main = view;
	    }
	    else if(view.params.name) {
	        app[view.params.name + 'View'] = view;
	        app.views[view.params.name] = view;
	    }
	
	    // Router
	    view.router = {
	        load: function (options) {
	            return app.router.load(view, options);
	        },
	        back: function (options) {
	            return app.router.back(view, options);
	        },
	        // Shortcuts
	        loadPage: function (options) {
	            options = options || {};
	            if (typeof options === 'string') {
	                var url = options;
	                options = {};
	                if (url && url.indexOf('#') === 0 && view.params.domCache) {
	                    options.pageName = url.split('#')[1];
	                }
	                else options.url = url;
	            }
	            return app.router.load(view, options);
	        },
	        loadContent: function (content) {
	            return app.router.load(view, {content: content});
	        },
	        reloadPage: function (url) {
	            return app.router.load(view, {url: url, reload: true});
	        },
	        reloadContent: function (content) {
	            return app.router.load(view, {content: content, reload: true});
	        },
	        reloadPreviousPage: function (url) {
	            return app.router.load(view, {url: url, reloadPrevious: true, reload: true});
	        },
	        reloadPreviousContent: function (content) {
	            return app.router.load(view, {content: content, reloadPrevious: true, reload: true});
	        },
	        refreshPage: function () {
	            var options = {
	                url: view.url,
	                reload: true,
	                ignoreCache: true
	            };
	            if (options.url && options.url.indexOf('#') === 0) {
	                if (view.params.domCache && view.pagesCache[options.url]) {
	                    options.pageName = view.pagesCache[options.url];
	                    options.url = undefined;
	                    delete options.url;
	                }
	                else if (view.contentCache[options.url]) {
	                    options.content = view.contentCache[options.url];
	                    options.url = undefined;
	                    delete options.url;
	                }
	            }
	            return app.router.load(view, options);
	        },
	        refreshPreviousPage: function () {
	            var options = {
	                url: view.history[view.history.length - 2],
	                reload: true,
	                reloadPrevious: true,
	                ignoreCache: true
	            };
	            if (options.url && options.url.indexOf('#') === 0 && view.params.domCache && view.pagesCache[options.url]) {
	                options.pageName = view.pagesCache[options.url];
	                options.url = undefined;
	                delete options.url;
	            }
	            return app.router.load(view, options);
	        }
	    };
	
	    // Aliases for temporary backward compatibility
	    view.loadPage = view.router.loadPage;
	    view.loadContent = view.router.loadContent;
	    view.reloadPage = view.router.reloadPage;
	    view.reloadContent = view.router.reloadContent;
	    view.reloadPreviousPage = view.router.reloadPreviousPage;
	    view.reloadPreviousContent = view.router.reloadPreviousContent;
	    view.refreshPage = view.router.refreshPage;
	    view.refreshPreviousPage = view.router.refreshPreviousPage;
	    view.back = view.router.back;
	
	    // Bars methods
	    view.hideNavbar = function (animated) {
	        return app.hideNavbar(container.find('.navbar'), animated);
	    };
	    view.showNavbar = function (animated) {
	        return app.showNavbar(container.find('.navbar'), animated);
	    };
	    view.hideToolbar = function (animated) {
	        return app.hideToolbar(container.find('.toolbar'), animated);
	    };
	    view.showToolbar = function (animated) {
	        return app.showToolbar(container.find('.toolbar'), animated);
	    };
	
	    // Push State on load
	    if (app.params.pushState && app.params.pushStateOnLoad && view.main) {
	        var pushStateUrl;
	        var pushStateUrlSplit = docLocation.split(pushStateSeparator)[1];
	        if (pushStateRoot) {
	            pushStateUrl = docLocation.split(app.params.pushStateRoot + pushStateSeparator)[1];
	        }
	        else if (pushStateSeparator && docLocation.indexOf(pushStateSeparator) >= 0 && docLocation.indexOf(pushStateSeparator + '#') < 0) {
	            pushStateUrl = pushStateUrlSplit;
	        }
	        var pushStateAnimatePages = app.params.pushStateNoAnimation ? false : undefined;
	        var historyState = history.state;
	        if (pushStateUrl) {
	            if (pushStateUrl.indexOf('#') >= 0 && view.params.domCache && historyState && historyState.pageName && 'viewIndex' in historyState) {
	                app.router.load(view, {pageName: historyState.pageName, url: historyState.url, animatePages: pushStateAnimatePages, pushState: false});
	            }
	            else if (pushStateUrl.indexOf('#') >= 0 && view.params.domCache && view.initialPagesUrl.indexOf(pushStateUrl) >= 0) {
	                app.router.load(view, {pageName: pushStateUrl.replace('#',''), animatePages: pushStateAnimatePages, pushState: false});
	            }
	            else app.router.load(view, {url: pushStateUrl, animatePages: pushStateAnimatePages, pushState: false});
	        }
	        else if (view.params.domCache && docLocation.indexOf(pushStateSeparator + '#') >= 0) {
	            if (historyState && historyState.pageName && 'viewIndex' in historyState) {
	                app.router.load(view, {pageName: historyState.pageName, url: historyState.url, animatePages: pushStateAnimatePages, pushState: false});
	            }
	            else if (pushStateSeparator && pushStateUrlSplit.indexOf('#') === 0) {
	                if (view.initialPagesUrl.indexOf(pushStateUrlSplit)) {
	                    app.router.load(view, {pageName: pushStateUrlSplit.replace('#', ''), animatePages: pushStateAnimatePages, pushState: false});
	                }
	            }
	        }
	    }
	
	    // Destroy
	    view.destroy = function () {
	        view.detachEvents();
	        if (view.main) {
	            app.mainView = null;
	            delete app.mainView;
	            app.views.main = null;
	            delete app.views.main;
	        }
	        else if(view.params.name) {
	            app[view.params.name + 'View'] = null;
	            delete app[view.params.name + 'View'];
	            app.views[view.params.name] = null;
	            delete app.views[view.params.name];
	        }
	        container.removeAttr('data-page');
	        container[0].f7View = null;
	        delete container[0].f7View;
	        
	        app.views.splice(app.views.indexOf(view), 1);
	
	        // Delete props & methods
	        for (var prop in view) {
	            if (view.hasOwnProperty(prop)) {
	                view[prop] = null;
	                delete view[prop];
	            }
	        }
	        view = null;
	    };
	
	    // Plugin hook
	    app.pluginHook('addView', view);
	
	    // Return view
	    return view;
	};
	
	app.addView = function (selector, params) {
	    return new View(selector, params);
	};
	
	app.getCurrentView = function (index) {
	    var popoverView = $('.popover.modal-in .view');
	    var popupView = $('.popup.modal-in .view');
	    var panelView = $('.panel.active .view');
	    var appViews = $('.views');
	    // Find active view as tab
	    var appView = appViews.children('.view');
	    // Propably in tabs or split view
	    if (appView.length > 1) {
	        if (appView.hasClass('tab')) {
	            // Tabs
	            appView = appViews.children('.view.active');
	        }
	        else {
	            // Split View, leave appView intact
	        }
	    }
	    if (popoverView.length > 0 && popoverView[0].f7View) return popoverView[0].f7View;
	    if (popupView.length > 0 && popupView[0].f7View) return popupView[0].f7View;
	    if (panelView.length > 0 && panelView[0].f7View) return panelView[0].f7View;
	    if (appView.length > 0) {
	        if (appView.length === 1 && appView[0].f7View) return appView[0].f7View;
	        if (appView.length > 1) {
	            var currentViews = [];
	            for (var i = 0; i < appView.length; i++) {
	                if (appView[i].f7View) currentViews.push(appView[i].f7View);
	            }
	            if (currentViews.length > 0 && typeof index !== 'undefined') return currentViews[index];
	            if (currentViews.length > 1) return currentViews;
	            if (currentViews.length === 1) return currentViews[0];
	            return undefined;
	        }
	    }
	    return undefined;
	};
	
	/*======================================================
	************   Navbars && Toolbars   ************
	======================================================*/
	// On Navbar Init Callback
	app.navbarInitCallback = function (view, pageContainer, navbarContainer, navbarInnerContainer) {
	    if (!navbarContainer && navbarInnerContainer) navbarContainer = $(navbarInnerContainer).parent('.navbar')[0];
	    if (!navbarInnerContainer || navbarInnerContainer.f7NavbarInitialized && view && !view.params.domCache) return;
	    var navbarData = {
	        container: navbarContainer,
	        innerContainer: navbarInnerContainer
	    };
	    var pageData = pageContainer && pageContainer.f7PageData;
	
	    var eventData = {
	        page: pageData,
	        navbar: navbarData
	    };
	
	    if (navbarInnerContainer.f7NavbarInitialized && ((view && view.params.domCache) || (!view && $(navbarContainer).parents('.popup, .popover, .login-screen, .modal, .actions-modal, .picker-modal').length > 0))) {
	        // Reinit Navbar
	        app.reinitNavbar(navbarContainer, navbarInnerContainer);
	
	        // Plugin hook
	        app.pluginHook('navbarReinit', eventData);
	
	        // Event
	        $(navbarInnerContainer).trigger('navbarReinit navbar:reinit', eventData);
	        return;
	    }
	    navbarInnerContainer.f7NavbarInitialized = true;
	    // Before Init
	    app.pluginHook('navbarBeforeInit', navbarData, pageData);
	    $(navbarInnerContainer).trigger('navbarBeforeInit navbar:beforeinit', eventData);
	
	    // Initialize Navbar
	    app.initNavbar(navbarContainer, navbarInnerContainer);
	
	    // On init
	    app.pluginHook('navbarInit', navbarData, pageData);
	    $(navbarInnerContainer).trigger('navbarInit navbar:init', eventData);
	};
	// Navbar Remove Callback
	app.navbarRemoveCallback = function (view, pageContainer, navbarContainer, navbarInnerContainer) {
	    if (!navbarContainer && navbarInnerContainer) navbarContainer = $(navbarInnerContainer).parent('.navbar')[0];
	    var navbarData = {
	        container: navbarContainer,
	        innerContainer: navbarInnerContainer
	    };
	    var pageData;
	    if (pageContainer) {
	        pageData = pageContainer.f7PageData;
	    }
	
	    var eventData = {
	        page: pageData,
	        navbar: navbarData
	    };
	    app.pluginHook('navbarBeforeRemove', navbarData, pageData);
	    $(navbarInnerContainer).trigger('navbarBeforeRemove navbar:beforeremove', eventData);
	    navbarData = null;
	    pageData = null;
	};
	app.initNavbar = function (navbarContainer, navbarInnerContainer) {
	    // Init Subnavbar Searchbar
	    if (app.initSearchbar) app.initSearchbar(navbarInnerContainer);
	};
	app.reinitNavbar = function (navbarContainer, navbarInnerContainer) {
	    // Re init navbar methods
	};
	app.initNavbarWithCallback = function (navbarContainer) {
	    navbarContainer = $(navbarContainer);
	    var viewContainer = navbarContainer.parents('.' + app.params.viewClass);
	    var view;
	    if (viewContainer.length === 0) return;
	    if (navbarContainer.parents('.navbar-through').length === 0 && viewContainer.find('.navbar-through').length === 0) return;
	    view = viewContainer[0].f7View || undefined;
	
	    navbarContainer.find('.navbar-inner').each(function () {
	        var navbarInnerContainer = this;
	        var pageContainer;
	        if ($(navbarInnerContainer).attr('data-page')) {
	            // For dom cache
	            pageContainer = viewContainer.find('.page[data-page="' + $(navbarInnerContainer).attr('data-page') + '"]')[0];
	        }
	        if (!pageContainer) {
	            var pages = viewContainer.find('.page');
	            if (pages.length === 1) {
	                pageContainer = pages[0];
	            }
	            else {
	                viewContainer.find('.page').each(function () {
	                    if (this.f7PageData && this.f7PageData.navbarInnerContainer === navbarInnerContainer) {
	                        pageContainer = this;
	                    }
	                });
	            }
	        }
	        app.navbarInitCallback(view, pageContainer, navbarContainer[0], navbarInnerContainer);
	    });
	};
	
	// Size Navbars
	app.sizeNavbars = function (viewContainer) {
	    if (app.params.material) return;
	    var navbarInner = viewContainer ? $(viewContainer).find('.navbar .navbar-inner:not(.cached)') : $('.navbar .navbar-inner:not(.cached)');
	    navbarInner.each(function () {
	        var n = $(this);
	        if (n.hasClass('cached')) return;
	        var left = app.rtl ? n.find('.right') : n.find('.left'),
	            right = app.rtl ? n.find('.left') : n.find('.right'),
	            center = n.find('.center'),
	            subnavbar = n.find('.subnavbar'),
	            noLeft = left.length === 0,
	            noRight = right.length === 0,
	            leftWidth = noLeft ? 0 : left.outerWidth(true),
	            rightWidth = noRight ? 0 : right.outerWidth(true),
	            centerWidth = center.outerWidth(true),
	            navbarStyles = n.styles(),
	            navbarWidth = n[0].offsetWidth - parseInt(navbarStyles.paddingLeft, 10) - parseInt(navbarStyles.paddingRight, 10),
	            onLeft = n.hasClass('navbar-on-left'),
	            currLeft, diff;
	
	        if (noRight) {
	            currLeft = navbarWidth - centerWidth;
	        }
	        if (noLeft) {
	            currLeft = 0;
	        }
	        if (!noLeft && !noRight) {
	            currLeft = (navbarWidth - rightWidth - centerWidth + leftWidth) / 2;
	        }
	        var requiredLeft = (navbarWidth - centerWidth) / 2;
	        if (navbarWidth - leftWidth - rightWidth > centerWidth) {
	            if (requiredLeft < leftWidth) {
	                requiredLeft = leftWidth;
	            }
	            if (requiredLeft + centerWidth > navbarWidth - rightWidth) {
	                requiredLeft = navbarWidth - rightWidth - centerWidth;
	            }
	            diff = requiredLeft - currLeft;
	        }
	        else {
	            diff = 0;
	        }
	        // RTL inverter
	        var inverter = app.rtl ? -1 : 1;
	
	        if (center.hasClass('sliding')) {
	            center[0].f7NavbarLeftOffset = -(currLeft + diff) * inverter;
	            center[0].f7NavbarRightOffset = (navbarWidth - currLeft - diff - centerWidth) * inverter;
	            if (onLeft) {
	                if (app.params.animateNavBackIcon) {
	                    var activeNavbarBackLink = n.parent().find('.navbar-on-center').find('.left.sliding .back .icon ~ span');
	                    if (activeNavbarBackLink.length > 0) {
	                        center[0].f7NavbarLeftOffset += activeNavbarBackLink[0].offsetLeft;
	                    }
	                }
	                center.transform('translate3d(' + center[0].f7NavbarLeftOffset + 'px, 0, 0)');
	            }
	        }
	        if (!noLeft && left.hasClass('sliding')) {
	            if (app.rtl) {
	                left[0].f7NavbarLeftOffset = -(navbarWidth - left[0].offsetWidth) / 2 * inverter;
	                left[0].f7NavbarRightOffset = leftWidth * inverter;
	            }
	            else {
	                left[0].f7NavbarLeftOffset = -leftWidth;
	                left[0].f7NavbarRightOffset = (navbarWidth - left[0].offsetWidth) / 2;
	                if (app.params.animateNavBackIcon && left.find('.back .icon').length > 0) {
	                    left[0].f7NavbarRightOffset -= left.find('.back .icon')[0].offsetWidth;
	                }
	            }
	            if (onLeft) left.transform('translate3d(' + left[0].f7NavbarLeftOffset + 'px, 0, 0)');
	        }
	        if (!noRight && right.hasClass('sliding')) {
	            if (app.rtl) {
	                right[0].f7NavbarLeftOffset = -rightWidth * inverter;
	                right[0].f7NavbarRightOffset = (navbarWidth - right[0].offsetWidth) / 2 * inverter;
	            }
	            else {
	                right[0].f7NavbarLeftOffset = -(navbarWidth - right[0].offsetWidth) / 2;
	                right[0].f7NavbarRightOffset = rightWidth;
	            }
	            if (onLeft) right.transform('translate3d(' + right[0].f7NavbarLeftOffset + 'px, 0, 0)');
	        }
	        if (subnavbar.length && subnavbar.hasClass('sliding')) {
	            subnavbar[0].f7NavbarLeftOffset = app.rtl ? subnavbar[0].offsetWidth : -subnavbar[0].offsetWidth;
	            subnavbar[0].f7NavbarRightOffset = -subnavbar[0].f7NavbarLeftOffset;
	        }
	
	        // Center left
	        var centerLeft = diff;
	        if (app.rtl && noLeft && noRight && center.length > 0) centerLeft = -centerLeft;
	        center.css({left: centerLeft + 'px'});
	        
	    });
	};
	
	// Hide/Show Navbars/Toolbars
	app.hideNavbar = function (navbarContainer, animated) {
	    if (typeof animated === 'undefined') animated = true;
	    $(navbarContainer).addClass('navbar-hidden' + (!animated ? (' not-animated') : ''));
	    return true;
	};
	app.showNavbar = function (navbarContainer, animated) {
	    if (typeof animated === 'undefined') animated = true;
	    var navbar = $(navbarContainer);
	    if (animated) {
	        navbar.removeClass('not-animated');
	        navbar.addClass('navbar-hiding').removeClass('navbar-hidden').transitionEnd(function () {
	            navbar.removeClass('navbar-hiding');
	        });
	    }
	    else {
	        navbar.removeClass('navbar-hidden navbar-hiding not-animated');
	    }
	    return true;
	};
	app.hideToolbar = function (toolbarContainer, animated) {
	    if (typeof animated === 'undefined') animated = true;
	    $(toolbarContainer).addClass('toolbar-hidden' + (!animated ? (' not-animated') : ''));
	    return true;
	};
	app.showToolbar = function (toolbarContainer, animated) {
	    if (typeof animated === 'undefined') animated = true;
	    var toolbar = $(toolbarContainer);
	    if (animated) {
	        toolbar.removeClass('not-animated');
	        toolbar.addClass('toolbar-hiding').removeClass('toolbar-hidden').transitionEnd(function () {
	            toolbar.removeClass('toolbar-hiding' + (!animated ? (' not-animated') : ''));
	        });
	    }
	    else {
	        toolbar.removeClass('toolbar-hidden toolbar-hiding not-animated');
	    }
	        
	};
	
	/*======================================================
	************   XHR   ************
	======================================================*/
	// XHR Caching
	app.cache = [];
	app.removeFromCache = function (url) {
	    var index = false;
	    for (var i = 0; i < app.cache.length; i++) {
	        if (app.cache[i].url === url) index = i;
	    }
	    if (index !== false) app.cache.splice(index, 1);
	};
	
	// XHR
	app.xhr = false;
	app.get = function (url, view, ignoreCache, callback) {
	    // should we ignore get params or not
	    var _url = url;
	    if (app.params.cacheIgnoreGetParameters && url.indexOf('?') >= 0) {
	        _url = url.split('?')[0];
	    }
	    if (app.params.cache && !ignoreCache && url.indexOf('nocache') < 0 && app.params.cacheIgnore.indexOf(_url) < 0) {
	        // Check is the url cached
	        for (var i = 0; i < app.cache.length; i++) {
	            if (app.cache[i].url === _url) {
	                // Check expiration
	                if ((new Date()).getTime() - app.cache[i].time < app.params.cacheDuration) {
	                    // Load from cache
	                    callback(app.cache[i].content);
	                    return false;
	                }
	            }
	        }
	    }
	
	    app.xhr = $.ajax({
	        url: url,
	        method: 'GET',
	        beforeSend: app.params.onAjaxStart,
	        complete: function (xhr) {
	            if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 0) {
	                if (app.params.cache) {
	                    app.removeFromCache(_url);
	                    app.cache.push({
	                        url: _url,
	                        time: (new Date()).getTime(),
	                        content: xhr.responseText
	                    });
	                }
	                callback(xhr.responseText, false);
	            }
	            else {
	                callback(xhr.responseText, true);
	            }
	            if (app.params.onAjaxComplete) app.params.onAjaxComplete(xhr);
	        },
	        error: function (xhr) {
	            callback(xhr.responseText, true);
	            if (app.params.onAjaxError) app.params.onAjaxError(xhr);
	        }
	    });
	    if (view) view.xhr = app.xhr;
	
	    return app.xhr;
	};
	
	/*======================================================
	************   Pages   ************
	======================================================*/
	// Page Callbacks API
	app.pageCallbacks = {};
	
	app.onPage = function (callbackName, pageName, callback) {
	    if (pageName && pageName.split(' ').length > 1) {
	        var pageNames = pageName.split(' ');
	        var returnCallbacks = [];
	        for (var i = 0; i < pageNames.length; i++) {
	            returnCallbacks.push(app.onPage(callbackName, pageNames[i], callback));
	        }
	        returnCallbacks.remove = function () {
	            for (var i = 0; i < returnCallbacks.length; i++) {
	                returnCallbacks[i].remove();
	            }
	        };
	        returnCallbacks.trigger = function () {
	            for (var i = 0; i < returnCallbacks.length; i++) {
	                returnCallbacks[i].trigger();
	            }
	        };
	        return returnCallbacks;
	    }
	    var callbacks = app.pageCallbacks[callbackName][pageName];
	    if (!callbacks) {
	        callbacks = app.pageCallbacks[callbackName][pageName] = [];
	    }
	    app.pageCallbacks[callbackName][pageName].push(callback);
	    return {
	        remove: function () {
	            var removeIndex;
	            for (var i = 0; i < callbacks.length; i++) {
	                if (callbacks[i].toString() === callback.toString()) {
	                    removeIndex = i;
	                }
	            }
	            if (typeof removeIndex !== 'undefined') callbacks.splice(removeIndex, 1);
	        },
	        trigger: callback
	    };
	};
	
	//Create callbacks methods dynamically
	function createPageCallback(callbackName) {
	    var capitalized = callbackName.replace(/^./, function (match) {
	        return match.toUpperCase();
	    });
	    app['onPage' + capitalized] = function (pageName, callback) {
	        return app.onPage(callbackName, pageName, callback);
	    };
	}
	
	var pageCallbacksNames = ('beforeInit init reinit beforeAnimation afterAnimation back afterBack beforeRemove').split(' ');
	for (var i = 0; i < pageCallbacksNames.length; i++) {
	    app.pageCallbacks[pageCallbacksNames[i]] = {};
	    createPageCallback(pageCallbacksNames[i]);
	}
	
	app.triggerPageCallbacks = function (callbackName, pageName, pageData) {
	    var allPagesCallbacks = app.pageCallbacks[callbackName]['*'];
	    if (allPagesCallbacks) {
	        for (var j = 0; j < allPagesCallbacks.length; j++) {
	            allPagesCallbacks[j](pageData);
	        }
	    }
	    var callbacks = app.pageCallbacks[callbackName][pageName];
	    if (!callbacks || callbacks.length === 0) return;
	    for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i](pageData);
	    }
	};
	
	// On Page Init Callback
	app.pageInitCallback = function (view, params) {
	    var pageContainer = params.pageContainer;
	    if (!pageContainer) return;
	    if (pageContainer.f7PageInitialized && view && !view.params.domCache) return;
	
	    var pageQuery = params.query;
	    if (!pageQuery) {
	        if (params.url && params.url.indexOf('?') > 0) {
	            pageQuery = $.parseUrlQuery(params.url || '');
	        }
	        else if (pageContainer.f7PageData && pageContainer.f7PageData.query) {
	            pageQuery = pageContainer.f7PageData.query;
	        }
	        else {
	            pageQuery = {};
	        }
	    }
	
	    // Page Data
	    var pageData = {
	        container: pageContainer,
	        url: params.url,
	        query: pageQuery,
	        name: $(pageContainer).attr('data-page'),
	        view: view,
	        from: params.position,
	        context: params.context,
	        navbarInnerContainer: params.navbarInnerContainer,
	        fromPage: params.fromPage
	    };
	    if (params.fromPage && !params.fromPage.navbarInnerContainer && params.oldNavbarInnerContainer) {
	        params.fromPage.navbarInnerContainer = params.oldNavbarInnerContainer;
	    }
	
	    if (pageContainer.f7PageInitialized && ((view && view.params.domCache) || (!view && $(pageContainer).parents('.popup, .popover, .login-screen, .modal, .actions-modal, .picker-modal').length > 0))) {
	        // Reinit Page
	        app.reinitPage(pageContainer);
	
	        // Callbacks
	        app.pluginHook('pageReinit', pageData);
	        if (app.params.onPageReinit) app.params.onPageReinit(app, pageData);
	        app.triggerPageCallbacks('reinit', pageData.name, pageData);
	        $(pageData.container).trigger('pageReinit page:reinit', {page: pageData});
	        return;
	    }
	    pageContainer.f7PageInitialized = true;
	
	    // Store pagedata in page
	    pageContainer.f7PageData = pageData;
	
	    // Update View's activePage
	    if (view && !params.preloadOnly && !params.reloadPrevious) {
	        // Add data-page on view
	        $(view.container).attr('data-page', pageData.name);
	        // Update View active page data
	        view.activePage = pageData;
	    }
	
	    // Before Init Callbacks
	    app.pluginHook('pageBeforeInit', pageData);
	    if (app.params.onPageBeforeInit) app.params.onPageBeforeInit(app, pageData);
	    app.triggerPageCallbacks('beforeInit', pageData.name, pageData);
	    $(pageData.container).trigger('pageBeforeInit page:beforeinit', {page: pageData});
	
	    // Init page
	    app.initPage(pageContainer);
	
	    // Init Callback
	    app.pluginHook('pageInit', pageData);
	    if (app.params.onPageInit) app.params.onPageInit(app, pageData);
	    app.triggerPageCallbacks('init', pageData.name, pageData);
	    $(pageData.container).trigger('pageInit page:init', {page: pageData});
	};
	app.pageRemoveCallback = function (view, pageContainer, position) {
	    var pageContext;
	    if (!pageContainer) return;
	    if (pageContainer.f7PageData) pageContext = pageContainer.f7PageData.context;
	    // Page Data
	    var pageData = {
	        container: pageContainer,
	        name: $(pageContainer).attr('data-page'),
	        view: view,
	        url: pageContainer.f7PageData && pageContainer.f7PageData.url,
	        query: pageContainer.f7PageData && pageContainer.f7PageData.query,
	        navbarInnerContainer: pageContainer.f7PageData && pageContainer.f7PageData.navbarInnerContainer,
	        from: position,
	        context: pageContext
	    };
	    // Before Init Callback
	    app.pluginHook('pageBeforeRemove', pageData);
	    if (app.params.onPageBeforeRemove) app.params.onPageBeforeRemove(app, pageData);
	    app.triggerPageCallbacks('beforeRemove', pageData.name, pageData);
	    $(pageData.container).trigger('pageBeforeRemove page:beforeremove', {page: pageData});
	    pageData = null;
	};
	app.pageBackCallback = function (callback, view, params) {
	    // Page Data
	    var pageContainer = params.pageContainer;
	    var pageContext;
	    if (!pageContainer) return;
	    if (pageContainer.f7PageData) pageContext = pageContainer.f7PageData.context;
	
	    var pageData = {
	        container: pageContainer,
	        name: $(pageContainer).attr('data-page'),
	        url: pageContainer.f7PageData && pageContainer.f7PageData.url,
	        query: pageContainer.f7PageData && pageContainer.f7PageData.query,
	        view: view,
	        from: params.position,
	        context: pageContext,
	        navbarInnerContainer: pageContainer.f7PageData && pageContainer.f7PageData.navbarInnerContainer,
	        swipeBack: params.swipeBack
	    };
	
	    if (callback === 'after') {
	        app.pluginHook('pageAfterBack', pageData);
	        if (app.params.onPageAfterBack) app.params.onPageAfterBack(app, pageData);
	        app.triggerPageCallbacks('afterBack', pageData.name, pageData);
	        $(pageContainer).trigger('pageAfterBack page:afterback', {page: pageData});
	
	    }
	    if (callback === 'before') {
	        app.pluginHook('pageBack', pageData);
	        if (app.params.onPageBack) app.params.onPageBack(app, pageData);
	        app.triggerPageCallbacks('back', pageData.name, pageData);
	        $(pageData.container).trigger('pageBack page:back', {page: pageData});
	    }
	};
	app.pageAnimCallback = function (callback, view, params) {
	    var pageContainer = params.pageContainer;
	    var pageContext;
	    if (!pageContainer) return;
	    if (pageContainer.f7PageData) pageContext = pageContainer.f7PageData.context;
	
	    var pageQuery = params.query;
	    if (!pageQuery) {
	        if (params.url && params.url.indexOf('?') > 0) {
	            pageQuery = $.parseUrlQuery(params.url || '');
	        }
	        else if (pageContainer.f7PageData && pageContainer.f7PageData.query) {
	            pageQuery = pageContainer.f7PageData.query;
	        }
	        else {
	            pageQuery = {};
	        }
	    }
	    // Page Data
	    var pageData = {
	        container: pageContainer,
	        url: params.url,
	        query: pageQuery,
	        name: $(pageContainer).attr('data-page'),
	        view: view,
	        from: params.position,
	        context: pageContext,
	        swipeBack: params.swipeBack,
	        navbarInnerContainer: pageContainer.f7PageData && pageContainer.f7PageData.navbarInnerContainer,
	        fromPage: params.fromPage
	    };
	    var oldPage = params.oldPage,
	        newPage = params.newPage;
	
	    // Update page date
	    pageContainer.f7PageData = pageData;
	
	    if (callback === 'after') {
	        app.pluginHook('pageAfterAnimation', pageData);
	        if (app.params.onPageAfterAnimation) app.params.onPageAfterAnimation(app, pageData);
	        app.triggerPageCallbacks('afterAnimation', pageData.name, pageData);
	        $(pageData.container).trigger('pageAfterAnimation page:afteranimation', {page: pageData});
	
	    }
	    if (callback === 'before') {
	        // Add data-page on view
	        $(view.container).attr('data-page', pageData.name);
	
	        // Update View's activePage
	        if (view) view.activePage = pageData;
	
	        // Hide/show navbar dynamically
	        if (newPage.hasClass('no-navbar') && !oldPage.hasClass('no-navbar')) {
	            view.hideNavbar();
	        }
	        if (!newPage.hasClass('no-navbar') && (oldPage.hasClass('no-navbar') || oldPage.hasClass('no-navbar-by-scroll'))) {
	            view.showNavbar();
	        }
	        // Hide/show navbar toolbar
	        if (newPage.hasClass('no-toolbar') && !oldPage.hasClass('no-toolbar')) {
	            view.hideToolbar();
	        }
	        if (!newPage.hasClass('no-toolbar') && (oldPage.hasClass('no-toolbar') || oldPage.hasClass('no-toolbar-by-scroll'))) {
	            view.showToolbar();
	        }
	        // Hide/show tabbar
	        var tabBar;
	        if (newPage.hasClass('no-tabbar') && !oldPage.hasClass('no-tabbar')) {
	            tabBar = $(view.container).find('.tabbar');
	            if (tabBar.length === 0) tabBar = $(view.container).parents('.' + app.params.viewsClass).find('.tabbar');
	            app.hideToolbar(tabBar);
	        }
	        if (!newPage.hasClass('no-tabbar') && (oldPage.hasClass('no-tabbar') || oldPage.hasClass('no-tabbar-by-scroll'))) {
	            tabBar = $(view.container).find('.tabbar');
	            if (tabBar.length === 0) tabBar = $(view.container).parents('.' + app.params.viewsClass).find('.tabbar');
	            app.showToolbar(tabBar);
	        }
	
	        oldPage.removeClass('no-navbar-by-scroll no-toolbar-by-scroll');
	        // Callbacks
	        app.pluginHook('pageBeforeAnimation', pageData);
	        if (app.params.onPageBeforeAnimation) app.params.onPageBeforeAnimation(app, pageData);
	        app.triggerPageCallbacks('beforeAnimation', pageData.name, pageData);
	        $(pageData.container).trigger('pageBeforeAnimation page:beforeanimation', {page: pageData});
	    }
	};
	
	// Init Page Events and Manipulations
	app.initPage = function (pageContainer) {
	    pageContainer = $(pageContainer);
	    if (pageContainer.length === 0) return;
	    // Size navbars on page load
	    if (app.sizeNavbars) app.sizeNavbars(pageContainer.parents('.' + app.params.viewClass)[0]);
	    // Init messages
	    if (app.initPageMessages) app.initPageMessages(pageContainer);
	    // Init forms storage
	    if (app.initFormsStorage) app.initFormsStorage(pageContainer);
	    // Init smart select
	    if (app.initSmartSelects) app.initSmartSelects(pageContainer);
	    // Init slider
	    if (app.initPageSwiper) app.initPageSwiper(pageContainer);
	    // Init pull to refres
	    if (app.initPullToRefresh) app.initPullToRefresh(pageContainer);
	    // Init infinite scroll
	    if (app.initPageInfiniteScroll) app.initPageInfiniteScroll(pageContainer);
	    // Init searchbar
	    if (app.initSearchbar) app.initSearchbar(pageContainer);
	    // Init message bar
	    if (app.initPageMessagebar) app.initPageMessagebar(pageContainer);
	    // Init scroll toolbars
	    if (app.initPageScrollToolbars) app.initPageScrollToolbars(pageContainer);
	    // Init lazy images
	    if (app.initImagesLazyLoad) app.initImagesLazyLoad(pageContainer);
	    // Init progress bars
	    if (app.initPageProgressbar) app.initPageProgressbar(pageContainer);
	    // Init resizeable textareas
	    if (app.initPageResizableTextarea) app.initPageResizableTextarea(pageContainer);
	    // Init Material Preloader
	    if (app.params.material && app.initPageMaterialPreloader) app.initPageMaterialPreloader(pageContainer);
	    // Init Material Inputs
	    if (app.params.material && app.initPageMaterialInputs) app.initPageMaterialInputs(pageContainer);
	    // Init Material Tabbar
	    if (app.params.material && app.initPageMaterialTabbar) app.initPageMaterialTabbar(pageContainer);
	};
	app.reinitPage = function (pageContainer) {
	    pageContainer = $(pageContainer);
	    if (pageContainer.length === 0) return;
	    // Size navbars on page reinit
	    if (app.sizeNavbars) app.sizeNavbars(pageContainer.parents('.' + app.params.viewClass)[0]);
	    // Reinit slider
	    if (app.reinitPageSwiper) app.reinitPageSwiper(pageContainer);
	    // Reinit lazy load
	    if (app.reinitLazyLoad) app.reinitLazyLoad(pageContainer);
	};
	app.initPageWithCallback = function (pageContainer) {
	    pageContainer = $(pageContainer);
	    var viewContainer = pageContainer.parents('.' + app.params.viewClass);
	    if (viewContainer.length === 0) return;
	    var view = viewContainer[0].f7View || undefined;
	    var url = view && view.url ? view.url : undefined;
	    if (viewContainer && pageContainer.attr('data-page')) {
	        viewContainer.attr('data-page', pageContainer.attr('data-page'));
	    }
	    app.pageInitCallback(view, {pageContainer: pageContainer[0], url: url, position: 'center'});
	};
	/*======================================================
	************   Navigation / Router   ************
	======================================================*/
	app.router = {
	    _remove: function (el) {
	        if (app.params.routerRemoveTimeout || app.params.routerRemoveWithTimeout) {
	            setTimeout(function () {
	                $(el).remove();
	            }, 0);
	        }
	        else $(el).remove();
	    },
	    _modalsSelector: '.popup, .modal, .popover, .actions-modal, .picker-modal, .login-screen',
	    // Temporary DOM Element
	    temporaryDom: document.createElement('div'),
	
	    // Find page or navbar in passed container which are related to View
	    findElement: function (selector, container, view, notCached) {
	        container = $(container);
	        if (notCached) selector = selector + ':not(.cached)';
	        var found = container.find(selector).filter(function (index, el) {
	            return $(el).parents(app.router._modalsSelector).length === 0;
	        });
	        if (found.length > 1) {
	            if (typeof view.selector === 'string') {
	                // Search in related view
	                found = container.find(view.selector + ' ' + selector);
	            }
	            if (found.length > 1) {
	                // Search in main view
	                found = container.find('.' + app.params.viewMainClass + ' ' + selector);
	            }
	        }
	        if (found.length === 1) return found;
	        else {
	            // Try to find non cached
	            if (!notCached) found = app.router.findElement(selector, container, view, true);
	            if (found && found.length === 1) return found;
	            if (found && found.length > 1) return $(found[0]);
	            else return undefined;
	        }
	    },
	
	    // Set pages classes for animationEnd
	    animatePages: function (leftPage, rightPage, direction) {
	        // Loading new page
	        var removeClasses = 'page-on-center page-on-right page-on-left';
	        if (direction === 'to-left') {
	            leftPage.removeClass(removeClasses).addClass('page-from-center-to-left');
	            rightPage.removeClass(removeClasses).addClass('page-from-right-to-center');
	        }
	        // Go back
	        if (direction === 'to-right') {
	            leftPage.removeClass(removeClasses).addClass('page-from-left-to-center');
	            rightPage.removeClass(removeClasses).addClass('page-from-center-to-right');
	
	        }
	    },
	
	    // Prepare navbar before animarion
	    prepareNavbar: function (newNavbarInner, oldNavbarInner, newNavbarPosition) {
	        $(newNavbarInner).find('.sliding').each(function () {
	            var sliding = $(this);
	            var slidingOffset = newNavbarPosition === 'right' ? this.f7NavbarRightOffset : this.f7NavbarLeftOffset;
	
	            if (app.params.animateNavBackIcon) {
	                if (sliding.hasClass('left') && sliding.find('.back .icon').length > 0) {
	                    sliding.find('.back .icon').transform('translate3d(' + (-slidingOffset) + 'px,0,0)');
	                }
	            }
	            sliding.transform('translate3d(' + slidingOffset + 'px,0,0)');
	        });
	    },
	
	    // Set navbars classes for animation
	    animateNavbars: function (leftNavbarInner, rightNavbarInner, direction) {
	        // Loading new page
	        var removeClasses = 'navbar-on-right navbar-on-center navbar-on-left';
	        if (direction === 'to-left') {
	            rightNavbarInner.removeClass(removeClasses).addClass('navbar-from-right-to-center');
	            rightNavbarInner.find('.sliding').each(function () {
	                var sliding = $(this);
	                sliding.transform('translate3d(0px,0,0)');
	                if (app.params.animateNavBackIcon) {
	                    if (sliding.hasClass('left') && sliding.find('.back .icon').length > 0) {
	                        sliding.find('.back .icon').transform('translate3d(0px,0,0)');
	                    }
	                }
	            });
	
	            leftNavbarInner.removeClass(removeClasses).addClass('navbar-from-center-to-left');
	            leftNavbarInner.find('.sliding').each(function () {
	                var sliding = $(this);
	                var rightText;
	                if (app.params.animateNavBackIcon) {
	                    if (sliding.hasClass('center') && rightNavbarInner.find('.sliding.left .back .icon').length > 0) {
	                        rightText = rightNavbarInner.find('.sliding.left .back span');
	                        if (rightText.length > 0) this.f7NavbarLeftOffset += rightText[0].offsetLeft;
	                    }
	                    if (sliding.hasClass('left') && sliding.find('.back .icon').length > 0) {
	                        sliding.find('.back .icon').transform('translate3d(' + (-this.f7NavbarLeftOffset) + 'px,0,0)');
	                    }
	                }
	                sliding.transform('translate3d(' + (this.f7NavbarLeftOffset) + 'px,0,0)');
	            });
	        }
	        // Go back
	        if (direction === 'to-right') {
	            leftNavbarInner.removeClass(removeClasses).addClass('navbar-from-left-to-center');
	            leftNavbarInner.find('.sliding').each(function () {
	                var sliding = $(this);
	                sliding.transform('translate3d(0px,0,0)');
	                if (app.params.animateNavBackIcon) {
	                    if (sliding.hasClass('left') && sliding.find('.back .icon').length > 0) {
	                        sliding.find('.back .icon').transform('translate3d(0px,0,0)');
	                    }
	                }
	            });
	
	            rightNavbarInner.removeClass(removeClasses).addClass('navbar-from-center-to-right');
	            rightNavbarInner.find('.sliding').each(function () {
	                var sliding = $(this);
	                if (app.params.animateNavBackIcon) {
	                    if (sliding.hasClass('left') && sliding.find('.back .icon').length > 0) {
	                        sliding.find('.back .icon').transform('translate3d(' + (-this.f7NavbarRightOffset) + 'px,0,0)');
	                    }
	                }
	                sliding.transform('translate3d(' + (this.f7NavbarRightOffset) + 'px,0,0)');
	            });
	        }
	    },
	
	    preprocess: function(view, content, url, next) {
	        // Plugin hook
	        app.pluginHook('routerPreprocess', view, content, url, next);
	
	        // Preprocess by plugin
	        content = app.pluginProcess('preprocess', content);
	
	        if (view && view.params && view.params.preprocess) {
	            content = view.params.preprocess(content, url, next);
	            if (typeof content !== 'undefined') {
	                next(content);
	            }
	        }
	        else if (app.params.preprocess) {
	            content = app.params.preprocess(content, url, next);
	            if (typeof content !== 'undefined') {
	                next(content);
	            }
	        }
	        else {
	            next(content);
	        }
	    },
	    preroute: function(view, options, isBack) {
	        if (isBack) options.isBack = true;
	        app.pluginHook('routerPreroute', view, options);
	        if ((app.params.preroute && app.params.preroute(view, options) === false) || (view && view.params.preroute && view.params.preroute(view, options) === false)) {
	            return true;
	        }
	        else {
	            return false;
	        }
	    },
	
	    template7Render: function (view, options) {
	        var url = options.url,
	            content = options.content, //initial content
	            t7_rendered_content = options.content, // will be rendered using Template7
	            context = options.context, // Context data for Template7
	            contextName = options.contextName,
	            template = options.template; // Template 7 compiled template
	
	        var t7_ctx, t7_template;
	        if (typeof content === 'string') {
	            if (url) {
	                if (app.template7Cache[url] && !options.ignoreCache) t7_template = t7.cache[url];
	                else {
	                    t7_template = t7.compile(content);
	                    t7.cache[url] = t7_template;
	                }
	            }
	            else t7_template = t7.compile(content);
	        }
	        else if (template) {
	            t7_template = template;
	        }
	
	        if (context) {
	            t7_ctx = context;
	            if (context && url) {
	                view.contextCache[url] = context;
	            }
	        }
	        else {
	            if (contextName) {
	                if (contextName.indexOf('.') >= 0) {
	                    var _ctx_path = contextName.split('.');
	                    var _ctx = t7.data[_ctx_path[0]];
	                    for (var i = 1; i < _ctx_path.length; i++) {
	                        if (_ctx_path[i]) _ctx = _ctx[_ctx_path[i]];
	                    }
	                    t7_ctx = _ctx;
	                }
	                else t7_ctx = t7.data[contextName];
	            }
	            if (!t7_ctx && url) {
	                t7_ctx = t7.data['url:' + url];
	            }
	            if (!t7_ctx && typeof content === 'string' && !template) {
	                //try to find by page name in content
	                var pageNameMatch = content.match(/(data-page=["'][^"^']*["'])/);
	                if (pageNameMatch) {
	                    var page = pageNameMatch[0].split('data-page=')[1].replace(/['"]/g, '');
	                    if (page) t7_ctx = t7.data['page:' + page];
	                }
	            }
	            if (!t7_ctx && template && t7.templates) {
	                // Try to find matched template name in t7.templates
	                for (var templateName in t7.templates) {
	                    if (t7.templates[templateName] === template) t7_ctx = t7.data[templateName];
	                }
	            }
	            if (!t7_ctx && url && url in view.contextCache) {
	                t7_ctx = view.contextCache[url];
	            }
	            if (!t7_ctx) {
	                t7_ctx = {};
	            }
	        }
	
	        if (t7_template && t7_ctx) {
	            if (typeof t7_ctx === 'function') t7_ctx = t7_ctx();
	            if (url) {
	                // Extend data with URL query
	                var query = $.parseUrlQuery(url);
	                t7_ctx.url_query = {};
	                for (var key in query) {
	                    t7_ctx.url_query[key] = query[key];
	                }
	            }
	            try {
	                t7_rendered_content = t7_template(t7_ctx);
	            }
	            catch (e) {
	                t7_rendered_content = '';
	                if (window.console && window.console.error) {
	                    console.error(e);
	                }
	            }
	        }
	
	        return {content: t7_rendered_content, context: t7_ctx};
	    }
	};
	
	
	app.router._load = function (view, options) {
	    // Plugin hook
	    app.pluginHook('routerLoad', view, options);
	
	    var url = options.url,
	        content = options.content, //initial content
	        t7_rendered = {content: options.content},
	        template = options.template, // Template 7 compiled template
	        pageName = options.pageName,
	        viewContainer = $(view.container),
	        pagesContainer = $(view.pagesContainer),
	        animatePages = options.animatePages,
	        newPage, oldPage, pagesInView, i, oldNavbarInner, newNavbarInner, navbar, dynamicNavbar, reloadPosition,
	        isDynamicPage = typeof url === 'undefined' && content || template,
	        pushState = options.pushState,
	        pageElement = options.pageElement;
	
	    if (typeof animatePages === 'undefined') animatePages = view.params.animatePages;
	
	    // Render with Template7
	    if (app.params.template7Pages && typeof content === 'string' || template) {
	        t7_rendered = app.router.template7Render(view, options);
	        if (t7_rendered.content && !content) {
	            content = t7_rendered.content;
	        }
	    }
	
	    app.router.temporaryDom.innerHTML = '';
	
	    // Parse DOM
	    if (!pageName && !pageElement) {
	        if ((typeof content === 'string') || (url && (typeof content === 'string'))) {
	            app.router.temporaryDom.innerHTML = t7_rendered.content;
	        } else {
	            if ('length' in content && content.length > 1) {
	                for (var ci = 0; ci < content.length; ci++) {
	                    $(app.router.temporaryDom).append(content[ci]);
	                }
	            } else {
	                $(app.router.temporaryDom).append(content);
	            }
	        }
	    }
	
	    // Reload position
	    reloadPosition = options.reload && (options.reloadPrevious ? 'left' : 'center');
	
	    // Find new page
	    if (pageName) newPage = pagesContainer.find('.page[data-page="' + pageName + '"]');
	    else {
	        if (pageElement) newPage = $(pageElement);
	        else newPage = app.router.findElement('.page', app.router.temporaryDom, view);
	    }
	    // If page not found exit
	    if (!newPage || newPage.length === 0 || (pageName && view.activePage && view.activePage.name === pageName)) {
	        view.allowPageChange = true;
	        return;
	    }
	
	    newPage.addClass(options.reload ? 'page-on-' + reloadPosition : 'page-on-right');
	
	    // Find old page (should be the last one) and remove older pages
	    pagesInView = pagesContainer.children('.page:not(.cached)');
	    if (pageElement) {
	        pagesInView = pagesInView.filter(function (index, page) {
	            if (page !== pageElement) return page;
	        });
	    }
	
	    if (options.reload && options.reloadPrevious && pagesInView.length === 1)  {
	        view.allowPageChange = true;
	        return;
	    }
	
	    if (options.reload) {
	        oldPage = pagesInView.eq(pagesInView.length - 1);
	    }
	    else {
	        if (pagesInView.length > 1) {
	            for (i = 0; i < pagesInView.length - 2; i++) {
	                if (!view.params.domCache) {
	                    app.pageRemoveCallback(view, pagesInView[i], 'left');
	                    app.router._remove(pagesInView[i]);
	                }
	                else {
	                    $(pagesInView[i]).addClass('cached');
	                }
	            }
	            if (!view.params.domCache) {
	                app.pageRemoveCallback(view, pagesInView[i], 'left');
	                app.router._remove(pagesInView[i]);
	            }
	            else {
	                $(pagesInView[i]).addClass('cached');
	            }
	        }
	        oldPage = pagesContainer.children('.page:not(.cached)');
	    }
	    if (pageElement && oldPage.length > 1) {
	        oldPage = oldPage.filter(function (index, page) {
	            if (page !== pageElement) return page;
	        });
	    }
	    if(view.params.domCache || pageElement) newPage.removeClass('cached');
	
	    // Dynamic navbar
	    if (view.params.dynamicNavbar) {
	        dynamicNavbar = true;
	        // Find navbar
	        if (pageName) {
	            newNavbarInner = viewContainer.find('.navbar-inner[data-page="' + pageName + '"]');
	        }
	        else {
	            newNavbarInner = app.router.findElement('.navbar-inner', app.router.temporaryDom, view);
	        }
	        if (!newNavbarInner || newNavbarInner.length === 0) {
	            // Look in page
	            newNavbarInner = newPage.find('.navbar-inner');
	            if (!newNavbarInner || newNavbarInner.length === 0) {
	                // Set false
	                dynamicNavbar = false;
	            }
	            else {
	                if (newNavbarInner.parent('.navbar').length > 0) {
	                    newNavbarInner.prependTo(newPage);
	                }
	            }
	        }
	        if (dynamicNavbar && newPage.find('.navbar').length > 0) {
	            app.router._remove(newPage.find('.navbar').filter(function(index, el){
	                return $(el).parents(app.router._modalsSelector).length === 0;
	            }));
	        }
	        navbar = viewContainer.children('.navbar');
	        if (options.reload) {
	            oldNavbarInner = navbar.find('.navbar-inner:not(.cached):last-child');
	        }
	        else {
	            oldNavbarInner = navbar.find('.navbar-inner:not(.cached)');
	
	            if (oldNavbarInner.length > 0) {
	                for (i = 0; i < oldNavbarInner.length - 1; i++) {
	                    if (!view.params.domCache) {
	                        app.navbarRemoveCallback(view, pagesInView[i], navbar[0], oldNavbarInner[i]);
	                        app.router._remove(oldNavbarInner[i]);
	                    }
	                    else
	                        $(oldNavbarInner[i]).addClass('cached');
	                }
	                if (!newNavbarInner && oldNavbarInner.length === 1) {
	                    if (!view.params.domCache) {
	                        app.navbarRemoveCallback(view, pagesInView[0], navbar[0], oldNavbarInner[0]);
	                        app.router._remove(oldNavbarInner[0]);
	                    }
	                    else
	                        $(oldNavbarInner[0]).addClass('cached');
	                }
	                oldNavbarInner = navbar.find('.navbar-inner:not(.cached)');
	            }
	        }
	    }
	    if (dynamicNavbar) {
	        newNavbarInner.addClass(options.reload ? 'navbar-on-' + reloadPosition : 'navbar-on-right');
	        if(view.params.domCache || pageElement) newNavbarInner.removeClass('cached');
	        newPage[0].f7RelatedNavbar = newNavbarInner[0];
	        newNavbarInner[0].f7RelatedPage = newPage[0];
	    }
	
	    // save content areas into view's cache
	    if (!url) {
	        var newPageName = pageName || newPage.attr('data-page');
	        if (isDynamicPage) url = '#' + app.params.dynamicPageUrl.replace(/{{name}}/g, newPageName).replace(/{{index}}/g, view.history.length - (options.reload ? 1 : 0));
	        else url = '#' + newPageName;
	        if (!view.params.domCache) {
	            view.contentCache[url] = content;
	        }
	        if (view.params.domCache && pageName) {
	            view.pagesCache[url] = pageName;
	        }
	    }
	    else if (url && pageElement) {
	        view.pageElementsCache[url] = {
	            page: newPage,
	            navbarInner: newNavbarInner
	        };
	    }
	
	    // Push State
	    if (app.params.pushState && !options.reloadPrevious && view.main)  {
	        if (typeof pushState === 'undefined') pushState = true;
	        var pushStateRoot = app.params.pushStateRoot || '';
	        var method = options.reload ? 'replaceState' : 'pushState';
	        if (pushState) {
	            if (!isDynamicPage && !pageName) {
	                history[method]({url: url, viewIndex: app.views.indexOf(view)}, '', pushStateRoot + app.params.pushStateSeparator + url);
	            }
	            else if (isDynamicPage && content) {
	                history[method]({content: typeof content === 'string' ? content : '', url: url, viewIndex: app.views.indexOf(view)}, '', pushStateRoot + app.params.pushStateSeparator + url);
	            }
	            else if (pageName) {
	                history[method]({pageName: pageName, url: url, viewIndex: app.views.indexOf(view)}, '', pushStateRoot + app.params.pushStateSeparator + url);
	            }
	        }
	    }
	
	    // Update View history
	    view.url = url;
	    if (options.reload) {
	        var lastUrl = view.history[view.history.length - (options.reloadPrevious ? 2 : 1)];
	        if (lastUrl &&
	            lastUrl.indexOf('#') === 0 &&
	            lastUrl in view.contentCache &&
	            lastUrl !== url &&
	            view.history.indexOf(lastUrl) === -1) {
	            view.contentCache[lastUrl] = null;
	            delete view.contentCache[lastUrl];
	        }
	        else if (lastUrl &&
	            lastUrl in view.pageElementsCache &&
	            lastUrl !== url &&
	            (view.history.indexOf(lastUrl) === -1 || view.history.indexOf(lastUrl) === view.history.length - 1)) {
	            view.pageElementsCache[lastUrl] = null;
	            delete view.pageElementsCache[lastUrl];
	        }
	        if (lastUrl &&
	            lastUrl in view.contextCache &&
	            lastUrl !== url &&
	            (view.history.indexOf(lastUrl) === -1 || view.history.indexOf(lastUrl) === view.history.length - 1)) {
	            view.contextCache[lastUrl] = null;
	            delete view.contextCache[lastUrl];
	        }
	        view.history[view.history.length - (options.reloadPrevious ? 2 : 1)] = url;
	    }
	    else {
	        view.history.push(url);
	    }
	
	    // Unique history
	    var historyBecameUnique = false;
	    if (view.params.uniqueHistory) {
	        var _history = view.history;
	        var _url = url;
	        if (view.params.uniqueHistoryIgnoreGetParameters) {
	            _history = [];
	            _url = url.split('?')[0];
	            for (i = 0; i < view.history.length; i++) {
	                _history.push(view.history[i].split('?')[0]);
	            }
	        }
	
	        if (_history.indexOf(_url) !== _history.lastIndexOf(_url)) {
	            view.history = view.history.slice(0, _history.indexOf(_url));
	            view.history.push(url);
	            historyBecameUnique = true;
	        }
	    }
	    // Dom manipulations
	    if (options.reloadPrevious) {
	        oldPage = oldPage.prev('.page');
	        newPage.insertBefore(oldPage);
	        if (dynamicNavbar) {
	            oldNavbarInner = oldNavbarInner.prev('.navbar-inner');
	            newNavbarInner.insertAfter(oldNavbarInner);
	        }
	    }
	    else {
	        pagesContainer.append(newPage[0]);
	        if (dynamicNavbar) navbar.append(newNavbarInner[0]);
	    }
	    // Remove Old Page And Navbar
	    if (options.reload) {
	        if (view.params.domCache && view.initialPages.indexOf(oldPage[0]) >= 0) {
	            oldPage.addClass('cached');
	            if (dynamicNavbar) oldNavbarInner.addClass('cached');
	        }
	        else {
	            app.pageRemoveCallback(view, oldPage[0], reloadPosition);
	            if (dynamicNavbar) app.navbarRemoveCallback(view, oldPage[0], navbar[0], oldNavbarInner[0]);
	            app.router._remove(oldPage);
	            if (dynamicNavbar) app.router._remove(oldNavbarInner);
	        }
	    }
	
	    // Page Init Events
	    app.pageInitCallback(view, {
	        pageContainer: newPage[0],
	        url: url,
	        position: options.reload ? reloadPosition : 'right',
	        navbarInnerContainer: dynamicNavbar ? newNavbarInner && newNavbarInner[0] : undefined,
	        oldNavbarInnerContainer: dynamicNavbar ? oldNavbarInner && oldNavbarInner[0] : undefined,
	        context: t7_rendered.context || options.context,
	        query: options.query,
	        fromPage: oldPage && oldPage.length && oldPage[0].f7PageData,
	        reload: options.reload,
	        reloadPrevious: options.reloadPrevious
	    });
	
	    // Navbar init event
	    if (dynamicNavbar) {
	        app.navbarInitCallback(view, newPage[0], navbar[0], newNavbarInner[0], url, options.reload ? reloadPosition : 'right');
	    }
	
	    if (options.reload) {
	        view.allowPageChange = true;
	        if (historyBecameUnique) view.refreshPreviousPage();
	        return;
	    }
	
	    if (dynamicNavbar && animatePages) {
	        app.router.prepareNavbar(newNavbarInner, oldNavbarInner, 'right');
	    }
	    // Force reLayout
	    var clientLeft = newPage[0].clientLeft;
	
	    // Before Anim Callback
	    app.pageAnimCallback('before', view, {
	        pageContainer: newPage[0],
	        url: url,
	        position: 'right',
	        oldPage: oldPage,
	        newPage: newPage,
	        query: options.query,
	        fromPage: oldPage && oldPage.length && oldPage[0].f7PageData
	    });
	
	    function afterAnimation() {
	        view.allowPageChange = true;
	        newPage.removeClass('page-from-right-to-center page-on-right page-on-left').addClass('page-on-center');
	        oldPage.removeClass('page-from-center-to-left page-on-center page-on-right').addClass('page-on-left');
	        if (dynamicNavbar) {
	            newNavbarInner.removeClass('navbar-from-right-to-center navbar-on-left navbar-on-right').addClass('navbar-on-center');
	            oldNavbarInner.removeClass('navbar-from-center-to-left navbar-on-center navbar-on-right').addClass('navbar-on-left');
	        }
	        app.pageAnimCallback('after', view, {
	            pageContainer: newPage[0],
	            url: url,
	            position: 'right',
	            oldPage: oldPage,
	            newPage: newPage,
	            query: options.query,
	            fromPage: oldPage && oldPage.length && oldPage[0].f7PageData
	        });
	        if (app.params.pushState && view.main) app.pushStateClearQueue();
	        if (!(view.params.swipeBackPage || view.params.preloadPreviousPage)) {
	            if (view.params.domCache) {
	                oldPage.addClass('cached');
	                if (dynamicNavbar) oldNavbarInner.addClass('cached');
	            }
	            else {
	                if (!(url.indexOf('#') === 0 && newPage.attr('data-page').indexOf('smart-select-') === 0)) {
	                    app.pageRemoveCallback(view, oldPage[0], 'left');
	                    if (dynamicNavbar) app.navbarRemoveCallback(view, oldPage[0], navbar[0], oldNavbarInner[0]);
	                    app.router._remove(oldPage);
	                    if (dynamicNavbar) app.router._remove(oldNavbarInner);
	                }
	            }
	        }
	        if (view.params.uniqueHistory && historyBecameUnique) {
	            view.refreshPreviousPage();
	        }
	    }
	    if (animatePages) {
	        // Set pages before animation
	        if (app.params.material && app.params.materialPageLoadDelay) {
	            setTimeout(function () {
	                app.router.animatePages(oldPage, newPage, 'to-left', view);
	            }, app.params.materialPageLoadDelay);
	        }
	        else {
	            app.router.animatePages(oldPage, newPage, 'to-left', view);
	        }
	
	        // Dynamic navbar animation
	        if (dynamicNavbar) {
	            setTimeout(function() {
	                app.router.animateNavbars(oldNavbarInner, newNavbarInner, 'to-left', view);
	            }, 0);
	        }
	        newPage.animationEnd(function () {
	            afterAnimation();
	        });
	    }
	    else {
	        if (dynamicNavbar) newNavbarInner.find('.sliding, .sliding .back .icon').transform('');
	        afterAnimation();
	    }
	
	};
	
	app.router.load = function (view, options) {
	    options = options || {};
	    if (app.router.preroute(view, options)) {
	        return false;
	    }
	    var url = options.url;
	    var content = options.content;
	    var pageName = options.pageName;
	    var pageElement = options.pageElement;
	    if (pageName) {
	        if (pageName.indexOf('?') > 0) {
	            options.query = $.parseUrlQuery(pageName);
	            options.pageName = pageName = pageName.split('?')[0];
	        }
	    }
	    var template = options.template;
	    if (view.params.reloadPages === true) options.reload = true;
	
	    if (!view.allowPageChange) return false;
	    if (url && view.url === url && !options.reload && !view.params.allowDuplicateUrls) return false;
	    view.allowPageChange = false;
	    if (app.xhr && view.xhr && view.xhr === app.xhr) {
	        app.xhr.abort();
	        app.xhr = false;
	    }
	    function proceed(content) {
	        app.router.preprocess(view, content, url, function (content) {
	            options.content = content;
	            app.router._load(view, options);
	        });
	    }
	    if (content || pageName || pageElement) {
	        proceed(content);
	        return;
	    }
	    else if (template) {
	        app.router._load(view, options);
	        return;
	    }
	
	    if (!options.url || options.url === '#') {
	        view.allowPageChange = true;
	        return;
	    }
	    app.get(options.url, view, options.ignoreCache, function (content, error) {
	        if (error) {
	            view.allowPageChange = true;
	            return;
	        }
	        proceed(content);
	    });
	};
	
	app.router._back = function (view, options) {
	    options = options || {};
	
	    app.pluginHook('routerBack', view, options);
	
	    var url = options.url,
	        content = options.content,
	        t7_rendered = {content: options.content}, // will be rendered using Template7
	        template = options.template, // Template 7 compiled template
	        animatePages = options.animatePages,
	        preloadOnly = options.preloadOnly,
	        pushState = options.pushState,
	        ignoreCache = options.ignoreCache,
	        force = options.force,
	        pageName = options.pageName,
	        pageElement = options.pageElement;
	
	    var viewContainer = $(view.container),
	        pagesContainer = $(view.pagesContainer),
	        pagesInView = pagesContainer.children('.page:not(.cached)'),
	        oldPage, newPage, oldNavbarInner, newNavbarInner, navbar, navbarInners, dynamicNavbar, manipulateDom = true;
	
	    if (typeof animatePages === 'undefined') animatePages = view.params.animatePages;
	
	    // Render with Template7
	    if (app.params.template7Pages && typeof content === 'string' || template) {
	        t7_rendered = app.router.template7Render(view, options);
	        if (t7_rendered.content && !content) {
	            content = t7_rendered.content;
	        }
	    }
	
	    // Animation
	    function afterAnimation() {
	        app.pageBackCallback('after', view, {
	            pageContainer: oldPage[0],
	            url: url,
	            position: 'center',
	            oldPage: oldPage,
	            newPage: newPage,
	        });
	        app.pageAnimCallback('after', view, {
	            pageContainer: newPage[0],
	            url: url,
	            position: 'left',
	            oldPage: oldPage,
	            newPage: newPage,
	            query: options.query,
	            fromPage: oldPage && oldPage.length && oldPage[0].f7PageData
	        });
	        app.router.afterBack(view, oldPage[0], newPage[0]);
	    }
	    function animateBack() {
	        // Page before animation callback
	        app.pageBackCallback('before', view, {
	            pageContainer: oldPage[0],
	            url: url,
	            position: 'center',
	            oldPage: oldPage,
	            newPage: newPage,
	        });
	        app.pageAnimCallback('before', view, {
	            pageContainer: newPage[0],
	            url: url,
	            position: 'left',
	            oldPage: oldPage,
	            newPage: newPage,
	            query: options.query,
	            fromPage: oldPage && oldPage.length && oldPage[0].f7PageData
	        });
	
	        if (animatePages) {
	            // Set pages before animation
	            app.router.animatePages(newPage, oldPage, 'to-right', view);
	
	            // Dynamic navbar animation
	            if (dynamicNavbar) {
	                setTimeout(function () {
	                    app.router.animateNavbars(newNavbarInner, oldNavbarInner, 'to-right', view);
	                }, 0);
	            }
	
	            newPage.animationEnd(function () {
	                afterAnimation();
	            });
	        }
	        else {
	            if (dynamicNavbar) newNavbarInner.find('.sliding, .sliding .back .icon').transform('');
	            afterAnimation();
	        }
	    }
	
	    function parseNewPage() {
	        app.router.temporaryDom.innerHTML = '';
	        // Parse DOM
	        if ((typeof content === 'string') || (url && (typeof content === 'string'))) {
	            app.router.temporaryDom.innerHTML = t7_rendered.content;
	        } else {
	            if ('length' in content && content.length > 1) {
	                for (var ci = 0; ci < content.length; ci++) {
	                    $(app.router.temporaryDom).append(content[ci]);
	                }
	            } else {
	                $(app.router.temporaryDom).append(content);
	            }
	        }
	        if (pageElement) newPage = $(pageElement);
	        else newPage = app.router.findElement('.page', app.router.temporaryDom, view);
	
	        if (view.params.dynamicNavbar) {
	            // Find navbar
	            newNavbarInner = app.router.findElement('.navbar-inner', app.router.temporaryDom, view);
	        }
	    }
	    function setPages() {
	        // If pages not found or there are still more than one, exit
	        if (!newPage || newPage.length === 0) {
	            view.allowPageChange = true;
	            return;
	        }
	        if (view.params.dynamicNavbar && typeof dynamicNavbar === 'undefined') {
	            if (!newNavbarInner || newNavbarInner.length === 0) {
	                dynamicNavbar = false;
	            }
	            else {
	                dynamicNavbar = true;
	            }
	        }
	
	        newPage.addClass('page-on-left').removeClass('cached');
	        if (dynamicNavbar) {
	            navbar = viewContainer.children('.navbar');
	            navbarInners = navbar.find('.navbar-inner:not(.cached)');
	            newNavbarInner.addClass('navbar-on-left').removeClass('cached');
	        }
	        // Remove/hide previous page in force mode
	        if (force) {
	            var pageToRemove, navbarToRemove;
	            pageToRemove = $(pagesInView[pagesInView.length - 2]);
	
	            if (dynamicNavbar) navbarToRemove = $(pageToRemove[0] && pageToRemove[0].f7RelatedNavbar || navbarInners[navbarInners.length - 2]);
	            if (view.params.domCache && view.initialPages.indexOf(pageToRemove[0]) >= 0) {
	                if (pageToRemove.length && pageToRemove[0] !== newPage[0]) pageToRemove.addClass('cached');
	                if (dynamicNavbar && navbarToRemove.length && navbarToRemove[0] !== newNavbarInner[0]) {
	                    navbarToRemove.addClass('cached');
	                }
	            }
	            else {
	                var removeNavbar = dynamicNavbar && navbarToRemove.length;
	                if (pageToRemove.length) {
	                    app.pageRemoveCallback(view, pageToRemove[0], 'right');
	                    if (removeNavbar) {
	                        app.navbarRemoveCallback(view, pageToRemove[0], navbar[0], navbarToRemove[0]);
	                    }
	                    app.router._remove(pageToRemove);
	                    if (removeNavbar) app.router._remove(navbarToRemove);
	                }
	                else if (removeNavbar) {
	                    app.navbarRemoveCallback(view, pageToRemove[0], navbar[0], navbarToRemove[0]);
	                    app.router._remove(navbarToRemove);
	                }
	            }
	            pagesInView = pagesContainer.children('.page:not(.cached)');
	            if (dynamicNavbar) {
	                navbarInners = viewContainer.children('.navbar').find('.navbar-inner:not(.cached)');
	            }
	            if (view.history.indexOf(url) >= 0) {
	                view.history = view.history.slice(0, view.history.indexOf(url) + 2);
	            }
	            else {
	                if (view.history[[view.history.length - 2]]) {
	                    view.history[view.history.length - 2] = url;
	                }
	                else {
	                    view.history.unshift(url);
	                }
	            }
	        }
	
	        oldPage = $(pagesInView[pagesInView.length - 1]);
	        if (view.params.domCache) {
	            if (oldPage[0] === newPage[0]) {
	                oldPage = pagesContainer.children('.page.page-on-center');
	                if (oldPage.length === 0 && view.activePage) oldPage = $(view.activePage.container);
	            }
	        }
	
	        if (dynamicNavbar && !oldNavbarInner) {
	            oldNavbarInner = $(navbarInners[navbarInners.length - 1]);
	            if (view.params.domCache) {
	                if (oldNavbarInner[0] === newNavbarInner[0]) {
	                    oldNavbarInner = navbar.children('.navbar-inner.navbar-on-center:not(.cached)');
	                }
	                if (oldNavbarInner.length === 0) {
	                    oldNavbarInner = navbar.children('.navbar-inner[data-page="'+oldPage.attr('data-page')+'"]');
	                }
	            }
	            if (oldNavbarInner.length === 0 || newNavbarInner[0] === oldNavbarInner[0]) dynamicNavbar = false;
	        }
	
	        if (dynamicNavbar) {
	            if (manipulateDom) newNavbarInner.insertBefore(oldNavbarInner);
	            newNavbarInner[0].f7RelatedPage = newPage[0];
	            newPage[0].f7RelatedNavbar = newNavbarInner[0];
	        }
	        if (manipulateDom) newPage.insertBefore(oldPage);
	
	        // Page Init Events
	        app.pageInitCallback(view, {
	            pageContainer: newPage[0],
	            url: url,
	            position: 'left',
	            navbarInnerContainer: dynamicNavbar ? newNavbarInner[0] : undefined,
	            oldNavbarInnerContainer: dynamicNavbar ? oldNavbarInner && oldNavbarInner[0] : undefined,
	            context: t7_rendered.context,
	            query: options.query,
	            fromPage: oldPage && oldPage.length && oldPage[0].f7PageData,
	            preloadOnly: preloadOnly
	        });
	        if (dynamicNavbar) {
	            app.navbarInitCallback(view, newPage[0], navbar[0], newNavbarInner[0], url, 'right');
	        }
	
	        if (dynamicNavbar && newNavbarInner.hasClass('navbar-on-left') && animatePages) {
	            app.router.prepareNavbar(newNavbarInner,  oldNavbarInner, 'left');
	        }
	
	        if (preloadOnly) {
	            view.allowPageChange = true;
	            return;
	        }
	
	        // Update View's URL
	        view.url = url;
	
	        // Force reLayout
	        var clientLeft = newPage[0].clientLeft;
	
	        animateBack();
	
	        // Push state
	        if (app.params.pushState && view.main)  {
	            if (typeof pushState === 'undefined') pushState = true;
	            if (!preloadOnly && history.state && pushState) {
	                history.back();
	            }
	        }
	        return;
	    }
	
	    // Simple go back when we have pages on left
	    if (pagesInView.length > 1 && !force) {
	        // Exit if only preloadOnly
	        if (preloadOnly) {
	            view.allowPageChange = true;
	            return;
	        }
	        // Update View's URL
	        view.url = view.history[view.history.length - 2];
	        url = view.url;
	
	        // Define old and new pages
	        newPage = $(pagesInView[pagesInView.length - 2]);
	        oldPage = $(pagesInView[pagesInView.length - 1]);
	
	        // Dynamic navbar
	        if (view.params.dynamicNavbar) {
	            dynamicNavbar = true;
	            // Find navbar
	            navbarInners = viewContainer.children('.navbar').find('.navbar-inner:not(.cached)');
	            newNavbarInner = $(navbarInners[0]);
	            oldNavbarInner = $(navbarInners[1]);
	            if (newNavbarInner.length === 0 || oldNavbarInner.length === 0 || oldNavbarInner[0] === newNavbarInner[0]) {
	                dynamicNavbar = false;
	            }
	        }
	        manipulateDom = false;
	        setPages();
	        return;
	    }
	
	    if (!force) {
	        // Go back when there is no pages on left
	        if (!preloadOnly) {
	            view.url = view.history[view.history.length - 2];
	            url = view.url;
	        }
	
	        if (content) {
	            parseNewPage();
	            setPages();
	            return;
	        }
	        else if (pageName) {
	            // Get dom cached pages
	            newPage = $(viewContainer).find('.page[data-page="' + pageName + '"]');
	            if (view.params.dynamicNavbar) {
	                newNavbarInner = $(viewContainer).children('.navbar').find('.navbar-inner[data-page="' + pageName + '"]');
	                if (newNavbarInner.length === 0 && newPage[0].f7RelatedNavbar) {
	                    newNavbarInner = $(newPage[0].f7RelatedNavbar);
	                }
	                if (newNavbarInner.length === 0 && newPage[0].f7PageData) {
	                    newNavbarInner = $(newPage[0].f7PageData.navbarInnerContainer);
	                }
	            }
	            setPages();
	            return;
	        }
	        else if (url && url in view.pageElementsCache) {
	            newPage = view.pageElementsCache[url].page;
	            newNavbarInner = view.pageElementsCache[url].navbarInner;
	            setPages();
	            return;
	        }
	        else {
	            view.allowPageChange = true;
	            return;
	        }
	    }
	    else {
	        if (url && url === view.url || pageName && view.activePage && view.activePage.name === pageName) {
	            view.allowPageChange = true;
	            return;
	        }
	        // Go back with force url
	        if (content) {
	            parseNewPage();
	            setPages();
	            return;
	        }
	        else if (pageName && view.params.domCache) {
	            if (pageName) url = '#' + pageName;
	
	            newPage = $(viewContainer).find('.page[data-page="' + pageName + '"]');
	            if (newPage[0].f7PageData && newPage[0].f7PageData.url) {
	                url = newPage[0].f7PageData.url;
	            }
	            if (view.params.dynamicNavbar) {
	                newNavbarInner = $(viewContainer).children('.navbar').find('.navbar-inner[data-page="' + pageName + '"]');
	                if (newNavbarInner.length === 0 && newPage[0].f7RelatedNavbar) {
	                    newNavbarInner = $(newPage[0].f7RelatedNavbar);
	                }
	                if (newNavbarInner.length === 0 && newPage[0].f7PageData) {
	                    newNavbarInner = $(newPage[0].f7PageData.navbarInnerContainer);
	                }
	            }
	            setPages();
	            return;
	        }
	        else if (pageElement && url) {
	            newPage = $(pageElement);
	            if (view.params.dynamicNavbar) {
	                newNavbarInner = newPage.find('.navbar-inner').filter(function (index, el) {
	                    return $(el).parents(app.router._modalsSelector).length === 0;
	                });
	                if (newNavbarInner.length > 0) {
	                    newPage.prepend(newNavbarInner);
	                    app.router._remove(newPage.find('.navbar').filter(function (index, el) {
	                        return $(el).parents(app.router._modalsSelector).length === 0;
	                    }));
	                }
	            }
	            setPages();
	            return;
	        }
	        else {
	            view.allowPageChange = true;
	            return;
	        }
	    }
	
	};
	app.router.back = function (view, options) {
	    options = options || {};
	    if (app.router.preroute(view, options, true)) {
	        return false;
	    }
	    var url = options.url;
	    var content = options.content;
	    var pageName = options.pageName;
	    var pageElement = options.pageElement;
	    if (pageName) {
	        if (pageName.indexOf('?') > 0) {
	            options.query = $.parseUrlQuery(pageName);
	            options.pageName = pageName = pageName.split('?')[0];
	        }
	    }
	    var force = options.force;
	    if (!view.allowPageChange) return false;
	    view.allowPageChange = false;
	    if (app.xhr && view.xhr && view.xhr === app.xhr) {
	        app.xhr.abort();
	        app.xhr = false;
	    }
	    var pagesInView = $(view.pagesContainer).find('.page:not(.cached)');
	
	    function proceed(content) {
	        app.router.preprocess(view, content, url, function (content) {
	            options.content = content;
	            app.router._back(view, options);
	        });
	    }
	    if (pagesInView.length > 1 && !force) {
	        // Simple go back to previos page in view
	        app.router._back(view, options);
	        return;
	    }
	    if (!force) {
	        url = view.history[view.history.length - 2] || options.url;
	        if (!options.url) options.url = url;
	        if (!url) {
	            view.allowPageChange = true;
	            return;
	        }
	        if (url.indexOf('#') === 0 && view.contentCache[url]) {
	            proceed(view.contentCache[url]);
	            return;
	        }
	        else if (url.indexOf('#') === 0 && view.params.domCache) {
	            if (!pageName) options.pageName = url.split('#')[1];
	            proceed();
	            return;
	        }
	        else if (url && url in view.pageElementsCache) {
	            proceed();
	        }
	        else if (url.indexOf('#') !== 0) {
	            // Load ajax page
	            app.get(options.url, view, options.ignoreCache, function (content, error) {
	                if (error) {
	                    view.allowPageChange = true;
	                    return;
	                }
	                proceed(content);
	            });
	            return;
	        }
	    }
	    else {
	        // Go back with force url
	        if (!url && content) {
	            proceed(content);
	            return;
	        }
	        else if (!url && pageName) {
	            if (pageName) url = '#' + pageName;
	            proceed();
	            return;
	        }
	        else if (url && pageElement) {
	            proceed();
	            return;
	        }
	        else if (url) {
	            app.get(options.url, view, options.ignoreCache, function (content, error) {
	                if (error) {
	                    view.allowPageChange = true;
	                    return;
	                }
	                proceed(content);
	            });
	            return;
	        }
	    }
	    view.allowPageChange = true;
	    return;
	};
	
	app.router.afterBack = function (view, oldPage, newPage) {
	    // Remove old page and set classes on new one
	    oldPage = $(oldPage);
	    newPage = $(newPage);
	
	    if (view.params.domCache && view.initialPages.indexOf(oldPage[0]) >= 0) {
	        oldPage.removeClass('page-from-center-to-right').addClass('cached');
	    }
	    else {
	        app.pageRemoveCallback(view, oldPage[0], 'right');
	        app.router._remove(oldPage);
	    }
	
	    newPage.removeClass('page-from-left-to-center page-on-left').addClass('page-on-center');
	    view.allowPageChange = true;
	
	    // Update View's History
	    var previousURL = view.history.pop();
	
	    var newNavbar;
	
	    // Updated dynamic navbar
	    if (view.params.dynamicNavbar) {
	        var inners = $(view.container).children('.navbar').find('.navbar-inner:not(.cached)');
	        var oldNavbar = $(oldPage[0].f7RelatedNavbar || inners[1]);
	        if (view.params.domCache && view.initialNavbars.indexOf(oldNavbar[0]) >= 0) {
	            oldNavbar.removeClass('navbar-from-center-to-right').addClass('cached');
	        }
	        else {
	            app.navbarRemoveCallback(view, oldPage[0], undefined, oldNavbar[0]);
	            app.router._remove(oldNavbar);
	        }
	        newNavbar = $(inners[0]).removeClass('navbar-on-left navbar-from-left-to-center').addClass('navbar-on-center');
	    }
	
	    // Remove pages in dom cache
	    if (view.params.domCache) {
	        $(view.container).find('.page.cached').each(function () {
	            var page = $(this);
	            var pageUrl = page[0].f7PageData && page[0].f7PageData.url;
	            if (pageUrl && view.history.indexOf(pageUrl) < 0 && view.initialPages.indexOf(this) < 0) {
	                app.pageRemoveCallback(view, page[0], 'right');
	                if (page[0].f7RelatedNavbar && view.params.dynamicNavbar) app.navbarRemoveCallback(view, page[0], undefined, page[0].f7RelatedNavbar);
	                app.router._remove(page);
	                if (page[0].f7RelatedNavbar && view.params.dynamicNavbar) app.router._remove(page[0].f7RelatedNavbar);
	            }
	        });
	    }
	
	    // Check previous page is content based only and remove it from content cache
	    if (!view.params.domCache &&
	        previousURL &&
	        previousURL.indexOf('#') > -1 &&
	        (previousURL in view.contentCache) &&
	        // If the same page is in the history multiple times, don't remove it.
	        view.history.indexOf(previousURL) === -1) {
	        view.contentCache[previousURL] = null;
	        delete view.contentCache[previousURL];
	    }
	    if (previousURL &&
	        (previousURL in view.pageElementsCache) &&
	        // If the same page is in the history multiple times, don't remove it.
	        view.history.indexOf(previousURL) === -1) {
	        view.pageElementsCache[previousURL] = null;
	        delete view.pageElementsCache[previousURL];
	    }
	    // Check for context cache
	    if (previousURL &&
	        (previousURL in view.contextCache) &&
	        // If the same page is in the history multiple times, don't remove it.
	        view.history.indexOf(previousURL) === -1) {
	        view.contextCache[previousURL] = null;
	        delete view.contextCache[previousURL];
	    }
	
	    if (app.params.pushState && view.main) app.pushStateClearQueue();
	
	    // Preload previous page
	    if (view.params.preloadPreviousPage) {
	        if (view.params.domCache && view.history.length > 1) {
	            var preloadUrl = view.history[view.history.length - 2];
	            var previousPage;
	            var previousNavbar;
	            if (preloadUrl && view.pagesCache[preloadUrl]) {
	                // Load by page name
	                previousPage = $(view.container).find('.page[data-page="' + view.pagesCache[preloadUrl] + '"]');
	                if (previousPage.next('.page')[0] !== newPage[0]) previousPage.insertBefore(newPage);
	                if (newNavbar) {
	                    previousNavbar = $(view.container).children('.navbar').find('.navbar-inner[data-page="' + view.pagesCache[preloadUrl] + '"]');
	                    if(!previousNavbar || previousNavbar.length === 0) previousNavbar = newNavbar.prev('.navbar-inner.cached');
	                    if (previousNavbar.next('.navbar-inner')[0] !== newNavbar[0]) previousNavbar.insertBefore(newNavbar);
	                }
	            }
	            else {
	                // Just load previous page
	                previousPage = newPage.prev('.page.cached');
	                if (newNavbar) previousNavbar = newNavbar.prev('.navbar-inner.cached');
	            }
	            if (previousPage && previousPage.length > 0) previousPage.removeClass('cached page-on-right page-on-center').addClass('page-on-left');
	            if (previousNavbar && previousNavbar.length > 0) previousNavbar.removeClass('cached navbar-on-right navbar-on-center').addClass('navbar-on-left');
	        }
	        else {
	            app.router.back(view, {preloadOnly: true});
	        }
	    }
	};
	
	/*===============================================================================
	************   Handle clicks and make them fast (on tap);   ************
	===============================================================================*/
	app.initClickEvents = function () {
	    function handleScrollTop(e) {
	        /*jshint validthis:true */
	        var clicked = $(this);
	        var target = $(e.target);
	        var isLink = clicked[0].nodeName.toLowerCase() === 'a' ||
	                     clicked.parents('a').length > 0 ||
	                     target[0].nodeName.toLowerCase() === 'a' ||
	                     target.parents('a').length > 0;
	
	        if (isLink) return;
	        var pageContent, page;
	        if (app.params.scrollTopOnNavbarClick && clicked.is('.navbar .center')) {
	            // Find active page
	            var navbar = clicked.parents('.navbar');
	
	            // Static Layout
	            pageContent = navbar.parents('.page-content');
	
	            if (pageContent.length === 0) {
	                // Fixed Layout
	                if (navbar.parents('.page').length > 0) {
	                    pageContent = navbar.parents('.page').find('.page-content');
	                }
	                // Through Layout
	                if (pageContent.length === 0) {
	                    if (navbar.nextAll('.pages').length > 0) {
	                        pageContent = navbar.nextAll('.pages').find('.page:not(.page-on-left):not(.page-on-right):not(.cached)').find('.page-content');
	                    }
	                }
	            }
	        }
	        if (app.params.scrollTopOnStatusbarClick && clicked.is('.statusbar-overlay')) {
	            if ($('.popup.modal-in').length > 0) {
	                // Check for opened popup
	                pageContent = $('.popup.modal-in').find('.page:not(.page-on-left):not(.page-on-right):not(.cached)').find('.page-content');
	            }
	            else if ($('.panel.active').length > 0) {
	                // Check for opened panel
	                pageContent = $('.panel.active').find('.page:not(.page-on-left):not(.page-on-right):not(.cached)').find('.page-content');
	            }
	            else if ($('.views > .view.active').length > 0) {
	                // View in tab bar app layout
	                pageContent = $('.views > .view.active').find('.page:not(.page-on-left):not(.page-on-right):not(.cached)').find('.page-content');
	            }
	            else {
	                // Usual case
	                pageContent = $('.views').find('.page:not(.page-on-left):not(.page-on-right):not(.cached)').find('.page-content');
	            }
	        }
	
	        if (pageContent && pageContent.length > 0) {
	            // Check for tab
	            if (pageContent.hasClass('tab')) {
	                pageContent = pageContent.parent('.tabs').children('.page-content.active');
	            }
	            if (pageContent.length > 0) pageContent.scrollTop(0, 300);
	        }
	    }
	    function handleClicks(e) {
	        /*jshint validthis:true */
	        var clicked = $(this);
	        var url = clicked.attr('href');
	        var isLink = clicked[0].nodeName.toLowerCase() === 'a';
	
	        // Check if link is external
	        if (isLink) {
	            if (clicked.is(app.params.externalLinks) || (url && url.indexOf('javascript:') >= 0)) {
	                if(url && clicked.attr('target') === '_system') {
	                    e.preventDefault();
	                    window.open(url, '_system');
	                }
	                return;
	            }
	        }
	
	        // Collect Clicked data- attributes
	        var clickedData = clicked.dataset();
	
	        // Smart Select
	        if (clicked.hasClass('smart-select')) {
	            if (app.smartSelectOpen) app.smartSelectOpen(clicked);
	        }
	
	        // Open Panel
	        if (clicked.hasClass('open-panel')) {
	            if ($('.panel').length === 1) {
	                if ($('.panel').hasClass('panel-left')) app.openPanel('left');
	                else app.openPanel('right');
	            }
	            else {
	                if (clickedData.panel === 'right') app.openPanel('right');
	                else app.openPanel('left');
	            }
	        }
	        
	        // Close Panel
	        if (clicked.hasClass('close-panel')) {
	            app.closePanel();
	        }
	
	        // Panel Overlay
	        if (clicked.hasClass('panel-overlay')) {
	            $('.panel.active').trigger('panel:overlay-click');
	            if (app.params.panelsCloseByOutside) app.closePanel();
	        }
	
	        // Popover
	        if (clicked.hasClass('open-popover')) {
	            var popover;
	            if (clickedData.popover) {
	                popover = clickedData.popover;
	            }
	            else popover = '.popover';
	            app.popover(popover, clicked);
	        }
	        if (clicked.hasClass('close-popover')) {
	            app.closeModal('.popover.modal-in');
	        }
	        // Popup
	        var popup;
	        if (clicked.hasClass('open-popup')) {
	            if (clickedData.popup) {
	                popup = clickedData.popup;
	            }
	            else popup = '.popup';
	            app.popup(popup);
	        }
	        if (clicked.hasClass('close-popup')) {
	            if (clickedData.popup) {
	                popup = clickedData.popup;
	            }
	            else popup = '.popup.modal-in';
	            app.closeModal(popup);
	        }
	        // Login Screen
	        var loginScreen;
	        if (clicked.hasClass('open-login-screen')) {
	            if (clickedData.loginScreen) {
	                loginScreen = clickedData.loginScreen;
	            }
	            else loginScreen = '.login-screen';
	            app.loginScreen(loginScreen);
	        }
	        if (clicked.hasClass('close-login-screen')) {
	            app.closeModal('.login-screen.modal-in');
	        }
	        // Close Modal
	        if (clicked.hasClass('modal-overlay')) {
	            if ($('.modal.modal-in').length > 0 && app.params.modalCloseByOutside)
	                app.closeModal('.modal.modal-in');
	            if ($('.actions-modal.modal-in').length > 0 && app.params.actionsCloseByOutside)
	                app.closeModal('.actions-modal.modal-in');
	
	            if ($('.popover.modal-in').length > 0) app.closeModal('.popover.modal-in');
	        }
	        if (clicked.hasClass('popup-overlay')) {
	            if ($('.popup.modal-in').length > 0 && app.params.popupCloseByOutside)
	                app.closeModal('.popup.modal-in');
	        }
	        if (clicked.hasClass('picker-modal-overlay')) {
	            if ($('.picker-modal.modal-in').length > 0)
	                app.closeModal('.picker-modal.modal-in');
	        }
	
	        // Picker
	        if (clicked.hasClass('close-picker')) {
	            var pickerToClose = $('.picker-modal.modal-in');
	            if (pickerToClose.length > 0) {
	                app.closeModal(pickerToClose);
	            }
	            else {
	                pickerToClose = $('.popover.modal-in .picker-modal');
	                if (pickerToClose.length > 0) {
	                    app.closeModal(pickerToClose.parents('.popover'));
	                }
	            }
	        }
	        if (clicked.hasClass('open-picker')) {
	            var pickerToOpen;
	            if (clickedData.picker) {
	                pickerToOpen = clickedData.picker;
	            }
	            else pickerToOpen = '.picker-modal';
	            app.pickerModal(pickerToOpen, clicked);
	        }
	
	        // Tabs
	        var isTabLink;
	        if (clicked.hasClass('tab-link')) {
	            isTabLink = true;
	            app.showTab(clickedData.tab || clicked.attr('href'), clicked);
	        }
	        // Swipeout Close
	        if (clicked.hasClass('swipeout-close')) {
	            app.swipeoutClose(clicked.parents('.swipeout-opened'));
	        }
	        // Swipeout Delete
	        if (clicked.hasClass('swipeout-delete')) {
	            if (clickedData.confirm) {
	                var text = clickedData.confirm;
	                var title = clickedData.confirmTitle;
	                if (title) {
	                    app.confirm(text, title, function () {
	                        app.swipeoutDelete(clicked.parents('.swipeout'));
	                    }, function () {
	                        if (clickedData.closeOnCancel) app.swipeoutClose(clicked.parents('.swipeout'));
	                    });
	                }
	                else {
	                    app.confirm(text, function () {
	                        app.swipeoutDelete(clicked.parents('.swipeout'));
	                    }, function () {
	                        if (clickedData.closeOnCancel) app.swipeoutClose(clicked.parents('.swipeout'));
	                    });
	                }
	            }
	            else {
	                app.swipeoutDelete(clicked.parents('.swipeout'));
	            }
	
	        }
	        // Sortable
	        if (clicked.hasClass('toggle-sortable')) {
	            app.sortableToggle(clickedData.sortable);
	        }
	        if (clicked.hasClass('open-sortable')) {
	            app.sortableOpen(clickedData.sortable);
	        }
	        if (clicked.hasClass('close-sortable')) {
	            app.sortableClose(clickedData.sortable);
	        }
	        // Accordion
	        if (clicked.hasClass('accordion-item-toggle') || (clicked.hasClass('item-link') && clicked.parent().hasClass('accordion-item'))) {
	            var accordionItem = clicked.parent('.accordion-item');
	            if (accordionItem.length === 0) accordionItem = clicked.parents('.accordion-item');
	            if (accordionItem.length === 0) accordionItem = clicked.parents('li');
	            app.accordionToggle(accordionItem);
	        }
	
	        // Speed Dial
	        if (clicked.hasClass('floating-button') && clicked.parent().hasClass('speed-dial')) {
	            clicked.parent().toggleClass('speed-dial-opened');
	        }
	        if (clicked.hasClass('close-speed-dial')) {
	            $('.speed-dial-opened').removeClass('speed-dial-opened');
	        }
	
	        // Load Page
	        if (app.params.ajaxLinks && !clicked.is(app.params.ajaxLinks) || !isLink || !app.params.router) {
	            return;
	        }
	        if (isLink) {
	            e.preventDefault();
	        }
	
	        var validUrl = url && url.length > 0 && url !== '#' && !isTabLink;
	        var template = clickedData.template;
	        if (validUrl || clicked.hasClass('back') || template) {
	            var view;
	            if (clickedData.view) {
	                view = $(clickedData.view)[0].f7View;
	            }
	            else {
	                view = clicked.parents('.' + app.params.viewClass)[0] && clicked.parents('.' + app.params.viewClass)[0].f7View;
	                if (view && view.params.linksView) {
	                    if (typeof view.params.linksView === 'string') view = $(view.params.linksView)[0].f7View;
	                    else if (view.params.linksView instanceof View) view = view.params.linksView;
	                }
	            }
	            if (!view) {
	                if (app.mainView) view = app.mainView;
	            }
	            if (!view) return;
	
	            var pageName;
	            if (!template) {
	                if (url && url.indexOf('#') === 0 && url !== '#')  {
	                    if (view.params.domCache) {
	                        pageName = url.split('#')[1];
	                    }
	                    else return;
	                }
	                if (url === '#' && !clicked.hasClass('back')) return;
	            }
	            else {
	                url = undefined;
	            }
	
	            var animatePages;
	            if (typeof clickedData.animatePages !== 'undefined') {
	                animatePages = clickedData.animatePages;
	            }
	            else {
	                if (clicked.hasClass('with-animation')) animatePages = true;
	                if (clicked.hasClass('no-animation')) animatePages = false;
	            }
	
	            var options = {
	                animatePages: animatePages,
	                ignoreCache: clickedData.ignoreCache,
	                force: clickedData.force,
	                reload: clickedData.reload,
	                reloadPrevious: clickedData.reloadPrevious,
	                pageName: pageName,
	                pushState: clickedData.pushState,
	                url: url
	            };
	
	            if (app.params.template7Pages) {
	                options.contextName = clickedData.contextName;
	                var context = clickedData.context;
	                if (context) {
	                    options.context = JSON.parse(context);
	                }
	            }
	            if (template && template in t7.templates) {
	                options.template = t7.templates[template];
	            }
	
	            if (clicked.hasClass('back')) view.router.back(options);
	            else view.router.load(options);
	        }
	    }
	    $(document).on('click', 'a, .open-panel, .close-panel, .panel-overlay, .modal-overlay, .popup-overlay, .swipeout-delete, .swipeout-close, .close-popup, .open-popup, .open-popover, .open-login-screen, .close-login-screen .smart-select, .toggle-sortable, .open-sortable, .close-sortable, .accordion-item-toggle, .close-picker, .picker-modal-overlay', handleClicks);
	    if (app.params.scrollTopOnNavbarClick || app.params.scrollTopOnStatusbarClick) {
	        $(document).on('click', '.statusbar-overlay, .navbar .center', handleScrollTop);
	    }
	
	    // Prevent scrolling on overlays
	    function preventScrolling(e) {
	        e.preventDefault();
	    }
	    if (app.support.touch && !app.device.android) {
	        $(document).on((app.params.fastClicks ? 'touchstart' : 'touchmove'), '.panel-overlay, .modal-overlay, .preloader-indicator-overlay, .popup-overlay, .searchbar-overlay', preventScrolling);
	    }
	};
	
	/*======================================================
	************   App Resize Actions   ************
	======================================================*/
	// Prevent iPad horizontal body scrolling when soft keyboard is opened
	function _fixIpadBodyScrolLeft() {
	    if (app.device.ipad) {
	        document.body.scrollLeft = 0;
	        setTimeout(function () {
	            document.body.scrollLeft = 0;
	        }, 0);
	    }
	}
	app.initResize = function () {
	    $(window).on('resize', app.resize);
	    $(window).on('orientationchange', app.orientationchange);
	};
	app.resize = function () {
	    if (app.sizeNavbars) app.sizeNavbars();
	    _fixIpadBodyScrolLeft();
	    
	};
	app.orientationchange = function () {
	    if (app.device && app.device.minimalUi) {
	        if (window.orientation === 90 || window.orientation === -90) document.body.scrollTop = 0;
	    }
	    _fixIpadBodyScrolLeft();
	};
	
	/*======================================================
	************   Panels   ************
	======================================================*/
	app.allowPanelOpen = true;
	app.openPanel = function (panelPosition, animated) {
	    if (typeof animated === 'undefined') animated = true;
	    if (!app.allowPanelOpen) return false;
	    var panel = $('.panel-' + panelPosition);
	    if (panel.length === 0 || panel.hasClass('active')) return false;
	    app.closePanel(); // Close if some panel is opened
	    app.allowPanelOpen = false;
	    var effect = panel.hasClass('panel-reveal') ? 'reveal' : 'cover';
	    panel[animated ? 'removeClass' : 'addClass']('not-animated');
	    panel.css({display: 'block'}).addClass('active');
	    panel.trigger('open panel:open');
	    if (app.params.material) {
	        $('.panel-overlay')[animated ? 'removeClass' : 'addClass']('not-animated');
	        $('.panel-overlay').show();
	    }
	    if (panel.find('.' + app.params.viewClass).length > 0) {
	        if (app.sizeNavbars) app.sizeNavbars(panel.find('.' + app.params.viewClass)[0]);
	    }
	
	    // Trigger reLayout
	    var clientLeft = panel[0].clientLeft;
	
	    // Transition End;
	    var transitionEndTarget = effect === 'reveal' ? $('.' + app.params.viewsClass) : panel;
	
	    function panelTransitionEnd() {
	        transitionEndTarget.transitionEnd(function (e) {
	            if ($(e.target).is(transitionEndTarget)) {
	                if (panel.hasClass('active')) {
	                    panel.trigger('opened panel:opened');
	                }
	                else {
	                    panel.trigger('closed panel:closed');
	                }
	                if (app.params.material) $('.panel-overlay').css({display: ''});
	                app.allowPanelOpen = true;
	            }
	            else panelTransitionEnd();
	        });
	    }
	    if (animated) {
	        panelTransitionEnd();    
	    }
	    else {
	        panel.trigger('opened panel:opened');
	        if (app.params.material) $('.panel-overlay').css({display: ''});
	        app.allowPanelOpen = true;
	    }
	
	    $('body').addClass('with-panel-' + panelPosition + '-' + effect);
	    return true;
	};
	app.closePanel = function (animated) {
	    if (typeof animated === 'undefined') animated = true;
	    var activePanel = $('.panel.active');
	    if (activePanel.length === 0) return false;
	    var effect = activePanel.hasClass('panel-reveal') ? 'reveal' : 'cover';
	    var panelPosition = activePanel.hasClass('panel-left') ? 'left' : 'right';
	    activePanel[animated ? 'removeClass' : 'addClass']('not-animated');
	    activePanel.removeClass('active');
	    if (app.params.material) {
	        $('.panel-overlay').removeClass('not-animated');
	    }
	    var transitionEndTarget = effect === 'reveal' ? $('.' + app.params.viewsClass) : activePanel;
	    activePanel.trigger('close panel:close');
	    app.allowPanelOpen = false;
	    if (animated) {
	        transitionEndTarget.transitionEnd(function () {
	            if (activePanel.hasClass('active')) return;
	            activePanel.css({display: ''});
	            activePanel.trigger('closed panel:closed');
	            $('body').removeClass('panel-closing');
	            app.allowPanelOpen = true;
	        });
	        $('body').addClass('panel-closing').removeClass('with-panel-' + panelPosition + '-' + effect);
	    }
	    else {
	        activePanel.css({display: ''});
	        activePanel.trigger('closed panel:closed');
	        activePanel.removeClass('not-animated');
	        $('body').removeClass('with-panel-' + panelPosition + '-' + effect);
	        app.allowPanelOpen = true;
	    }
	};
	/*======================================================
	************   Swipe panels   ************
	======================================================*/
	app.initSwipePanels = function () {
	    var panel, side;
	    if (app.params.swipePanel) {
	        panel = $('.panel.panel-' + app.params.swipePanel);
	        side = app.params.swipePanel;
	        if (panel.length === 0 && side !== 'both') return;
	    }
	    else {
	        if (app.params.swipePanelOnlyClose) {
	            if ($('.panel').length === 0) return;
	        }
	        else return;
	    }
	
	    var panelOverlay = $('.panel-overlay');
	    var isTouched, isMoved, isScrolling, touchesStart = {}, touchStartTime, touchesDiff, translate, overlayOpacity, opened, panelWidth, effect, direction;
	    var views = $('.' + app.params.viewsClass);
	
	    function handleTouchStart(e) {
	        if (!app.allowPanelOpen || (!app.params.swipePanel && !app.params.swipePanelOnlyClose) || isTouched) return;
	        if ($('.modal-in, .photo-browser-in').length > 0) return;
	        if (!(app.params.swipePanelCloseOpposite || app.params.swipePanelOnlyClose)) {
	            if ($('.panel.active').length > 0 && !panel.hasClass('active')) return;
	        }
	        if (e.target && e.target.nodeName.toLowerCase() === 'input' && e.target.type === 'range') return;
	        if ($(e.target).closest('.tabs-swipeable-wrap').length > 0) return;
	        touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	        touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	        if (app.params.swipePanelCloseOpposite || app.params.swipePanelOnlyClose) {
	            if ($('.panel.active').length > 0) {
	                side = $('.panel.active').hasClass('panel-left') ? 'left' : 'right';
	            }
	            else {
	                if (app.params.swipePanelOnlyClose) return;
	                side = app.params.swipePanel;
	            }
	            if (!side) return;
	        }
	        panel = $('.panel.panel-' + side);
	        opened = panel.hasClass('active');
	        if (app.params.swipePanelActiveArea && !opened) {
	            if (side === 'left') {
	                if (touchesStart.x > app.params.swipePanelActiveArea) return;
	            }
	            if (side === 'right') {
	                if (touchesStart.x < window.innerWidth - app.params.swipePanelActiveArea) return;
	            }
	        }
	        isMoved = false;
	        isTouched = true;
	        isScrolling = undefined;
	
	        touchStartTime = (new Date()).getTime();
	        direction = undefined;
	    }
	    function handleTouchMove(e) {
	        if (!isTouched) return;
	        if (e.f7PreventPanelSwipe) return;
	        var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	        var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	        if (typeof isScrolling === 'undefined') {
	            isScrolling = !!(isScrolling || Math.abs(pageY - touchesStart.y) > Math.abs(pageX - touchesStart.x));
	        }
	        if (isScrolling) {
	            isTouched = false;
	            return;
	        }
	        if (!direction) {
	            if (pageX > touchesStart.x) {
	                direction = 'to-right';
	            }
	            else {
	                direction = 'to-left';
	            }
	
	            if(side === 'both'){
	                if ($('.panel.active').length > 0) {
	                    side = $('.panel.active').hasClass('panel-left') ? 'left' : 'right';
	                }
	                else {
	                    side = direction === 'to-right' ? 'left' : 'right';
	                }
	                if (app.params.swipePanelActiveArea > 0) {
	                    if (side === 'left' && touchesStart.x > app.params.swipePanelActiveArea) {
	                        isTouched = false;
	                        return;
	                    }
	                    if (side === 'right' && touchesStart.x < window.innerWidth - app.params.swipePanelActiveArea) {
	                        isTouched = false;
	                        return;
	                    }
	                }
	                panel = $('.panel.panel-' + side);
	            }
	
	            if (
	                side === 'left' &&
	                (
	                    direction === 'to-left' && !panel.hasClass('active')
	                ) ||
	                side === 'right' &&
	                (
	                    direction === 'to-right' && !panel.hasClass('active')
	                )
	            )
	            {
	                isTouched = false;
	                return;
	            }
	        }
	
	        if (app.params.swipePanelNoFollow) {
	            var timeDiff = (new Date()).getTime() - touchStartTime;
	            if (timeDiff < 300) {
	                if (direction === 'to-left') {
	                    if (side === 'right') app.openPanel(side);
	                    if (side === 'left' && panel.hasClass('active')) app.closePanel();
	                }
	                if (direction === 'to-right') {
	                    if (side === 'left') app.openPanel(side);
	                    if (side === 'right' && panel.hasClass('active')) app.closePanel();
	                }
	            }
	            isTouched = false;
	            isMoved = false;
	            return;
	        }
	
	        if (!isMoved) {
	            effect = panel.hasClass('panel-cover') ? 'cover' : 'reveal';
	            if (!opened) {
	                panel.show();
	                panelOverlay.show();
	            }
	            panelWidth = panel[0].offsetWidth;
	            panel.transition(0);
	            if (panel.find('.' + app.params.viewClass).length > 0) {
	                if (app.sizeNavbars) app.sizeNavbars(panel.find('.' + app.params.viewClass)[0]);
	            }
	        }
	
	        isMoved = true;
	
	        e.preventDefault();
	        var threshold = opened ? 0 : -app.params.swipePanelThreshold;
	        if (side === 'right') threshold = -threshold;
	
	        touchesDiff = pageX - touchesStart.x + threshold;
	
	        if (side === 'right') {
	            translate = touchesDiff  - (opened ? panelWidth : 0);
	            if (translate > 0) translate = 0;
	            if (translate < -panelWidth) {
	                translate = -panelWidth;
	            }
	        }
	        else {
	            translate = touchesDiff  + (opened ? panelWidth : 0);
	            if (translate < 0) translate = 0;
	            if (translate > panelWidth) {
	                translate = panelWidth;
	            }
	        }
	        if (effect === 'reveal') {
	            views.transform('translate3d(' + translate + 'px,0,0)').transition(0);
	            panelOverlay.transform('translate3d(' + translate + 'px,0,0)').transition(0);
	
	            panel.trigger('panel:swipe', {progress: Math.abs(translate / panelWidth)});
	            app.pluginHook('swipePanelSetTransform', views[0], panel[0], Math.abs(translate / panelWidth));
	        }
	        else {
	            panel.transform('translate3d(' + translate + 'px,0,0)').transition(0);
	            if (app.params.material) {
	                panelOverlay.transition(0);
	                overlayOpacity = Math.abs(translate/panelWidth);
	                panelOverlay.css({opacity: overlayOpacity});
	            }
	            panel.trigger('panel:swipe', {progress: Math.abs(translate / panelWidth)});
	            app.pluginHook('swipePanelSetTransform', views[0], panel[0], Math.abs(translate / panelWidth));
	        }
	    }
	    function handleTouchEnd(e) {
	        if (!isTouched || !isMoved) {
	            isTouched = false;
	            isMoved = false;
	            return;
	        }
	        isTouched = false;
	        isMoved = false;
	        var timeDiff = (new Date()).getTime() - touchStartTime;
	        var action;
	        var edge = (translate === 0 || Math.abs(translate) === panelWidth);
	
	        if (!opened) {
	            if (translate === 0) {
	                action = 'reset';
	            }
	            else if (
	                timeDiff < 300 && Math.abs(translate) > 0 ||
	                timeDiff >= 300 && (Math.abs(translate) >= panelWidth / 2)
	            ) {
	                action = 'swap';
	            }
	            else {
	                action = 'reset';
	            }
	        }
	        else {
	            if (translate === -panelWidth) {
	                action = 'reset';
	            }
	            else if (
	                timeDiff < 300 && Math.abs(translate) >= 0 ||
	                timeDiff >= 300 && (Math.abs(translate) <= panelWidth / 2)
	            ) {
	                if (side === 'left' && translate === panelWidth) action = 'reset';
	                else action = 'swap';
	            }
	            else {
	                action = 'reset';
	            }
	        }
	        if (action === 'swap') {
	            app.allowPanelOpen = true;
	            if (opened) {
	                app.closePanel();
	                if (edge) {
	                    panel.css({display: ''});
	                    $('body').removeClass('panel-closing');
	                }
	            }
	            else {
	                app.openPanel(side);
	            }
	            if (edge) app.allowPanelOpen = true;
	        }
	        if (action === 'reset') {
	            if (opened) {
	                app.allowPanelOpen = true;
	                app.openPanel(side);
	            }
	            else {
	                app.closePanel();
	                if (edge) {
	                    app.allowPanelOpen = true;
	                    panel.css({display: ''});
	                }
	                else {
	                    var target = effect === 'reveal' ? views : panel;
	                    panel.trigger('close panel:close');
	                    $('body').addClass('panel-closing');
	                    target.transitionEnd(function () {
	                        panel.trigger('close panel:closed');
	                        panel.css({display: ''});
	                        $('body').removeClass('panel-closing');
	                        app.allowPanelOpen = true;
	                    });
	                }
	            }
	        }
	        if (effect === 'reveal') {
	            views.transition('');
	            views.transform('');
	        }
	        panel.transition('').transform('');
	        panelOverlay.css({display: ''}).transform('').transition('').css('opacity', '');
	    }
	    var passiveListener = app.touchEvents.start === 'touchstart' && app.support.passiveListener ? {passive: true, capture: false} : false;
	    $(document).on(app.touchEvents.start, handleTouchStart, passiveListener);
	    $(document).on(app.touchEvents.move, handleTouchMove);
	    $(document).on(app.touchEvents.end, handleTouchEnd, passiveListener);
	};
	
	/*======================================================
	************   Image Lazy Loading   ************
	************   Based on solution by Marc Godard, https://github.com/MarcGodard   ************
	======================================================*/
	app.initImagesLazyLoad = function (pageContainer) {
	    pageContainer = $(pageContainer);
	
	    // Lazy images
	    var lazyLoadImages;
	    if (pageContainer.hasClass('lazy')) {
	        lazyLoadImages = pageContainer;
	        pageContainer = lazyLoadImages.parents('.page');
	    }
	    else {
	        lazyLoadImages = pageContainer.find('.lazy');
	    }
	    if (lazyLoadImages.length === 0) return;
	
	    // Scrollable page content
	    var pageContent;
	    if (pageContainer.hasClass('page-content'))  {
	        pageContent = pageContainer;
	        pageContainer = pageContainer.parents('.page');
	    }
	    else  {
	        pageContent = pageContainer.find('.page-content');
	    }
	    if (pageContent.length === 0) return;
	
	    // Placeholder
	    var placeholderSrc = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEXCwsK592mkAAAACklEQVQI12NgAAAAAgAB4iG8MwAAAABJRU5ErkJggg==';
	    if (typeof app.params.imagesLazyLoadPlaceholder === 'string') {
	        placeholderSrc = app.params.imagesLazyLoadPlaceholder;
	    }
	    if (app.params.imagesLazyLoadPlaceholder !== false) lazyLoadImages.each(function(){
	        if ($(this).attr('data-src')) $(this).attr('src', placeholderSrc);
	    });
	
	    // load image
	    var imagesSequence = [];
	    var imageIsLoading = false;
	    function loadImage(el) {
	        el = $(el);
	
	        var bg = el.attr('data-background');
	        var src = bg ? bg : el.attr('data-src');
	        if (!src) return;
	
	        function onLoad() {
	            el.removeClass('lazy').addClass('lazy-loaded');
	            if (bg) {
	                el.css('background-image', 'url(' + src + ')');
	            }
	            else {
	                el.attr('src', src);
	            }
	
	            if (app.params.imagesLazyLoadSequential) {
	                imageIsLoading = false;
	                if (imagesSequence.length > 0) {
	                    loadImage(imagesSequence.shift());
	                }
	            }
	        }
	        
	        function onError() {
	            el.removeClass('lazy').addClass('lazy-loaded');
	            if (bg) {
	                el.css('background-image', 'url(' + placeholderSrc + ')');
	            }
	            else {
	                el.attr('src', placeholderSrc);
	            }
	
	            if (app.params.imagesLazyLoadSequential) {
	                imageIsLoading = false;
	                if (imagesSequence.length > 0) {
	                    loadImage(imagesSequence.shift());
	                }
	            }
	        }
	
	        if (app.params.imagesLazyLoadSequential) {
	            if (imageIsLoading) {
	                if (imagesSequence.indexOf(el[0]) < 0) imagesSequence.push(el[0]);
	                return;
	            }
	        }
	
	        // Loading flag
	        imageIsLoading = true;
	        
	        var image = new Image();
	        image.onload = onLoad;
	        image.onerror = onError;
	        image.src =src;
	    }
	    function lazyHandler() {
	        lazyLoadImages = pageContainer.find('.lazy');
	        lazyLoadImages.each(function(index, el) {
	            el = $(el);
	            if (el.parents('.tab:not(.active)').length > 0) {
	                return;
	            }
	            if (isElementInViewport(el[0])) {
	                loadImage(el);
	            }
	        });
	    }
	
	    function isElementInViewport (el) {
	        var rect = el.getBoundingClientRect();
	        var threshold = app.params.imagesLazyLoadThreshold || 0;
	        return (
	            rect.top >= (0 - threshold) &&
	            rect.left >= (0 - threshold) &&
	            rect.top <= (window.innerHeight + threshold) &&
	            rect.left <= (window.innerWidth + threshold)
	        );
	    }
	
	    function attachEvents(destroy) {
	        var method = destroy ? 'off' : 'on';
	        lazyLoadImages[method]('lazy', lazyHandler);
	        lazyLoadImages.parents('.tab')[method]('show', lazyHandler);
	        pageContainer[method]('lazy', lazyHandler);
	        pageContent[method]('lazy', lazyHandler);
	        pageContent[method]('scroll', lazyHandler);
	        $(window)[method]('resize', lazyHandler);
	    }
	    function detachEvents() {
	        attachEvents(true);
	    }
	
	    // Store detach function
	    pageContainer[0].f7DestroyImagesLazyLoad = detachEvents;
	
	    // Attach events
	    attachEvents();
	
	    // Destroy on page remove
	    if (pageContainer.hasClass('page')) {
	        pageContainer.once('page:beforeremove', detachEvents);
	    }
	
	    // Run loader on page load/init
	    lazyHandler();
	
	    // Run after page animation
	    pageContainer.once('page:afteranimation', lazyHandler);
	};
	app.destroyImagesLazyLoad = function (pageContainer) {
	    pageContainer = $(pageContainer);
	    if (pageContainer.length > 0 && pageContainer[0].f7DestroyImagesLazyLoad) {
	        pageContainer[0].f7DestroyImagesLazyLoad();
	    }
	};
	app.reinitImagesLazyLoad = function (pageContainer) {
	    pageContainer = $(pageContainer);
	    if (pageContainer.length > 0) {
	        pageContainer.trigger('lazy');
	    }
	};
	
	/*======================================================
	************   Material Preloader   ************
	======================================================*/
	app.initPageMaterialPreloader = function (pageContainer) {
	    $(pageContainer).find('.preloader').each(function () {
	        if ($(this).children().length === 0) {
	            $(this).html(app.params.materialPreloaderHtml);
	        }
	    });
	};
	/*===============================================================================
	************   Accordion   ************
	===============================================================================*/
	app.accordionToggle = function (item) {
	    item = $(item);
	    if (item.length === 0) return;
	    if (item.hasClass('accordion-item-expanded')) app.accordionClose(item);
	    else app.accordionOpen(item);
	};
	app.accordionOpen = function (item) {
	    item = $(item);
	    var list = item.parents('.accordion-list').eq(0);
	    var content = item.children('.accordion-item-content');
	    if (content.length === 0) content = item.find('.accordion-item-content');
	    var expandedItem = list.length > 0 && item.parent().children('.accordion-item-expanded');
	    if (expandedItem.length > 0) {
	        app.accordionClose(expandedItem);
	    }
	    content.css('height', content[0].scrollHeight + 'px').transitionEnd(function () {
	        if (item.hasClass('accordion-item-expanded')) {
	            content.transition(0);
	            content.css('height', 'auto');
	            var clientLeft = content[0].clientLeft;
	            content.transition('');
	            item.trigger('opened accordion:opened');
	        }
	        else {
	            content.css('height', '');
	            item.trigger('closed accordion:closed');
	        }
	    });
	    item.trigger('open accordion:open');
	    item.addClass('accordion-item-expanded');
	};
	app.accordionClose = function (item) {
	    item = $(item);
	    var content = item.children('.accordion-item-content');
	    if (content.length === 0) content = item.find('.accordion-item-content');
	    item.removeClass('accordion-item-expanded');
	    content.transition(0);
	    content.css('height', content[0].scrollHeight + 'px');
	    // Relayout
	    var clientLeft = content[0].clientLeft;
	    // Close
	    content.transition('');
	    content.css('height', '').transitionEnd(function () {
	        if (item.hasClass('accordion-item-expanded')) {
	            content.transition(0);
	            content.css('height', 'auto');
	            var clientLeft = content[0].clientLeft;
	            content.transition('');
	            item.trigger('opened accordion:opened');
	        }
	        else {
	            content.css('height', '');
	            item.trigger('closed accordion:closed');
	        }
	    });
	    item.trigger('close accordion:close');
	};
	/*===============================================================================
	************   Fast Clicks   ************
	************   Inspired by https://github.com/ftlabs/fastclick   ************
	===============================================================================*/
	app.initFastClicks = function () {
	    if (app.params.activeState) {
	        $('html').addClass('watch-active-state');
	    }
	    if (app.device.ios && app.device.webView) {
	        // Strange hack required for iOS 8 webview to work on inputs
	        window.addEventListener('touchstart', function () {});
	    }
	
	    var touchStartX, touchStartY, touchStartTime, targetElement, trackClick, activeSelection, scrollParent, lastClickTime, isMoved, tapHoldFired, tapHoldTimeout;
	    var activableElement, activeTimeout, needsFastClick, needsFastClickTimeOut;
	    var rippleWave, rippleTarget, rippleTransform, rippleTimeout;
	    function findActivableElement(el) {
	        var target = $(el);
	        var parents = target.parents(app.params.activeStateElements);
	        var activable;
	        if (target.is(app.params.activeStateElements)) {
	            activable = target;
	        }
	        if (parents.length > 0) {
	            activable = activable ? activable.add(parents) : parents;
	        }
	        return activable ? activable : target;
	    }
	    function isInsideScrollableView(el) {
	        var pageContent = el.parents('.page-content, .panel');
	
	        if (pageContent.length === 0) {
	            return false;
	        }
	
	        // This event handler covers the "tap to stop scrolling".
	        if (pageContent.prop('scrollHandlerSet') !== 'yes') {
	            pageContent.on('scroll', function() {
	              clearTimeout(activeTimeout);
	              clearTimeout(rippleTimeout);
	            });
	            pageContent.prop('scrollHandlerSet', 'yes');
	        }
	
	        return true;
	    }
	    function addActive() {
	        if (!activableElement) return;
	        activableElement.addClass('active-state');
	    }
	    function removeActive(el) {
	        if (!activableElement) return;
	        activableElement.removeClass('active-state');
	        activableElement = null;
	    }
	    function isFormElement(el) {
	        var nodes = ('input select textarea label').split(' ');
	        if (el.nodeName && nodes.indexOf(el.nodeName.toLowerCase()) >= 0) return true;
	        return false;
	    }
	    function androidNeedsBlur(el) {
	        var noBlur = ('button input textarea select').split(' ');
	        if (document.activeElement && el !== document.activeElement && document.activeElement !== document.body) {
	            if (noBlur.indexOf(el.nodeName.toLowerCase()) >= 0) {
	                return false;
	            }
	            else {
	                return true;
	            }
	        }
	        else {
	            return false;
	        }
	    }
	    function targetNeedsFastClick(el) {
	        var $el = $(el);
	        if (el.nodeName.toLowerCase() === 'input' && (el.type === 'file' || el.type === 'range')) return false;
	        if (el.nodeName.toLowerCase() === 'select' && app.device.android) return false;
	        if ($el.hasClass('no-fastclick') || $el.parents('.no-fastclick').length > 0) return false;
	        if (app.params.fastClicksExclude && $el.is(app.params.fastClicksExclude)) return false;
	        return true;
	    }
	    function targetNeedsFocus(el) {
	        if (document.activeElement === el) {
	            return false;
	        }
	        var tag = el.nodeName.toLowerCase();
	        var skipInputs = ('button checkbox file image radio submit').split(' ');
	        if (el.disabled || el.readOnly) return false;
	        if (tag === 'textarea') return true;
	        if (tag === 'select') {
	            if (app.device.android) return false;
	            else return true;
	        }
	        if (tag === 'input' && skipInputs.indexOf(el.type) < 0) return true;
	    }
	    function targetNeedsPrevent(el) {
	        el = $(el);
	        var prevent = true;
	        if (el.is('label') || el.parents('label').length > 0) {
	            if (app.device.android) {
	                prevent = false;
	            }
	            else if (app.device.ios && el.is('input')) {
	                prevent = true;
	            }
	            else prevent = false;
	        }
	        return prevent;
	    }
	
	    // Mouse Handlers
	    function handleMouseDown (e) {
	        findActivableElement(e.target).addClass('active-state');
	        if ('which' in e && e.which === 3) {
	            setTimeout(function () {
	                $('.active-state').removeClass('active-state');
	            }, 0);
	        }
	        if (app.params.material && app.params.materialRipple) {
	            touchStartX = e.pageX;
	            touchStartY = e.pageY;
	            rippleTouchStart(e.target, e.pageX, e.pageY);
	        }
	    }
	    function handleMouseMove (e) {
	        $('.active-state').removeClass('active-state');
	        if (app.params.material && app.params.materialRipple) {
	            rippleTouchMove();
	        }
	    }
	    function handleMouseUp (e) {
	        $('.active-state').removeClass('active-state');
	        if (app.params.material && app.params.materialRipple) {
	            rippleTouchEnd();
	        }
	    }
	
	    // Material Touch Ripple Effect
	    function findRippleElement(el) {
	        var needsRipple = app.params.materialRippleElements;
	        var $el = $(el);
	        if ($el.is(needsRipple)) {
	            if ($el.hasClass('no-ripple')) {
	                return false;
	            }
	            return $el;
	        }
	        else if ($el.parents(needsRipple).length > 0) {
	            var rippleParent = $el.parents(needsRipple).eq(0);
	            if (rippleParent.hasClass('no-ripple')) {
	                return false;
	            }
	            return rippleParent;
	        }
	        else return false;
	    }
	    function createRipple(x, y, el) {
	        if (!el) return;
	        var box = el[0].getBoundingClientRect();
	        var center = {
	            x: x - box.left,
	            y: y - box.top
	        },
	            height = box.height,
	            width = box.width;
	        var diameter = Math.max(Math.pow((Math.pow(height, 2) + Math.pow(width, 2)), 0.5), 48);
	
	        rippleWave = $(
	            '<div class="ripple-wave" style="width: ' + diameter + 'px; height: '+diameter+'px; margin-top:-'+diameter/2+'px; margin-left:-'+diameter/2+'px; left:'+center.x+'px; top:'+center.y+'px;"></div>'
	        );
	        el.prepend(rippleWave);
	        var clientLeft = rippleWave[0].clientLeft;
	        rippleTransform = 'translate3d('+(-center.x + width/2)+'px, '+(-center.y + height/2)+'px, 0) scale(1)';
	        rippleWave.transform(rippleTransform);
	    }
	
	    function removeRipple() {
	        if (!rippleWave) return;
	        var toRemove = rippleWave;
	
	        var removeTimeout = setTimeout(function () {
	            toRemove.remove();
	        }, 400);
	
	        rippleWave
	            .addClass('ripple-wave-fill')
	            .transform(rippleTransform.replace('scale(1)', 'scale(1.01)'))
	            .transitionEnd(function () {
	                clearTimeout(removeTimeout);
	
	                var rippleWave = $(this)
	                    .addClass('ripple-wave-out')
	                    .transform(rippleTransform.replace('scale(1)', 'scale(1.01)'));
	
	                removeTimeout = setTimeout(function () {
	                    rippleWave.remove();
	                }, 700);
	
	                setTimeout(function () {
	                    rippleWave.transitionEnd(function(){
	                        clearTimeout(removeTimeout);
	                        $(this).remove();
	                    });
	                }, 0);
	            });
	
	        rippleWave = rippleTarget = undefined;
	    }
	
	    function rippleTouchStart (el, x, y) {
	        rippleTarget = findRippleElement(el);
	        if (!rippleTarget || rippleTarget.length === 0) {
	            rippleTarget = undefined;
	            return;
	        }
	        if (!isInsideScrollableView(rippleTarget)) {
	            createRipple(touchStartX, touchStartY, rippleTarget);
	        }
	        else {
	            rippleTimeout = setTimeout(function () {
	                createRipple(touchStartX, touchStartY, rippleTarget);
	            }, 80);
	        }
	    }
	    function rippleTouchMove() {
	        clearTimeout(rippleTimeout);
	        removeRipple();
	    }
	    function rippleTouchEnd() {
	        if (rippleWave) {
	            removeRipple();
	        }
	        else if (rippleTarget && !isMoved) {
	            clearTimeout(rippleTimeout);
	            createRipple(touchStartX, touchStartY, rippleTarget);
	            setTimeout(removeRipple, 0);
	        }
	        else {
	            removeRipple();
	        }
	    }
	
	    // Send Click
	    function sendClick(e) {
	        var touch = e.changedTouches[0];
	        var evt = document.createEvent('MouseEvents');
	        var eventType = 'click';
	        if (app.device.android && targetElement.nodeName.toLowerCase() === 'select') {
	            eventType = 'mousedown';
	        }
	        evt.initMouseEvent(eventType, true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
	        evt.forwardedTouchEvent = true;
	        targetElement.dispatchEvent(evt);
	    }
	
	    // Touch Handlers
	    function handleTouchStart(e) {
	        isMoved = false;
	        tapHoldFired = false;
	        if (e.targetTouches.length > 1) {
	            if (activableElement) removeActive();
	            return true;
	        }
	        if (e.touches.length > 1 && activableElement) {
	            removeActive();
	        }
	        if (app.params.tapHold) {
	            if (tapHoldTimeout) clearTimeout(tapHoldTimeout);
	            tapHoldTimeout = setTimeout(function () {
	                if (e && e.touches && e.touches.length > 1) return;
	                tapHoldFired = true;
	                e.preventDefault();
	                $(e.target).trigger('taphold');
	            }, app.params.tapHoldDelay);
	        }
	        if (needsFastClickTimeOut) clearTimeout(needsFastClickTimeOut);
	        needsFastClick = targetNeedsFastClick(e.target);
	
	        if (!needsFastClick) {
	            trackClick = false;
	            return true;
	        }
	        if (app.device.ios || (app.device.android && 'getSelection' in window)) {
	            var selection = window.getSelection();
	            if (selection.rangeCount && selection.focusNode !== document.body && (!selection.isCollapsed || document.activeElement === selection.focusNode)) {
	                activeSelection = true;
	                return true;
	            }
	            else {
	                activeSelection = false;
	            }
	        }
	        if (app.device.android)  {
	            if (androidNeedsBlur(e.target)) {
	                document.activeElement.blur();
	            }
	        }
	
	        trackClick = true;
	        targetElement = e.target;
	        touchStartTime = (new Date()).getTime();
	        touchStartX = e.targetTouches[0].pageX;
	        touchStartY = e.targetTouches[0].pageY;
	
	        // Detect scroll parent
	        if (app.device.ios) {
	            scrollParent = undefined;
	            $(targetElement).parents().each(function () {
	                var parent = this;
	                if (parent.scrollHeight > parent.offsetHeight && !scrollParent) {
	                    scrollParent = parent;
	                    scrollParent.f7ScrollTop = scrollParent.scrollTop;
	                }
	            });
	        }
	        if ((e.timeStamp - lastClickTime) < app.params.fastClicksDelayBetweenClicks) {
	            e.preventDefault();
	        }
	
	        if (app.params.activeState) {
	            activableElement = findActivableElement(targetElement);
	            // If it's inside a scrollable view, we don't trigger active-state yet,
	            // because it can be a scroll instead. Based on the link:
	            // http://labnote.beedesk.com/click-scroll-and-pseudo-active-on-mobile-webk
	            if (!isInsideScrollableView(activableElement)) {
	                addActive();
	            } else {
	                activeTimeout = setTimeout(addActive, 80);
	            }
	        }
	        if (app.params.material && app.params.materialRipple) {
	            rippleTouchStart(targetElement, touchStartX, touchStartY);
	        }
	    }
	    function handleTouchMove(e) {
	        if (!trackClick) return;
	        var _isMoved = false;
	        var distance = app.params.fastClicksDistanceThreshold;
	        if (distance) {
	            var pageX = e.targetTouches[0].pageX;
	            var pageY = e.targetTouches[0].pageY;
	            if (Math.abs(pageX - touchStartX) > distance ||  Math.abs(pageY - touchStartY) > distance) {
	                _isMoved = true;
	            }
	        }
	        else {
	            _isMoved = true;
	        }
	        if (_isMoved) {
	            trackClick = false;
	            targetElement = null;
	            isMoved = true;
	            if (app.params.tapHold) {
	                clearTimeout(tapHoldTimeout);
	            }
				if (app.params.activeState) {
					clearTimeout(activeTimeout);
					removeActive();
				}
	            if (app.params.material && app.params.materialRipple) {
	                rippleTouchMove();
	            }
	        }
	    }
	    function handleTouchEnd(e) {
	        clearTimeout(activeTimeout);
	        clearTimeout(tapHoldTimeout);
	
	        if (!trackClick) {
	            if (!activeSelection && needsFastClick) {
	                if (!(app.device.android && !e.cancelable)) {
	                    e.preventDefault();
	                }
	            }
	            return true;
	        }
	
	        if (document.activeElement === e.target) {
	            if (app.params.activeState) removeActive();
	            if (app.params.material && app.params.materialRipple) {
	                rippleTouchEnd();
	            }
	            return true;
	        }
	
	        if (!activeSelection) {
	            e.preventDefault();
	        }
	
	        if ((e.timeStamp - lastClickTime) < app.params.fastClicksDelayBetweenClicks) {
	            setTimeout(removeActive, 0);
	            return true;
	        }
	
	        lastClickTime = e.timeStamp;
	
	        trackClick = false;
	
	        if (app.device.ios && scrollParent) {
	            if (scrollParent.scrollTop !== scrollParent.f7ScrollTop) {
	                return false;
	            }
	        }
	
	        // Add active-state here because, in a very fast tap, the timeout didn't
	        // have the chance to execute. Removing active-state in a timeout gives
	        // the chance to the animation execute.
	        if (app.params.activeState) {
	            addActive();
	            setTimeout(removeActive, 0);
	        }
	        // Remove Ripple
	        if (app.params.material && app.params.materialRipple) {
	            rippleTouchEnd();
	        }
	
	        // Trigger focus when required
	        if (targetNeedsFocus(targetElement)) {
	            if (app.device.ios && app.device.webView) {
	                if ((event.timeStamp - touchStartTime) > 159) {
	                    targetElement = null;
	                    return false;
	                }
	                targetElement.focus();
	                return false;
	            }
	            else {
	                targetElement.focus();
	            }
	        }
	
	        // Blur active elements
	        if (document.activeElement && targetElement !== document.activeElement && document.activeElement !== document.body && targetElement.nodeName.toLowerCase() !== 'label') {
	            document.activeElement.blur();
	        }
	
	        // Send click
	        e.preventDefault();
	        sendClick(e);
	        return false;
	    }
	    function handleTouchCancel(e) {
	        trackClick = false;
	        targetElement = null;
	
	        // Remove Active State
	        clearTimeout(activeTimeout);
	        clearTimeout(tapHoldTimeout);
	        if (app.params.activeState) {
	            removeActive();
	        }
	
	        // Remove Ripple
	        if (app.params.material && app.params.materialRipple) {
	            rippleTouchEnd();
	        }
	    }
	
	    function handleClick(e) {
	        var allowClick = false;
	
	        if (trackClick) {
	            targetElement = null;
	            trackClick = false;
	            return true;
	        }
	        if (e.target.type === 'submit' && e.detail === 0 || e.target.type === 'file') {
	            return true;
	        }
	        if (!targetElement) {
	            if (!isFormElement(e.target)) {
	                allowClick =  true;
	            }
	        }
	        if (!needsFastClick) {
	            allowClick = true;
	        }
	        if (document.activeElement === targetElement) {
	            allowClick =  true;
	        }
	        if (e.forwardedTouchEvent) {
	            allowClick =  true;
	        }
	        if (!e.cancelable) {
	            allowClick =  true;
	        }
	        if (app.params.tapHold && app.params.tapHoldPreventClicks && tapHoldFired) {
	            allowClick = false;
	        }
	        if (!allowClick) {
	            e.stopImmediatePropagation();
	            e.stopPropagation();
	            if (targetElement) {
	                if (targetNeedsPrevent(targetElement) || isMoved) {
	                    e.preventDefault();
	                }
	            }
	            else {
	                e.preventDefault();
	            }
	            targetElement = null;
	        }
	        needsFastClickTimeOut = setTimeout(function () {
	            needsFastClick = false;
	        }, (app.device.ios || app.device.androidChrome ? 100 : 400));
	
	        if (app.params.tapHold) {
	            tapHoldTimeout = setTimeout(function () {
	                tapHoldFired = false;
	            }, (app.device.ios || app.device.androidChrome ? 100 : 400));
	        }
	
	        return allowClick;
	    }
	    if (app.support.touch) {
	        document.addEventListener('click', handleClick, true);
	
	        document.addEventListener('touchstart', handleTouchStart);
	        document.addEventListener('touchmove', handleTouchMove);
	        document.addEventListener('touchend', handleTouchEnd);
	        document.addEventListener('touchcancel', handleTouchCancel);
	    }
	    else {
	        if (app.params.activeState) {
	            document.addEventListener('mousedown', handleMouseDown);
	            document.addEventListener('mousemove', handleMouseMove);
	            document.addEventListener('mouseup', handleMouseUp);
	        }
	    }
	    if (app.params.material && app.params.materialRipple) {
	        document.addEventListener('contextmenu', function (e) {
	            if (activableElement) removeActive();
	            rippleTouchEnd();
	        });
	    }
	
	};
	
	/*===============================================================================
	************   Store and parse forms data   ************
	===============================================================================*/
	app.formsData = {};
	app.formStoreData = function (formId, formJSON) {
	    // Store form data in app.formsData
	    app.formsData[formId] = formJSON;
	
	    // Store form data in local storage also
	    app.ls['f7form-' + formId] = JSON.stringify(formJSON);
	};
	app.formDeleteData = function (formId) {
	    // Delete form data from app.formsData
	    if (app.formsData[formId]) {
	        app.formsData[formId] = '';
	        delete app.formsData[formId];
	    }
	
	    // Delete form data from local storage also
	    if (app.ls['f7form-' + formId]) {
	        app.ls['f7form-' + formId] = '';
	        app.ls.removeItem('f7form-' + formId);
	    }
	};
	app.formGetData = function (formId) {
	    // First of all check in local storage
	    if (app.ls['f7form-' + formId]) {
	        return JSON.parse(app.ls['f7form-' + formId]);
	    }
	    // Try to get it from formsData obj
	    else if (app.formsData[formId]) return app.formsData[formId];
	};
	app.formToData = function (form) {
	    form = $(form);
	    if (form.length !== 1) return false;
	
	    // Form data
	    var formData = {};
	
	    // Skip input types
	    var skipTypes = ['submit', 'image', 'button', 'file'];
	    var skipNames = [];
	    form.find('input, select, textarea').each(function () {
	        var input = $(this);
	        var name = input.attr('name');
	        var type = input.attr('type');
	        var tag = this.nodeName.toLowerCase();
	        if (skipTypes.indexOf(type) >= 0) return;
	        if (skipNames.indexOf(name) >= 0 || !name) return;
	        if (tag === 'select' && input.prop('multiple')) {
	            skipNames.push(name);
	            formData[name] = [];
	            form.find('select[name="' + name + '"] option').each(function () {
	                if (this.selected) formData[name].push(this.value);
	            });
	        }
	        else {
	            switch (type) {
	                case 'checkbox' :
	                    skipNames.push(name);
	                    formData[name] = [];
	                    form.find('input[name="' + name + '"]').each(function () {
	                        if (this.checked) formData[name].push(this.value);
	                    });
	                    break;
	                case 'radio' :
	                    skipNames.push(name);
	                    form.find('input[name="' + name + '"]').each(function () {
	                        if (this.checked) formData[name] = this.value;
	                    });
	                    break;
	                default :
	                    formData[name] = input.val();
	                    break;
	            }
	        }
	    });
	    form.trigger('formToJSON formToData form:todata', {formData: formData});
	
	    return formData;
	};
	app.formToJSON = app.formToData;
	app.formFromData = function (form, formData) {
	    form = $(form);
	    if (form.length !== 1) return false;
	
	    // Skip input types
	    var skipTypes = ['submit', 'image', 'button', 'file'];
	    var skipNames = [];
	
	    form.find('input, select, textarea').each(function () {
	        var input = $(this);
	        var name = input.attr('name');
	        var type = input.attr('type');
	        var tag = this.nodeName.toLowerCase();
	        if (typeof formData[name] === 'undefined' || formData[name] === null) return;
	        if (skipTypes.indexOf(type) >= 0) return;
	        if (skipNames.indexOf(name) >= 0 || !name) return;
	        if (tag === 'select' && input.prop('multiple')) {
	            skipNames.push(name);
	            form.find('select[name="' + name + '"] option').each(function () {
	                if (formData[name].indexOf(this.value) >= 0) this.selected = true;
	                else this.selected = false;
	            });
	        }
	        else {
	            switch (type) {
	                case 'checkbox' :
	                    skipNames.push(name);
	                    form.find('input[name="' + name + '"]').each(function () {
	                        if (formData[name].indexOf(this.value) >= 0) this.checked = true;
	                        else this.checked = false;
	                    });
	                    break;
	                case 'radio' :
	                    skipNames.push(name);
	                    form.find('input[name="' + name + '"]').each(function () {
	                        if (formData[name] === this.value) this.checked = true;
	                        else this.checked = false;
	                    });
	                    break;
	                default :
	                    input.val(formData[name]);
	                    break;
	            }
	        }
	        if (tag === 'select' && input.parents('.smart-select').length > 0) {
	            input.trigger('change');
	        }
	    });
	    form.trigger('formFromJSON formFromData form:fromdata', {formData: formData});
	};
	app.formFromJSON = app.formFromData;
	
	app.initFormsStorage = function (pageContainer) {
	    pageContainer = $(pageContainer);
	    var forms = pageContainer.find('form.store-data');
	    if (forms.length === 0) return;
	
	    // Parse forms data and fill form if there is such data
	    forms.each(function () {
	        var id = this.getAttribute('id');
	        if (!id) return;
	        var formData = app.formGetData(id);
	        if (formData) app.formFromData(this, formData);
	    });
	    // Update forms data on inputs change
	    function storeForm() {
	        /*jshint validthis:true */
	        var form = $(this);
	        var formId = form[0].id;
	        if (!formId) return;
	        var formJSON = app.formToData(form);
	        if (!formJSON) return;
	        app.formStoreData(formId, formJSON);
	        form.trigger('store form:storedata', {data: formJSON});
	    }
	    forms.on('change submit', storeForm);
	
	    // Detach Listeners
	    function pageBeforeRemove() {
	        forms.off('change submit', storeForm);
	        pageContainer.off('page:beforeremove', pageBeforeRemove);
	    }
	    pageContainer.on('page:beforeremove', pageBeforeRemove);
	};
	/*===============================================================================
	************   Ajax submit for forms   ************
	===============================================================================*/
	// Ajax submit on forms
	$(document).on('submit change', 'form.ajax-submit, form.ajax-submit-onchange', function (e) {
	    var form = $(this);
	    if (e.type === 'change' && !form.hasClass('ajax-submit-onchange')) return;
	    if (e.type === 'submit') e.preventDefault();
	
	    var method = (form.attr('method') || 'GET').toUpperCase();
	    var contentType = form.prop('enctype') || form.attr('enctype');
	
	    var url = form.attr('action');
	    if (!url) return;
	
	    var data;
	    if (method === 'POST') data = new FormData(form[0]);
	    else data = $.serializeObject(app.formToJSON(form[0]));
	
	    var xhr = $.ajax({
	        method: method,
	        url: url,
	        contentType: contentType,
	        data: data,
	        beforeSend: function (xhr) {
	            form.trigger('beforeSubmit form:beforesend', {data:data, xhr: xhr});
	        },
	        error: function (xhr) {
	            form.trigger('submitError form:error', {data:data, xhr: xhr});
	        },
	        success: function (data) {
	            form.trigger('submitted form:success', {data: data, xhr: xhr});
	        }
	    });
	});
	
	
	/*===============================================================================
	************   Resizable textarea   ************
	===============================================================================*/
	app.resizeTextarea = function (textarea) {
	    textarea = $(textarea);
	    if (!textarea.hasClass('resizable')) {
	        return;
	    }
	    textarea.css({'height': ''});
	    var height = textarea[0].offsetHeight;
	    var diff = height - textarea[0].clientHeight;
	    var scrollHeight = textarea[0].scrollHeight;
	
	    if (scrollHeight + diff > height) {
	        var newAreaHeight = scrollHeight + diff;
	        textarea.css('height', newAreaHeight + 'px');
	    }
	};
	app.resizableTextarea = function (textarea) {
	    textarea = $(textarea);
	    if (textarea.length === 0) return;
	    var textareaTimeout;
	    function handleTextarea() {
	        clearTimeout(textareaTimeout);
	        textareaTimeout = setTimeout(function () {
	            app.resizeTextarea(textarea);
	        }, 0);
	    }
	    textarea[0].f7DestroyResizableTextarea = function () {
	        textarea.off('change keydown keypress keyup paste cut', handleTextarea);
	    };
	    return textarea.on('change keydown keypress keyup paste cut', handleTextarea);
	};
	app.destroyResizableTextarea = function (pageContainer) {
	    pageContainer = $(pageContainer);
	    if (pageContainer.length > 0 && pageContainer.is('textarea') && pageContainer[0].f7DestroyResizableTextarea) {
	        pageContainer[0].f7DestroyResizableTextarea();
	    }
	    else if (pageContainer.length > 0) {
	        pageContainer.find('textarea.resiable').each(function () {
	            var textarea = this;
	            if (textarea.f7DestroyResizableTextarea) {
	                textarea.f7DestroyResizableTextarea ();
	            }
	        });
	    }
	};
	app.initPageResizableTextarea = function (pageContainer) {
	    pageContainer = $(pageContainer);
	    var textareas = pageContainer.find('textarea.resizable');
	    textareas.each(function () {
	        app.resizableTextarea(this);
	    });
	};
	/*======================================================
	************   Material Text Inputs   ************
	======================================================*/
	app.initPageMaterialInputs = function (pageContainer) {
	    pageContainer = $(pageContainer);
	    var textareas = pageContainer.find('textarea.resizable');
	    pageContainer.find('.item-input').each(function () {
	        var itemInput = $(this);
	        var notInputs = ['checkbox', 'button', 'submit', 'range', 'radio', 'image'];
	        itemInput.find('input, select, textarea').each(function () {
	            var input = $(this);
	            if (notInputs.indexOf(input.attr('type')) < 0) {
	                itemInput.addClass('item-input-field');
	                if (input.val().trim() !== '') {
	                    input.parents('.item-input, .input-field').add(input.parents('.item-inner')).addClass('not-empty-state');
	                }
	            }
	        });
	        if (itemInput.parents('.input-item, .inputs-list').length > 0) return;
	        itemInput.parents('.list-block').eq(0).addClass('inputs-list');
	    });
	};
	/*======================================================
	************   Material Focus Inputs   ************
	======================================================*/
	app.initMaterialWatchInputs = function () {
	    var notInputs = ['checkbox', 'button', 'submit', 'range', 'radio', 'image'];
	    function addFocusState(e) {
	        /*jshint validthis:true*/
	        var i = $(this);
	        var type = i.attr('type');
	        if (notInputs.indexOf(type) >= 0) return;
	        var els = i.add(i.parents('.item-input, .input-field')).add(i.parents('.item-inner').eq(0));
	        els.addClass('focus-state');
	    }
	    function removeFocusState(e) {
	        /*jshint validthis:true*/
	        var i = $(this), value = i.val();
	        var type = i.attr('type');
	        if (notInputs.indexOf(type) >= 0) return;
	        var els = i.add(i.parents('.item-input, .input-field')).add(i.parents('.item-inner').eq(0));
	        els.removeClass('focus-state');
	        if (value && value.trim() !== '') {
	            els.addClass('not-empty-state');
	        }
	        else {
	            els.removeClass('not-empty-state');
	        }
	    }
	    function watchChangeState(e) {
	        /*jshint validthis:true*/
	        var i = $(this), value = i.val();
	        var type = i.attr('type');
	        if (notInputs.indexOf(type) >= 0) return;
	        var els = i.add(i.parents('.item-input, .input-field')).add(i.parents('.item-inner').eq(0));
	        if (value && value.trim() !== '') {
	            els.addClass('not-empty-state');
	        }
	        else {
	            els.removeClass('not-empty-state');
	        }
	    }
	    $(document).on('change', '.item-input input, .item-input select, .item-input textarea, input, textarea, select', watchChangeState, true);
	    $(document).on('focus', '.item-input input, .item-input select, .item-input textarea, input, textarea, select', addFocusState, true);
	    $(document).on('blur', '.item-input input, .item-input select, .item-input textarea, input, textarea, select', removeFocusState, true);
	};
	/* ===============================================================================
	************   Infinite Scroll   ************
	=============================================================================== */
	function handleInfiniteScroll() {
	    /*jshint validthis:true */
	    var inf = $(this);
	    var scrollTop = inf[0].scrollTop;
	    var scrollHeight = inf[0].scrollHeight;
	    var height = inf[0].offsetHeight;
	    var distance = inf[0].getAttribute('data-distance');
	    var virtualListContainer = inf.find('.virtual-list');
	    var virtualList;
	    var onTop = inf.hasClass('infinite-scroll-top');
	    if (!distance) distance = 50;
	    if (typeof distance === 'string' && distance.indexOf('%') >= 0) {
	        distance = parseInt(distance, 10) / 100 * height;
	    }
	    if (distance > height) distance = height;
	    if (onTop) {
	        if (scrollTop < distance) {
	            inf.trigger('infinite');
	        }
	    }
	    else {
	        if (scrollTop + height >= scrollHeight - distance) {
	            if (virtualListContainer.length > 0) {
	                virtualList = virtualListContainer.eq(-1)[0].f7VirtualList;
	                if (virtualList && !virtualList.reachEnd && !virtualList.params.updatableScroll) {
	                    return;
	                }
	            }
	            inf.trigger('infinite');
	        }
	    }
	
	}
	app.attachInfiniteScroll = function (infiniteContent) {
	    $(infiniteContent).on('scroll', handleInfiniteScroll);
	};
	app.detachInfiniteScroll = function (infiniteContent) {
	    $(infiniteContent).off('scroll', handleInfiniteScroll);
	};
	
	app.initPageInfiniteScroll = function (pageContainer) {
	    pageContainer = $(pageContainer);
	    var infiniteContent = pageContainer.find('.infinite-scroll');
	    if (infiniteContent.length === 0) return;
	    app.attachInfiniteScroll(infiniteContent);
	    function detachEvents() {
	        app.detachInfiniteScroll(infiniteContent);
	        pageContainer.off('page:beforeremove', detachEvents);
	    }
	    pageContainer.on('page:beforeremove', detachEvents);
	};
	/*======================================================
	************   Messagebar   ************
	======================================================*/
	var Messagebar = function (container, params) {
	    var defaults = {
	        textarea: null,
	        maxHeight: null,
	    };
	    params = params || {};
	    for (var def in defaults) {
	        if (typeof params[def] === 'undefined' || params[def] === null) {
	            params[def] = defaults[def];
	        }
	    }
	    
	    // Instance
	    var m = this;
	
	    // Params
	    m.params = params;
	
	    // Container
	    m.container = $(container);
	    if (m.container.length === 0) return;
	
	    // Textarea
	    m.textarea = m.params.textarea ? $(m.params.textarea) : m.container.find('textarea');
	
	    // Is In Page
	    m.pageContainer = m.container.parents('.page').eq(0);
	    m.pageContent = m.pageContainer.find('.page-content');
	
	    // Initial Sizes
	    m.pageContentPadding = parseInt(m.pageContent.css('padding-bottom'));
	    m.initialBarHeight = m.container[0].offsetHeight;
	    m.initialAreaHeight = m.textarea[0].offsetHeight;
	    
	
	    // Resize textarea
	    m.sizeTextarea = function () {
	        // Reset
	        m.textarea.css({'height': ''});
	        
	        var height = m.textarea[0].offsetHeight;
	        var diff = height - m.textarea[0].clientHeight;
	        var scrollHeight = m.textarea[0].scrollHeight;
	
	        // Update
	        if (scrollHeight + diff > height) {
	            var newAreaHeight = scrollHeight + diff;
	            var newBarHeight = m.initialBarHeight + (newAreaHeight - m.initialAreaHeight);
	            var maxBarHeight = m.params.maxHeight || m.container.parents('.view')[0].offsetHeight - 88;
	            if (newBarHeight > maxBarHeight) {
	                newBarHeight = parseInt(maxBarHeight, 10);
	                newAreaHeight = newBarHeight - m.initialBarHeight + m.initialAreaHeight;
	            }
	            m.textarea.css('height', newAreaHeight + 'px');
	            m.container.css('height', newBarHeight + 'px');
	            var onBottom = (m.pageContent[0].scrollTop === m.pageContent[0].scrollHeight - m.pageContent[0].offsetHeight);
	            if (m.pageContent.length > 0) {
	                m.pageContent.css('padding-bottom', newBarHeight + 'px');
	                if (m.pageContent.find('.messages-new-first').length === 0 && onBottom) {
	                    m.pageContent.scrollTop(m.pageContent[0].scrollHeight - m.pageContent[0].offsetHeight);
	                }
	            }
	        }
	        else {
	            if (m.pageContent.length > 0) {
	                m.container.css({'height': '', 'bottom': ''});
	                m.pageContent.css({'padding-bottom': ''});
	            }
	        }
	    };
	    
	    // Clear
	    m.clear = function () {
	        m.textarea.val('').trigger('change');
	    };
	    m.value = function (value) {
	        if (typeof value === 'undefined') return m.textarea.val();
	        else m.textarea.val(value).trigger('change');  
	    };
	    
	    // Handle textarea
	    m.textareaTimeout = undefined;
	    m.handleTextarea = function (e) {
	        clearTimeout(m.textareaTimeout);
	        m.textareaTimeout = setTimeout(function () {
	            m.sizeTextarea();
	        }, 0);
	    };
	
	    //Events
	    function preventSubmit(e) {
	        e.preventDefault();
	    }
	
	    m.attachEvents = function (destroy) {
	        var method = destroy ? 'off' : 'on';
	        m.container[method]('submit', preventSubmit);
	        m.textarea[method]('change keydown keypress keyup paste cut', m.handleTextarea);
	    };
	    m.detachEvents = function () {
	        m.attachEvents(true);
	    };
	    
	    // Init Destroy
	    m.init = function () {
	        m.attachEvents();
	    };
	    m.destroy = function () {
	        m.detachEvents();
	        m = null;
	    };
	
	    // Init
	    m.init();
	
	    m.container[0].f7Messagebar = m;
	    return m;
	};
	app.messagebar = function (container, params) {
	    return new Messagebar(container, params);
	};
	app.initPageMessagebar = function (pageContainer) {
	    pageContainer = $(pageContainer);
	    var messagebar = pageContainer.hasClass('messagebar') ? pageContainer : pageContainer.find('.messagebar');
	    if (messagebar.length === 0) return;
	    if (!messagebar.hasClass('messagebar-init')) return;
	    var mb = app.messagebar(messagebar, messagebar.dataset());
	
	    // Destroy on page remove
	    function pageBeforeRemove() {
	        mb.destroy();
	        pageContainer.off('page:beforeremove', pageBeforeRemove);
	    }
	    if (pageContainer.hasClass('page')) {
	        pageContainer.on('page:beforeremove', pageBeforeRemove);
	    }
	};
	/*======================================================
	************   Messages   ************
	======================================================*/
	var Messages = function (container, params) {
	    var defaults = {
	        autoLayout: true,
	        newMessagesFirst: false,
	        scrollMessages: true,
	        scrollMessagesOnlyOnEdge: false,
	        messageTemplate:
	            '{{#if day}}' +
	            '<div class="messages-date">{{day}} {{#if time}}, <span>{{time}}</span>{{/if}}</div>' +
	            '{{/if}}' +
	            '<div class="message message-{{type}} {{#if hasImage}}message-pic{{/if}} {{#if avatar}}message-with-avatar{{/if}} {{#if position}}message-appear-from-{{position}}{{/if}}">' +
	                '{{#if name}}<div class="message-name">{{name}}</div>{{/if}}' +
	                '<div class="message-text">{{text}}{{#if date}}<div class="message-date">{{date}}</div>{{/if}}</div>' +
	                '{{#if avatar}}<div class="message-avatar" style="background-image:url({{avatar}})"></div>{{/if}}' +
	                '{{#if label}}<div class="message-label">{{label}}</div>{{/if}}' +
	            '</div>'
	    };
	    params = params || {};
	    for (var def in defaults) {
	        if (typeof params[def] === 'undefined' || params[def] === null) {
	            params[def] = defaults[def];
	        }
	    }
	
	    // Instance
	    var m = this;
	
	    // Params
	    m.params = params;
	
	    // Container
	    m.container = $(container);
	    if (m.container.length === 0) return;
	
	    // Autolayout
	    if (m.params.autoLayout) m.container.addClass('messages-auto-layout');
	
	    // New messages first
	    if (m.params.newMessagesFirst) m.container.addClass('messages-new-first');
	
	    // Is In Page
	    m.pageContainer = m.container.parents('.page').eq(0);
	    m.pageContent = m.pageContainer.find('.page-content');
	
	    // Compiled template
	    m.template = Template7.compile(m.params.messageTemplate);
	
	    // Auto Layout
	    m.layout = function () {
	        if (!m.container.hasClass('messages-auto-layout')) m.container.addClass('messages-auto-layout');
	        m.container.find('.message').each(function () {
	            var message = $(this);
	            if (message.find('.message-text img').length > 0) {
	                var childNodes = message.find('.message-text')[0].childNodes;
	                var onlyPic = true;
	                for (var i = 0 ; i < childNodes.length; i++) {
	                    if (childNodes[i].nodeType === 1 && childNodes[i].nodeName.toLowerCase() !== 'img') onlyPic = false;
	                    if (childNodes[i].nodeType === 3 && childNodes[i].textContent.trim() !== '') onlyPic = false;
	                }
	                if (onlyPic) message.addClass('message-pic');
	                else message.removeClass('message-pic');
	            }
	            if (message.find('.message-avatar').length > 0) message.addClass('message-with-avatar');
	        });
	        m.container.find('.message').each(function () {
	            var message = $(this);
	            var isSent = message.hasClass('message-sent');
	            var next = message.next('.message-' + (isSent ? 'sent' : 'received'));
	            var prev = message.prev('.message-' + (isSent ? 'sent' : 'received'));
	            if (next.length === 0) {
	                message.addClass('message-last message-with-tail');
	            }
	            else message.removeClass('message-last message-with-tail');
	
	            if (prev.length === 0) {
	                message.addClass('message-first');
	            }
	            else message.removeClass('message-first');
	
	            if (prev.length > 0 && prev.find('.message-name').length > 0 && message.find('.message-name').length > 0) {
	                if (prev.find('.message-name').text() !== message.find('.message-name').text()) {
	                    prev.addClass('message-last message-with-tail');
	                    message.addClass('message-first');
	                }
	            }
	        });
	    };
	
	    // Add Message
	    m.appendMessage = function (props, animate) {
	        return m.addMessage(props, 'append', animate);
	    };
	    m.prependMessage = function (props, animate) {
	        return m.addMessage(props, 'prepend', animate);
	    };
	    m.addMessage = function (props, method, animate) {
	        return m.addMessages([props], method, animate);
	    };
	    m.addMessages = function (newMessages, method, animate) {
	        if (typeof animate === 'undefined') {
	            animate = true;
	        }
	        if (typeof method === 'undefined') {
	            method = m.params.newMessagesFirst ? 'prepend' : 'append';
	        }
	        var newMessagesHTML = '', i;
	        for (i = 0; i < newMessages.length; i++) {
	            var props = newMessages[i] || {};
	            props.type = props.type || 'sent';
	            if (!props.text) continue;
	            props.hasImage = props.text.indexOf('<img') >= 0;
	            if (props.onlyImage === false) props.hasImage = false;
	            if (animate) props.position = method === 'append' ? 'bottom' : 'top';
	
	            newMessagesHTML += m.template(props);
	        }
	        var scrollHeightBefore = m.pageContent[0].scrollHeight,
	            heightBefore = m.pageContent[0].offsetHeight,
	            scrollBefore = m.pageContent[0].scrollTop;
	        m.container[method](newMessagesHTML);
	        if (m.params.autoLayout) m.layout();
	        if (method === 'prepend') {
	            m.pageContent[0].scrollTop = scrollBefore + (m.pageContent[0].scrollHeight - scrollHeightBefore);
	        }
	        if (m.params.scrollMessages && (method === 'append' && !m.params.newMessagesFirst) || (method === 'prepend' && m.params.newMessagesFirst)) {
	            if (m.params.scrollMessagesOnlyOnEdge) {
	                var onEdge = false;
	                if (m.params.newMessagesFirst) {
	                    if (scrollBefore === 0) onEdge = true;
	                }
	                else {
	                    if (scrollBefore - (scrollHeightBefore - heightBefore) >= -10) onEdge = true;
	                }
	                if (onEdge) m.scrollMessages(animate ? undefined : 0);
	            }
	            else m.scrollMessages(animate ? undefined : 0);
	        }
	        var messages = m.container.find('.message');
	        if (newMessages.length === 1) {
	            return method === 'append' ? messages[messages.length - 1] : messages[0];
	        }
	        else {
	            var messagesToReturn = [];
	            if (method === 'append') {
	                for (i = messages.length - newMessages.length; i < messages.length; i++) {
	                    messagesToReturn.push(messages[i]);
	                }
	            }
	            else {
	                for (i = 0; i < newMessages.length; i++) {
	                    messagesToReturn.push(messages[i]);
	                }
	            }
	            return messagesToReturn;
	        }
	
	    };
	    m.removeMessage = function (message) {
	        message = $(message);
	        if (message.length === 0) {
	            return false;
	        }
	        else {
	            message.remove();
	            if (m.params.autoLayout) m.layout();
	            return true;
	        }
	    };
	    m.removeMessages = function (messages) {
	        m.removeMessage(messages);
	    };
	    m.clean = function () {
	        m.container.html('');
	    };
	
	    // Scroll
	    m.scrollMessages = function (duration, scrollTop) {
	        if (typeof duration === 'undefined') duration = 400;
	        var currentScroll = m.pageContent[0].scrollTop;
	        var newScroll;
	        if (typeof scrollTop !== 'undefined') newScroll = scrollTop;
	        else {
	            newScroll = m.params.newMessagesFirst ? 0 : m.pageContent[0].scrollHeight - m.pageContent[0].offsetHeight;
	            if (newScroll === currentScroll) return;
	        }
	        m.pageContent.scrollTop(newScroll, duration);
	    };
	
	    // Init Destroy
	    m.init = function () {
	        if (m.params.messages) {
	            m.addMessages(m.params.messages, undefined, false);
	        }
	        else {
	            if (m.params.autoLayout) m.layout();
	            m.scrollMessages(0);
	        }
	
	    };
	    m.destroy = function () {
	        m = null;
	    };
	
	    // Init
	    m.init();
	
	    m.container[0].f7Messages = m;
	    return m;
	};
	app.messages = function (container, params) {
	    return new Messages (container, params);
	};
	app.initPageMessages = function (pageContainer) {
	    pageContainer = $(pageContainer);
	    var messages = pageContainer.find('.messages');
	    if (messages.length === 0) return;
	    if (!messages.hasClass('messages-init')) {
	        return;
	    }
	    var m = app.messages(messages, messages.dataset());
	
	    // Destroy on page remove
	    function pageBeforeRemove() {
	        m.destroy();
	        pageContainer.off('page:beforeremove', pageBeforeRemove);
	    }
	    if (pageContainer.hasClass('page')) {
	        pageContainer.on('page:beforeremove', pageBeforeRemove);
	    }
	};
	
	/*======================================================
	************   Modals   ************
	======================================================*/
	var _modalTemplateTempDiv = document.createElement('div');
	app.modalStack = [];
	app.modalStackClearQueue = function () {
	    if (app.modalStack.length) {
	        (app.modalStack.shift())();
	    }
	};
	app.modal = function (params) {
	    params = params || {};
	    var modalHTML = '';
	    if (app.params.modalTemplate) {
	        if (!app._compiledTemplates.modal) app._compiledTemplates.modal = t7.compile(app.params.modalTemplate);
	        modalHTML = app._compiledTemplates.modal(params);
	    }
	    else {
	        var buttonsHTML = '';
	        if (params.buttons && params.buttons.length > 0) {
	            for (var i = 0; i < params.buttons.length; i++) {
	                buttonsHTML += '<span class="modal-button' + (params.buttons[i].bold ? ' modal-button-bold' : '') + '">' + params.buttons[i].text + '</span>';
	            }
	        }
	        var titleHTML = params.title ? '<div class="modal-title">' + params.title + '</div>' : '';
	        var textHTML = params.text ? '<div class="modal-text">' + params.text + '</div>' : '';
	        var afterTextHTML = params.afterText ? params.afterText : '';
	        var noButtons = !params.buttons || params.buttons.length === 0 ? 'modal-no-buttons' : '';
	        var verticalButtons = params.verticalButtons ? 'modal-buttons-vertical': '';
	        var modalButtonsHTML = params.buttons && params.buttons.length > 0 ? '<div class="modal-buttons modal-buttons-' + params.buttons.length + ' ' + verticalButtons + '">' + buttonsHTML + '</div>' : '';
	        modalHTML = '<div class="modal ' + noButtons + ' ' + (params.cssClass || '') + '"><div class="modal-inner">' + (titleHTML + textHTML + afterTextHTML) + '</div>' + modalButtonsHTML + '</div>';
	    }
	
	    _modalTemplateTempDiv.innerHTML = modalHTML;
	
	    var modal = $(_modalTemplateTempDiv).children();
	
	    app.root.append(modal[0]);
	
	    // Add events on buttons
	    modal.find('.modal-button').each(function (index, el) {
	        $(el).on('click', function (e) {
	            if (params.buttons[index].close !== false) app.closeModal(modal);
	            if (params.buttons[index].onClick) params.buttons[index].onClick(modal, e);
	            if (params.onClick) params.onClick(modal, index);
	        });
	    });
	    app.openModal(modal);
	    return modal[0];
	};
	app.alert = function (text, title, callbackOk) {
	    if (typeof title === 'function') {
	        callbackOk = arguments[1];
	        title = undefined;
	    }
	    return app.modal({
	        text: text || '',
	        title: typeof title === 'undefined' ? app.params.modalTitle : title,
	        buttons: [ {text: app.params.modalButtonOk, bold: true, onClick: callbackOk} ]
	    });
	};
	app.confirm = function (text, title, callbackOk, callbackCancel) {
	    if (typeof title === 'function') {
	        callbackCancel = arguments[2];
	        callbackOk = arguments[1];
	        title = undefined;
	    }
	    return app.modal({
	        text: text || '',
	        title: typeof title === 'undefined' ? app.params.modalTitle : title,
	        buttons: [
	            {text: app.params.modalButtonCancel, onClick: callbackCancel},
	            {text: app.params.modalButtonOk, bold: true, onClick: callbackOk}
	        ]
	    });
	};
	app.prompt = function (text, title, callbackOk, callbackCancel) {
	    if (typeof title === 'function') {
	        callbackCancel = arguments[2];
	        callbackOk = arguments[1];
	        title = undefined;
	    }
	    return app.modal({
	        text: text || '',
	        title: typeof title === 'undefined' ? app.params.modalTitle : title,
	        afterText: '<div class="input-field"><input type="text" class="modal-text-input"></div>',
	        buttons: [
	            {
	                text: app.params.modalButtonCancel
	            },
	            {
	                text: app.params.modalButtonOk,
	                bold: true
	            }
	        ],
	        onClick: function (modal, index) {
	            if (index === 0 && callbackCancel) callbackCancel($(modal).find('.modal-text-input').val());
	            if (index === 1 && callbackOk) callbackOk($(modal).find('.modal-text-input').val());
	        }
	    });
	};
	app.modalLogin = function (text, title, callbackOk, callbackCancel) {
	    if (typeof title === 'function') {
	        callbackCancel = arguments[2];
	        callbackOk = arguments[1];
	        title = undefined;
	    }
	    return app.modal({
	        text: text || '',
	        title: typeof title === 'undefined' ? app.params.modalTitle : title,
	        afterText: '<div class="input-field modal-input-double"><input type="text" name="modal-username" placeholder="' + app.params.modalUsernamePlaceholder + '" class="modal-text-input"></div><div class="input-field modal-input-double"><input type="password" name="modal-password" placeholder="' + app.params.modalPasswordPlaceholder + '" class="modal-text-input"></div>',
	        buttons: [
	            {
	                text: app.params.modalButtonCancel
	            },
	            {
	                text: app.params.modalButtonOk,
	                bold: true
	            }
	        ],
	        onClick: function (modal, index) {
	            var username = $(modal).find('.modal-text-input[name="modal-username"]').val();
	            var password = $(modal).find('.modal-text-input[name="modal-password"]').val();
	            if (index === 0 && callbackCancel) callbackCancel(username, password);
	            if (index === 1 && callbackOk) callbackOk(username, password);
	        }
	    });
	};
	app.modalPassword = function (text, title, callbackOk, callbackCancel) {
	    if (typeof title === 'function') {
	        callbackCancel = arguments[2];
	        callbackOk = arguments[1];
	        title = undefined;
	    }
	    return app.modal({
	        text: text || '',
	        title: typeof title === 'undefined' ? app.params.modalTitle : title,
	        afterText: '<div class="input-field"><input type="password" name="modal-password" placeholder="' + app.params.modalPasswordPlaceholder + '" class="modal-text-input"></div>',
	        buttons: [
	            {
	                text: app.params.modalButtonCancel
	            },
	            {
	                text: app.params.modalButtonOk,
	                bold: true
	            }
	        ],
	        onClick: function (modal, index) {
	            var password = $(modal).find('.modal-text-input[name="modal-password"]').val();
	            if (index === 0 && callbackCancel) callbackCancel(password);
	            if (index === 1 && callbackOk) callbackOk(password);
	        }
	    });
	};
	app.showPreloader = function (title) {
	    return app.modal({
	        title: title || app.params.modalPreloaderTitle,
	        text: '<div class="preloader">' + (app.params.material ? app.params.materialPreloaderHtml : '') + '</div>',
	        cssClass: 'modal-preloader'
	    });
	};
	app.hidePreloader = function () {
	    app.closeModal('.modal.modal-in');
	};
	app.showIndicator = function () {
	    if ($('.preloader-indicator-overlay').length > 0) return;
	    app.root.append('<div class="preloader-indicator-overlay"></div><div class="preloader-indicator-modal"><span class="preloader preloader-white">' + (app.params.material ? app.params.materialPreloaderHtml : '') + '</span></div>');
	};
	app.hideIndicator = function () {
	    $('.preloader-indicator-overlay, .preloader-indicator-modal').remove();
	};
	// Action Sheet
	app.actions = function (target, params, animated) {
	    var toPopover = false, modal, groupSelector, buttonSelector;
	    if (arguments.length === 1 || arguments.length === 2 && typeof arguments[1] === 'boolean') {
	        // Actions
	        params = arguments[0];
	        animated = arguments[1];
	    }
	    else {
	        // Popover
	        if (app.device.ios) {
	            if (app.device.ipad) toPopover = true;
	        }
	        else {
	            if ($(window).width() >= 768) toPopover = true;
	        }
	    }
	    if (typeof animated === 'undefined') animated = true;
	
	    params = params || [];
	
	    if (params.length > 0 && !$.isArray(params[0])) {
	        params = [params];
	    }
	    var modalHTML;
	    if (toPopover) {
	        var actionsToPopoverTemplate = app.params.modalActionsToPopoverTemplate ||
	            '<div class="popover actions-popover">' +
	              '<div class="popover-inner">' +
	                '{{#each this}}' +
	                '<div class="list-block">' +
	                  '<ul>' +
	                    '{{#each this}}' +
	                    '{{#if label}}' +
	                    '<li class="actions-popover-label {{#if color}}color-{{color}}{{/if}} {{#if bold}}actions-popover-bold{{/if}}">{{text}}</li>' +
	                    '{{else}}' +
	                    '<li><a href="#" class="item-link list-button {{#if color}}color-{{color}}{{/if}} {{#if bg}}bg-{{bg}}{{/if}} {{#if bold}}actions-popover-bold{{/if}} {{#if disabled}}disabled{{/if}}">{{text}}</a></li>' +
	                    '{{/if}}' +
	                    '{{/each}}' +
	                  '</ul>' +
	                '</div>' +
	                '{{/each}}' +
	              '</div>' +
	            '</div>';
	        if (!app._compiledTemplates.actionsToPopover) {
	            app._compiledTemplates.actionsToPopover = t7.compile(actionsToPopoverTemplate);
	        }
	        var popoverHTML = app._compiledTemplates.actionsToPopover(params);
	        modal = $(app.popover(popoverHTML, target, true, animated));
	        groupSelector = '.list-block ul';
	        buttonSelector = '.list-button';
	    }
	    else {
	        if (app.params.modalActionsTemplate) {
	            if (!app._compiledTemplates.actions) app._compiledTemplates.actions = t7.compile(app.params.modalActionsTemplate);
	            modalHTML = app._compiledTemplates.actions(params);
	        }
	        else {
	            var buttonsHTML = '';
	            for (var i = 0; i < params.length; i++) {
	                for (var j = 0; j < params[i].length; j++) {
	                    if (j === 0) buttonsHTML += '<div class="actions-modal-group">';
	                    var button = params[i][j];
	                    var buttonClass = button.label ? 'actions-modal-label' : 'actions-modal-button';
	                    if (button.bold) buttonClass += ' actions-modal-button-bold';
	                    if (button.color) buttonClass += ' color-' + button.color;
	                    if (button.bg) buttonClass += ' bg-' + button.bg;
	                    if (button.disabled) buttonClass += ' disabled';
	                    buttonsHTML += '<div class="' + buttonClass + '">' + button.text + '</div>';
	                    if (j === params[i].length - 1) buttonsHTML += '</div>';
	                }
	            }
	            modalHTML = '<div class="actions-modal">' + buttonsHTML + '</div>';
	        }
	        _modalTemplateTempDiv.innerHTML = modalHTML;
	        modal = $(_modalTemplateTempDiv).children();
	        app.root.append(modal[0]);
	        groupSelector = '.actions-modal-group';
	        buttonSelector = '.actions-modal-button';
	    }
	
	    var groups = modal.find(groupSelector);
	    groups.each(function (index, el) {
	        var groupIndex = index;
	        $(el).children().each(function (index, el) {
	            var buttonIndex = index;
	            var buttonParams = params[groupIndex][buttonIndex];
	            var clickTarget;
	            if (!toPopover && $(el).is(buttonSelector)) clickTarget = $(el);
	            if (toPopover && $(el).find(buttonSelector).length > 0) clickTarget = $(el).find(buttonSelector);
	
	            if (clickTarget) {
	                clickTarget.on('click', function (e) {
	                    if (buttonParams.close !== false) app.closeModal(modal);
	                    if (buttonParams.onClick) buttonParams.onClick(modal, e);
	                });
	            }
	        });
	    });
	    if (!toPopover) app.openModal(modal, animated);
	    return modal[0];
	};
	app.popover = function (modal, target, removeOnClose, animated) {
	    if (typeof removeOnClose === 'undefined') removeOnClose = true;
	    if (typeof animated === 'undefined') animated = true;
	    if (typeof modal === 'string' && modal.indexOf('<') >= 0) {
	        var _modal = document.createElement('div');
	        _modal.innerHTML = modal.trim();
	        if (_modal.childNodes.length > 0) {
	            modal = _modal.childNodes[0];
	            if (removeOnClose) modal.classList.add('remove-on-close');
	            app.root.append(modal);
	        }
	        else return false; //nothing found
	    }
	    modal = $(modal);
	    target = $(target);
	    if (modal.length === 0 || target.length === 0) return false;
	    if (modal.parents('body').length === 0) {
	        if (removeOnClose) modal.addClass('remove-on-close');
	        app.root.append(modal[0]);
	    }
	    if (modal.find('.popover-angle').length === 0 && !app.params.material) {
	        modal.append('<div class="popover-angle"></div>');
	    }
	    modal.show();
	
	    var material = app.params.material;
	
	    function sizePopover() {
	        modal.css({left: '', top: ''});
	        var modalWidth =  modal.width();
	        var modalHeight =  modal.height(); // 13 - height of angle
	        var modalAngle, modalAngleSize = 0, modalAngleLeft, modalAngleTop;
	        if (!material) {
	            modalAngle = modal.find('.popover-angle');
	            modalAngleSize = modalAngle.width() / 2;
	            modalAngle.removeClass('on-left on-right on-top on-bottom').css({left: '', top: ''});
	        }
	        else {
	            modal.removeClass('popover-on-left popover-on-right popover-on-top popover-on-bottom').css({left: '', top: ''});
	        }
	
	        var targetWidth = target.outerWidth();
	        var targetHeight = target.outerHeight();
	        var targetOffset = target.offset();
	        var targetParentPage = target.parents('.page');
	        if (targetParentPage.length > 0) {
	            targetOffset.top = targetOffset.top - targetParentPage[0].scrollTop;
	        }
	
	        var windowHeight = $(window).height();
	        var windowWidth = $(window).width();
	
	        var modalTop = 0;
	        var modalLeft = 0;
	        var diff = 0;
	        // Top Position
	        var modalPosition = material ? 'bottom' : 'top';
	        if (material) {
	            if (modalHeight < windowHeight - targetOffset.top - targetHeight) {
	                // On bottom
	                modalPosition = 'bottom';
	                modalTop = targetOffset.top;
	            }
	            else if (modalHeight < targetOffset.top) {
	                // On top
	                modalTop = targetOffset.top - modalHeight + targetHeight;
	                modalPosition = 'top';
	            }
	            else {
	                // On middle
	                modalPosition = 'bottom';
	                modalTop = targetOffset.top;
	            }
	
	            if (modalTop <= 0) {
	                modalTop = 8;
	            }
	            else if (modalTop + modalHeight >= windowHeight) {
	                modalTop = windowHeight - modalHeight - 8;
	            }
	
	            // Horizontal Position
	            modalLeft = targetOffset.left;
	            if (modalLeft + modalWidth >= windowWidth - 8) {
	                modalLeft = targetOffset.left + targetWidth - modalWidth - 8;
	            }
	            if (modalLeft < 8) {
	                modalLeft = 8;
	            }
	            if (modalPosition === 'top') {
	                modal.addClass('popover-on-top');
	            }
	            if (modalPosition === 'bottom') {
	                modal.addClass('popover-on-bottom');
	            }
	            if (target.hasClass('floating-button-to-popover') && !modal.hasClass('modal-in')) {
	                modal.addClass('popover-floating-button');
	                var diffX = (modalLeft + modalWidth / 2) - (targetOffset.left + targetWidth / 2),
	                    diffY = (modalTop + modalHeight / 2) - (targetOffset.top + targetHeight / 2);
	                target
	                    .addClass('floating-button-to-popover-in')
	                    .transform('translate3d(' + diffX + 'px, ' + diffY + 'px,0)')
	                    .transitionEnd(function (e) {
	                        if (!target.hasClass('floating-button-to-popover-in')) return;
	                        target
	                            .addClass('floating-button-to-popover-scale')
	                            .transform('translate3d(' + diffX + 'px, ' + diffY + 'px,0) scale(' + (modalWidth/targetWidth) + ', ' + (modalHeight/targetHeight) + ')');
	                    });
	
	                modal.once('popover:close', function () {
	                    target
	                        .removeClass('floating-button-to-popover-in floating-button-to-popover-scale')
	                        .addClass('floating-button-to-popover-out')
	                        .transform('')
	                        .transitionEnd(function (e) {
	                            target.removeClass('floating-button-to-popover-out');
	                        });
	                });
	                modal.once('popover:closed', function () {
	                    modal.removeClass('popover-floating-button');
	                });
	            }
	
	        }
	        else {
	            if ((modalHeight + modalAngleSize) < targetOffset.top) {
	                // On top
	                modalTop = targetOffset.top - modalHeight - modalAngleSize;
	            }
	            else if ((modalHeight + modalAngleSize) < windowHeight - targetOffset.top - targetHeight) {
	                // On bottom
	                modalPosition = 'bottom';
	                modalTop = targetOffset.top + targetHeight + modalAngleSize;
	            }
	            else {
	                // On middle
	                modalPosition = 'middle';
	                modalTop = targetHeight / 2 + targetOffset.top - modalHeight / 2;
	                diff = modalTop;
	                if (modalTop <= 0) {
	                    modalTop = 5;
	                }
	                else if (modalTop + modalHeight >= windowHeight) {
	                    modalTop = windowHeight - modalHeight - 5;
	                }
	                diff = diff - modalTop;
	            }
	
	            // Horizontal Position
	            if (modalPosition === 'top' || modalPosition === 'bottom') {
	                modalLeft = targetWidth / 2 + targetOffset.left - modalWidth / 2;
	                diff = modalLeft;
	                if (modalLeft < 5) modalLeft = 5;
	                if (modalLeft + modalWidth > windowWidth) modalLeft = windowWidth - modalWidth - 5;
	                if (modalPosition === 'top') {
	                    modalAngle.addClass('on-bottom');
	                }
	                if (modalPosition === 'bottom') {
	                    modalAngle.addClass('on-top');
	                }
	                diff = diff - modalLeft;
	                modalAngleLeft = (modalWidth / 2 - modalAngleSize + diff);
	                modalAngleLeft = Math.max(Math.min(modalAngleLeft, modalWidth - modalAngleSize * 2 - 13), 13);
	                modalAngle.css({left: modalAngleLeft + 'px'});
	
	            }
	            else if (modalPosition === 'middle') {
	                modalLeft = targetOffset.left - modalWidth - modalAngleSize;
	                modalAngle.addClass('on-right');
	                if (modalLeft < 5 || (modalLeft + modalWidth > windowWidth)) {
	                    if (modalLeft < 5) modalLeft = targetOffset.left + targetWidth + modalAngleSize;
	                    if (modalLeft + modalWidth > windowWidth) modalLeft = windowWidth - modalWidth - 5;
	                    modalAngle.removeClass('on-right').addClass('on-left');
	                }
	                modalAngleTop = (modalHeight / 2 - modalAngleSize + diff);
	                modalAngleTop = Math.max(Math.min(modalAngleTop, modalHeight - modalAngleSize * 2 - 13), 13);
	                modalAngle.css({top: modalAngleTop + 'px'});
	            }
	        }
	
	
	        // Apply Styles
	        modal.css({top: modalTop + 'px', left: modalLeft + 'px'});
	    }
	
	    sizePopover();
	
	    $(window).on('resize', sizePopover);
	
	    modal.on('popover:close', function () {
	        $(window).off('resize', sizePopover);
	    });
	
	    app.openModal(modal, animated);
	    return modal[0];
	};
	app.popup = function (modal, removeOnClose, animated) {
	    if (typeof removeOnClose === 'undefined') removeOnClose = true;
	    if (typeof animated === 'undefined') animated = true;
	    if (typeof modal === 'string' && modal.indexOf('<') >= 0) {
	        var _modal = document.createElement('div');
	        _modal.innerHTML = modal.trim();
	        if (_modal.childNodes.length > 0) {
	            modal = _modal.childNodes[0];
	            if (removeOnClose) modal.classList.add('remove-on-close');
	            app.root.append(modal);
	        }
	        else return false; //nothing found
	    }
	    modal = $(modal);
	    if (modal.length === 0) return false;
	    if (modal.parents('body').length === 0) {
	        if (removeOnClose) modal.addClass('remove-on-close');
	        app.root.append(modal[0]);
	    }
	    modal.show();
	
	    app.openModal(modal, animated);
	    return modal[0];
	};
	app.pickerModal = function (modal, removeOnClose, animated) {
	    if (typeof removeOnClose === 'undefined') removeOnClose = true;
	    if (typeof animated === 'undefined') animated = true;
	    if (typeof modal === 'string' && modal.indexOf('<') >= 0) {
	        modal = $(modal);
	        if (modal.length > 0) {
	            if (removeOnClose) modal.addClass('remove-on-close');
	            app.root.append(modal[0]);
	        }
	        else return false; //nothing found
	    }
	    modal = $(modal);
	    if (modal.length === 0) return false;
	    if (modal.parents('body').length === 0) {
	        if (removeOnClose) modal.addClass('remove-on-close');
	        app.root.append(modal[0]);
	    }
	    if ($('.picker-modal.modal-in:not(.modal-out)').length > 0 && !modal.hasClass('modal-in')) {
	        app.closeModal('.picker-modal.modal-in:not(.modal-out)');
	    }
	    modal.show();
	    app.openModal(modal, animated);
	    return modal[0];
	};
	app.loginScreen = function (modal, animated) {
	    if (!modal) modal = '.login-screen';
	    if (typeof animated === 'undefined') animated = true;
	    modal = $(modal);
	    if (modal.length === 0) return false;
	    if ($('.login-screen.modal-in:not(.modal-out)').length > 0 && !modal.hasClass('modal-in')) {
	        app.closeModal('.login-screen.modal-in:not(.modal-out)');
	    }
	    modal.show();
	    
	    app.openModal(modal, animated);
	    return modal[0];
	};
	app.openModal = function (modal, animated) {
	    if (typeof animated === 'undefined') animated = true;
	    modal = $(modal);
	    modal[animated ? 'removeClass' : 'addClass']('not-animated');
	
	    var isModal = modal.hasClass('modal');
	    var isPopover = modal.hasClass('popover');
	    var isPopup = modal.hasClass('popup');
	    var isLoginScreen = modal.hasClass('login-screen');
	    var isPickerModal = modal.hasClass('picker-modal');
	    var isActions = modal.hasClass('actions-modal');
	
	    // Modal Event Prefix
	    var modalType = 'modal';
	    if (isPopover) modalType = 'popover';
	    if (isPopup) modalType = 'popup';
	    if (isLoginScreen) modalType = 'loginscreen';
	    if (isPickerModal) modalType = 'picker';
	    if (isActions) modalType = 'actions';
	
	    if ($('.modal.modal-in:not(.modal-out)').length && app.params.modalStack && isModal) {
	        app.modalStack.push(function () {
	            app.openModal(modal);
	        });
	        return;
	    }
	
	    // do nothing if this modal already shown
	    if (true === modal.data('f7-modal-shown')) {
	        return;
	    }
	    modal.data('f7-modal-shown', true);
	
	    // Move modal
	    var modalParent = modal.parent();
	    if (app.params.modalsMoveToRoot && !modalParent.is(app.root)) {
	        app.root.append(modal);
	        modal.once(modalType + ':closed', function() {
	           modalParent.append(modal);
	        });
	    }
	
	    modal.once(modalType + ':close', function() {
	       modal.removeData('f7-modal-shown');
	    });
	
	    if (isModal) {
	        modal.show();
	        modal.css({
	            marginTop: - Math.round(modal.outerHeight() / 2) + 'px'
	        });
	    }
	
	    var overlay;
	    if (!isLoginScreen && !isPickerModal) {
	        if ($('.modal-overlay').length === 0 && !isPopup) {
	            app.root.append('<div class="modal-overlay"></div>');
	        }
	        if ($('.popup-overlay').length === 0 && isPopup) {
	            app.root.append('<div class="popup-overlay"></div>');
	        }
	        overlay = isPopup ? $('.popup-overlay') : $('.modal-overlay');
	    }
	    if (app.params.material && isPickerModal) {
	        if (modal.hasClass('picker-calendar')) {
	            if ($('.picker-modal-overlay').length === 0 && !isPopup) {
	                app.root.append('<div class="picker-modal-overlay"></div>');
	            }
	            overlay = $('.picker-modal-overlay');
	        }
	    }
	    if (overlay) {
	        overlay[animated ? 'removeClass' : 'addClass']('not-animated');
	    }
	
	    //Make sure that styles are applied, trigger relayout;
	    var clientLeft = modal[0].clientLeft;
	
	    // Trugger open event
	    modal.trigger('open ' + modalType + ':open');
	
	    // Picker modal body class
	    if (isPickerModal) {
	        $('body').addClass('with-picker-modal');
	    }
	
	    // Init Pages and Navbars in modal
	    if (modal.find('.' + app.params.viewClass).length > 0) {
	        modal.find('.page').each(function () {
	            app.initPageWithCallback(this);
	        });
	        modal.find('.navbar').each(function () {
	            app.initNavbarWithCallback(this);
	        });
	    }
	
	    // Classes for transition in
	    if (!isLoginScreen && !isPickerModal) overlay.addClass('modal-overlay-visible');
	    if (app.params.material && isPickerModal && overlay) overlay.addClass('modal-overlay-visible');
	    if (animated) {
	        modal.removeClass('modal-out').addClass('modal-in').transitionEnd(function (e) {
	            if (modal.hasClass('modal-out')) modal.trigger('closed ' + modalType + ':closed');
	            else modal.trigger('opened ' + modalType + ':opened');
	        });
	    }
	    else {
	        modal.removeClass('modal-out').addClass('modal-in');
	        modal.trigger('opened ' + modalType + ':opened');
	    }
	    return true;
	};
	app.closeModal = function (modal, animated) {
	    if (typeof animated === 'undefined') animated = true;
	    modal = $(modal || '.modal-in');
	    if (typeof modal !== 'undefined' && modal.length === 0) {
	        return;
	    }
	    modal[animated ? 'removeClass' : 'addClass']('not-animated');
	    var isModal = modal.hasClass('modal');
	    var isPopover = modal.hasClass('popover');
	    var isPopup = modal.hasClass('popup');
	    var isLoginScreen = modal.hasClass('login-screen');
	    var isPickerModal = modal.hasClass('picker-modal');
	    var isActions = modal.hasClass('actions-modal');
	
	    // Modal Event Prefix
	    var modalType = 'modal';
	    if (isPopover) modalType = 'popover';
	    if (isPopup) modalType = 'popup';
	    if (isLoginScreen) modalType = 'loginscreen';
	    if (isPickerModal) modalType = 'picker';
	    if (isActions) modalType = 'actions';
	
	    var removeOnClose = modal.hasClass('remove-on-close');
	
	    // For Actions
	    var keepOnClose = modal.hasClass('keep-on-close');
	
	    var overlay;
	
	    if (isPopup) overlay = $('.popup-overlay');
	    else {
	        if (isPickerModal && app.params.material) overlay = $('.picker-modal-overlay');
	        else if (!isPickerModal) overlay = $('.modal-overlay');
	    }
	
	    if (isPopup){
	        if (modal.length === $('.popup.modal-in').length) {
	            overlay.removeClass('modal-overlay-visible');
	        }
	    }
	    else if (overlay && overlay.length > 0) {
	        overlay.removeClass('modal-overlay-visible');
	    }
	    if (overlay) overlay[animated ? 'removeClass' : 'addClass']('not-animated');
	
	    modal.trigger('close ' + modalType + ':close');
	
	    // Picker modal body class
	    if (isPickerModal) {
	        $('body').removeClass('with-picker-modal');
	        $('body').addClass('picker-modal-closing');
	    }
	
	    if (!(isPopover && !app.params.material)) {
	        if (animated) {
	            modal.removeClass('modal-in').addClass('modal-out').transitionEnd(function (e) {
	                if (modal.hasClass('modal-out')) modal.trigger('closed ' + modalType + ':closed');
	                else {
	                    modal.trigger('opened ' + modalType + ':opened');
	                    if (isPopover) return;
	                }
	
	                if (isPickerModal) {
	                    $('body').removeClass('picker-modal-closing');
	                }
	                if (isPopup || isLoginScreen || isPickerModal || isPopover) {
	                    modal.removeClass('modal-out').hide();
	                    if (removeOnClose && modal.length > 0) {
	                        modal.remove();
	                    }
	                }
	                else if (!keepOnClose) {
	                    modal.remove();
	                }
	            });
	        }
	        else {
	            modal.trigger('closed ' + modalType + ':closed');
	            modal.removeClass('modal-in modal-out');
	            if (isPickerModal) {
	                $('body').removeClass('picker-modal-closing');
	            }
	            if (isPopup || isLoginScreen || isPickerModal || isPopover) {
	                modal.hide();
	                if (removeOnClose && modal.length > 0) {
	                    modal.remove();
	                }
	            }
	            else if (!keepOnClose) {
	                modal.remove();
	            }
	        }
	        if (isModal && app.params.modalStack) {
	            app.modalStackClearQueue();
	        }
	    }
	    else {
	        modal.removeClass('modal-in modal-out not-animated').trigger('closed ' + modalType + ':closed').hide();
	        if (removeOnClose) {
	            modal.remove();
	        }
	    }
	    return true;
	};
	
	/*======================================================
	************   Photo Browser   ************
	======================================================*/
	var PhotoBrowser = function (params) {
	    var pb = this, i;
	
	    var defaults = {
	        photos : [],
	        initialSlide: 0,
	        spaceBetween: 20,
	        speed: 300,
	        zoom: true,
	        zoomMax: 3,
	        zoomMin: 1,
	        exposition: true,
	        expositionHideCaptions: false,
	        type: 'standalone',
	        navbar: true,
	        toolbar: true,
	        theme: 'light',
	        swipeToClose: true,
	        backLinkText: 'Close',
	        ofText: 'of',
	        loop: false,
	        lazyLoading: false,
	        lazyLoadingInPrevNext: false,
	        lazyLoadingOnTransitionStart: false,
	        material: app.params.material,
	        materialPreloaderSvg: app.params.materialPreloaderSvg,
	        materialPreloaderHtml: app.params.materialPreloaderHtml,
	        /*
	        Callbacks:
	        onLazyImageLoad(pb, slide, img)
	        onLazyImageReady(pb, slide, img)
	        onOpen(pb)
	        onClose(pb)
	        onTransitionStart(swiper)
	        onTransitionEnd(swiper)
	        onSlideChangeStart(swiper)
	        onSlideChangeEnd(swiper)
	        onTap(swiper, e)
	        onClick(swiper, e)
	        onDoubleTap(swiper, e)
	        onSwipeToClose(pb)
	        */
	    };
	
	    params = params || {};
	    if (!params.backLinkText && app.params.material) defaults.backLinkText = '';
	    for (var def in defaults) {
	        if (typeof params[def] === 'undefined') {
	            params[def] = defaults[def];
	        }
	    }
	    if (params.maxZoom) {
	        params.zoomMax = params.maxZoom;
	    }
	    if (params.minZoom) {
	        params.zoomMin = params.minZoom;
	    }
	
	    pb.params = params;
	    pb.params.iconsColorClass = pb.params.iconsColor ? 'color-' + pb.params.iconsColor : (pb.params.theme === 'dark' ? 'color-white' : '');
	    pb.params.preloaderColorClass = pb.params.theme === 'dark' ? 'preloader-white' : '';
	
	    // Templates
	    var photoTemplate = pb.params.photoTemplate || 
	        '<div class="photo-browser-slide swiper-slide">' +
	            '<span class="swiper-zoom-container">' +
	                '<img src="{{js "this.url || this"}}">' +
	            '</span>' +
	        '</div>';
	    var photoLazyTemplate = pb.params.lazyPhotoTemplate ||
	        '<div class="photo-browser-slide photo-browser-slide-lazy swiper-slide">' +
	            '<div class="preloader {{@root.preloaderColorClass}}">{{#if @root.material}}{{@root.materialPreloaderHtml}}{{/if}}</div>' +
	            '<span class="swiper-zoom-container">' +
	                '<img data-src="{{js "this.url || this"}}" class="swiper-lazy">' +
	            '</span>' +
	        '</div>';
	    var objectTemplate = pb.params.objectTemplate ||
	        '<div class="photo-browser-slide photo-browser-object-slide swiper-slide">{{js "this.html || this"}}</div>';
	    var captionTemplate = pb.params.captionTemplate ||
	        '<div class="photo-browser-caption" data-caption-index="{{@index}}">' +
	            '{{caption}}' +
	        '</div>';
	    var navbarTemplate = pb.params.navbarTemplate ||
	        '<div class="navbar">' +
	            '<div class="navbar-inner">' +
	                '<div class="left sliding">' +
	                    '<a href="#" class="link ' + (params.type === 'popup' ? 'close-popup' : 'photo-browser-close-link')+ ' {{#unless backLinkText}}icon-only{{/unless}} {{js "this.type === \'page\' ? \'back\' : \'\'"}}">' +
	                        '<i class="icon icon-back {{iconsColorClass}}"></i>' +
	                        '{{#if backLinkText}}<span>{{backLinkText}}</span>{{/if}}' +
	                    '</a>' +
	                '</div>' +
	                '<div class="center sliding">' +
	                    '<span class="photo-browser-current"></span> ' +
	                    '<span class="photo-browser-of">{{ofText}}</span> ' +
	                    '<span class="photo-browser-total"></span>' +
	                '</div>' +
	                '<div class="right"></div>' +
	            '</div>' +
	        '</div>';
	    var toolbarTemplate = pb.params.toolbarTemplate ||
	        '<div class="toolbar tabbar">' +
	            '<div class="toolbar-inner">' +
	                '<a href="#" class="link photo-browser-prev">' +
	                    '<i class="icon icon-prev {{iconsColorClass}}"></i>' +
	                '</a>' +
	                '<a href="#" class="link photo-browser-next">' +
	                    '<i class="icon icon-next {{iconsColorClass}}"></i>' +
	                '</a>' +
	            '</div>' +
	        '</div>';
	
	    var htmlTemplate = t7.compile('<div class="photo-browser photo-browser-{{theme}}">' +
	            '<div class="view navbar-fixed toolbar-fixed">' +
	                '{{#unless material}}{{#if navbar}}' +
	                navbarTemplate +
	                '{{/if}}{{/unless}}' +
	                '<div class="page no-toolbar {{#unless navbar}}no-navbar{{/unless}} toolbar-fixed navbar-fixed" data-page="photo-browser-slides">' +
	                    '{{#if material}}{{#if navbar}}' +
	                    navbarTemplate +
	                    '{{/if}}{{/if}}' +
	                    '{{#if toolbar}}' +
	                    toolbarTemplate +
	                    '{{/if}}' +
	                    '<div class="photo-browser-captions photo-browser-captions-{{js "this.captionsTheme || this.theme"}}">' +
	                        '{{#each photos}}{{#if caption}}' +
	                        captionTemplate +
	                        '{{/if}}{{/each}}' +
	                    '</div>' +
	                    '<div class="photo-browser-swiper-container swiper-container">' +
	                        '<div class="photo-browser-swiper-wrapper swiper-wrapper">' +
	                            '{{#each photos}}' +
	                            '{{#js_compare "this.html || ((typeof this === \'string\' || this instanceof String) && (this.indexOf(\'<\') >= 0 || this.indexOf(\'>\') >= 0))"}}' +
	                                objectTemplate +
	                            '{{else}}' +
	                                '{{#if @root.lazyLoading}}' +
	                                photoLazyTemplate +
	                                '{{else}}' +
	                                photoTemplate +
	                                '{{/if}}' +
	                            '{{/js_compare}}' +
	                            '{{/each}}' +
	                        '</div>' +
	                    '</div>' +
	                '</div>' +
	            '</div>' +
	        '</div>')(pb.params);
	
	    pb.activeIndex = pb.params.initialSlide;
	    pb.openIndex = pb.activeIndex;
	    pb.opened = false;
	
	    pb.open = function (index) {
	        if (typeof index === 'undefined') index = pb.activeIndex;
	        index = parseInt(index, 10);
	        if (pb.opened && pb.swiper) {
	            pb.swiper.slideTo(index);
	            return;
	        }
	        pb.opened = true;
	        pb.openIndex = index;
	        if (pb.params.type === 'standalone') {
	            app.root.append(htmlTemplate);
	        }
	        if (pb.params.type === 'popup') {
	            pb.popup = app.popup('<div class="popup photo-browser-popup">' + htmlTemplate + '</div>');
	            $(pb.popup).on('popup:closed', pb.onPopupClose);
	        }
	        if (pb.params.type === 'page') {
	            $(document).on('page:beforeinit', pb.onPageBeforeInit);
	            $(document).on('page:beforeremove', pb.onPageBeforeRemove);
	            if (!pb.params.view) pb.params.view = app.mainView;
	            pb.params.view.loadContent(htmlTemplate);
	            return;
	        }
	        pb.layout(pb.openIndex);
	        if (pb.params.onOpen) {
	            pb.params.onOpen(pb);
	        }
	
	    };
	    pb.close = function () {
	        pb.opened = false;
	        if (!pb.swiperContainer || pb.swiperContainer.length === 0) {
	            return;
	        }
	        if (pb.params.onClose) {
	            pb.params.onClose(pb);
	        }
	        // Detach events
	        pb.attachEvents(true);
	        // Delete from DOM
	        if (pb.params.type === 'standalone') {
	            pb.container.removeClass('photo-browser-in').addClass('photo-browser-out').animationEnd(function () {
	                pb.container.remove();
	            });
	        }
	        // Destroy slider
	        pb.swiper.destroy();
	        // Delete references
	        pb.swiper = pb.swiperContainer = pb.swiperWrapper = pb.slides = undefined; //gestureSlide = gestureImg = gestureImgWrap = undefined;
	    };
	
	    pb.onPopupClose = function (e) {
	        pb.close();
	        $(pb.popup).off('page:beforeinit', pb.onPopupClose);
	    };
	    pb.onPageBeforeInit = function (e) {
	        if (e.detail.page.name === 'photo-browser-slides') {
	            pb.layout(pb.openIndex);
	        }
	        $(document).off('page:beforeinit', pb.onPageBeforeInit);
	    };
	    pb.onPageBeforeRemove = function (e) {
	        if (e.detail.page.name === 'photo-browser-slides') {
	            pb.close();
	        }
	        $(document).off('page:beforeremove', pb.onPageBeforeRemove);
	    };
	
	    pb.onSliderTransitionStart = function (swiper) {
	        pb.activeIndex = swiper.activeIndex;
	
	        var current = swiper.activeIndex + 1;
	        var total = swiper.slides.length;
	        if (pb.params.loop) {
	            total = total - 2;
	            current = current - swiper.loopedSlides;
	            if (current < 1) current = total + current;
	            if (current > total) current = current - total;
	        }
	        pb.container.find('.photo-browser-current').text(current);
	        pb.container.find('.photo-browser-total').text(total);
	
	        $('.photo-browser-prev, .photo-browser-next').removeClass('photo-browser-link-inactive');
	
	        if (swiper.isBeginning && !pb.params.loop) {
	            $('.photo-browser-prev').addClass('photo-browser-link-inactive');
	        }
	        if (swiper.isEnd && !pb.params.loop) {
	            $('.photo-browser-next').addClass('photo-browser-link-inactive');
	        }
	
	        // Update captions
	        if (pb.captions.length > 0) {
	            pb.captionsContainer.find('.photo-browser-caption-active').removeClass('photo-browser-caption-active');
	            var captionIndex = pb.params.loop ? swiper.slides.eq(swiper.activeIndex).attr('data-swiper-slide-index') : pb.activeIndex;
	            pb.captionsContainer.find('[data-caption-index="' + captionIndex + '"]').addClass('photo-browser-caption-active');
	        }
	
	
	        // Stop Video
	        var previousSlideVideo = swiper.slides.eq(swiper.previousIndex).find('video');
	        if (previousSlideVideo.length > 0) {
	            if ('pause' in previousSlideVideo[0]) previousSlideVideo[0].pause();
	        }
	        // Callback
	        if (pb.params.onTransitionStart) pb.params.onTransitionStart(swiper);
	    };
	    pb.onSliderTransitionEnd = function (swiper) {
	        if (pb.params.onTransitionEnd) pb.params.onTransitionEnd(swiper);
	    };
	
	    pb.layout = function (index) {
	        if (pb.params.type === 'page') {
	            pb.container = $('.photo-browser-swiper-container').parents('.view');
	        }
	        else {
	            pb.container = $('.photo-browser');
	        }
	        if (pb.params.type === 'standalone') {
	            pb.container.addClass('photo-browser-in');
	            app.sizeNavbars(pb.container);
	        }
	        pb.swiperContainer = pb.container.find('.photo-browser-swiper-container');
	        pb.swiperWrapper = pb.container.find('.photo-browser-swiper-wrapper');
	        pb.slides = pb.container.find('.photo-browser-slide');
	        pb.captionsContainer = pb.container.find('.photo-browser-captions');
	        pb.captions = pb.container.find('.photo-browser-caption');
	
	        var sliderSettings = {
	            nextButton: pb.params.nextButton || '.photo-browser-next',
	            prevButton: pb.params.prevButton || '.photo-browser-prev',
	            indexButton: pb.params.indexButton,
	            initialSlide: index,
	            spaceBetween: pb.params.spaceBetween,
	            speed: pb.params.speed,
	            loop: pb.params.loop,
	            lazyLoading: pb.params.lazyLoading,
	            lazyLoadingInPrevNext: pb.params.lazyLoadingInPrevNext,
	            lazyLoadingOnTransitionStart: pb.params.lazyLoadingOnTransitionStart,
	            preloadImages: pb.params.lazyLoading ? false : true,
	            zoom: pb.params.zoom,
	            zoomMax: pb.params.zoomMax,
	            zoomMin: pb.params.zoomMin,
	            onTap: function (swiper, e) {
	                if (pb.params.onTap) pb.params.onTap(swiper, e);
	            },
	            onClick: function (swiper, e) {
	                if (pb.params.exposition) pb.toggleExposition();
	                if (pb.params.onClick) pb.params.onClick(swiper, e);
	            },
	            onDoubleTap: function (swiper, e) {
	                // pb.toggleZoom(e);
	                if (pb.params.onDoubleTap) pb.params.onDoubleTap(swiper, e);
	            },
	            onTransitionStart: function (swiper) {
	                pb.onSliderTransitionStart(swiper);
	            },
	            onTransitionEnd: function (swiper) {
	                pb.onSliderTransitionEnd(swiper);
	            },
	            onSlideChangeStart: pb.params.onSlideChangeStart,
	            onSlideChangeEnd: pb.params.onSlideChangeEnd,
	            onLazyImageLoad: function (swiper, slide, img) {
	                if (pb.params.onLazyImageLoad) pb.params.onLazyImageLoad(pb, slide, img);
	            },
	            onLazyImageReady: function (swiper, slide, img) {
	                $(slide).removeClass('photo-browser-slide-lazy');
	                if (pb.params.onLazyImageReady) pb.params.onLazyImageReady(pb, slide, img);
	            }
	        };
	
	        if (pb.params.swipeToClose && pb.params.type !== 'page') {
	            sliderSettings.onTouchStart = pb.swipeCloseTouchStart;
	            sliderSettings.onTouchMoveOpposite = pb.swipeCloseTouchMove;
	            sliderSettings.onTouchEnd = pb.swipeCloseTouchEnd;
	        }
	
	        pb.swiper = app.swiper(pb.swiperContainer, sliderSettings);
	        if (index === 0) {
	            pb.onSliderTransitionStart(pb.swiper);
	        }
	        pb.attachEvents();
	    };
	    pb.attachEvents = function (detach) {
	        var action = detach ? 'off' : 'on';
	        pb.container.find('.photo-browser-close-link')[action]('click', pb.close);
	    };
	
	
	    // Expose
	    pb.exposed = false;
	    pb.toggleExposition = function () {
	        if (pb.container) pb.container.toggleClass('photo-browser-exposed');
	        if (pb.params.expositionHideCaptions) pb.captionsContainer.toggleClass('photo-browser-captions-exposed');
	        pb.exposed = !pb.exposed;
	    };
	    pb.enableExposition = function () {
	        if (pb.container) pb.container.addClass('photo-browser-exposed');
	        if (pb.params.expositionHideCaptions) pb.captionsContainer.addClass('photo-browser-captions-exposed');
	        pb.exposed = true;
	    };
	    pb.disableExposition = function () {
	        if (pb.container) pb.container.removeClass('photo-browser-exposed');
	        if (pb.params.expositionHideCaptions) pb.captionsContainer.removeClass('photo-browser-captions-exposed');
	        pb.exposed = false;
	    };
	
	    // Swipe Up To Close
	    var swipeToCloseIsTouched = false;
	    var allowSwipeToClose = true;
	    var swipeToCloseDiff, swipeToCloseStart, swipeToCloseCurrent, swipeToCloseStarted = false, swipeToCloseActiveSlide, swipeToCloseTimeStart;
	    pb.swipeCloseTouchStart = function (swiper, e) {
	        if (!allowSwipeToClose) return;
	        swipeToCloseIsTouched = true;
	    };
	    pb.swipeCloseTouchMove = function (swiper, e) {
	        if (!swipeToCloseIsTouched) return;
	        if (!swipeToCloseStarted) {
	            swipeToCloseStarted = true;
	            swipeToCloseStart = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	            swipeToCloseActiveSlide = pb.swiper.slides.eq(pb.swiper.activeIndex);
	            swipeToCloseTimeStart = (new Date()).getTime();
	        }
	        e.preventDefault();
	        swipeToCloseCurrent = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	        swipeToCloseDiff = swipeToCloseStart - swipeToCloseCurrent;
	        var opacity = 1 - Math.abs(swipeToCloseDiff) / 300;
	        swipeToCloseActiveSlide.transform('translate3d(0,' + (-swipeToCloseDiff) + 'px,0)');
	        pb.swiper.container.css('opacity', opacity).transition(0);
	    };
	    pb.swipeCloseTouchEnd = function (swiper, e) {
	        swipeToCloseIsTouched = false;
	        if (!swipeToCloseStarted) {
	            swipeToCloseStarted = false;
	            return;
	        }
	        swipeToCloseStarted = false;
	        allowSwipeToClose = false;
	        var diff = Math.abs(swipeToCloseDiff);
	        var timeDiff = (new Date()).getTime() - swipeToCloseTimeStart;
	        if ((timeDiff < 300 && diff > 20) || (timeDiff >= 300 && diff > 100)) {
	            setTimeout(function () {
	                if (pb.params.type === 'standalone') {
	                    pb.close();
	                }
	                if (pb.params.type === 'popup') {
	                    app.closeModal(pb.popup);
	                }
	                if (pb.params.onSwipeToClose) {
	                    pb.params.onSwipeToClose(pb);
	                }
	                allowSwipeToClose = true;
	            }, 0);
	            return;
	        }
	        if (diff !== 0) {
	            swipeToCloseActiveSlide.addClass('transitioning').transitionEnd(function () {
	                allowSwipeToClose = true;
	                swipeToCloseActiveSlide.removeClass('transitioning');
	            });
	        }
	        else {
	            allowSwipeToClose = true;
	        }
	        pb.swiper.container.css('opacity', '').transition('');
	        swipeToCloseActiveSlide.transform('');
	    };
	
	    return pb;
	};
	
	app.photoBrowser = function (params) {
	    return new PhotoBrowser(params);
	};
	
	/*======================================================
	************   Picker   ************
	======================================================*/
	var Picker = function (params) {
	    var p = this;
	    var defaults = {
	        updateValuesOnMomentum: false,
	        updateValuesOnTouchmove: true,
	        rotateEffect: false,
	        momentumRatio: 7,
	        freeMode: false,
	        // Common settings
	        closeByOutsideClick: true,
	        scrollToInput: true,
	        inputReadOnly: true,
	        convertToPopover: true,
	        onlyInPopover: false,
	        toolbar: true,
	        toolbarCloseText: 'Done',
	        toolbarTemplate: 
	            '<div class="toolbar">' +
	                '<div class="toolbar-inner">' +
	                    '<div class="left"></div>' +
	                    '<div class="right">' +
	                        '<a href="#" class="link close-picker">{{closeText}}</a>' +
	                    '</div>' +
	                '</div>' +
	            '</div>'
	    };
	    params = params || {};
	    for (var def in defaults) {
	        if (typeof params[def] === 'undefined') {
	            params[def] = defaults[def];
	        }
	    }
	    p.params = params;
	    p.cols = [];
	    p.initialized = false;
	    
	    // Inline flag
	    p.inline = p.params.container ? true : false;
	
	    // 3D Transforms origin bug, only on safari
	    var originBug = app.device.ios || (navigator.userAgent.toLowerCase().indexOf('safari') >= 0 && navigator.userAgent.toLowerCase().indexOf('chrome') < 0) && !app.device.android;
	
	    // Should be converted to popover
	    function isPopover() {
	        var toPopover = false;
	        if (!p.params.convertToPopover && !p.params.onlyInPopover) return toPopover;
	        if (!p.inline && p.params.input) {
	            if (p.params.onlyInPopover) toPopover = true;
	            else {
	                if (app.device.ios) {
	                    toPopover = app.device.ipad ? true : false;
	                }
	                else {
	                    if ($(window).width() >= 768) toPopover = true;
	                }
	            }
	        } 
	        return toPopover; 
	    }
	    function inPopover() {
	        if (p.opened && p.container && p.container.length > 0 && p.container.parents('.popover').length > 0) return true;
	        else return false;
	    }
	
	    // Value
	    p.setValue = function (arrValues, transition) {
	        var valueIndex = 0;
	        if (p.cols.length === 0) {
	            p.value = arrValues;
	            p.updateValue(arrValues);
	            return;
	        }
	        for (var i = 0; i < p.cols.length; i++) {
	            if (p.cols[i] && !p.cols[i].divider) {
	                p.cols[i].setValue(arrValues[valueIndex], transition);
	                valueIndex++;
	            }
	        }
	    };
	    p.updateValue = function (forceValues) {
	        var newValue = forceValues || [];
	        var newDisplayValue = [], i;
	        if (p.cols.length === 0) {
	            for (i = 0; i < p.params.cols.length; i++) {
	                if (p.params.cols[i].displayValues !== undefined) {
	                    newDisplayValue.push(p.params.cols[i].displayValues[newValue[i]]);
	                }
	                else {
	                    newDisplayValue.push(newValue[i]);
	                }
	            }
	        }
	        else {
	            for (i = 0; i < p.cols.length; i++) {
	                if (!p.cols[i].divider) {
	                    newValue.push(p.cols[i].value);
	                    newDisplayValue.push(p.cols[i].displayValue);
	                }
	            }
	        }
	            
	        if (newValue.indexOf(undefined) >= 0) {
	            return;
	        }
	        p.value = newValue;
	        p.displayValue = newDisplayValue;
	        if (p.params.onChange) {
	            p.params.onChange(p, p.value, p.displayValue);
	        }
	        if (p.input && p.input.length > 0) {
	            $(p.input).val(p.params.formatValue ? p.params.formatValue(p, p.value, p.displayValue) : p.value.join(' '));
	            $(p.input).trigger('change');
	        }
	    };
	
	    // Columns Handlers
	    p.initPickerCol = function (colElement, updateItems) {
	        var colContainer = $(colElement);
	        var colIndex = colContainer.index();
	        var col = p.cols[colIndex];
	        if (col.divider) return;
	        col.container = colContainer;
	        col.wrapper = col.container.find('.picker-items-col-wrapper');
	        col.items = col.wrapper.find('.picker-item');
	        
	        var i, j;
	        var wrapperHeight, itemHeight, itemsHeight, minTranslate, maxTranslate;
	        col.replaceValues = function (values, displayValues) {
	            col.destroyEvents();
	            col.values = values;
	            col.displayValues = displayValues;
	            var newItemsHTML = p.columnHTML(col, true);
	            col.wrapper.html(newItemsHTML);
	            col.items = col.wrapper.find('.picker-item');
	            col.calcSize();
	            col.setValue(col.values[0], 0, true);
	            col.initEvents();
	        };
	        col.calcSize = function () {
	            if (p.params.rotateEffect) {
	                col.container.removeClass('picker-items-col-absolute');
	                if (!col.width) col.container.css({width:''});
	            }
	            var colWidth, colHeight;
	            colWidth = 0;
	            colHeight = col.container[0].offsetHeight;
	            wrapperHeight = col.wrapper[0].offsetHeight;
	            itemHeight = col.items[0].offsetHeight;
	            itemsHeight = itemHeight * col.items.length;
	            minTranslate = colHeight / 2 - itemsHeight + itemHeight / 2;
	            maxTranslate = colHeight / 2 - itemHeight / 2;    
	            if (col.width) {
	                colWidth = col.width;
	                if (parseInt(colWidth, 10) === colWidth) colWidth = colWidth + 'px';
	                col.container.css({width: colWidth});
	            }
	            if (p.params.rotateEffect) {
	                if (!col.width) {
	                    col.items.each(function () {
	                        var item = $(this);
	                        item.css({width:'auto'});
	                        colWidth = Math.max(colWidth, item[0].offsetWidth);
	                        item.css({width:''});
	                    });
	                    col.container.css({width: (colWidth + 2) + 'px'});
	                }
	                col.container.addClass('picker-items-col-absolute');
	            }
	        };
	        col.calcSize();
	        
	        col.wrapper.transform('translate3d(0,' + maxTranslate + 'px,0)').transition(0);
	
	
	        var activeIndex = 0;
	        var animationFrameId;
	
	        // Set Value Function
	        col.setValue = function (newValue, transition, valueCallbacks) {
	            if (typeof transition === 'undefined') transition = '';
	            var newActiveIndex = col.wrapper.find('.picker-item[data-picker-value="' + newValue + '"]').index();
	            if(typeof newActiveIndex === 'undefined' || newActiveIndex === -1) {
	                return;
	            }
	            var newTranslate = -newActiveIndex * itemHeight + maxTranslate;
	            // Update wrapper
	            col.wrapper.transition(transition);
	            col.wrapper.transform('translate3d(0,' + (newTranslate) + 'px,0)');
	                
	            // Watch items
	            if (p.params.updateValuesOnMomentum && col.activeIndex && col.activeIndex !== newActiveIndex ) {
	                $.cancelAnimationFrame(animationFrameId);
	                col.wrapper.transitionEnd(function(){
	                    $.cancelAnimationFrame(animationFrameId);
	                });
	                updateDuringScroll();
	            }
	
	            // Update items
	            col.updateItems(newActiveIndex, newTranslate, transition, valueCallbacks);
	        };
	
	        col.updateItems = function (activeIndex, translate, transition, valueCallbacks) {
	            if (typeof translate === 'undefined') {
	                translate = $.getTranslate(col.wrapper[0], 'y');
	            }
	            if(typeof activeIndex === 'undefined') activeIndex = -Math.round((translate - maxTranslate)/itemHeight);
	            if (activeIndex < 0) activeIndex = 0;
	            if (activeIndex >= col.items.length) activeIndex = col.items.length - 1;
	            var previousActiveIndex = col.activeIndex;
	            col.activeIndex = activeIndex;
	            col.wrapper.find('.picker-selected').removeClass('picker-selected');
	
	            col.items.transition(transition);
	            
	            var selectedItem = col.items.eq(activeIndex).addClass('picker-selected').transform('');
	                
	            // Set 3D rotate effect
	            if (p.params.rotateEffect) {
	                var percentage = (translate - (Math.floor((translate - maxTranslate)/itemHeight) * itemHeight + maxTranslate)) / itemHeight;
	                
	                col.items.each(function () {
	                    var item = $(this);
	                    var itemOffsetTop = item.index() * itemHeight;
	                    var translateOffset = maxTranslate - translate;
	                    var itemOffset = itemOffsetTop - translateOffset;
	                    var percentage = itemOffset / itemHeight;
	
	                    var itemsFit = Math.ceil(col.height / itemHeight / 2) + 1;
	                    
	                    var angle = (-18*percentage);
	                    if (angle > 180) angle = 180;
	                    if (angle < -180) angle = -180;
	                    // Far class
	                    if (Math.abs(percentage) > itemsFit) item.addClass('picker-item-far');
	                    else item.removeClass('picker-item-far');
	                    // Set transform
	                    item.transform('translate3d(0, ' + (-translate + maxTranslate) + 'px, ' + (originBug ? -110 : 0) + 'px) rotateX(' + angle + 'deg)');
	                });
	            }
	
	            if (valueCallbacks || typeof valueCallbacks === 'undefined') {
	                // Update values
	                col.value = selectedItem.attr('data-picker-value');
	                col.displayValue = col.displayValues ? col.displayValues[activeIndex] : col.value;
	                // On change callback
	                if (previousActiveIndex !== activeIndex) {
	                    if (col.onChange) {
	                        col.onChange(p, col.value, col.displayValue);
	                    }
	                    p.updateValue();
	                }
	            }
	        };
	
	        function updateDuringScroll() {
	            animationFrameId = $.requestAnimationFrame(function () {
	                col.updateItems(undefined, undefined, 0);
	                updateDuringScroll();
	            });
	        }
	
	        // Update items on init
	        if (updateItems) col.updateItems(0, maxTranslate, 0);
	
	        var allowItemClick = true;
	        var isTouched, isMoved, touchStartY, touchCurrentY, touchStartTime, touchEndTime, startTranslate, returnTo, currentTranslate, prevTranslate, velocityTranslate, velocityTime;
	        function handleTouchStart (e) {
	            if (isMoved || isTouched) return;
	            e.preventDefault();
	            isTouched = true;
	            touchStartY = touchCurrentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	            touchStartTime = (new Date()).getTime();
	            
	            allowItemClick = true;
	            startTranslate = currentTranslate = $.getTranslate(col.wrapper[0], 'y');
	        }
	        function handleTouchMove (e) {
	            if (!isTouched) return;
	            e.preventDefault();
	            allowItemClick = false;
	            touchCurrentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	            if (!isMoved) {
	                // First move
	                $.cancelAnimationFrame(animationFrameId);
	                isMoved = true;
	                startTranslate = currentTranslate = $.getTranslate(col.wrapper[0], 'y');
	                col.wrapper.transition(0);
	            }
	
	            var diff = touchCurrentY - touchStartY;
	            currentTranslate = startTranslate + diff;
	            returnTo = undefined;
	
	            // Normalize translate
	            if (currentTranslate < minTranslate) {
	                currentTranslate = minTranslate - Math.pow(minTranslate - currentTranslate, 0.8);
	                returnTo = 'min';
	            }
	            if (currentTranslate > maxTranslate) {
	                currentTranslate = maxTranslate + Math.pow(currentTranslate - maxTranslate, 0.8);
	                returnTo = 'max';
	            }
	            // Transform wrapper
	            col.wrapper.transform('translate3d(0,' + currentTranslate + 'px,0)');
	
	            // Update items
	            col.updateItems(undefined, currentTranslate, 0, p.params.updateValuesOnTouchmove);
	            
	            // Calc velocity
	            velocityTranslate = currentTranslate - prevTranslate || currentTranslate;
	            velocityTime = (new Date()).getTime();
	            prevTranslate = currentTranslate;
	        }
	        function handleTouchEnd (e) {
	            if (!isTouched || !isMoved) {
	                isTouched = isMoved = false;
	                return;
	            }
	            isTouched = isMoved = false;
	            col.wrapper.transition('');
	            if (returnTo) {
	                if (returnTo === 'min') {
	                    col.wrapper.transform('translate3d(0,' + minTranslate + 'px,0)');
	                }
	                else col.wrapper.transform('translate3d(0,' + maxTranslate + 'px,0)');
	            }
	            touchEndTime = new Date().getTime();
	            var velocity, newTranslate;
	            if (touchEndTime - touchStartTime > 300) {
	                newTranslate = currentTranslate;
	            }
	            else {
	                velocity = Math.abs(velocityTranslate / (touchEndTime - velocityTime));
	                newTranslate = currentTranslate + velocityTranslate * p.params.momentumRatio;
	            }
	
	            newTranslate = Math.max(Math.min(newTranslate, maxTranslate), minTranslate);
	
	            // Active Index
	            var activeIndex = -Math.floor((newTranslate - maxTranslate)/itemHeight);
	
	            // Normalize translate
	            if (!p.params.freeMode) newTranslate = -activeIndex * itemHeight + maxTranslate;
	
	            // Transform wrapper
	            col.wrapper.transform('translate3d(0,' + (parseInt(newTranslate,10)) + 'px,0)');
	
	            // Update items
	            col.updateItems(activeIndex, newTranslate, '', true);
	
	            // Watch items
	            if (p.params.updateValuesOnMomentum) {
	                updateDuringScroll();
	                col.wrapper.transitionEnd(function(){
	                    $.cancelAnimationFrame(animationFrameId);
	                });
	            }
	
	            // Allow click
	            setTimeout(function () {
	                allowItemClick = true;
	            }, 100);
	        }
	
	        function handleClick(e) {
	            if (!allowItemClick) return;
	            $.cancelAnimationFrame(animationFrameId);
	            /*jshint validthis:true */
	            var value = $(this).attr('data-picker-value');
	            col.setValue(value);
	        }
	
	        col.initEvents = function (detach) {
	            var method = detach ? 'off' : 'on';
	            col.container[method](app.touchEvents.start, handleTouchStart);
	            col.container[method](app.touchEvents.move, handleTouchMove);
	            col.container[method](app.touchEvents.end, handleTouchEnd);
	            col.items[method]('click', handleClick);
	        };
	        col.destroyEvents = function () {
	            col.initEvents(true);
	        };
	
	        col.container[0].f7DestroyPickerCol = function () {
	            col.destroyEvents();
	        };
	
	        col.initEvents();
	
	    };
	    p.destroyPickerCol = function (colContainer) {
	        colContainer = $(colContainer);
	        if ('f7DestroyPickerCol' in colContainer[0]) colContainer[0].f7DestroyPickerCol();
	    };
	    // Resize cols
	    function resizeCols() {
	        if (!p.opened) return;
	        for (var i = 0; i < p.cols.length; i++) {
	            if (!p.cols[i].divider) {
	                p.cols[i].calcSize();
	                p.cols[i].setValue(p.cols[i].value, 0, false);
	            }
	        }
	    }
	    $(window).on('resize', resizeCols);
	
	    // HTML Layout
	    p.columnHTML = function (col, onlyItems) {
	        var columnItemsHTML = '';
	        var columnHTML = '';
	        if (col.divider) {
	            columnHTML += '<div class="picker-items-col picker-items-col-divider ' + (col.textAlign ? 'picker-items-col-' + col.textAlign : '') + ' ' + (col.cssClass || '') + '">' + col.content + '</div>';
	        }
	        else {
	            for (var j = 0; j < col.values.length; j++) {
	                columnItemsHTML += '<div class="picker-item" data-picker-value="' + col.values[j] + '">' + (col.displayValues ? col.displayValues[j] : col.values[j]) + '</div>';
	            }
	            columnHTML += '<div class="picker-items-col ' + (col.textAlign ? 'picker-items-col-' + col.textAlign : '') + ' ' + (col.cssClass || '') + '"><div class="picker-items-col-wrapper">' + columnItemsHTML + '</div></div>';
	        }
	        return onlyItems ? columnItemsHTML : columnHTML;
	    };
	    p.layout = function () {
	        var pickerHTML = '';
	        var pickerClass = '';
	        var i;
	        p.cols = [];
	        var colsHTML = '';
	        for (i = 0; i < p.params.cols.length; i++) {
	            var col = p.params.cols[i];
	            colsHTML += p.columnHTML(p.params.cols[i]);
	            p.cols.push(col);
	        }
	        pickerClass = 'picker-modal picker-columns ' + (p.params.cssClass || '') + (p.params.rotateEffect ? ' picker-3d' : '');
	        pickerHTML =
	            '<div class="' + (pickerClass) + '">' +
	                (p.params.toolbar ? p.params.toolbarTemplate.replace(/{{closeText}}/g, p.params.toolbarCloseText) : '') +
	                '<div class="picker-modal-inner picker-items">' +
	                    colsHTML +
	                    '<div class="picker-center-highlight"></div>' +
	                '</div>' +
	            '</div>';
	            
	        p.pickerHTML = pickerHTML;    
	    };
	
	    // Input Events
	    function openOnInput(e) {
	        e.preventDefault();
	        if (p.opened) return;
	        p.open();
	        if (p.params.scrollToInput && !isPopover()) {
	            var pageContent = p.input.parents('.page-content');
	            if (pageContent.length === 0) return;
	
	            var paddingTop = parseInt(pageContent.css('padding-top'), 10),
	                paddingBottom = parseInt(pageContent.css('padding-bottom'), 10),
	                pageHeight = pageContent[0].offsetHeight - paddingTop - p.container.height(),
	                pageScrollHeight = pageContent[0].scrollHeight - paddingTop - p.container.height(),
	                newPaddingBottom;
	            var inputTop = p.input.offset().top - paddingTop + p.input[0].offsetHeight;
	            if (inputTop > pageHeight) {
	                var scrollTop = pageContent.scrollTop() + inputTop - pageHeight;
	                if (scrollTop + pageHeight > pageScrollHeight) {
	                    newPaddingBottom = scrollTop + pageHeight - pageScrollHeight + paddingBottom;
	                    if (pageHeight === pageScrollHeight) {
	                        newPaddingBottom = p.container.height();
	                    }
	                    pageContent.css({'padding-bottom': (newPaddingBottom) + 'px'});
	                }
	                pageContent.scrollTop(scrollTop, 300);
	            }
	        }
	    }
	    function closeOnHTMLClick(e) {
	        if (inPopover()) return;
	        if (p.input && p.input.length > 0) {
	            if (e.target !== p.input[0] && $(e.target).parents('.picker-modal').length === 0) p.close();
	        }
	        else {
	            if ($(e.target).parents('.picker-modal').length === 0) p.close();   
	        }
	    }
	
	    if (p.params.input) {
	        p.input = $(p.params.input);
	        if (p.input.length > 0) {
	            if (p.params.inputReadOnly) p.input.prop('readOnly', true);
	            if (!p.inline) {
	                p.input.on('click', openOnInput);    
	            }
	            if (p.params.inputReadOnly) {
	                p.input.on('focus mousedown', function (e) {
	                    e.preventDefault();
	                });
	            }
	        }
	            
	    }
	    
	    if (!p.inline && p.params.closeByOutsideClick) $('html').on('click', closeOnHTMLClick);
	
	    // Open
	    function onPickerClose() {
	        p.opened = false;
	        if (p.input && p.input.length > 0) {
	            p.input.parents('.page-content').css({'padding-bottom': ''});
	            if (app.params.material) p.input.trigger('blur');
	        }
	        if (p.params.onClose) p.params.onClose(p);
	
	        // Destroy events
	        p.container.find('.picker-items-col').each(function () {
	            p.destroyPickerCol(this);
	        });
	    }
	
	    p.opened = false;
	    p.open = function () {
	        var toPopover = isPopover();
	
	        if (!p.opened) {
	
	            // Layout
	            p.layout();
	
	            // Append
	            if (toPopover) {
	                p.pickerHTML = '<div class="popover popover-picker-columns"><div class="popover-inner">' + p.pickerHTML + '</div></div>';
	                p.popover = app.popover(p.pickerHTML, p.params.input, true);
	                p.container = $(p.popover).find('.picker-modal');
	                $(p.popover).on('popover:close', function () {
	                    onPickerClose();
	                });
	            }
	            else if (p.inline) {
	                p.container = $(p.pickerHTML);
	                p.container.addClass('picker-modal-inline');
	                $(p.params.container).append(p.container);
	            }
	            else {
	                p.container = $(app.pickerModal(p.pickerHTML));
	                $(p.container)
	                .on('picker:close', function () {
	                    onPickerClose();
	                });
	            }
	
	            // Store picker instance
	            p.container[0].f7Picker = p;
	
	            // Init Events
	            p.container.find('.picker-items-col').each(function () {
	                var updateItems = true;
	                if ((!p.initialized && p.params.value) || (p.initialized && p.value)) updateItems = false;
	                p.initPickerCol(this, updateItems);
	            });
	            
	            // Set value
	            if (!p.initialized) {
	                if (p.value) p.setValue(p.value, 0);
	                else if (p.params.value) {
	                    p.setValue(p.params.value, 0);
	                }
	            }
	            else {
	                if (p.value) p.setValue(p.value, 0);
	            }
	
	            // Material Focus
	            if (p.input && p.input.length > 0 && app.params.material) {
	                p.input.trigger('focus');
	            }
	        }
	
	        // Set flag
	        p.opened = true;
	        p.initialized = true;
	
	        if (p.params.onOpen) p.params.onOpen(p);
	    };
	
	    // Close
	    p.close = function () {
	        if (!p.opened || p.inline) return;
	        if (inPopover()) {
	            app.closeModal(p.popover);
	            return;
	        }
	        else {
	            app.closeModal(p.container);
	            return;
	        }
	    };
	
	    // Destroy
	    p.destroy = function () {
	        p.close();
	        if (p.params.input && p.input.length > 0) {
	            p.input.off('click focus', openOnInput);
	        }
	        $('html').off('click', closeOnHTMLClick);
	        $(window).off('resize', resizeCols);
	    };
	
	    if (p.inline) {
	        p.open();
	    }
	    else {
	        if (!p.initialized && p.params.value) p.setValue(p.params.value);
	    }
	
	    return p;
	};
	app.picker = function (params) {
	    return new Picker(params);
	};
	/*======================================================
	************   Pull To Refresh   ************
	======================================================*/
	app.initPullToRefresh = function (pageContainer) {
	    var eventsTarget = $(pageContainer);
	    if (!eventsTarget.hasClass('pull-to-refresh-content')) {
	        eventsTarget = eventsTarget.find('.pull-to-refresh-content');
	    }
	    if (!eventsTarget || eventsTarget.length === 0) return;
	
	    var touchId, isTouched, isMoved, touchesStart = {}, isScrolling, touchesDiff, touchStartTime, container, refresh = false, useTranslate = false, startTranslate = 0, translate, scrollTop, wasScrolled, layer, triggerDistance, dynamicTriggerDistance, pullStarted;
	    var page = eventsTarget.hasClass('page') ? eventsTarget : eventsTarget.parents('.page');
	    var hasNavbar = false;
	    if (page.find('.navbar').length > 0 || page.parents('.navbar-fixed, .navbar-through').length > 0 || page.hasClass('navbar-fixed') || page.hasClass('navbar-through')) hasNavbar = true;
	    if (page.hasClass('no-navbar')) hasNavbar = false;
	    if (!hasNavbar) eventsTarget.addClass('pull-to-refresh-no-navbar');
	
	    container = eventsTarget;
	
	    // Define trigger distance
	    if (container.attr('data-ptr-distance')) {
	        dynamicTriggerDistance = true;
	    }
	    else {
	        triggerDistance = 44;   
	    }
	    
	    function handleTouchStart(e) {
	        if (isTouched) {
	            if (app.device.os === 'android') {
	                if ('targetTouches' in e && e.targetTouches.length > 1) return;
	            }
	            else return;
	        }
	        
	        /*jshint validthis:true */
	        container = $(this);
	        if (container.hasClass('refreshing')) {
	            return;
	        }
	        
	        isMoved = false;
	        pullStarted = false;
	        isTouched = true;
	        isScrolling = undefined;
	        wasScrolled = undefined;
	        if (e.type === 'touchstart') touchId = e.targetTouches[0].identifier;
	        touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	        touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	        touchStartTime = (new Date()).getTime();
	        
	    }
	    
	    function handleTouchMove(e) {
	        if (!isTouched) return;
	        var pageX, pageY, touch;
	        if (e.type === 'touchmove') {
	            if (touchId && e.touches) {
	                for (var i = 0; i < e.touches.length; i++) {
	                    if (e.touches[i].identifier === touchId) {
	                        touch = e.touches[i];
	                    }
	                }
	            }
	            if (!touch) touch = e.targetTouches[0];
	            pageX = touch.pageX;
	            pageY = touch.pageY;
	        }
	        else {
	            pageX = e.pageX;
	            pageY = e.pageY;
	        }
	        if (!pageX || !pageY) return;
	            
	
	        if (typeof isScrolling === 'undefined') {
	            isScrolling = !!(isScrolling || Math.abs(pageY - touchesStart.y) > Math.abs(pageX - touchesStart.x));
	        }
	        if (!isScrolling) {
	            isTouched = false;
	            return;
	        }
	
	        scrollTop = container[0].scrollTop;
	        if (typeof wasScrolled === 'undefined' && scrollTop !== 0) wasScrolled = true; 
	
	        if (!isMoved) {
	            /*jshint validthis:true */
	            container.removeClass('transitioning');
	            if (scrollTop > container[0].offsetHeight) {
	                isTouched = false;
	                return;
	            }
	            if (dynamicTriggerDistance) {
	                triggerDistance = container.attr('data-ptr-distance');
	                if (triggerDistance.indexOf('%') >= 0) triggerDistance = container[0].offsetHeight * parseInt(triggerDistance, 10) / 100;
	            }
	            startTranslate = container.hasClass('refreshing') ? triggerDistance : 0;
	            if (container[0].scrollHeight === container[0].offsetHeight || app.device.os !== 'ios') {
	                useTranslate = true;
	            }
	            else {
	                useTranslate = false;
	            }
	        }
	        isMoved = true;
	        touchesDiff = pageY - touchesStart.y;
	        
	        if (touchesDiff > 0 && scrollTop <= 0 || scrollTop < 0) {
	            // iOS 8 fix
	            if (app.device.os === 'ios' && parseInt(app.device.osVersion.split('.')[0], 10) > 7 && scrollTop === 0 && !wasScrolled) useTranslate = true;
	
	            if (useTranslate) {
	                e.preventDefault();
	                translate = (Math.pow(touchesDiff, 0.85) + startTranslate);
	                container.transform('translate3d(0,' + translate + 'px,0)');
	            }
	            if ((useTranslate && Math.pow(touchesDiff, 0.85) > triggerDistance) || (!useTranslate && touchesDiff >= triggerDistance * 2)) {
	                refresh = true;
	                container.addClass('pull-up').removeClass('pull-down');
	            }
	            else {
	                refresh = false;
	                container.removeClass('pull-up').addClass('pull-down');
	            }
	            if (!pullStarted) {
	                container.trigger('pullstart ptr:pullstart');
	                pullStarted = true;
	            }
	            container.trigger('pullmove ptr:pullmove', {
	                event: e,
	                scrollTop: scrollTop,
	                translate: translate,
	                touchesDiff: touchesDiff
	            });
	        }
	        else {
	            pullStarted = false;
	            container.removeClass('pull-up pull-down');
	            refresh = false;
	            return;
	        }
	    }
	    function handleTouchEnd(e) {
	        if (e.type === 'touchend' && e.changedTouches && e.changedTouches.length > 0 && touchId) {
	            if (e.changedTouches[0].identifier !== touchId) return;
	        }
	        if (!isTouched || !isMoved) {
	            isTouched = false;
	            isMoved = false;
	            return;
	        }
	        if (translate) {
	            container.addClass('transitioning');
	            translate = 0;
	        }
	        container.transform('');
	        if (refresh) {
	            container.addClass('refreshing');
	            container.trigger('refresh ptr:refresh', {
	                done: function () {
	                    app.pullToRefreshDone(container);
	                }
	            });
	        }
	        else {
	            container.removeClass('pull-down');
	        }
	        isTouched = false;
	        isMoved = false;
	        if (pullStarted) container.trigger('pullend ptr:pullend');
	    }
	
	    // Attach Events
	    var passiveListener = app.touchEvents.start === 'touchstart' && app.support.passiveListener ? {passive: true, capture: false} : false;
	    eventsTarget.on(app.touchEvents.start, handleTouchStart, passiveListener);
	    eventsTarget.on(app.touchEvents.move, handleTouchMove);
	    eventsTarget.on(app.touchEvents.end, handleTouchEnd, passiveListener);
	
	    // Detach Events on page remove
	    if (page.length === 0) return;
	    function destroyPullToRefresh() {
	        eventsTarget.off(app.touchEvents.start, handleTouchStart);
	        eventsTarget.off(app.touchEvents.move, handleTouchMove);
	        eventsTarget.off(app.touchEvents.end, handleTouchEnd);
	    }
	    eventsTarget[0].f7DestroyPullToRefresh = destroyPullToRefresh;
	    function detachEvents() {
	        destroyPullToRefresh();
	        page.off('page:beforeremove', detachEvents);
	    }
	    page.on('page:beforeremove', detachEvents);
	
	};
	
	app.pullToRefreshDone = function (container) {
	    container = $(container);
	    if (container.length === 0) container = $('.pull-to-refresh-content.refreshing');
	    container.removeClass('refreshing').addClass('transitioning');
	    container.transitionEnd(function () {
	        container.removeClass('transitioning pull-up pull-down');
	        container.trigger('refreshdone ptr:done');
	    });
	};
	app.pullToRefreshTrigger = function (container) {
	    container = $(container);
	    if (container.length === 0) container = $('.pull-to-refresh-content');
	    if (container.hasClass('refreshing')) return;
	    container.addClass('transitioning refreshing');
	    container.trigger('refresh ptr:refresh', {
	        done: function () {
	            app.pullToRefreshDone(container);
	        }
	    });
	};
	
	app.destroyPullToRefresh = function (pageContainer) {
	    pageContainer = $(pageContainer);
	    var pullToRefreshContent = pageContainer.hasClass('pull-to-refresh-content') ? pageContainer : pageContainer.find('.pull-to-refresh-content');
	    if (pullToRefreshContent.length === 0) return;
	    if (pullToRefreshContent[0].f7DestroyPullToRefresh) pullToRefreshContent[0].f7DestroyPullToRefresh();
	};
	
	/*======================================================
	************   Handle Browser's History   ************
	======================================================*/
	app.pushStateQueue = [];
	app.pushStateClearQueue = function () {
	    if (app.pushStateQueue.length === 0) return;
	    var queue = app.pushStateQueue.pop();
	    var animatePages;
	    if (app.params.pushStateNoAnimation === true) animatePages = false;
	    if (queue.action === 'back') {
	        app.router.back(queue.view, {animatePages: animatePages});
	    }
	    if (queue.action === 'loadPage') {
	        app.router.load(queue.view, {url: queue.stateUrl, animatePages: animatePages, pushState: false});
	    }
	    if (queue.action === 'loadContent') {
	        app.router.load(queue.view, {content: queue.stateContent, animatePages: animatePages, pushState: false});
	    }
	    if (queue.action === 'loadPageName') {
	        app.router.load(queue.view, {pageName: queue.statePageName, url: queue.stateUrl, animatePages: animatePages, pushState: false});
	    }
	};
	
	app.initPushState = function () {
	    var blockPopstate = true;
	    $(window).on('load', function () {
	        setTimeout(function () {
	            blockPopstate = false;
	        }, 0);
	    });
	
	    if (document.readyState && document.readyState === 'complete') {
	        blockPopstate = false;
	    }
	
	    function handlePopState(e) {
	        if (blockPopstate) return;
	        var mainView = app.mainView;
	        if (!mainView) return;
	        var state = e.state;
	        if (!state) {
	            state = {
	                viewIndex: app.views.indexOf(mainView),
	                url : mainView.history[0]
	            };
	        }
	        if (state.viewIndex < 0) return;
	        var view = app.views[state.viewIndex];
	        var stateUrl = state && state.url || undefined;
	        var stateContent = state && state.content || undefined;
	        var statePageName = state && state.pageName || undefined;
	        var animatePages;
	
	        if (app.params.pushStateNoAnimation === true) animatePages = false;
	
	        if (stateUrl !== view.url) {
	            if (view.history.indexOf(stateUrl) >= 0) {
	                // Go Back
	                if (view.allowPageChange) {
	                    app.router.back(view, {url:undefined, animatePages: animatePages, pushState: false, preloadOnly:false});
	                }
	                else {
	                    app.pushStateQueue.push({
	                        action: 'back',
	                        view: view
	                    });
	                }
	            }
	            else if (stateContent) {
	                // Load Page
	                if (view.allowPageChange) {
	                    app.router.load(view, {content:stateContent, animatePages: animatePages, pushState: false});
	                }
	                else {
	                    app.pushStateQueue.unshift({
	                        action: 'loadContent',
	                        stateContent: stateContent,
	                        view: view
	                    });
	                }
	
	            }
	            else if (statePageName) {
	                // Load Page by page name with Dom Cache
	                if (view.allowPageChange) {
	                    app.router.load(view, {pageName:statePageName, url: stateUrl, animatePages: animatePages, pushState: false});
	                }
	                else {
	                    app.pushStateQueue.unshift({
	                        action: 'loadPageName',
	                        statePageName: statePageName,
	                        view: view
	                    });
	                }
	            }
	            else  {
	                // Load Page
	                if (view.allowPageChange) {
	                    app.router.load(view, {url:stateUrl, animatePages: animatePages, pushState: false});
	                }
	                else {
	                    app.pushStateQueue.unshift({
	                        action: 'loadPage',
	                        stateUrl: stateUrl,
	                        view: view
	                    });
	                }
	            }
	        }
	    }
	    $(window).on('popstate', handlePopState);
	};
	
	/*======================================================
	************   Searchbar   ************
	======================================================*/
	var Searchbar = function (container, params) {
	    var defaults = {
	        input: null,
	        clearButton: null,
	        cancelButton: null,
	        searchList: null,
	        searchIn: '.item-title',
	        searchBy: '',
	        found: null,
	        notFound: null,
	        overlay: null,
	        ignore: '.searchbar-ignore',
	        customSearch: false,
	        removeDiacritics: false,
	        hideDividers: true,
	        hideGroups: true,
	        /* Callbacks
	        onSearch
	        onEnable
	        onDisable
	        onClear
	        */
	
	    };
	    params = params || {};
	    for (var def in defaults) {
	        if (typeof params[def] === 'undefined' || params[def] === null && defaults.hasOwnProperty(def)) {
	            params[def] = defaults[def];
	        }
	    }
	    
	    // Instance
	    var s = this;
	
	    // Material
	    s.material = app.params.material;
	
	    // Params
	    s.params = params;
	
	    // Container
	    container = $(container);
	    s.container = container;
	
	    // Active
	    s.active = false;
	
	    // Input
	    s.input = s.params.input ? $(s.params.input) : s.container.find('input[type="search"]');
	    s.clearButton = s.params.clearButton ? $(s.params.clearButton) : s.container.find('.searchbar-clear');
	    s.cancelButton = s.params.cancelButton ? $(s.params.cancelButton) : s.container.find('.searchbar-cancel');
	
	    // Search List
	    s.searchList = $(s.params.searchList);
	
	    // Is Virtual List
	    s.isVirtualList = s.searchList.hasClass('virtual-list');
	
	    // Is In Page
	    s.pageContainer = s.container.parents('.page').eq(0);
	
	    // Overlay
	    if (!s.params.overlay) {
	        s.overlay = s.pageContainer.length > 0 ? s.pageContainer.find('.searchbar-overlay') : $('.searchbar-overlay');
	    }
	    else {
	        s.overlay = $(s.params.overlay);
	    }
	    // Found and not found
	    if (!s.params.found) {
	        s.found = s.pageContainer.length > 0 ? s.pageContainer.find('.searchbar-found') : $('.searchbar-found');
	    }
	    else {
	        s.found = $(s.params.found);
	    }
	    if (!s.params.notFound) {
	        s.notFound = s.pageContainer.length > 0 ? s.pageContainer.find('.searchbar-not-found') : $('.searchbar-not-found');
	    }
	    else {
	        s.notFound = $(s.params.notFound);
	    }
	
	    // Set Cancel button
	    var cancelMarginProp = app.rtl ? 'margin-left' : 'margin-right';
	    var cancelButtonHasMargin = false;
	    s.setCancelButtonMargin = function () {
	        s.cancelButton.transition(0).show();
	        s.cancelButton.css(cancelMarginProp, -s.cancelButton[0].offsetWidth + 'px');
	        var clientLeft = s.cancelButton[0].clientLeft;
	        s.cancelButton.transition('');
	        cancelButtonHasMargin = true;
	    };
	
	    // Trigger
	    s.triggerEvent = function (eventName, callbackName, eventData) {
	        s.container.trigger(eventName, eventData);
	        if (s.searchList.length > 0) s.searchList.trigger(eventName, eventData);
	        if (callbackName && s.params[callbackName]) s.params[callbackName](s, eventData);
	    };
	
	    // Enable/disalbe
	    s.enable = function (e) {
	        function _enable() {
	            if ((s.searchList.length || s.params.customSearch) && !s.container.hasClass('searchbar-active') && !s.query) s.overlay.addClass('searchbar-overlay-active');
	            s.container.addClass('searchbar-active');
	            if (s.cancelButton.length > 0 && !s.material) {
	                if (!cancelButtonHasMargin) {
	                    s.setCancelButtonMargin();
	                }
	                s.cancelButton.css(cancelMarginProp, '0px');
	            }
	            s.triggerEvent('enableSearch searchbar:enable', 'onEnable');
	            s.active = true;
	        }
	        if (app.device.ios && !app.params.material && e && e.type === 'focus') {
	            setTimeout(function () {
	                _enable();
	            }, 400);
	        }
	        else {
	            _enable();
	        }
	    };
	
	    s.disable = function () {
	        s.input.val('').trigger('change');
	        s.container.removeClass('searchbar-active searchbar-not-empty');
	        if (s.cancelButton.length > 0 && !s.material) s.cancelButton.css(cancelMarginProp, -s.cancelButton[0].offsetWidth + 'px');
	
	        if (s.searchList.length || s.params.customSearch) s.overlay.removeClass('searchbar-overlay-active');
	
	        s.active = false;
	        function _disable() {
	            s.input.blur();
	        }
	        if (app.device.ios) {
	            setTimeout(function () {
	                _disable();
	            }, 400);
	        }
	        else {
	            _disable();
	        }
	        s.triggerEvent('disableSearch searchbar:disable', 'onDisable');
	    };
	
	    // Clear
	    s.clear = function (e) {
	        if (!s.query && e && $(e.target).hasClass('searchbar-clear')) {
	            s.disable();
	            return;
	        }
	        var previousQuery = s.value;
	        s.input.val('').trigger('change').focus();
	        s.triggerEvent('clearSearch searchbar:clear', 'onClear', {previousQuery: previousQuery});
	    };
	
	    // Search
	    s.handleInput = function () {
	        setTimeout(function () {
	            var value = s.input.val().trim();
	            if ((s.searchList.length > 0 || s.params.customSearch) && (s.params.searchIn || s.isVirtualList)) s.search(value, true);
	        }, 0);
	    };
	
	    var previousQuery = '';
	    var virtualList;
	    s.search = function (query, internal) {
	        if (query.trim() === previousQuery) return;
	        previousQuery = query.trim();
	
	        if (!internal) {
	            if (!s.active) {
	                s.enable();
	            }
	            s.input.val(query);
	        }
	        s.query = s.value = query;
	        // Add active/inactive classes on overlay
	        if (query.length === 0) {
	            s.container.removeClass('searchbar-not-empty');
	            if (s.searchList.length && s.container.hasClass('searchbar-active')) s.overlay.addClass('searchbar-overlay-active');
	        }
	        else {
	            s.container.addClass('searchbar-not-empty');
	            if (s.searchList.length && s.container.hasClass('searchbar-active')) s.overlay.removeClass('searchbar-overlay-active');
	        }
	
	        if (s.params.customSearch) {
	            s.triggerEvent('search searchbar:search', 'onSearch', {query: query});
	            return;
	        }
	
	        var foundItems = [], _vlQuery;
	        if (s.isVirtualList) {
	            virtualList = s.searchList[0].f7VirtualList;
	            if (query.trim() === '') {
	                virtualList.resetFilter();
	                s.notFound.hide();
	                s.found.show();
	                return;
	            }
	            _vlQuery = s.params.removeDiacritics ? $.removeDiacritics(query) : query;
	            if (virtualList.params.searchAll) {
	                foundItems = virtualList.params.searchAll(_vlQuery, virtualList.items) || [];
	            }
	            else if (virtualList.params.searchByItem) {
	                for (var i = 0; i < virtualList.items.length; i++) {
	                    if(virtualList.params.searchByItem(_vlQuery, i, virtualList.params.items[i])) {
	                        foundItems.push(i);
	                    }
	                }
	            }
	        }
	        else {
	            var values;
	            if (s.params.removeDiacritics) values = $.removeDiacritics(query.trim().toLowerCase()).split(' ');
	            else {
	                values = query.trim().toLowerCase().split(' ');
	            }
	            s.searchList.find('li').removeClass('hidden-by-searchbar').each(function (index, el) {
	                el = $(el);
	                var compareWithText = [];
	                el.find(s.params.searchIn).each(function () {
	                    var itemText = $(this).text().trim().toLowerCase();
	                    if (s.params.removeDiacritics) itemText = $.removeDiacritics(itemText);
	                    compareWithText.push(itemText);
	                });
	                compareWithText = compareWithText.join(' ');
	                var wordsMatch = 0;
	                for (var i = 0; i < values.length; i++) {
	                    if (compareWithText.indexOf(values[i]) >= 0) wordsMatch++;
	                }
	                if (wordsMatch !== values.length && !(s.params.ignore && el.is(s.params.ignore))) {
	                    el.addClass('hidden-by-searchbar');
	                }
	                else {
	                    foundItems.push(el[0]);
	                }
	            });
	
	            if (s.params.hideDividers) {
	                s.searchList.find('.item-divider, .list-group-title').each(function () {
	                    var title = $(this);
	                    var nextElements = title.nextAll('li');
	                    var hide = true;
	                    for (var i = 0; i < nextElements.length; i++) {
	                        var nextEl = $(nextElements[i]);
	                        if (nextEl.hasClass('list-group-title') || nextEl.hasClass('item-divider')) break;
	                        if (!nextEl.hasClass('hidden-by-searchbar')) {
	                            hide = false;
	                        }
	                    }
	                    var ignore = s.params.ignore && title.is(s.params.ignore);
	                    if (hide && !ignore) title.addClass('hidden-by-searchbar');
	                    else title.removeClass('hidden-by-searchbar');
	                });
	            }
	            if (s.params.hideGroups) {
	                s.searchList.find('.list-group').each(function () {
	                    var group = $(this);
	                    var ignore = s.params.ignore && group.is(s.params.ignore);
	                    var notHidden = group.find('li:not(.hidden-by-searchbar)');
	                    if (notHidden.length === 0 && !ignore) {
	                        group.addClass('hidden-by-searchbar');
	                    }
	                    else {
	                        group.removeClass('hidden-by-searchbar');
	                    }
	                });
	            }
	        }
	        s.triggerEvent('search searchbar:search', 'onSearch', {query: query, foundItems: foundItems});
	        if (foundItems.length === 0) {
	            s.notFound.show();
	            s.found.hide();
	        }
	        else {
	            s.notFound.hide();
	            s.found.show();
	        }
	        if (s.isVirtualList) {
	            virtualList.filterItems(foundItems);
	        }
	    };
	
	    // Events
	    function preventSubmit(e) {
	        e.preventDefault();
	    }
	
	    s.attachEvents = function (destroy) {
	        var method = destroy ? 'off' : 'on';
	        s.container[method]('submit', preventSubmit);
	        if (!s.material) s.cancelButton[method]('click', s.disable);
	        s.overlay[method]('click', s.disable);
	        s.input[method]('focus', s.enable);
	        s.input[method]('change keydown keypress keyup', s.handleInput);
	        s.clearButton[method]('click', s.clear);
	            
	    };
	    s.detachEvents = function() {
	        s.attachEvents(true);
	    };
	
	    // Init Destroy
	    s.init = function () {
	        s.attachEvents();
	    };
	    s.destroy = function () {
	        if (!s) return;
	        s.detachEvents();
	        s = null;
	    };
	
	    // Init
	    s.init();
	
	    s.container[0].f7Searchbar = s;
	    return s;
	
	};
	app.searchbar = function (container, params) {
	    return new Searchbar(container, params);
	};
	app.initSearchbar = function (container) {
	    container = $(container);
	    var searchbar = container.hasClass('searchbar') ? container : container.find('.searchbar');
	    if (searchbar.length === 0) return;
	    if (!searchbar.hasClass('searchbar-init')) return;
	
	    var sb = app.searchbar(searchbar, searchbar.dataset());
	
	    function onBeforeRemove() {
	        if (sb) sb.destroy();
	    }
	    if (container.hasClass('page')) {
	        container.once('pageBeforeRemove', onBeforeRemove);   
	    }
	    else if (container.hasClass('navbar-inner')) {
	        container.once('navbarBeforeRemove', onBeforeRemove);
	    }
	};
	/*=============================================================
	************   Hide/show Toolbar/Navbar on scroll   ************
	=============================================================*/
	app.initPageScrollToolbars = function (pageContainer) {
	    pageContainer = $(pageContainer);
	    var scrollContent = pageContainer.find('.page-content');
	    if (scrollContent.length === 0) return;
	    var hideNavbar = (app.params.hideNavbarOnPageScroll || scrollContent.hasClass('hide-navbar-on-scroll') || scrollContent.hasClass('hide-bars-on-scroll')) && !(scrollContent.hasClass('keep-navbar-on-scroll') || scrollContent.hasClass('keep-bars-on-scroll'));
	    var hideToolbar = (app.params.hideToolbarOnPageScroll || scrollContent.hasClass('hide-toolbar-on-scroll') || scrollContent.hasClass('hide-bars-on-scroll')) && !(scrollContent.hasClass('keep-toolbar-on-scroll') || scrollContent.hasClass('keep-bars-on-scroll'));
	    var hideTabbar = (app.params.hideTabbarOnPageScroll || scrollContent.hasClass('hide-tabbar-on-scroll')) && !(scrollContent.hasClass('keep-tabbar-on-scroll'));
	
	    if (!(hideNavbar || hideToolbar || hideTabbar)) return;
	    
	    var viewContainer = scrollContent.parents('.' + app.params.viewClass);
	    if (viewContainer.length === 0) return;
	
	    var navbar = viewContainer.find('.navbar'), 
	        toolbar = viewContainer.find('.toolbar'), 
	        tabbar;
	    if (hideTabbar) {
	        tabbar = viewContainer.find('.tabbar');
	        if (tabbar.length === 0) tabbar = viewContainer.parents('.' + app.params.viewsClass).find('.tabbar');
	    }
	
	    var hasNavbar = navbar.length > 0,
	        hasToolbar = toolbar.length > 0,
	        hasTabbar = tabbar && tabbar.length > 0;
	
	    var previousScroll, currentScroll;
	        previousScroll = currentScroll = scrollContent[0].scrollTop;
	
	    var scrollHeight, offsetHeight, reachEnd, action, navbarHidden, toolbarHidden, tabbarHidden;
	
	    var toolbarHeight = (hasToolbar && hideToolbar) ? toolbar[0].offsetHeight : 0;
	    var tabbarHeight = (hasTabbar && hideTabbar) ? tabbar[0].offsetHeight : 0;
	    var bottomBarHeight = tabbarHeight || toolbarHeight;
	
	    function handleScroll(e) {
	        if (pageContainer.hasClass('page-on-left')) return;
	        currentScroll = scrollContent[0].scrollTop;
	        scrollHeight = scrollContent[0].scrollHeight;
	        offsetHeight = scrollContent[0].offsetHeight;
	        reachEnd =  currentScroll + offsetHeight >= scrollHeight - bottomBarHeight;
	        navbarHidden = navbar.hasClass('navbar-hidden');
	        toolbarHidden = toolbar.hasClass('toolbar-hidden');
	        tabbarHidden = tabbar && tabbar.hasClass('toolbar-hidden');
	
	        if (reachEnd) {
	            if (app.params.showBarsOnPageScrollEnd) {
	                action = 'show';
	            }
	        }
	        else if (previousScroll > currentScroll) {
	            if (app.params.showBarsOnPageScrollTop || currentScroll <= 44) {
	                action = 'show';
	            }
	            else {
	                action = 'hide';
	            }
	        }
	        else {
	            if (currentScroll > 44) {
	                action = 'hide';
	            }
	            else {
	                action = 'show';
	            }
	        }
	
	        if (action === 'show') {
	            if (hasNavbar && hideNavbar && navbarHidden) {
	                app.showNavbar(navbar);
	                pageContainer.removeClass('no-navbar-by-scroll'); 
	                navbarHidden = false;
	            }
	            if (hasToolbar && hideToolbar && toolbarHidden) {
	                app.showToolbar(toolbar);
	                pageContainer.removeClass('no-toolbar-by-scroll'); 
	                toolbarHidden = false;
	            }
	            if (hasTabbar && hideTabbar && tabbarHidden) {
	                app.showToolbar(tabbar);
	                pageContainer.removeClass('no-tabbar-by-scroll'); 
	                tabbarHidden = false;
	            }
	        }
	        else {
	            if (hasNavbar && hideNavbar && !navbarHidden) {
	                app.hideNavbar(navbar);
	                pageContainer.addClass('no-navbar-by-scroll'); 
	                navbarHidden = true;
	            }
	            if (hasToolbar && hideToolbar && !toolbarHidden) {
	                app.hideToolbar(toolbar);
	                pageContainer.addClass('no-toolbar-by-scroll'); 
	                toolbarHidden = true;
	            }
	            if (hasTabbar && hideTabbar && !tabbarHidden) {
	                app.hideToolbar(tabbar);
	                pageContainer.addClass('no-tabbar-by-scroll'); 
	                tabbarHidden = true;
	            }
	        }
	            
	        previousScroll = currentScroll;
	    }
	    scrollContent.on('scroll', handleScroll);
	    scrollContent[0].f7ScrollToolbarsHandler = handleScroll;
	};
	app.destroyScrollToolbars = function (pageContainer) {
	    pageContainer = $(pageContainer);
	    var scrollContent = pageContainer.find('.page-content');
	    if (scrollContent.length === 0) return;
	    var handler = scrollContent[0].f7ScrollToolbarsHandler;
	    if (!handler) return;
	    scrollContent.off('scroll', scrollContent[0].f7ScrollToolbarsHandler);
	};
	/*===============================================================================
	************   Smart Select   ************
	===============================================================================*/
	app.initSmartSelects = function (pageContainer) {
	    pageContainer = $(pageContainer);
	    var selects;
	    if (pageContainer.is('.smart-select')) {
	        selects = pageContainer;
	    }
	    else {
	        selects = pageContainer.find('.smart-select');
	    }
	    if (selects.length === 0) return;
	
	    selects.each(function () {
	        var smartSelect = $(this);
	
	        var $select = smartSelect.find('select');
	        if ($select.length === 0) return;
	
	        var select = $select[0];
	        if (select.length === 0) return;
	
	        var valueText = [];
	        var displayAs;
	        for (var i = 0; i < select.length; i++) {
	            if (select[i].selected) {
	                displayAs = select[i].dataset ? select[i].dataset.displayAs : $(select[i]).data('display-as');
	                if (displayAs && typeof displayAs !== 'undefined') {
						valueText.push(displayAs);
					} else {
						valueText.push(select[i].textContent.trim());
					}
				}
	        }
	
	        var itemAfter = smartSelect.find('.item-after');
	        if (itemAfter.length === 0) {
	            smartSelect.find('.item-inner').append('<div class="item-after">' + valueText.join(', ') + '</div>');
	        }
	        else {
	            var selectedText = itemAfter.text();
	            if (itemAfter.hasClass('smart-select-value')) {
	                for (i = 0; i < select.length; i++) {
	                    select[i].selected = select[i].textContent.trim() === selectedText.trim();
	                }
	            } else {
	                itemAfter.text(valueText.join(', '));
	            }
	        }
	
	        $select.on('change', function () {
	            var valueText = [];
	            for (var i = 0; i < select.length; i++) {
	                if (select[i].selected) {
	                    var displayAs = select[i].dataset ? select[i].dataset.displayAs : $(select[i]).data('display-as');
	                	if (displayAs && typeof displayAs !== 'undefined') {
							valueText.push(displayAs);
						} else {
							valueText.push(select[i].textContent.trim());
						}
					}
	            }
	            smartSelect.find('.item-after').text(valueText.join(', '));
	        });
	
	    });
	
	};
	app.smartSelectAddOption = function (select, option, index) {
	    select = $(select);
	    var smartSelect = select.parents('.smart-select');
	    if (typeof index === 'undefined') {
	        select.append(option);
	    }
	    else {
	        $(option).insertBefore(select.find('option').eq(index));
	    }
	    app.initSmartSelects(smartSelect);
	    var selectName = smartSelect.find('select').attr('name');
	    var opened = $('.page.smart-select-page[data-select-name="' + selectName + '"]').length > 0;
	    if (opened) {
	        app.smartSelectOpen(smartSelect, true);
	    }
	};
	app.smartSelectOpen = function (smartSelect, reLayout) {
	    smartSelect = $(smartSelect);
	    if (smartSelect.length === 0) return;
	
	    // Find related view
	    var view = smartSelect.parents('.' + app.params.viewClass);
	    if (view.length === 0) return;
	    view = view[0].f7View;
	
	    // Parameters
	    var openIn = smartSelect.attr('data-open-in') || app.params.smartSelectOpenIn;
	    if (openIn === 'popup') {
	        if ($('.popup.smart-select-popup').length > 0) return;
	    }
	    else if (openIn === 'picker') {
	        if ($('.picker-modal.modal-in').length > 0 && !reLayout){
	            if (smartSelect[0].f7SmartSelectPicker !== $('.picker-modal.modal-in:not(.modal-out)')[0]) app.closeModal($('.picker-modal.modal-in:not(.modal-out)'));
	            else return;
	        }
	    }
	    else {
	        if (!view) return;
	    }
	
	    var smartSelectData = smartSelect.dataset();
	    var pageTitle = smartSelectData.pageTitle || smartSelect.find('.item-title').text();
	    var backText = smartSelectData.backText || app.params.smartSelectBackText;
	    var closeText;
	    if (openIn === 'picker') {
	        closeText = smartSelectData.pickerCloseText || smartSelectData.backText || app.params.smartSelectPickerCloseText ;
	    }
	    else {
	        closeText = smartSelectData.popupCloseText || smartSelectData.backText || app.params.smartSelectPopupCloseText ;
	    }
	    var backOnSelect = smartSelectData.backOnSelect !== undefined ? smartSelectData.backOnSelect : app.params.smartSelectBackOnSelect;
	    var formTheme = smartSelectData.formTheme || app.params.smartSelectFormTheme;
	    var navbarTheme = smartSelectData.navbarTheme || app.params.smartSelectNavbarTheme;
	    var toolbarTheme = smartSelectData.toolbarTheme || app.params.smartSelectToolbarTheme;
	    var virtualList = smartSelectData.virtualList;
	    var virtualListHeight = smartSelectData.virtualListHeight;
	    var material = app.params.material;
	    var pickerHeight = smartSelectData.pickerHeight || app.params.smartSelectPickerHeight;
	
	    // Collect all options/values
	    var select = smartSelect.find('select')[0];
	    var $select = $(select);
	    var $selectData = $select.dataset();
	    if (select.disabled || smartSelect.hasClass('disabled') || $select.hasClass('disabled')) {
	        return;
	    }
	    var values = [];
	    var id = (new Date()).getTime();
	    var inputType = select.multiple ? 'checkbox' : 'radio';
	    var inputName = inputType + '-' + id;
	    var maxLength = $select.attr('maxlength');
	    var selectName = select.name;
	    var option, optionHasMedia, optionImage, optionIcon, optionGroup, optionGroupLabel, optionPreviousGroup, optionIsLabel, previousGroup, optionColor, optionClassName, optionData;
	    for (var i = 0; i < select.length; i++) {
	        option = $(select[i]);
	        optionData = option.dataset();
	        optionImage = optionData.optionImage || $selectData.optionImage || smartSelectData.optionImage;
	        optionIcon = optionData.optionIcon || $selectData.optionIcon || smartSelectData.optionIcon;
	        optionHasMedia = optionImage || optionIcon || inputType === 'checkbox';
	        if (material) optionHasMedia = optionImage || optionIcon;
	        optionColor = optionData.optionColor;
	        optionClassName = optionData.optionClass;
	        if (option[0].disabled) optionClassName += ' disabled';
	        optionGroup = option.parent('optgroup')[0];
	        optionGroupLabel = optionGroup && optionGroup.label;
	        optionIsLabel = false;
	        if (optionGroup) {
	            if (optionGroup !== previousGroup) {
	                optionIsLabel = true;
	                previousGroup = optionGroup;
	                values.push({
	                    groupLabel: optionGroupLabel,
	                    isLabel: optionIsLabel
	                });
	            }
	        }
	        values.push({
	            value: option[0].value,
	            text: option[0].textContent.trim(),
	            selected: option[0].selected,
	            group: optionGroup,
	            groupLabel: optionGroupLabel,
	            image: optionImage,
	            icon: optionIcon,
	            color: optionColor,
	            className: optionClassName,
	            disabled: option[0].disabled,
	            inputType: inputType,
	            id: id,
	            hasMedia: optionHasMedia,
	            checkbox: inputType === 'checkbox',
	            inputName: inputName,
	            material: app.params.material
	        });
	    }
	
	
	    // Item template/HTML
	    if (!app._compiledTemplates.smartSelectItem) {
	        app._compiledTemplates.smartSelectItem = t7.compile(app.params.smartSelectItemTemplate ||
	            '{{#if isLabel}}' +
	            '<li class="item-divider">{{groupLabel}}</li>' +
	            '{{else}}' +
	            '<li{{#if className}} class="{{className}}"{{/if}}>' +
	                '<label class="label-{{inputType}} item-content">' +
	                    '<input type="{{inputType}}" name="{{inputName}}" value="{{value}}" {{#if selected}}checked{{/if}}>' +
	                    '{{#if material}}' +
	                        '{{#if hasMedia}}' +
	                        '<div class="item-media">' +
	                            '{{#if icon}}<i class="icon {{icon}}"></i>{{/if}}' +
	                            '{{#if image}}<img src="{{image}}">{{/if}}' +
	                        '</div>' +
	                        '<div class="item-inner">' +
	                            '<div class="item-title{{#if color}} color-{{color}}{{/if}}">{{text}}</div>' +
	                        '</div>' +
	                        '<div class="item-after">' +
	                            '<i class="icon icon-form-{{inputType}}"></i>' +
	                        '</div>' +
	                        '{{else}}' +
	                        '<div class="item-media">' +
	                            '<i class="icon icon-form-{{inputType}}"></i>' +
	                        '</div>' +
	                        '<div class="item-inner">' +
	                            '<div class="item-title{{#if color}} color-{{color}}{{/if}}">{{text}}</div>' +
	                        '</div>' +
	                        '{{/if}}' +
	                    '{{else}}' +
	                        '{{#if hasMedia}}' +
	                        '<div class="item-media">' +
	                            '{{#if checkbox}}<i class="icon icon-form-checkbox"></i>{{/if}}' +
	                            '{{#if icon}}<i class="icon {{icon}}"></i>{{/if}}' +
	                            '{{#if image}}<img src="{{image}}">{{/if}}' +
	                        '</div>' +
	                        '{{/if}}' +
	                        '<div class="item-inner">' +
	                            '<div class="item-title{{#if color}} color-{{color}}{{/if}}">{{text}}</div>' +
	                        '</div>' +
	                    '{{/if}}' +
	                '</label>' +
	            '</li>' +
	            '{{/if}}'
	        );
	    }
	    var smartSelectItemTemplate = app._compiledTemplates.smartSelectItem;
	
	    var inputsHTML = '';
	    if (!virtualList) {
	        for (var j = 0; j < values.length; j++) {
	            inputsHTML += smartSelectItemTemplate(values[j]);
	        }
	    }
	
	    // Toolbar / Navbar
	    var toolbarHTML = '', navbarHTML;
	    var noNavbar = '', noToolbar = '', noTabbar = '', navbarLayout;
	
	    if (openIn === 'picker') {
	        if (!app._compiledTemplates.smartSelectToolbar) {
	            app._compiledTemplates.smartSelectToolbar = t7.compile(app.params.smartSelectToolbarTemplate ||
	                '<div class="toolbar {{#if toolbarTheme}}theme-{{toolbarTheme}}{{/if}}">' +
	                  '<div class="toolbar-inner">' +
	                    '<div class="left"></div>' +
	                    '<div class="right"><a href="#" class="link close-picker"><span>{{closeText}}</span></a></div>' +
	                '</div>' +
	              '</div>'
	            );
	        }
	
	        toolbarHTML = app._compiledTemplates.smartSelectToolbar({
	            pageTitle: pageTitle,
	            closeText: closeText,
	            openIn: openIn,
	            toolbarTheme: toolbarTheme,
	            inPicker: openIn === 'picker'
	        });
	    }
	    else {
	        // Navbar HTML
	        if (!app._compiledTemplates.smartSelectNavbar) {
	            app._compiledTemplates.smartSelectNavbar = t7.compile(app.params.smartSelectNavbarTemplate ||
	                '<div class="navbar {{#if navbarTheme}}theme-{{navbarTheme}}{{/if}}">' +
	                    '<div class="navbar-inner">' +
	                        '{{leftTemplate}}' +
	                        '<div class="center sliding">{{pageTitle}}</div>' +
	                    '</div>' +
	                '</div>'
	            );
	        }
	        navbarHTML = app._compiledTemplates.smartSelectNavbar({
	            pageTitle: pageTitle,
	            backText: backText,
	            closeText: closeText,
	            openIn: openIn,
	            navbarTheme: navbarTheme,
	            inPopup: openIn === 'popup',
	            inPage: openIn === 'page',
	            leftTemplate: openIn === 'popup' ?
	                (app.params.smartSelectPopupCloseTemplate || (material ? '<div class="left"><a href="#" class="link close-popup icon-only"><i class="icon icon-back"></i></a></div>' : '<div class="left"><a href="#" class="link close-popup"><i class="icon icon-back"></i><span>{{closeText}}</span></a></div>')).replace(/{{closeText}}/g, closeText) :
	                (app.params.smartSelectBackTemplate || (material ? '<div class="left"><a href="#" class="back link icon-only"><i class="icon icon-back"></i></a></div>' : '<div class="left sliding"><a href="#" class="back link"><i class="icon icon-back"></i><span>{{backText}}</span></a></div>')).replace(/{{backText}}/g, backText)
	        });
	        // Determine navbar layout type - static/fixed/through
	        if (openIn === 'page') {
	            navbarLayout = 'static';
	            if (smartSelect.parents('.navbar-through').length > 0) navbarLayout = 'through';
	            if (smartSelect.parents('.navbar-fixed').length > 0) navbarLayout = 'fixed';
	            noToolbar = smartSelect.parents('.page').hasClass('no-toolbar') ? 'no-toolbar' : '';
	            noNavbar  = smartSelect.parents('.page').hasClass('no-navbar')  ? 'no-navbar'  : 'navbar-' + navbarLayout;
	            noTabbar = smartSelect.parents('.page').hasClass('no-tabbar') ? 'no-tabbar' : '';
	        }
	        else {
	            navbarLayout = 'fixed';
	        }
	    }
	
	
	    // Page Layout
	    var pageName = 'smart-select-' + inputName;
	
	    var useSearchbar = typeof smartSelect.data('searchbar') === 'undefined' ? app.params.smartSelectSearchbar : (smartSelect.data('searchbar') === 'true' ? true : false);
	    var searchbarPlaceholder, searchbarCancel;
	
	    if (useSearchbar) {
	        searchbarPlaceholder = smartSelect.data('searchbar-placeholder') || 'Search';
	        searchbarCancel = smartSelect.data('searchbar-cancel') || 'Cancel';
	    }
	
	    var searchbarHTML =   '<form class="searchbar searchbar-init" data-search-list=".smart-select-list-' + id + '" data-search-in=".item-title">' +
	                            '<div class="searchbar-input">' +
	                                '<input type="search" placeholder="' + searchbarPlaceholder + '">' +
	                                '<a href="#" class="searchbar-clear"></a>' +
	                            '</div>' +
	                            (material ? '' : '<a href="#" class="searchbar-cancel">' + searchbarCancel + '</a>') +
	                          '</form>' +
	                          '<div class="searchbar-overlay"></div>';
	
	    var pageHTML =
	        (openIn !== 'picker' && navbarLayout === 'through' ? navbarHTML : '') +
	        '<div class="pages">' +
	        '  <div data-page="' + pageName + '" data-select-name="' + selectName + '" class="page smart-select-page ' + noNavbar + ' ' + noToolbar + ' ' + noTabbar + '">' +
	             (openIn !== 'picker' && navbarLayout === 'fixed' ? navbarHTML : '') +
	             (useSearchbar ? searchbarHTML : '') +
	        '    <div class="page-content">' +
	               (openIn !== 'picker' && navbarLayout === 'static' ? navbarHTML : '') +
	        '      <div class="list-block ' + (virtualList ? 'virtual-list' : '') + ' smart-select-list-' + id + ' ' + (formTheme ? 'theme-' + formTheme : '') + '">' +
	        '        <ul>' +
	                    (virtualList ? '' : inputsHTML) +
	        '        </ul>' +
	        '      </div>' +
	        '    </div>' +
	        '  </div>' +
	        '</div>';
	
	    // Define popup and picker
	    var popup, picker;
	
	    // Scroll SS Picker To Input
	    function scrollToInput() {
	        var pageContent = smartSelect.parents('.page-content');
	        if (pageContent.length === 0) return;
	        var paddingTop = parseInt(pageContent.css('padding-top'), 10),
	            paddingBottom = parseInt(pageContent.css('padding-bottom'), 10),
	            pageHeight = pageContent[0].offsetHeight - paddingTop - picker.height(),
	            pageScrollHeight = pageContent[0].scrollHeight - paddingTop - picker.height(),
	            newPaddingBottom;
	        var inputTop = smartSelect.offset().top - paddingTop + smartSelect[0].offsetHeight;
	        if (inputTop > pageHeight) {
	            var scrollTop = pageContent.scrollTop() + inputTop - pageHeight;
	            if (scrollTop + pageHeight > pageScrollHeight) {
	                newPaddingBottom = scrollTop + pageHeight - pageScrollHeight + paddingBottom;
	                if (pageHeight === pageScrollHeight) {
	                    newPaddingBottom = picker.height();
	                }
	                pageContent.css({'padding-bottom': (newPaddingBottom) + 'px'});
	            }
	            pageContent.scrollTop(scrollTop, 300);
	        }
	    }
	    // Close SS Picker on HTML Click
	    function closeOnHTMLClick(e) {
	        var close = true;
	        if (e.target === smartSelect[0] || $(e.target).parents(smartSelect[0]).length > 0) {
	            close = false;
	        }
	        if ($(e.target).parents('.picker-modal').length > 0) {
	            close = false;
	        }
	        if (close) {
	            app.closeModal('.smart-select-picker.modal-in');
	        }
	    }
	
	    // Check max length
	    function checkMaxLength(container) {
	        if (select.selectedOptions.length >= maxLength) {
	            container.find('input[type="checkbox"]').each(function () {
	                if (!this.checked) {
	                    $(this).parents('li').addClass('disabled');
	                }
	                else {
	                    $(this).parents('li').removeClass('disabled');
	                }
	            });
	        }
	        else {
	            container.find('.disabled').removeClass('disabled');
	        }
	    }
	    // Event Listeners on new page
	    function handleInputs(container) {
	        container = $(container);
	        if (virtualList) {
	            var virtualListInstance = app.virtualList(container.find('.virtual-list'), {
	                items: values,
	                template: smartSelectItemTemplate,
	                height: virtualListHeight || undefined,
	                searchByItem: function (query, index, item) {
	                    if (item.text && item.text.toLowerCase().indexOf(query.trim().toLowerCase()) >=0 ) return true;
	                    return false;
	                }
	            });
	            container.once(openIn === 'popup' || openIn === 'picker' ? 'closed': 'pageBeforeRemove', function () {
	                if (virtualListInstance && virtualListInstance.destroy) virtualListInstance.destroy();
	            });
	        }
	        if (maxLength) {
	            checkMaxLength(container);
	        }
	        if (backOnSelect) {
	            container.find('input[type="radio"][name="' + inputName + '"]:checked').parents('label').once('click', function () {
	                if (openIn === 'popup') app.closeModal(popup);
	                else if (openIn === 'picker') app.closeModal(picker);
	                else view.router.back();
	            });
	        }
	        container.on('change', 'input[name="' + inputName + '"]', function () {
				var option, text;
	            var input = this;
	            var value = input.value;
	            var optionText = [];
	            var displayAs;
	            if (input.type === 'checkbox') {
	                var values = [];
	                for (var i = 0; i < select.options.length; i++) {
	                    option = select.options[i];
	                    if (option.value === value) {
	                        option.selected = input.checked;
	                    }
	                    if (option.selected) {
	                        displayAs = option.dataset ? option.dataset.displayAs : $(option).data('display-as');
	                        text = displayAs && typeof displayAs !== 'undefined' ? displayAs : option.textContent;
	                        optionText.push(text.trim());
	                    }
	                }
	                if (maxLength) {
	                    checkMaxLength(container);
	                }
	            }
	            else {
	                option = smartSelect.find('option[value="' + value + '"]')[0];
	                displayAs = option.dataset ? option.dataset.displayAs : $(option).data('display-as');
	                text = displayAs && typeof displayAs !== 'undefined' ? displayAs : option.textContent;
	                optionText = [text];
	                select.value = value;
	            }
	
	            $select.trigger('change');
	            smartSelect.find('.item-after').text(optionText.join(', '));
	            if (backOnSelect && inputType === 'radio') {
	                if (openIn === 'popup') app.closeModal(popup);
	                else if (openIn === 'picker') app.closeModal(picker);
	                else view.router.back();
	            }
	        });
	    }
	    function pageInit(e) {
	        var page = e.detail.page;
	        if (page.name === pageName) {
	            handleInputs(page.container);
	        }
	    }
	    if (openIn === 'popup') {
	        if (reLayout) {
	            popup = $('.popup.smart-select-popup .view');
	            popup.html(pageHTML);
	        }
	        else {
	            popup = app.popup(
	                '<div class="popup smart-select-popup smart-select-popup-' + inputName + '">' +
	                    '<div class="view navbar-fixed">' +
	                        pageHTML +
	                    '</div>' +
	                '</div>'
	                );
	            popup = $(popup);
	        }
	        app.initPage(popup.find('.page'));
	        handleInputs(popup);
	    }
	    else if (openIn === 'picker') {
	        if (reLayout) {
	            picker = $('.picker-modal.smart-select-picker .view');
	            picker.html(pageHTML);
	        }
	        else {
	            picker = app.pickerModal(
	                '<div class="picker-modal smart-select-picker smart-select-picker-' + inputName + '"' + (pickerHeight ? ' style="height:' + pickerHeight + '"' : '') + '>' +
	                    toolbarHTML +
	                    '<div class="picker-modal-inner">' +
	                        '<div class="view">' +
	                            pageHTML +
	                        '</div>' +
	                    '</div>' +
	                '</div>'
	                );
	            picker = $(picker);
	
	            // Scroll To Input
	            scrollToInput();
	
	            // Close On Click
	            $('html').on('click', closeOnHTMLClick);
	
	            // On Close
	            picker.once('picker:close', function () {
	                // Reset linked picker
	                smartSelect[0].f7SmartSelectPicker = undefined;
	
	                // Detach html click
	                $('html').off('click', closeOnHTMLClick);
	
	                // Restore page padding bottom
	                smartSelect.parents('.page-content').css({paddingBottom: ''});
	            });
	
	            // Link Picker
	            smartSelect[0].f7SmartSelectPicker = picker[0];
	        }
	
	        // Init Page
	        app.initPage(picker.find('.page'));
	
	        // Attach events
	        handleInputs(picker);
	    }
	    else {
	        $(document).once('page:init', '.smart-select-page', pageInit);
	        view.router.load({
	            content: pageHTML,
	            reload: reLayout ? true : undefined
	        });
	    }
	};
	
	/*===============================================================================
	************   Sortable   ************
	===============================================================================*/
	app.sortableToggle = function (sortableContainer) {
	    sortableContainer = $(sortableContainer);
	    if (sortableContainer.length === 0) sortableContainer = $('.list-block.sortable');
	    sortableContainer.toggleClass('sortable-opened');
	    if (sortableContainer.hasClass('sortable-opened')) {
	        sortableContainer.trigger('open sortable:open');
	    }
	    else {
	        sortableContainer.trigger('close sortable:close');
	    }
	    return sortableContainer;
	};
	app.sortableOpen = function (sortableContainer) {
	    sortableContainer = $(sortableContainer);
	    if (sortableContainer.length === 0) sortableContainer = $('.list-block.sortable');
	    sortableContainer.addClass('sortable-opened');
	    sortableContainer.trigger('open sortable:open');
	    return sortableContainer;
	};
	app.sortableClose = function (sortableContainer) {
	    sortableContainer = $(sortableContainer);
	    if (sortableContainer.length === 0) sortableContainer = $('.list-block.sortable');
	    sortableContainer.removeClass('sortable-opened');
	    sortableContainer.trigger('close sortable:close');
	    return sortableContainer;
	};
	app.initSortable = function () {
	    var isTouched, isMoved, touchStartY, touchesDiff, sortingEl, sortingElHeight, sortingItems, minTop, maxTop, insertAfter, insertBefore, sortableContainer, startIndex;
	    
	    function handleTouchStart(e) {
	        isMoved = false;
	        isTouched = true;
	        touchStartY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	        /*jshint validthis:true */
	        sortingEl = $(this).parent();
	        startIndex = sortingEl.index();
	        sortingItems = sortingEl.parent().find('li');
	        sortableContainer = sortingEl.parents('.sortable');
	        e.preventDefault();
	        app.allowPanelOpen = app.allowSwipeout = false;
	    }
	    function handleTouchMove(e) {
	        if (!isTouched || !sortingEl) return;
	        var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	        var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	        if (!isMoved) {
	            sortingEl.addClass('sorting');
	            sortableContainer.addClass('sortable-sorting');
	            minTop = sortingEl[0].offsetTop;
	            maxTop = sortingEl.parent().height() - sortingEl[0].offsetTop - sortingEl.height();
	            sortingElHeight = sortingEl[0].offsetHeight;
	        }
	        isMoved = true;
	
	        e.preventDefault();
	        e.f7PreventPanelSwipe = true;
	        touchesDiff = pageY - touchStartY;
	        var translate = touchesDiff;
	        if (translate < -minTop) translate = -minTop;
	        if (translate > maxTop) translate = maxTop;
	        sortingEl.transform('translate3d(0,' + translate + 'px,0)');
	
	        insertBefore = insertAfter = undefined;
	
	        sortingItems.each(function () {
	            var currentEl = $(this);
	            if (currentEl[0] === sortingEl[0]) return;
	            var currentElOffset = currentEl[0].offsetTop;
	            var currentElHeight = currentEl.height();
	            var sortingElOffset = sortingEl[0].offsetTop + translate;
	
	            if ((sortingElOffset >= currentElOffset - currentElHeight / 2) && sortingEl.index() < currentEl.index()) {
	                currentEl.transform('translate3d(0, '+(-sortingElHeight)+'px,0)');
	                insertAfter = currentEl;
	                insertBefore = undefined;
	            }
	            else if ((sortingElOffset <= currentElOffset + currentElHeight / 2) && sortingEl.index() > currentEl.index()) {
	                currentEl.transform('translate3d(0, '+(sortingElHeight)+'px,0)');
	                insertAfter = undefined;
	                if (!insertBefore) insertBefore = currentEl;
	            }
	            else {
	                $(this).transform('translate3d(0, 0%,0)');
	            }
	        });
	    }
	    function handleTouchEnd(e) {
	        app.allowPanelOpen = app.allowSwipeout = true;
	        if (!isTouched || !isMoved) {
	            isTouched = false;
	            isMoved = false;
	            return;
	        }
	        e.preventDefault();
	        sortingItems.transform('');
	        sortingEl.removeClass('sorting');
	        sortableContainer.removeClass('sortable-sorting');
	        var virtualList, oldIndex, newIndex;
	        if (insertAfter) {
	            sortingEl.insertAfter(insertAfter);
	            sortingEl.trigger('sort sortable:sort', {startIndex: startIndex, newIndex: sortingEl.index()});
	        }
	        if (insertBefore) {
	            sortingEl.insertBefore(insertBefore);
	            sortingEl.trigger('sort sortable:sort', {startIndex: startIndex, newIndex: sortingEl.index()});
	        }
	        if ((insertAfter || insertBefore) && sortableContainer.hasClass('virtual-list')) {
	            virtualList = sortableContainer[0].f7VirtualList;
	            oldIndex = sortingEl[0].f7VirtualListIndex;
	            newIndex = insertBefore ? insertBefore[0].f7VirtualListIndex : insertAfter[0].f7VirtualListIndex;
	            if (virtualList) virtualList.moveItem(oldIndex, newIndex);
	        }
	        insertAfter = insertBefore = undefined;
	        isTouched = false;
	        isMoved = false;
	    }
	    $(document).on(app.touchEvents.start, '.list-block.sortable .sortable-handler', handleTouchStart);
	    if (app.support.touch) {
	        $(document).on(app.touchEvents.move, '.list-block.sortable .sortable-handler', handleTouchMove);
	        $(document).on(app.touchEvents.end, '.list-block.sortable .sortable-handler', handleTouchEnd);
	    }
	    else {
	        $(document).on(app.touchEvents.move, handleTouchMove);
	        $(document).on(app.touchEvents.end, handleTouchEnd);
	    }
	};
	
	/*===============================================================================
	************   Swipeout Actions (Swipe to delete)   ************
	===============================================================================*/
	app.swipeoutOpenedEl = undefined;
	app.allowSwipeout = true;
	app.initSwipeout = function (swipeoutEl) {
	    var isTouched, isMoved, isScrolling, touchesStart = {}, touchStartTime, touchesDiff, swipeOutEl, swipeOutContent, actionsRight, actionsLeft, actionsLeftWidth, actionsRightWidth, translate, opened, openedActions, buttonsLeft, buttonsRight, direction, overswipeLeftButton, overswipeRightButton, overswipeLeft, overswipeRight, noFoldLeft, noFoldRight;
	    $(document).on(app.touchEvents.start, function (e) {
	        if (app.swipeoutOpenedEl) {
	            var target = $(e.target);
	            if (!(
	                app.swipeoutOpenedEl.is(target[0]) ||
	                target.parents('.swipeout').is(app.swipeoutOpenedEl) ||
	                target.hasClass('modal-in') ||
	                target.hasClass('modal-overlay') ||
	                target.hasClass('actions-modal') || 
	                target.parents('.actions-modal.modal-in, .modal.modal-in').length > 0
	                )) {
	                app.swipeoutClose(app.swipeoutOpenedEl);
	            }
	        }
	    });
	
	    function handleTouchStart(e) {
	        if (!app.allowSwipeout) return;
	        isMoved = false;
	        isTouched = true;
	        isScrolling = undefined;
	        touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	        touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	        touchStartTime = (new Date()).getTime();
	    }
	    function handleTouchMove(e) {
	        if (!isTouched) return;
	        var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	        var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	        if (typeof isScrolling === 'undefined') {
	            isScrolling = !!(isScrolling || Math.abs(pageY - touchesStart.y) > Math.abs(pageX - touchesStart.x));
	        }
	        if (isScrolling) {
	            isTouched = false;
	            return;
	        }
	
	        if (!isMoved) {
	            if ($('.list-block.sortable-opened').length > 0) return;
	            /*jshint validthis:true */
	            swipeOutEl = $(this);
	            swipeOutContent = swipeOutEl.find('.swipeout-content');
	            actionsRight = swipeOutEl.find('.swipeout-actions-right');
	            actionsLeft = swipeOutEl.find('.swipeout-actions-left');
	            actionsLeftWidth = actionsRightWidth = buttonsLeft = buttonsRight = overswipeRightButton = overswipeLeftButton = null;
	            noFoldLeft = actionsLeft.hasClass('swipeout-actions-no-fold') || app.params.swipeoutActionsNoFold;
	            noFoldRight = actionsRight.hasClass('swipeout-actions-no-fold') || app.params.swipeoutActionsNoFold;
	            if (actionsLeft.length > 0) {
	                actionsLeftWidth = actionsLeft.outerWidth();
	                buttonsLeft = actionsLeft.children('a');
	                overswipeLeftButton = actionsLeft.find('.swipeout-overswipe');
	            }
	            if (actionsRight.length > 0) {
	                actionsRightWidth = actionsRight.outerWidth();
	                buttonsRight = actionsRight.children('a');
	                overswipeRightButton = actionsRight.find('.swipeout-overswipe');
	            }
	            opened = swipeOutEl.hasClass('swipeout-opened');
	            if (opened) {
	                openedActions = swipeOutEl.find('.swipeout-actions-left.swipeout-actions-opened').length > 0 ? 'left' : 'right';
	            }
	            swipeOutEl.removeClass('transitioning');
	            if (!app.params.swipeoutNoFollow) {
	                swipeOutEl.find('.swipeout-actions-opened').removeClass('swipeout-actions-opened');
	                swipeOutEl.removeClass('swipeout-opened');
	            }
	        }
	        isMoved = true;
	        e.preventDefault();
	        
	        touchesDiff = pageX - touchesStart.x;
	        translate = touchesDiff;
	
	        if (opened) {
	            if (openedActions === 'right') translate = translate - actionsRightWidth;
	            else translate = translate + actionsLeftWidth;
	        }
	
	        if (translate > 0 && actionsLeft.length === 0 || translate < 0 && actionsRight.length === 0) {
	            if (!opened) {
	                isTouched = isMoved = false;
	                swipeOutContent.transform('');
	                if (buttonsRight && buttonsRight.length > 0) {
	                    buttonsRight.transform('');
	                }
	                if (buttonsLeft && buttonsLeft.length > 0) {
	                    buttonsLeft.transform('');
	                }
	                return;
	            }
	            translate = 0;
	        }
	
	        if (translate < 0) direction = 'to-left';
	        else if (translate > 0) direction = 'to-right';
	        else {
	            if (!direction) direction = 'to-left';
	        }
	        
	        var i, buttonOffset, progress;
	        
	        e.f7PreventPanelSwipe = true;
	        if (app.params.swipeoutNoFollow) {
	            if (opened) {
	                if (openedActions === 'right' && touchesDiff > 0) {
	                    app.swipeoutClose(swipeOutEl);
	                }
	                if (openedActions === 'left' && touchesDiff < 0) {
	                    app.swipeoutClose(swipeOutEl);
	                }
	            }
	            else {
	                if (touchesDiff < 0 && actionsRight.length > 0) {
	                    app.swipeoutOpen(swipeOutEl, 'right');
	                }
	                if (touchesDiff > 0 && actionsLeft.length > 0) {
	                    app.swipeoutOpen(swipeOutEl, 'left');
	                }
	            }
	            isTouched = false;
	            isMoved = false;
	            return;
	        }
	        overswipeLeft = false;
	        overswipeRight = false;
	        var $button;
	        if (actionsRight.length > 0) {
	            // Show right actions
	            progress = translate / actionsRightWidth;
	            if (translate < -actionsRightWidth) {
	                translate = -actionsRightWidth - Math.pow(-translate - actionsRightWidth, 0.8);
	                if (overswipeRightButton.length > 0) {
	                    overswipeRight = true;
	                }
	            }
	            for (i = 0; i < buttonsRight.length; i++) {
	                if (typeof buttonsRight[i]._buttonOffset === 'undefined') {
	                    buttonsRight[i]._buttonOffset = buttonsRight[i].offsetLeft;
	                }
	                buttonOffset = buttonsRight[i]._buttonOffset;
	                $button = $(buttonsRight[i]);
	                if (overswipeRightButton.length > 0 && $button.hasClass('swipeout-overswipe')) {
	                    $button.css({left: (overswipeRight ? -buttonOffset : 0) + 'px'});
	                    if (overswipeRight) {
	                        $button.addClass('swipeout-overswipe-active');
	                    }
	                    else {
	                        $button.removeClass('swipeout-overswipe-active');   
	                    }
	                }
	                $button.transform('translate3d(' + (translate - buttonOffset * (1 + Math.max(progress, -1))) + 'px,0,0)');
	            }
	        }
	        if (actionsLeft.length > 0) {
	            // Show left actions
	            progress = translate / actionsLeftWidth;
	            if (translate > actionsLeftWidth) {
	                translate = actionsLeftWidth + Math.pow(translate - actionsLeftWidth, 0.8);
	                if (overswipeLeftButton.length > 0) {
	                    overswipeLeft = true;
	                }
	            }
	            for (i = 0; i < buttonsLeft.length; i++) {
	                if (typeof buttonsLeft[i]._buttonOffset === 'undefined') {
	                    buttonsLeft[i]._buttonOffset = actionsLeftWidth - buttonsLeft[i].offsetLeft - buttonsLeft[i].offsetWidth;
	                }
	                buttonOffset = buttonsLeft[i]._buttonOffset;
	                $button = $(buttonsLeft[i]);
	                if (overswipeLeftButton.length > 0 && $button.hasClass('swipeout-overswipe')) {
	                    $button.css({left: (overswipeLeft ? buttonOffset : 0) + 'px'});
	                    if (overswipeLeft) {
	                        $button.addClass('swipeout-overswipe-active');
	                    }
	                    else {
	                        $button.removeClass('swipeout-overswipe-active');   
	                    }
	                }
	                if (buttonsLeft.length > 1) {
	                    $button.css('z-index', buttonsLeft.length - i); 
	                }
	                $button.transform('translate3d(' + (translate + buttonOffset * (1 - Math.min(progress, 1))) + 'px,0,0)');
	            }
	        }
	        swipeOutContent.transform('translate3d(' + translate + 'px,0,0)');
	    }
	    function handleTouchEnd(e) {
	        if (!isTouched || !isMoved) {
	            isTouched = false;
	            isMoved = false;
	            return;
	        }
	
	        isTouched = false;
	        isMoved = false;
	        var timeDiff = (new Date()).getTime() - touchStartTime;
	        var action, actionsWidth, actions, buttons, i;
	
	        actions = direction === 'to-left' ? actionsRight : actionsLeft;
	        actionsWidth = direction === 'to-left' ? actionsRightWidth : actionsLeftWidth;
	
	        if (
	            timeDiff < 300 && (touchesDiff < -10 && direction === 'to-left' || touchesDiff > 10 && direction === 'to-right') ||
	            timeDiff >= 300 && Math.abs(translate) > actionsWidth / 2
	        ) {
	            action = 'open';
	        }
	        else {
	            action = 'close';
	        }
	        if (timeDiff < 300) {
	            if (Math.abs(translate) === 0) action = 'close';
	            if (Math.abs(translate) === actionsWidth) action = 'open';
	        }
	        
	        if (action === 'open') {
	            app.swipeoutOpenedEl = swipeOutEl;
	            swipeOutEl.trigger('open swipeout:open');
	            swipeOutEl.addClass('swipeout-opened transitioning');
	            var newTranslate = direction === 'to-left' ? -actionsWidth : actionsWidth;
	            swipeOutContent.transform('translate3d(' + newTranslate + 'px,0,0)');
	            actions.addClass('swipeout-actions-opened');
	            buttons = direction === 'to-left' ? buttonsRight : buttonsLeft;
	            if (buttons) {
	                for (i = 0; i < buttons.length; i++) {
	                    $(buttons[i]).transform('translate3d(' + newTranslate + 'px,0,0)');
	                }
	            }
	            if (overswipeRight) {
	                actionsRight.find('.swipeout-overswipe')[0].click();
	            }
	            if (overswipeLeft) {
	                actionsLeft.find('.swipeout-overswipe')[0].click();
	            }
	        }
	        else {
	            swipeOutEl.trigger('close swipeout:close');
	            app.swipeoutOpenedEl = undefined;
	            swipeOutEl.addClass('transitioning').removeClass('swipeout-opened');
	            swipeOutContent.transform('');
	            actions.removeClass('swipeout-actions-opened');
	        }
	        
	        var buttonOffset;
	        if (buttonsLeft && buttonsLeft.length > 0 && buttonsLeft !== buttons) {
	            for (i = 0; i < buttonsLeft.length; i++) {
	                buttonOffset = buttonsLeft[i]._buttonOffset;
	                if (typeof buttonOffset === 'undefined') {
	                    buttonsLeft[i]._buttonOffset = actionsLeftWidth - buttonsLeft[i].offsetLeft - buttonsLeft[i].offsetWidth;
	                }
	                $(buttonsLeft[i]).transform('translate3d(' + (buttonOffset) + 'px,0,0)');
	            }
	        }
	        if (buttonsRight && buttonsRight.length > 0 && buttonsRight !== buttons) {
	            for (i = 0; i < buttonsRight.length; i++) {
	                buttonOffset = buttonsRight[i]._buttonOffset;
	                if (typeof buttonOffset === 'undefined') {
	                    buttonsRight[i]._buttonOffset = buttonsRight[i].offsetLeft;
	                }
	                $(buttonsRight[i]).transform('translate3d(' + (-buttonOffset) + 'px,0,0)');
	            }
	        }
	        swipeOutContent.transitionEnd(function (e) {
	            if (opened && action === 'open' || closed && action === 'close') return;
	            swipeOutEl.trigger(action === 'open' ? 'opened' : 'closed');
	            if (opened && action === 'close') {
	                if (actionsRight.length > 0) {
	                    buttonsRight.transform('');
	                }
	                if (actionsLeft.length > 0) {
	                    buttonsLeft.transform('');
	                }
	            }
	        });
	    }
	    if (swipeoutEl) {
	        $(swipeoutEl).on(app.touchEvents.start, handleTouchStart);
	        $(swipeoutEl).on(app.touchEvents.move, handleTouchMove);
	        $(swipeoutEl).on(app.touchEvents.end, handleTouchEnd);
	    }
	    else {
	        $(document).on(app.touchEvents.start, '.list-block li.swipeout', handleTouchStart);
	        $(document).on(app.touchEvents.move, '.list-block li.swipeout', handleTouchMove);
	        $(document).on(app.touchEvents.end, '.list-block li.swipeout', handleTouchEnd);
	    }
	        
	};
	app.swipeoutOpen = function (el, dir, callback) {
	    el = $(el);
	    if (arguments.length === 2) {
	        if (typeof arguments[1] === 'function') {
	            callback = dir;
	        }
	    }
	
	    if (el.length === 0) return;
	    if (el.length > 1) el = $(el[0]);
	    if (!el.hasClass('swipeout') || el.hasClass('swipeout-opened')) return;
	    if (!dir) {
	        if (el.find('.swipeout-actions-right').length > 0) dir = 'right';
	        else dir = 'left';
	    }
	    var swipeOutActions = el.find('.swipeout-actions-' + dir);
	    if (swipeOutActions.length === 0) return;
	    el.trigger('open swipeout:open').addClass('swipeout-opened').removeClass('transitioning');
	    swipeOutActions.addClass('swipeout-actions-opened');
	    var buttons = swipeOutActions.children('a');
	    var swipeOutActionsWidth = swipeOutActions.outerWidth();
	    var translate = dir === 'right' ? -swipeOutActionsWidth : swipeOutActionsWidth;
	    var i;
	    if (buttons.length > 1) {
	        for (i = 0; i < buttons.length; i++) {
	            if (dir === 'right') {
	                $(buttons[i]).transform('translate3d(' + (- buttons[i].offsetLeft) + 'px,0,0)');
	            }
	            else {
	                $(buttons[i]).css('z-index', buttons.length - i).transform('translate3d(' + (swipeOutActionsWidth - buttons[i].offsetWidth - buttons[i].offsetLeft) + 'px,0,0)');
	            }
	        }
	        var clientLeft = buttons[1].clientLeft;
	    }
	    el.addClass('transitioning');
	    for (i = 0; i < buttons.length; i++) {
	        $(buttons[i]).transform('translate3d(' + (translate) + 'px,0,0)');
	    }
	    el.find('.swipeout-content').transform('translate3d(' + translate + 'px,0,0)').transitionEnd(function () {
	        el.trigger('opened swipeout:opened');
	        if (callback) callback.call(el[0]);
	    });
	    app.swipeoutOpenedEl = el;
	};
	app.swipeoutClose = function (el, callback) {
	    el = $(el);
	    if (el.length === 0) return;
	    if (!el.hasClass('swipeout-opened')) return;
	    var dir = el.find('.swipeout-actions-opened').hasClass('swipeout-actions-right') ? 'right' : 'left';
	    var swipeOutActions = el.find('.swipeout-actions-opened').removeClass('swipeout-actions-opened');
	    var buttons = swipeOutActions.children('a');
	    var swipeOutActionsWidth = swipeOutActions.outerWidth();
	    app.allowSwipeout = false;
	    el.trigger('close swipeout:close');
	    el.removeClass('swipeout-opened').addClass('transitioning');
	
	    var closeTO;
	    function onSwipeoutClose() {
	        app.allowSwipeout = true;
	        if (el.hasClass('swipeout-opened')) return;
	        el.removeClass('transitioning');
	        buttons.transform('');
	        el.trigger('closed swipeout:closed');
	        if (callback) callback.call(el[0]);
	        if (closeTO) clearTimeout(closeTO);
	    }
	    el.find('.swipeout-content').transform('').transitionEnd(onSwipeoutClose);
	    closeTO = setTimeout(onSwipeoutClose, 500);
	    
	    for (var i = 0; i < buttons.length; i++) {
	        if (dir === 'right') {
	            $(buttons[i]).transform('translate3d(' + (-buttons[i].offsetLeft) + 'px,0,0)');
	        }
	        else {
	            $(buttons[i]).transform('translate3d(' + (swipeOutActionsWidth - buttons[i].offsetWidth - buttons[i].offsetLeft) + 'px,0,0)');
	        }
	        $(buttons[i]).css({left:0 + 'px'}).removeClass('swipeout-overswipe-active');
	    }
	    if (app.swipeoutOpenedEl && app.swipeoutOpenedEl[0] === el[0]) app.swipeoutOpenedEl = undefined;
	};
	app.swipeoutDelete = function (el, callback) {
	    el = $(el);
	    if (el.length === 0) return;
	    if (el.length > 1) el = $(el[0]);
	    app.swipeoutOpenedEl = undefined;
	    el.trigger('delete swipeout:delete');
	    el.css({height: el.outerHeight() + 'px'});
	    var clientLeft = el[0].clientLeft;
	    el.css({height: 0 + 'px'}).addClass('deleting transitioning').transitionEnd(function () {
	        el.trigger('deleted swipeout:deleted');
	        if (callback) callback.call(el[0]);
	        if (el.parents('.virtual-list').length > 0) {
	            var virtualList = el.parents('.virtual-list')[0].f7VirtualList;
	            var virtualIndex = el[0].f7VirtualListIndex;
	            if (virtualList && typeof virtualIndex !== 'undefined') virtualList.deleteItem(virtualIndex);
	        }
	        else {
	            if (app.params.swipeoutRemoveWithTimeout) {
	                setTimeout(function () {
	                    el.remove();
	                }, 0);
	            }
	            else el.remove();
	        }
	    });
	    var translate = '-100%';
	    el.find('.swipeout-content').transform('translate3d(' + translate + ',0,0)');
	};
	
	/*===========================
	Framework7 Swiper Additions
	===========================*/
	app.swiper = function (container, params) {
	    return new Swiper(container, params);
	};
	app.initPageSwiper = function (pageContainer) {
	    pageContainer = $(pageContainer);
	    var swipers = pageContainer.find('.swiper-init, .tabs-swipeable-wrap');
	    if (swipers.length === 0) return;
	    function destroySwiperOnRemove(slider) {
	        function destroySwiper() {
	            slider.destroy();
	            pageContainer.off('page:beforeremove', destroySwiper);
	        }
	        pageContainer.on('page:beforeremove', destroySwiper);
	    }
	    swipers.each(function () {
	        var swiper = $(this), initialSlide;
	        var params;
	        if (swiper.hasClass('tabs-swipeable-wrap')) {
	            swiper.addClass('swiper-container').children('.tabs').addClass('swiper-wrapper').children('.tab').addClass('swiper-slide');
	            initialSlide = swiper.children('.tabs').children('.tab.active').index();
	        }
	        if (swiper.data('swiper')) {
	            params = JSON.parse(swiper.data('swiper'));
	        }
	        else {
	            params = swiper.dataset();
	        }
	        if (typeof params.initialSlide === 'undefined' && typeof initialSlide !== 'undefined') {
	            params.initialSlide = initialSlide;
	        }
	        if (swiper.hasClass('tabs-swipeable-wrap')) {
	            params.onSlideChangeStart = function (s) {
	                app.showTab(s.slides.eq(s.activeIndex));
	            };
	        }
	        var _slider = app.swiper(swiper[0], params);
	        destroySwiperOnRemove(_slider);
	    });
	};
	app.reinitPageSwiper = function (pageContainer) {
	    pageContainer = $(pageContainer);
	    var sliders = pageContainer.find('.swiper-init, .tabs-swipeable-wrap');
	    if (sliders.length === 0) return;
	    for (var i = 0; i < sliders.length; i++) {
	        var sliderInstance = sliders[0].swiper;
	        if (sliderInstance) {
	            sliderInstance.update(true);
	        }
	    }
	};
	
	/*======================================================
	************   Material Tabbar   ************
	======================================================*/
	app.materialTabbarSetHighlight = function (tabbar, activeLink) {
	    tabbar = $(tabbar);
	    activeLink = activeLink || tabbar.find('.tab-link.active');
	
	    if (activeLink && activeLink.length > 0) {
	        var tabLinkWidth, highlightTranslate;
	        if (tabbar.hasClass('tabbar-scrollable')) {
	            tabLinkWidth = activeLink[0].offsetWidth + 'px';
	            highlightTranslate = activeLink[0].offsetLeft + 'px';
	        }
	        else {
	            tabLinkWidth = 1 / tabbar.find('.tab-link').length * 100 + '%';
	            highlightTranslate = (app.rtl ? - activeLink.index(): activeLink.index()) * 100 + '%';
	        }
	
	        tabbar.find('.tab-link-highlight')
	            .css({width: tabLinkWidth})
	            .transform('translate3d(' + highlightTranslate + ',0,0)');
	    }
	};
	app.initPageMaterialTabbar = function (pageContainer) {
	    pageContainer = $(pageContainer);
	    var tabbar = pageContainer.find('.tabbar');
	    if (tabbar.length === 0 && pageContainer.hasClass('tabbar')) tabbar = pageContainer;
	
	    function tabbarSetHighlight() {
	        app.materialTabbarSetHighlight(tabbar);
	    }
	    if (tabbar.length > 0) {
	        if (tabbar.find('.tab-link-highlight').length === 0) {
	            tabbar.find('.toolbar-inner').append('<span class="tab-link-highlight"></span>');
	        }
	
	        tabbarSetHighlight();
	        $(window).on('resize', tabbarSetHighlight);
	        pageContainer.once('page:beforeremove', function () {
	            $(window).off('resize', tabbarSetHighlight);
	        });
	    }
	};
	app.initMaterialTabbar = function (tabbar) {
	    return app.initPageMaterialTabbar(tabbar);
	};
	/* ===============================================================================
	************   Tabs   ************
	=============================================================================== */
	app.showTab = function (tab, tabLink, animated, force) {
	    var newTab = $(tab);
	    if (arguments.length === 2 && typeof arguments[1] === 'boolean') {
	        tab = arguments[0];
	        animated = arguments[1];
	    }
	    if (arguments.length === 3 && typeof arguments[1] === 'boolean' && typeof arguments[2] === 'boolean') {
	        tab = arguments[0];
	        animated = arguments[1];
	        force = arguments[2];
	    }
	    if (typeof animated === 'undefined') animated = true;
	    if (newTab.length === 0) return false;
	    if (newTab.hasClass('active')) {
	        if (force) newTab.trigger('show tab:show');
	        return false;
	    }
	    var tabs = newTab.parent('.tabs');
	    if (tabs.length === 0) return false;
	
	    // Return swipeouts in hidden tabs
	    app.allowSwipeout = true;
	
	    // Animated tabs
	    var isAnimatedTabs = tabs.parent().hasClass('tabs-animated-wrap');
	    if (isAnimatedTabs) {
	        tabs.parent()[animated ? 'removeClass' : 'addClass']('not-animated');
	        var tabTranslate = (app.rtl ? newTab.index() : -newTab.index()) * 100;
	        tabs.transform('translate3d(' + tabTranslate + '%,0,0)');
	    }
	
	    // Swipeable tabs
	    var isSwipeableTabs = tabs.parent().hasClass('tabs-swipeable-wrap'), swiper;
	    if (isSwipeableTabs) {
	        swiper = tabs.parent()[0].swiper;
	        if (swiper.activeIndex !== newTab.index()) swiper.slideTo(newTab.index(), animated ? undefined : 0, false);
	    }
	
	    // Remove active class from old tabs
	    var oldTab = tabs.children('.tab.active').removeClass('active').trigger('hide tab:hide');
	    // Add active class to new tab
	    newTab.addClass('active');
	    // Trigger 'show' event on new tab
	    newTab.trigger('show tab:show');
	
	    // Update navbars in new tab
	    if (!isAnimatedTabs && !isSwipeableTabs && newTab.find('.navbar').length > 0) {
	        // Find tab's view
	        var viewContainer;
	        if (newTab.hasClass(app.params.viewClass)) viewContainer = newTab[0];
	        else viewContainer = newTab.parents('.' + app.params.viewClass)[0];
	        app.sizeNavbars(viewContainer);
	    }
	
	    // Find related link for new tab
	    if (tabLink) tabLink = $(tabLink);
	    else {
	        // Search by id
	        if (typeof tab === 'string') tabLink = $('.tab-link[href="' + tab + '"]');
	        else tabLink = $('.tab-link[href="#' + newTab.attr('id') + '"]');
	        // Search by data-tab
	        if (!tabLink || tabLink && tabLink.length === 0) {
	            $('[data-tab]').each(function () {
	                if (newTab.is($(this).attr('data-tab'))) tabLink = $(this);
	            });
	        }
	    }
	    if (tabLink.length === 0) return;
	
	    // Find related link for old tab
	    var oldTabLink;
	    if (oldTab && oldTab.length > 0) {
	        // Search by id
	        var oldTabId = oldTab.attr('id');
	        if (oldTabId) oldTabLink = $('.tab-link[href="#' + oldTabId + '"]');
	        // Search by data-tab
	        if (!oldTabLink || oldTabLink && oldTabLink.length === 0) {
	            $('[data-tab]').each(function () {
	                if (oldTab.is($(this).attr('data-tab'))) oldTabLink = $(this);
	            });
	        }
	    }
	
	    // Update links' classes
	    if (tabLink && tabLink.length > 0) {
	        tabLink.addClass('active');
	        // Material Highlight
	        if (app.params.material) {
	            var tabbar = tabLink.parents('.tabbar');
	            if (tabbar.length > 0) {
	                if (tabbar.find('.tab-link-highlight').length === 0) {
	                    tabbar.find('.toolbar-inner').append('<span class="tab-link-highlight"></span>');
	                }
	                app.materialTabbarSetHighlight(tabbar, tabLink);
	            }
	        }
	    }
	    if (oldTabLink && oldTabLink.length > 0) oldTabLink.removeClass('active');
	
	    return true;
	};
	/*===============================================================================
	************   Virtual List   ************
	===============================================================================*/
	var VirtualList = function (listBlock, params) {
	    var defaults = {
	        cols: 1,
	        height: app.params.material ? 48 : 44,
	        cache: true,
	        dynamicHeightBufferSize: 1,
	        showFilteredItemsOnly: false,
	        template: 
	            '<li>' +
	                '<div class="item-content">' +
	                    '<div class="item-inner">' +
	                        '<div class="item-title">{{this}}</div>' +
	                    '</div>' +
	                '</div>' +
	            '</li>'
	    };
	    params = params || {};
	    for (var def in defaults) {
	        if (typeof params[def] === 'undefined') {
	            params[def] = defaults[def];
	        }
	    }
	
	    // Preparation
	    var vl = this;
	    vl.listBlock = $(listBlock);
	    vl.params = params;
	    vl.items = vl.params.items;
	    if (vl.params.showFilteredItemsOnly) {
	        vl.filteredItems = [];
	    }
	    if (vl.params.template && !vl.params.renderItem) {
	        if (typeof vl.params.template === 'string') vl.template = t7.compile(vl.params.template);
	        else if (typeof vl.params.template === 'function') vl.template = vl.params.template;
	    }
	    vl.pageContent = vl.listBlock.parents('.page-content');
	
	    // Bad scroll
	    var updatableScroll;
	    if (typeof vl.params.updatableScroll !== 'undefined') {
	        updatableScroll = vl.params.updatableScroll;
	    }
	    else {
	        updatableScroll = true;
	        if (app.device.ios && app.device.osVersion.split('.')[0] < 8) {
	            updatableScroll = false;
	        }
	        vl.params.updatableScroll = updatableScroll;
	    }
	
	    // Append <ul>
	    vl.ul = vl.params.ul ? $(vl.params.ul) : vl.listBlock.children('ul');
	    if (vl.ul.length === 0) {
	        vl.listBlock.append('<ul></ul>');
	        vl.ul = vl.listBlock.children('ul');
	    }
	
	    // DOM cached items
	    vl.domCache = {};
	    vl.displayDomCache = {};
	
	    // Temporary DOM Element
	    vl.tempDomElement = document.createElement('ul');
	
	    // Last repain position
	    vl.lastRepaintY = null;
	
	    // Fragment
	    vl.fragment = document.createDocumentFragment();
	
	    // Filter
	    vl.filterItems = function (indexes, resetScrollTop) {
	        vl.filteredItems = [];
	        var firstIndex = indexes[0];
	        var lastIndex = indexes[indexes.length - 1];
	        for (var i = 0; i < indexes.length; i++) {
	            vl.filteredItems.push(vl.items[indexes[i]]);
	        }
	        if (typeof resetScrollTop === 'undefined') resetScrollTop = true;
	        if (resetScrollTop) {
	            vl.pageContent[0].scrollTop = 0;
	        }
	        vl.update();
	    };
	    vl.resetFilter = function () {
	        if (vl.params.showFilteredItemsOnly) {
	            vl.filteredItems = [];
	        }
	        else {
	            vl.filteredItems = null;
	            delete vl.filteredItems;    
	        }
	        vl.update();
	    };
	
	    var pageHeight, rowsPerScreen, rowsBefore, rowsAfter, rowsToRender, maxBufferHeight = 0, listHeight;
	    var dynamicHeight = typeof vl.params.height === 'function';
	
	    // Set list size
	    vl.setListSize = function () {
	        var items = vl.filteredItems || vl.items;
	        pageHeight = vl.pageContent[0].offsetHeight;
	        if (dynamicHeight) {
	            listHeight = 0;
	            vl.heights = [];
	            for (var i = 0; i < items.length; i++) {
	                var itemHeight = vl.params.height(items[i]);
	                listHeight += itemHeight;
	                vl.heights.push(itemHeight);
	            }
	        }
	        else {
	            listHeight = Math.ceil(items.length /  vl.params.cols) * vl.params.height;
	            rowsPerScreen = Math.ceil(pageHeight / vl.params.height);
	            rowsBefore = vl.params.rowsBefore || rowsPerScreen * 2;
	            rowsAfter = vl.params.rowsAfter || rowsPerScreen;
	            rowsToRender = (rowsPerScreen + rowsBefore + rowsAfter);
	            maxBufferHeight = rowsBefore / 2 * vl.params.height;
	        }
	
	        if (updatableScroll) {
	            vl.ul.css({height: listHeight + 'px'});
	        }
	    };
	
	    // Render items
	    vl.render = function (force, forceScrollTop) {
	        if (force) vl.lastRepaintY = null;
	
	        var scrollTop = -(vl.listBlock[0].getBoundingClientRect().top - vl.pageContent[0].getBoundingClientRect().top);
	
	        if (typeof forceScrollTop !== 'undefined') scrollTop = forceScrollTop;
	
	        if (vl.lastRepaintY === null || Math.abs(scrollTop - vl.lastRepaintY) > maxBufferHeight || (!updatableScroll && (vl.pageContent[0].scrollTop + pageHeight >= vl.pageContent[0].scrollHeight))) {
	            vl.lastRepaintY = scrollTop;
	        }
	        else {
	            return;
	        }
	
	        var items = vl.filteredItems || vl.items, 
	            fromIndex, toIndex, heightBeforeFirstItem = 0, heightBeforeLastItem = 0;
	        if (dynamicHeight) {
	            var itemTop = 0, j, itemHeight; 
	            maxBufferHeight = pageHeight;
	
	            for (j = 0; j < vl.heights.length; j++) {
	                itemHeight = vl.heights[j];
	                if (typeof fromIndex === 'undefined') {
	                    if (itemTop + itemHeight >= scrollTop - pageHeight * 2 * vl.params.dynamicHeightBufferSize) fromIndex = j;
	                    else heightBeforeFirstItem += itemHeight;
	                }
	
	                if (typeof toIndex === 'undefined') {
	                    if (itemTop + itemHeight >= scrollTop + pageHeight * 2 * vl.params.dynamicHeightBufferSize || j === vl.heights.length - 1) toIndex = j + 1;
	                    heightBeforeLastItem += itemHeight;
	                }
	                itemTop += itemHeight;
	            }
	            toIndex = Math.min(toIndex, items.length);
	        }
	        else {
	            fromIndex = (parseInt(scrollTop / vl.params.height) - rowsBefore) * vl.params.cols;
	            if (fromIndex < 0) {
	                fromIndex = 0;
	            }
	            toIndex = Math.min(fromIndex + rowsToRender * vl.params.cols, items.length);
	        }
	
	        var topPosition;
	        vl.reachEnd = false;
	        for (var i = fromIndex; i < toIndex; i++) {
	            var item, index;
	            // Define real item index
	            index = vl.items.indexOf(items[i]);
	
	            if (i === fromIndex) vl.currentFromIndex = index;
	            if (i === toIndex - 1) vl.currentToIndex = index;
	            if (vl.filteredItems) {
	                if (vl.items[index] === vl.filteredItems[vl.filteredItems.length - 1]) vl.reachEnd = true;
	            }
	            else {
	                if (index === vl.items.length - 1) vl.reachEnd = true;
	            }
	
	            // Find items
	            if (vl.domCache[index]) {
	                item = vl.domCache[index];
	            }
	            else {
	                if (vl.template && !vl.params.renderItem) {
	                    vl.tempDomElement.innerHTML = vl.template(items[i], {index: index}).trim();
	                }
	                else if (vl.params.renderItem) {
	                    vl.tempDomElement.innerHTML = vl.params.renderItem(index, items[i]).trim();
	                }
	                else {
	                    vl.tempDomElement.innerHTML = items[i].toString().trim();
	                }
	                item = vl.tempDomElement.childNodes[0];
	                if (vl.params.cache) vl.domCache[index] = item;
	            }
	            item.f7VirtualListIndex = index;
	
	            // Set item top position
	            if (i === fromIndex) {
	                if (dynamicHeight) {
	                    topPosition = heightBeforeFirstItem;
	                }
	                else {
	                    topPosition = (i * vl.params.height / vl.params.cols);
	                }
	            }
	            item.style.top = topPosition + 'px';
	
	            // Before item insert
	            if (vl.params.onItemBeforeInsert) vl.params.onItemBeforeInsert(vl, item);
	
	            // Append item to fragment
	            vl.fragment.appendChild(item);
	
	
	        }
	
	        // Update list height with not updatable scroll
	        if (!updatableScroll) {
	            if (dynamicHeight) {
	                vl.ul[0].style.height = heightBeforeLastItem + 'px';
	            }
	            else {
	                vl.ul[0].style.height = i * vl.params.height / vl.params.cols + 'px';
	            }
	        }
	
	        // Update list html
	        if (vl.params.onBeforeClear) vl.params.onBeforeClear(vl, vl.fragment);
	        vl.ul[0].innerHTML = '';
	
	        if (vl.params.onItemsBeforeInsert) vl.params.onItemsBeforeInsert(vl, vl.fragment);
	        if (items && items.length === 0) {
	            vl.reachEnd = true;
	            if (vl.params.emptyTemplate) vl.ul[0].innerHTML = vl.params.emptyTemplate;
	        }
	        else {
	            vl.ul[0].appendChild(vl.fragment);
	        }
	        
	        if (vl.params.onItemsAfterInsert) vl.params.onItemsAfterInsert(vl, vl.fragment);
	
	        if (typeof forceScrollTop !== 'undefined' && force) {
	            vl.pageContent.scrollTop(forceScrollTop, 0);
	        }
	    };
	
	    vl.scrollToItem = function (index) {
	        if (index > vl.items.length) return false;
	
	        var itemTop = 0, listTop;
	        if (dynamicHeight) {
	            for (var i = 0; i < index; i++) {
	                itemTop += vl.heights[i];
	            }
	        }
	        else {
	            itemTop = index * vl.params.height;
	        }
	        listTop = vl.listBlock[0].offsetTop;
	        vl.render(true, listTop + itemTop - parseInt(vl.pageContent.css('padding-top'), 10));
	        return true;
	    };
	
	    // Handle scroll event
	    vl.handleScroll = function (e) {
	        vl.render();
	    };
	    // Handle resize event
	    vl._isVisible = function (el) {
	        return !!( el.offsetWidth || el.offsetHeight || el.getClientRects().length );
	    };
	    vl.handleResize = function (e) {
	        if (vl._isVisible(vl.listBlock[0])) {
	            vl.setListSize();
	            vl.render(true);
	        }
	    };
	
	    vl.attachEvents = function (detach) {
	        var action = detach ? 'off' : 'on';
	        vl.pageContent[action]('scroll', vl.handleScroll);
	        vl.listBlock.parents('.tab').eq(0)[action]('tab:show', vl.handleResize);
	        vl.listBlock.parents('.panel').eq(0)[action]('panel:open', vl.handleResize);
	        vl.listBlock.parents('.popup').eq(0)[action]('popup:open', vl.handleResize);
	        $(window)[action]('resize', vl.handleResize);
	    };
	
	    // Init Virtual List
	    vl.init = function () {
	        vl.attachEvents();
	        vl.setListSize();
	        vl.render();
	    };
	
	    // Append
	    vl.appendItems = function (items) {
	        for (var i = 0; i < items.length; i++) {
	            vl.items.push(items[i]);
	        }
	        vl.update();
	    };
	    vl.appendItem = function (item) {
	        vl.appendItems([item]);
	    };
	    // Replace
	    vl.replaceAllItems = function (items) {
	        vl.items = items;
	        delete vl.filteredItems;
	        vl.domCache = {};
	        vl.update();
	    };
	    vl.replaceItem = function (index, item) {
	        vl.items[index] = item;
	        if (vl.params.cache) delete vl.domCache[index];
	        vl.update();
	    };
	    // Prepend
	    vl.prependItems = function (items) {
	        for (var i = items.length - 1; i >= 0; i--) {
	            vl.items.unshift(items[i]);
	        }
	        if (vl.params.cache) {
	            var newCache = {};
	            for (var cached in vl.domCache) {
	                newCache[parseInt(cached, 10) + items.length] = vl.domCache[cached];
	            }
	            vl.domCache = newCache;
	        }
	        vl.update();
	    };
	    vl.prependItem = function (item) {
	        vl.prependItems([item]);
	    };
	
	    // Move
	    vl.moveItem = function (oldIndex, newIndex) {
	        if (oldIndex === newIndex) return;
	        // remove item from array
	        var item = vl.items.splice(oldIndex, 1)[0];
	        if (newIndex >= vl.items.length) {
	            // Add item to the end
	            vl.items.push(item);
	            newIndex = vl.items.length - 1;
	        }
	        else {
	            // Add item to new index
	            vl.items.splice(newIndex, 0, item);
	        }
	        // Update cache
	        if (vl.params.cache) {
	            var newCache = {};
	            for (var cached in vl.domCache) {
	                var cachedIndex = parseInt(cached, 10);
	                var leftIndex = oldIndex < newIndex ? oldIndex : newIndex;
	                var rightIndex = oldIndex < newIndex ? newIndex : oldIndex;
	                var indexShift = oldIndex < newIndex ? -1 : 1;
	                if (cachedIndex < leftIndex || cachedIndex > rightIndex) newCache[cachedIndex] = vl.domCache[cachedIndex];
	                if (cachedIndex === leftIndex) newCache[rightIndex] = vl.domCache[cachedIndex];
	                if (cachedIndex > leftIndex && cachedIndex <= rightIndex) newCache[cachedIndex + indexShift] = vl.domCache[cachedIndex];
	            }
	            vl.domCache = newCache;
	        }
	        vl.update();
	    };
	    // Insert before
	    vl.insertItemBefore = function (index, item) {
	        if (index === 0) {
	            vl.prependItem(item);
	            return;
	        }
	        if (index >= vl.items.length) {
	            vl.appendItem(item);
	            return;
	        }
	        vl.items.splice(index, 0, item);
	        // Update cache
	        if (vl.params.cache) {
	            var newCache = {};
	            for (var cached in vl.domCache) {
	                var cachedIndex = parseInt(cached, 10);
	                if (cachedIndex >= index) {
	                    newCache[cachedIndex + 1] = vl.domCache[cachedIndex];
	                }
	            }
	            vl.domCache = newCache;
	        }
	        vl.update();
	    };
	    // Delete
	    vl.deleteItems = function (indexes) {
	        var prevIndex, indexShift = 0;
	        for (var i = 0; i < indexes.length; i++) {
	            var index = indexes[i];
	            if (typeof prevIndex !== 'undefined') {
	                if (index > prevIndex) {
	                    indexShift = -i;
	                }
	            }
	            index = index + indexShift;
	            prevIndex = indexes[i];
	            // Delete item
	            var deletedItem = vl.items.splice(index, 1)[0];
	
	            // Delete from filtered
	            if (vl.filteredItems && vl.filteredItems.indexOf(deletedItem) >= 0) {
	                vl.filteredItems.splice(vl.filteredItems.indexOf(deletedItem), 1);
	            }
	            // Update cache
	            if (vl.params.cache) {
	                var newCache = {};
	                for (var cached in vl.domCache) {
	                    var cachedIndex = parseInt(cached, 10);
	                    if (cachedIndex === index) {
	                        delete vl.domCache[index];
	                    }
	                    else if (parseInt(cached, 10) > index) {
	                        newCache[cachedIndex - 1] = vl.domCache[cached];
	                    }
	                    else {
	                        newCache[cachedIndex] = vl.domCache[cached];   
	                    }
	                }
	                vl.domCache = newCache;
	            }
	        }
	        vl.update();
	    };
	    vl.deleteAllItems = function () {
	        vl.items = [];
	        delete vl.filteredItems;
	        if (vl.params.cache) vl.domCache = {};
	        vl.update();
	    };
	    vl.deleteItem = function (index) {
	        vl.deleteItems([index]);
	    };
	
	    // Clear cache
	    vl.clearCache = function () {
	        vl.domCache = {};
	    };
	
	    // Update Virtual List
	    vl.update = function () {
	        vl.setListSize();
	        vl.render(true);
	    };
	
	    // Destroy
	    vl.destroy = function () {
	        vl.attachEvents(true);
	        delete vl.items;
	        delete vl.domCache;
	    };
	
	    // Init Virtual List
	    vl.init();
	
	    // Store vl in container
	    vl.listBlock[0].f7VirtualList = vl;
	    return vl;
	};
	
	// App Method
	app.virtualList = function (listBlock, params) {
	    return new VirtualList(listBlock, params);
	};
	
	app.reinitVirtualList = function (pageContainer) {
	    var page = $(pageContainer);
	    var vlists = page.find('.virtual-list');
	    if (vlists.length === 0) return;
	    for (var i = 0; i < vlists.length; i++) {
	        var vlistInstance = vlists[i].f7VirtualList;
	        if (vlistInstance) {
	            vlistInstance.update();
	        }
	    }
	};
	/*===========================
	Compile Template7 Templates On App Init
	===========================*/
	app.initTemplate7Templates = function () {
	    if (!window.Template7) return;
	    Template7.templates = Template7.templates || app.params.templates || {};
	    Template7.data = Template7.data || app.params.template7Data || {};
	    Template7.cache = Template7.cache || {};
	
	    app.templates = Template7.templates;
	    app.template7Data = Template7.data;
	    app.template7Cache = Template7.cache;
	
	    // Precompile templates on app init
	    if (!app.params.precompileTemplates) return;
	    $('script[type="text/template7"]').each(function () {
	        var id = $(this).attr('id');
	        if (!id) return;
	        Template7.templates[id] = Template7.compile($(this).html());
	    });
	};
	
	/*=======================================
	************   Plugins API   ************
	=======================================*/
	var _plugins = [];
	app.initPlugins = function () {
	    // Initialize plugins
	    for (var plugin in app.plugins) {
	        var p = app.plugins[plugin](app, app.params[plugin]);
	        if (p) _plugins.push(p);
	    }
	};
	// Plugin Hooks
	app.pluginHook = function (hook) {
	    for (var i = 0; i < _plugins.length; i++) {
	        if (_plugins[i].hooks && hook in _plugins[i].hooks) {
	            _plugins[i].hooks[hook](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	        }
	    }
	};
	// Prevented by plugin
	app.pluginPrevent = function (action) {
	    var prevent = false;
	    for (var i = 0; i < _plugins.length; i++) {
	        if (_plugins[i].prevents && action in _plugins[i].prevents) {
	            if (_plugins[i].prevents[action](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5])) prevent = true;
	        }
	    }
	    return prevent;
	};
	// Preprocess content by plugin
	app.pluginProcess = function (process, data) {
	    var processed = data;
	    for (var i = 0; i < _plugins.length; i++) {
	        if (_plugins[i].preprocess && process in _plugins[i].preprocess) {
	            processed = _plugins[i].preprocess[process](data, arguments[2], arguments[3], arguments[4], arguments[5], arguments[6]);
	        }
	    }
	    return processed;
	};
	
	
	/*======================================================
	************   App Init   ************
	======================================================*/
	app.init = function () {
	    // Compile Template7 templates on app load
	    if (app.initTemplate7Templates) app.initTemplate7Templates();
	    
	    // Init Plugins
	    if (app.initPlugins) app.initPlugins();
	    
	    // Init Device
	    if (app.getDeviceInfo) app.getDeviceInfo();
	    
	    // Init Click events
	    if (app.initFastClicks && app.params.fastClicks) app.initFastClicks();
	    if (app.initClickEvents) app.initClickEvents();
	
	    // Init each page callbacks
	    $('.page:not(.cached)').each(function () {
	        app.initPageWithCallback(this);
	    });
	
	    // Init each navbar callbacks
	    $('.navbar:not(.cached)').each(function () {
	        app.initNavbarWithCallback(this); 
	    });
	    
	    // Init resize events
	    if (app.initResize) app.initResize();
	
	    // Init push state
	    if (app.initPushState && app.params.pushState) app.initPushState();
	
	    // Init Live Swipeouts events
	    if (app.initSwipeout && app.params.swipeout) app.initSwipeout();
	
	    // Init Live Sortable events
	    if (app.initSortable && app.params.sortable) app.initSortable();
	
	    // Init Live Swipe Panels
	    if (app.initSwipePanels && (app.params.swipePanel || app.params.swipePanelOnlyClose)) app.initSwipePanels();
	    
	    // Init Material Inputs
	    if (app.params.material && app.initMaterialWatchInputs) app.initMaterialWatchInputs();
	
	    // Init Material Tabbar
	    if (app.params.material) {
	        $('.tabbar').each(function (index, el) {
	            if ($(el).parents('.page').length === 0) {
	                app.initMaterialTabbar(el);
	            }
	        });
	    }
	    
	    // App Init callback
	    if (app.params.onAppInit) app.params.onAppInit();
	
	    // Plugin app init hook
	    app.pluginHook('appInit');
	};
	if (app.params.init) app.init();
	
	    //Return instance        
	    return app;
	};
	
	/*===========================
	Dom7 Library
	===========================*/
	var Dom7 = (function () {
	    var Dom7 = function (arr) {
	        var _this = this, i = 0;
	        // Create array-like object
	        for (i = 0; i < arr.length; i++) {
	            _this[i] = arr[i];
	        }
	        _this.length = arr.length;
	        // Return collection with methods
	        return this;
	    };
	    var $ = function (selector, context) {
	        var arr = [], i = 0;
	        if (selector && !context) {
	            if (selector instanceof Dom7) {
	                return selector;
	            }
	        }
	        if (selector) {
	            // String
	            if (typeof selector === 'string') {
	                var els, tempParent, html;
	                selector = html = selector.trim();
	                if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
	                    var toCreate = 'div';
	                    if (html.indexOf('<li') === 0) toCreate = 'ul';
	                    if (html.indexOf('<tr') === 0) toCreate = 'tbody';
	                    if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
	                    if (html.indexOf('<tbody') === 0) toCreate = 'table';
	                    if (html.indexOf('<option') === 0) toCreate = 'select';
	                    tempParent = document.createElement(toCreate);
	                    tempParent.innerHTML = html;
	                    for (i = 0; i < tempParent.childNodes.length; i++) {
	                        arr.push(tempParent.childNodes[i]);
	                    }
	                }
	                else {
	                    if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
	                        // Pure ID selector
	                        els = [document.getElementById(selector.split('#')[1])];
	                    }
	                    else {
	                        // Other selectors
	                        els = (context || document).querySelectorAll(selector);
	                    }
	                    for (i = 0; i < els.length; i++) {
	                        if (els[i]) arr.push(els[i]);
	                    }
	                }
	            }
	            // Node/element
	            else if (selector.nodeType || selector === window || selector === document) {
	                arr.push(selector);
	            }
	            //Array of elements or instance of Dom
	            else if (selector.length > 0 && selector[0].nodeType) {
	                for (i = 0; i < selector.length; i++) {
	                    arr.push(selector[i]);
	                }
	            }
	        }
	        return new Dom7(arr);
	    };
	Dom7.prototype = {
	    // Classes and attributes
	    addClass: function (className) {
	        if (typeof className === 'undefined') {
	            return this;
	        }
	        var classes = className.split(' ');
	        for (var i = 0; i < classes.length; i++) {
	            for (var j = 0; j < this.length; j++) {
	                if (typeof this[j].classList !== 'undefined') this[j].classList.add(classes[i]);
	            }
	        }
	        return this;
	    },
	    removeClass: function (className) {
	        var classes = className.split(' ');
	        for (var i = 0; i < classes.length; i++) {
	            for (var j = 0; j < this.length; j++) {
	                if (typeof this[j].classList !== 'undefined') this[j].classList.remove(classes[i]);
	            }
	        }
	        return this;
	    },
	    hasClass: function (className) {
	        if (!this[0]) return false;
	        else return this[0].classList.contains(className);
	    },
	    toggleClass: function (className) {
	        var classes = className.split(' ');
	        for (var i = 0; i < classes.length; i++) {
	            for (var j = 0; j < this.length; j++) {
	                if (typeof this[j].classList !== 'undefined') this[j].classList.toggle(classes[i]);
	            }
	        }
	        return this;
	    },
	    attr: function (attrs, value) {
	        if (arguments.length === 1 && typeof attrs === 'string') {
	            // Get attr
	            if (this[0]) return this[0].getAttribute(attrs);
	            else return undefined;
	        }
	        else {
	            // Set attrs
	            for (var i = 0; i < this.length; i++) {
	                if (arguments.length === 2) {
	                    // String
	                    this[i].setAttribute(attrs, value);
	                }
	                else {
	                    // Object
	                    for (var attrName in attrs) {
	                        this[i][attrName] = attrs[attrName];
	                        this[i].setAttribute(attrName, attrs[attrName]);
	                    }
	                }
	            }
	            return this;
	        }
	    },
	    removeAttr: function (attr) {
	        for (var i = 0; i < this.length; i++) {
	            this[i].removeAttribute(attr);
	        }
	        return this;
	    },
	    prop: function (props, value) {
	        if (arguments.length === 1 && typeof props === 'string') {
	            // Get prop
	            if (this[0]) return this[0][props];
	        }
	        else {
	            // Set props
	            for (var i = 0; i < this.length; i++) {
	                if (arguments.length === 2) {
	                    // String
	                    this[i][props] = value;
	                }
	                else {
	                    // Object
	                    for (var propName in props) {
	                        this[i][propName] = props[propName];
	                    }
	                }
	            }
	            return this;
	        }
	    },
	    data: function (key, value) {
	        var el;
	        if (typeof value === 'undefined') {
	            el = this[0];
	            // Get value
	            if (el) {
	                if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
	                    return el.dom7ElementDataStorage[key];
	                }
	                else {
	                    var dataKey = el.getAttribute('data-' + key);
	                    if (dataKey) {
	                        return dataKey;
	                    }
	                    else return undefined;
	                }
	            }
	            else return undefined;
	        }
	        else {
	            // Set value
	            for (var i = 0; i < this.length; i++) {
	                el = this[i];
	                if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
	                el.dom7ElementDataStorage[key] = value;
	            }
	            return this;
	        }
	    },
	    removeData: function(key) {
	        for (var i = 0; i < this.length; i++) {
	            var el = this[i];
	            if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
	                el.dom7ElementDataStorage[key] = null;
	                delete el.dom7ElementDataStorage[key];
	            }
	        }
	    },
	    dataset: function () {
	        var el = this[0];
	        if (el) {
	            var dataset = {};
	            if (el.dataset) {
	                for (var dataKey in el.dataset) {
	                    dataset[dataKey] = el.dataset[dataKey];
	                }
	            }
	            else {
	                for (var i = 0; i < el.attributes.length; i++) {
	                    var attr = el.attributes[i];
	                    if (attr.name.indexOf('data-') >= 0) {
	                        dataset[$.toCamelCase(attr.name.split('data-')[1])] = attr.value;
	                    }
	                }
	            }
	            for (var key in dataset) {
	                if (dataset[key] === 'false') dataset[key] = false;
	                else if (dataset[key] === 'true') dataset[key] = true;
	                else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] = dataset[key] * 1;
	            }
	            return dataset;
	        }
	    },
	    val: function (value) {
	        if (typeof value === 'undefined') {
	            if (this[0]) {
	                if (this[0].multiple && this[0].nodeName.toLowerCase() === 'select') {
	                    var values = [];
	                    for (var i = 0; i < this[0].selectedOptions.length; i++) {
	                        values.push(this[0].selectedOptions[i].value);
	                    }
	                    return values;
	                }
	                return this[0].value;
	            }
	            else return undefined;
	        }
	        else {
	            for (var i = 0; i < this.length; i++) {
	                this[i].value = value;
	            }
	            return this;
	        }
	    },
	    // Transforms
	    transform : function (transform) {
	        for (var i = 0; i < this.length; i++) {
	            var elStyle = this[i].style;
	            elStyle.webkitTransform = elStyle.transform = transform;
	        }
	        return this;
	    },
	    transition: function (duration) {
	        if (typeof duration !== 'string') {
	            duration = duration + 'ms';
	        }
	        for (var i = 0; i < this.length; i++) {
	            var elStyle = this[i].style;
	            elStyle.webkitTransitionDuration = elStyle.transitionDuration = duration;
	        }
	        return this;
	    },
	    //Events
	    on: function (eventName, targetSelector, listener, capture) {
	        function handleLiveEvent(e) {
	            var target = e.target;
	            if ($(target).is(targetSelector)) listener.call(target, e);
	            else {
	                var parents = $(target).parents();
	                for (var k = 0; k < parents.length; k++) {
	                    if ($(parents[k]).is(targetSelector)) listener.call(parents[k], e);
	                }
	            }
	        }
	        var events = eventName.split(' ');
	        var i, j;
	        for (i = 0; i < this.length; i++) {
	            if (typeof targetSelector === 'function' || targetSelector === false) {
	                // Usual events
	                if (typeof targetSelector === 'function') {
	                    listener = arguments[1];
	                    capture = arguments[2] || false;
	                }
	                for (j = 0; j < events.length; j++) {
	                    this[i].addEventListener(events[j], listener, capture);
	                }
	            }
	            else {
	                //Live events
	                for (j = 0; j < events.length; j++) {
	                    if (!this[i].dom7LiveListeners) this[i].dom7LiveListeners = [];
	                    this[i].dom7LiveListeners.push({listener: listener, liveListener: handleLiveEvent});
	                    this[i].addEventListener(events[j], handleLiveEvent, capture);
	                }
	            }
	        }
	
	        return this;
	    },
	    off: function (eventName, targetSelector, listener, capture) {
	        var events = eventName.split(' ');
	        for (var i = 0; i < events.length; i++) {
	            for (var j = 0; j < this.length; j++) {
	                if (typeof targetSelector === 'function' || targetSelector === false) {
	                    // Usual events
	                    if (typeof targetSelector === 'function') {
	                        listener = arguments[1];
	                        capture = arguments[2] || false;
	                    }
	                    this[j].removeEventListener(events[i], listener, capture);
	                }
	                else {
	                    // Live event
	                    if (this[j].dom7LiveListeners) {
	                        for (var k = 0; k < this[j].dom7LiveListeners.length; k++) {
	                            if (this[j].dom7LiveListeners[k].listener === listener) {
	                                this[j].removeEventListener(events[i], this[j].dom7LiveListeners[k].liveListener, capture);
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        return this;
	    },
	    once: function (eventName, targetSelector, listener, capture) {
	        var dom = this;
	        if (typeof targetSelector === 'function') {
	            listener = arguments[1];
	            capture = arguments[2];
	            targetSelector = false;
	        }
	        function proxy(e) {
	            listener.call(e.target, e);
	            dom.off(eventName, targetSelector, proxy, capture);
	        }
	        return dom.on(eventName, targetSelector, proxy, capture);
	    },
	    trigger: function (eventName, eventData) {
	        var events = eventName.split(' ');
	        for (var i = 0; i < events.length; i++) {
	            for (var j = 0; j < this.length; j++) {
	                var evt;
	                try {
	                    evt = new CustomEvent(events[i], {detail: eventData, bubbles: true, cancelable: true});
	                }
	                catch (e) {
	                    evt = document.createEvent('Event');
	                    evt.initEvent(events[i], true, true);
	                    evt.detail = eventData;
	                }
	                this[j].dispatchEvent(evt);
	            }
	        }
	        return this;
	    },
	    transitionEnd: function (callback) {
	        var events = ['webkitTransitionEnd', 'transitionend'],
	            i, dom = this;
	        function fireCallBack(e) {
	            /*jshint validthis:true */
	            if (e.target !== this) return;
	            callback.call(this, e);
	            for (i = 0; i < events.length; i++) {
	                dom.off(events[i], fireCallBack);
	            }
	        }
	        if (callback) {
	            for (i = 0; i < events.length; i++) {
	                dom.on(events[i], fireCallBack);
	            }
	        }
	        return this;
	    },
	    animationEnd: function (callback) {
	        var events = ['webkitAnimationEnd', 'animationend'],
	            i, dom = this;
	        function fireCallBack(e) {
	            callback(e);
	            for (i = 0; i < events.length; i++) {
	                dom.off(events[i], fireCallBack);
	            }
	        }
	        if (callback) {
	            for (i = 0; i < events.length; i++) {
	                dom.on(events[i], fireCallBack);
	            }
	        }
	        return this;
	    },
	    // Sizing/Styles
	    width: function () {
	        if (this[0] === window) {
	            return window.innerWidth;
	        }
	        else {
	            if (this.length > 0) {
	                return parseFloat(this.css('width'));
	            }
	            else {
	                return null;
	            }
	        }
	    },
	    outerWidth: function (includeMargins) {
	        if (this.length > 0) {
	            if (includeMargins) {
	                var styles = this.styles();
	                return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));    
	            }
	            else
	                return this[0].offsetWidth;
	        }
	        else return null;
	    },
	    height: function () {
	        if (this[0] === window) {
	            return window.innerHeight;
	        }
	        else {
	            if (this.length > 0) {
	                return parseFloat(this.css('height'));
	            }
	            else {
	                return null;
	            }
	        }
	    },
	    outerHeight: function (includeMargins) {
	        if (this.length > 0) {
	            if (includeMargins) {
	                var styles = this.styles();
	                return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));    
	            }
	            else
	                return this[0].offsetHeight;
	        }
	        else return null;
	    },
	    offset: function () {
	        if (this.length > 0) {
	            var el = this[0];
	            var box = el.getBoundingClientRect();
	            var body = document.body;
	            var clientTop  = el.clientTop  || body.clientTop  || 0;
	            var clientLeft = el.clientLeft || body.clientLeft || 0;
	            var scrollTop  = window.pageYOffset || el.scrollTop;
	            var scrollLeft = window.pageXOffset || el.scrollLeft;
	            return {
	                top: box.top  + scrollTop  - clientTop,
	                left: box.left + scrollLeft - clientLeft
	            };
	        }
	        else {
	            return null;
	        }
	    },
	    hide: function () {
	        for (var i = 0; i < this.length; i++) {
	            this[i].style.display = 'none';
	        }
	        return this;
	    },
	    show: function () {
	        for (var i = 0; i < this.length; i++) {
	            this[i].style.display = 'block';
	        }
	        return this;
	    },
	    styles: function () {
	        if (this[0]) return window.getComputedStyle(this[0], null);
	    },
	    css: function (props, value) {
	        var i;
	        if (arguments.length === 1) {
	            if (typeof props === 'string') {
	                if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
	            }
	            else {
	                for (i = 0; i < this.length; i++) {
	                    for (var prop in props) {
	                        this[i].style[prop] = props[prop];
	                    }
	                }
	                return this;
	            }
	        }
	        if (arguments.length === 2 && typeof props === 'string') {
	            for (i = 0; i < this.length; i++) {
	                this[i].style[props] = value;
	            }
	            return this;
	        }
	        return this;
	    },
	
	    //Dom manipulation
	    // Iterate over the collection passing elements to `callback`
	    each: function (callback) {
	        // Don't bother continuing without a callback
	        if (!callback) return this;
	        // Iterate over the current collection
	        for (var i = 0; i < this.length; i++) {
	            // If the callback returns false
	            if (callback.call(this[i], i, this[i]) === false) {
	                // End the loop early
	                return this;
	            }
	        }
	        // Return `this` to allow chained DOM operations
	        return this;
	    },
	    filter: function (callback) {
	        var matchedItems = [];
	        var dom = this;
	        for (var i = 0; i < dom.length; i++) {
	            if (callback.call(dom[i], i, dom[i])) matchedItems.push(dom[i]);
	        }
	        return new Dom7(matchedItems);
	    },
	    html: function (html) {
	        if (typeof html === 'undefined') {
	            return this[0] ? this[0].innerHTML : undefined;
	        }
	        else {
	            for (var i = 0; i < this.length; i++) {
	                this[i].innerHTML = html;
	            }
	            return this;
	        }
	    },
	    text: function (text) {
	        if (typeof text === 'undefined') {
	            if (this[0]) {
	                return this[0].textContent.trim();
	            }
	            else return null;
	        }
	        else {
	            for (var i = 0; i < this.length; i++) {
	                this[i].textContent = text;
	            }
	            return this;
	        }
	    },
	    is: function (selector) {
	        var compareWith, i, el = this[0];
	        if (!el || typeof selector === 'undefined') return false;
	        if (typeof selector === 'string') {
	            if (el.matches) return el.matches(selector);
	            else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
	            else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
	            else {
	                compareWith = $(selector);
	                for (i = 0; i < compareWith.length; i++) {
	                    if (compareWith[i] === el) return true;
	                }
	                return false;
	            }
	        }
	        else if (selector === document) return el === document;
	        else if (selector === window) return el === window;
	        else {
	            if (selector.nodeType || selector instanceof Dom7) {
	                compareWith = selector.nodeType ? [selector] : selector;
	                for (i = 0; i < compareWith.length; i++) {
	                    if (compareWith[i] === el) return true;
	                }
	                return false;
	            }
	            return false;
	        }
	
	    },
	    indexOf: function (el) {
	        for (var i = 0; i < this.length; i++) {
	            if (this[i] === el) return i;
	        }
	    },
	    index: function () {
	        var i, child = this[0];
	        if (child) {
	            i = 0;
	            while ((child = child.previousSibling) !== null) {
	                if (child.nodeType === 1) i++;
	            }
	            return i;
	        }
	    },
	    eq: function (index) {
	        if (typeof index === 'undefined') return this;
	        var length = this.length;
	        var returnIndex;
	        if (index > length - 1) {
	            return new Dom7([]);
	        }
	        if (index < 0) {
	            returnIndex = length + index;
	            if (returnIndex < 0) return new Dom7([]);
	            else return new Dom7([this[returnIndex]]);
	        }
	        return new Dom7([this[index]]);
	    },
	    append: function () {
	        var i, j, k, newChild;
	
	        for (k = 0; k < arguments.length; k++) {
	          newChild = arguments[k];
	
	          for (i = 0; i < this.length; i++) {
	              if (typeof newChild === 'string') {
	                  var tempDiv = document.createElement('div');
	                  tempDiv.innerHTML = newChild;
	                  while (tempDiv.firstChild) {
	                      this[i].appendChild(tempDiv.firstChild);
	                  }
	              }
	              else if (newChild instanceof Dom7) {
	                  for (j = 0; j < newChild.length; j++) {
	                      this[i].appendChild(newChild[j]);
	                  }
	              }
	              else {
	                  this[i].appendChild(newChild);
	              }
	          }
	        }
	
	        return this;
	    },
	    appendTo: function (parent) {
	        $(parent).append(this);
	        return this;
	    },
	    prepend: function (newChild) {
	        var i, j;
	        for (i = 0; i < this.length; i++) {
	            if (typeof newChild === 'string') {
	                var tempDiv = document.createElement('div');
	                tempDiv.innerHTML = newChild;
	                for (j = tempDiv.childNodes.length - 1; j >= 0; j--) {
	                    this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
	                }
	                // this[i].insertAdjacentHTML('afterbegin', newChild);
	            }
	            else if (newChild instanceof Dom7) {
	                for (j = 0; j < newChild.length; j++) {
	                    this[i].insertBefore(newChild[j], this[i].childNodes[0]);
	                }
	            }
	            else {
	                this[i].insertBefore(newChild, this[i].childNodes[0]);
	            }
	        }
	        return this;
	    },
	    prependTo: function (parent) {
	        $(parent).prepend(this);
	        return this;
	    },
	    insertBefore: function (selector) {
	        var before = $(selector);
	        for (var i = 0; i < this.length; i++) {
	            if (before.length === 1) {
	                before[0].parentNode.insertBefore(this[i], before[0]);
	            }
	            else if (before.length > 1) {
	                for (var j = 0; j < before.length; j++) {
	                    before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
	                }
	            }
	        }
	    },
	    insertAfter: function (selector) {
	        var after = $(selector);
	        for (var i = 0; i < this.length; i++) {
	            if (after.length === 1) {
	                after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
	            }
	            else if (after.length > 1) {
	                for (var j = 0; j < after.length; j++) {
	                    after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
	                }
	            }
	        }
	    },
	    next: function (selector) {
	        if (this.length > 0) {
	            if (selector) {
	                if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return new Dom7([this[0].nextElementSibling]);
	                else return new Dom7([]);
	            }
	            else {
	                if (this[0].nextElementSibling) return new Dom7([this[0].nextElementSibling]);
	                else return new Dom7([]);
	            }
	        }
	        else return new Dom7([]);
	    },
	    nextAll: function (selector) {
	        var nextEls = [];
	        var el = this[0];
	        if (!el) return new Dom7([]);
	        while (el.nextElementSibling) {
	            var next = el.nextElementSibling;
	            if (selector) {
	                if($(next).is(selector)) nextEls.push(next);
	            }
	            else nextEls.push(next);
	            el = next;
	        }
	        return new Dom7(nextEls);
	    },
	    prev: function (selector) {
	        if (this.length > 0) {
	            var el = this[0];
	            if (selector) {
	                if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) return new Dom7([el.previousElementSibling]);
	                else return new Dom7([]);
	            }
	            else {
	                if (el.previousElementSibling) return new Dom7([el.previousElementSibling]);
	                else return new Dom7([]);
	            }
	        }
	        else return new Dom7([]);
	    },
	    prevAll: function (selector) {
	        var prevEls = [];
	        var el = this[0];
	        if (!el) return new Dom7([]);
	        while (el.previousElementSibling) {
	            var prev = el.previousElementSibling;
	            if (selector) {
	                if($(prev).is(selector)) prevEls.push(prev);
	            }
	            else prevEls.push(prev);
	            el = prev;
	        }
	        return new Dom7(prevEls);
	    },
	    siblings: function (selector) {
	        return this.nextAll(selector).add(this.prevAll(selector));
	    },
	    parent: function (selector) {
	        var parents = [];
	        for (var i = 0; i < this.length; i++) {
	            if (this[i].parentNode !== null) {
	                if (selector) {
	                    if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
	                }
	                else {
	                   parents.push(this[i].parentNode);
	                }
	            }
	        }
	        return $($.unique(parents));
	    },
	    parents: function (selector) {
	        var parents = [];
	        for (var i = 0; i < this.length; i++) {
	            var parent = this[i].parentNode;
	            while (parent) {
	                if (selector) {
	                    if ($(parent).is(selector)) parents.push(parent);
	                }
	                else {
	                    parents.push(parent);
	                }
	                parent = parent.parentNode;
	            }
	        }
	        return $($.unique(parents));
	    },
	    closest: function (selector) {
	        var closest = this;
	        if (typeof selector === 'undefined') {
	            return new Dom7([]);
	        }
	        if (!closest.is(selector)) {
	            closest = closest.parents(selector).eq(0);
	        }
	        return closest;
	    },
	    find : function (selector) {
	        var foundElements = [];
	        for (var i = 0; i < this.length; i++) {
	            var found = this[i].querySelectorAll(selector);
	            for (var j = 0; j < found.length; j++) {
	                foundElements.push(found[j]);
	            }
	        }
	        return new Dom7(foundElements);
	    },
	    children: function (selector) {
	        var children = [];
	        for (var i = 0; i < this.length; i++) {
	            var childNodes = this[i].childNodes;
	
	            for (var j = 0; j < childNodes.length; j++) {
	                if (!selector) {
	                    if (childNodes[j].nodeType === 1) children.push(childNodes[j]);
	                }
	                else {
	                    if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) children.push(childNodes[j]);
	                }
	            }
	        }
	        return new Dom7($.unique(children));
	    },
	    remove: function () {
	        for (var i = 0; i < this.length; i++) {
	            if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
	        }
	        return this;
	    },
	    detach: function () {
	        return this.remove();
	    },
	    add: function () {
	        var dom = this;
	        var i, j;
	        for (i = 0; i < arguments.length; i++) {
	            var toAdd = $(arguments[i]);
	            for (j = 0; j < toAdd.length; j++) {
	                dom[dom.length] = toAdd[j];
	                dom.length++;
	            }
	        }
	        return dom;
	    },
	    empty: function () {
	        for (var i = 0; i < this.length; i++) {
	            var el = this[i];
	            if (el.nodeType === 1) {
	                for (var j = 0; j < el.childNodes.length; j++) {
	                    if (el.childNodes[j].parentNode) el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
	                }
	                el.textContent = '';
	            }
	        }
	        return this;
	    }
	};
	
	// Shortcuts
	(function () {
	    var shortcuts = ('click blur focus focusin focusout keyup keydown keypress submit change mousedown mousemove mouseup mouseenter mouseleave mouseout mouseover touchstart touchend touchmove resize scroll').split(' ');
	    var notTrigger = ('resize scroll').split(' ');
	    function createMethod(name) {
	        Dom7.prototype[name] = function (targetSelector, listener, capture) {
	            var i;
	            if (typeof targetSelector === 'undefined') {
	                for (i = 0; i < this.length; i++) {
	                    if (notTrigger.indexOf(name) < 0) {
	                        if (name in this[i]) this[i][name]();
	                        else {
	                            $(this[i]).trigger(name);
	                        }
	                    }
	                }
	                return this;
	            }
	            else {
	                return this.on(name, targetSelector, listener, capture);
	            }
	        };
	    }
	    for (var i = 0; i < shortcuts.length; i++) {
	        createMethod(shortcuts[i]);
	    }
	})();
	
	// DOM Library Utilities
	$.parseUrlQuery= function (url) {
	    url = url || location.href;
	    var query = {},i, params, param, length;
	    if (typeof url === 'string' && url.length)  {
	        url = url.indexOf('?')>-1 ? url.replace(/\S*\?/,'') : '';
	        params = url.split('&'), length = params.length;
	
	        for (i = 0; i < length; i++) {
	            param = params[i].replace(/#\S+/g,'').split('=');
	            query[decodeURIComponent(param[0])] = decodeURIComponent(param[1]) || '';
	        }
	    }
	
	    return query;
	};
	$.isArray = function (arr) {
	    if (Object.prototype.toString.apply(arr) === '[object Array]') return true;
	    else return false;
	};
	$.each = function (obj, callback) {
	    // Check it's iterable
	    // TODO: Should probably raise a value error here
	    if (typeof obj !== 'object') return;
	    // Don't bother continuing without a callback
	    if (!callback) return;
	    if ($.isArray(obj) || obj instanceof Dom7) {
	        var i;
	        // Array
	        for (i = 0; i < obj.length; i++) {
	            // If callback returns false
	            if (callback(i, obj[i]) === false) {
	                // Break out of the loop
	                return;
	            }
	        }
	    }
	    else {
	        var prop;
	        // Object
	        for (prop in obj) {
	            // Check the propertie belongs to the object
	            // not it's prototype
	            if (obj.hasOwnProperty(prop)) {
	                // If the callback returns false
	                if (callback(prop, obj[prop]) === false) {
	                    // Break out of the loop;
	                    return;
	                }
	            }
	        }
	    }
	};
	$.unique = function (arr) {
	    var unique = [];
	    for (var i = 0; i < arr.length; i++) {
	        if (unique.indexOf(arr[i]) === -1) unique.push(arr[i]);
	    }
	    return unique;
	};
	$.serializeObject = $.param = function (obj, parents) {
	    if (typeof obj === 'string') return obj;
	    var resultArray = [];
	    var separator = '&';
	    parents = parents || [];
	    var newParents;
	    function var_name(name) {
	        if (parents.length > 0) {
	            var _parents = '';
	            for (var j = 0; j < parents.length; j++) {
	                if (j === 0) _parents += parents[j];
	                else _parents += '[' + encodeURIComponent(parents[j]) + ']';
	            }
	            return _parents + '[' + encodeURIComponent(name) + ']';
	        }
	        else {
	            return encodeURIComponent(name);
	        }
	    }
	    function var_value(value) {
	        return encodeURIComponent(value);
	    }
	    for (var prop in obj) {
	        if (obj.hasOwnProperty(prop)) {
	            var toPush;
	            if ($.isArray(obj[prop])) {
	                toPush = [];
	                for (var i = 0; i < obj[prop].length; i ++) {
	                    if (!$.isArray(obj[prop][i]) && typeof obj[prop][i] === 'object') {
	                        newParents = parents.slice();
	                        newParents.push(prop);
	                        newParents.push(i + '');
	                        toPush.push($.serializeObject(obj[prop][i], newParents));
	                    }
	                    else {
	                        toPush.push(var_name(prop) + '[]=' + var_value(obj[prop][i]));
	                    }
	
	                }
	                if (toPush.length > 0) resultArray.push(toPush.join(separator));
	            }
	            else if (obj[prop] === null) {
	                resultArray.push(var_name(prop) + '=');
	            }
	            else if (typeof obj[prop] === 'object') {
	                // Object, convert to named array
	                newParents = parents.slice();
	                newParents.push(prop);
	                toPush = $.serializeObject(obj[prop], newParents);
	                if (toPush !== '') resultArray.push(toPush);
	            }
	            else if (typeof obj[prop] !== 'undefined' && obj[prop] !== '') {
	                // Should be string or plain value
	                resultArray.push(var_name(prop) + '=' + var_value(obj[prop]));
	            }
	            else if (obj[prop] === '') resultArray.push(var_name(prop));
	        }
	    }
	    return resultArray.join(separator);
	};
	$.toCamelCase = function (string) {
	    return string.toLowerCase().replace(/-(.)/g, function(match, group1) {
	        return group1.toUpperCase();
	    });
	};
	$.dataset = function (el) {
	    return $(el).dataset();
	};
	$.getTranslate = function (el, axis) {
	    var matrix, curTransform, curStyle, transformMatrix;
	
	    // automatic axis detection
	    if (typeof axis === 'undefined') {
	        axis = 'x';
	    }
	
	    curStyle = window.getComputedStyle(el, null);
	    if (window.WebKitCSSMatrix) {
	        curTransform = curStyle.transform || curStyle.webkitTransform;
	        if (curTransform.split(',').length > 6) {
	            curTransform = curTransform.split(', ').map(function(a){
	                return a.replace(',','.');
	            }).join(', ');
	        }
	        // Some old versions of Webkit choke when 'none' is passed; pass
	        // empty string instead in this case
	        transformMatrix = new WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
	    }
	    else {
	        transformMatrix = curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
	        matrix = transformMatrix.toString().split(',');
	    }
	
	    if (axis === 'x') {
	        //Latest Chrome and webkits Fix
	        if (window.WebKitCSSMatrix)
	            curTransform = transformMatrix.m41;
	        //Crazy IE10 Matrix
	        else if (matrix.length === 16)
	            curTransform = parseFloat(matrix[12]);
	        //Normal Browsers
	        else
	            curTransform = parseFloat(matrix[4]);
	    }
	    if (axis === 'y') {
	        //Latest Chrome and webkits Fix
	        if (window.WebKitCSSMatrix)
	            curTransform = transformMatrix.m42;
	        //Crazy IE10 Matrix
	        else if (matrix.length === 16)
	            curTransform = parseFloat(matrix[13]);
	        //Normal Browsers
	        else
	            curTransform = parseFloat(matrix[5]);
	    }
	    
	    return curTransform || 0;
	};
	
	$.requestAnimationFrame = function (callback) {
	    if (window.requestAnimationFrame) return window.requestAnimationFrame(callback);
	    else if (window.webkitRequestAnimationFrame) return window.webkitRequestAnimationFrame(callback);
	    else {
	        return window.setTimeout(callback, 1000 / 60);
	    }
	};
	$.cancelAnimationFrame = function (id) {
	    if (window.cancelAnimationFrame) return window.cancelAnimationFrame(id);
	    else if (window.webkitCancelAnimationFrame) return window.webkitCancelAnimationFrame(id);
	    else {
	        return window.clearTimeout(id);
	    }  
	};
	$.supportTouch = !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
	
	// Remove Diacritics
	var defaultDiacriticsRemovalap = [
	    {base:'A', letters:'\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'},
	    {base:'AA',letters:'\uA732'},
	    {base:'AE',letters:'\u00C6\u01FC\u01E2'},
	    {base:'AO',letters:'\uA734'},
	    {base:'AU',letters:'\uA736'},
	    {base:'AV',letters:'\uA738\uA73A'},
	    {base:'AY',letters:'\uA73C'},
	    {base:'B', letters:'\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'},
	    {base:'C', letters:'\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'},
	    {base:'D', letters:'\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'},
	    {base:'DZ',letters:'\u01F1\u01C4'},
	    {base:'Dz',letters:'\u01F2\u01C5'},
	    {base:'E', letters:'\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'},
	    {base:'F', letters:'\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'},
	    {base:'G', letters:'\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'},
	    {base:'H', letters:'\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'},
	    {base:'I', letters:'\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'},
	    {base:'J', letters:'\u004A\u24BF\uFF2A\u0134\u0248'},
	    {base:'K', letters:'\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'},
	    {base:'L', letters:'\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'},
	    {base:'LJ',letters:'\u01C7'},
	    {base:'Lj',letters:'\u01C8'},
	    {base:'M', letters:'\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'},
	    {base:'N', letters:'\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'},
	    {base:'NJ',letters:'\u01CA'},
	    {base:'Nj',letters:'\u01CB'},
	    {base:'O', letters:'\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'},
	    {base:'OI',letters:'\u01A2'},
	    {base:'OO',letters:'\uA74E'},
	    {base:'OU',letters:'\u0222'},
	    {base:'OE',letters:'\u008C\u0152'},
	    {base:'oe',letters:'\u009C\u0153'},
	    {base:'P', letters:'\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'},
	    {base:'Q', letters:'\u0051\u24C6\uFF31\uA756\uA758\u024A'},
	    {base:'R', letters:'\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'},
	    {base:'S', letters:'\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'},
	    {base:'T', letters:'\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'},
	    {base:'TZ',letters:'\uA728'},
	    {base:'U', letters:'\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'},
	    {base:'V', letters:'\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'},
	    {base:'VY',letters:'\uA760'},
	    {base:'W', letters:'\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'},
	    {base:'X', letters:'\u0058\u24CD\uFF38\u1E8A\u1E8C'},
	    {base:'Y', letters:'\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'},
	    {base:'Z', letters:'\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'},
	    {base:'a', letters:'\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'},
	    {base:'aa',letters:'\uA733'},
	    {base:'ae',letters:'\u00E6\u01FD\u01E3'},
	    {base:'ao',letters:'\uA735'},
	    {base:'au',letters:'\uA737'},
	    {base:'av',letters:'\uA739\uA73B'},
	    {base:'ay',letters:'\uA73D'},
	    {base:'b', letters:'\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'},
	    {base:'c', letters:'\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'},
	    {base:'d', letters:'\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'},
	    {base:'dz',letters:'\u01F3\u01C6'},
	    {base:'e', letters:'\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'},
	    {base:'f', letters:'\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'},
	    {base:'g', letters:'\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'},
	    {base:'h', letters:'\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'},
	    {base:'hv',letters:'\u0195'},
	    {base:'i', letters:'\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'},
	    {base:'j', letters:'\u006A\u24D9\uFF4A\u0135\u01F0\u0249'},
	    {base:'k', letters:'\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'},
	    {base:'l', letters:'\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'},
	    {base:'lj',letters:'\u01C9'},
	    {base:'m', letters:'\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'},
	    {base:'n', letters:'\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'},
	    {base:'nj',letters:'\u01CC'},
	    {base:'o', letters:'\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'},
	    {base:'oi',letters:'\u01A3'},
	    {base:'ou',letters:'\u0223'},
	    {base:'oo',letters:'\uA74F'},
	    {base:'p',letters:'\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'},
	    {base:'q',letters:'\u0071\u24E0\uFF51\u024B\uA757\uA759'},
	    {base:'r',letters:'\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'},
	    {base:'s',letters:'\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'},
	    {base:'t',letters:'\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'},
	    {base:'tz',letters:'\uA729'},
	    {base:'u',letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'},
	    {base:'v',letters:'\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'},
	    {base:'vy',letters:'\uA761'},
	    {base:'w',letters:'\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'},
	    {base:'x',letters:'\u0078\u24E7\uFF58\u1E8B\u1E8D'},
	    {base:'y',letters:'\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'},
	    {base:'z',letters:'\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'}
	];
	
	var diacriticsMap = {};
	for (var i=0; i < defaultDiacriticsRemovalap.length; i++){
	    var letters = defaultDiacriticsRemovalap[i].letters;
	    for (var j=0; j < letters.length ; j++){
	        diacriticsMap[letters[j]] = defaultDiacriticsRemovalap[i].base;
	    }
	}
	
	$.removeDiacritics = function (str) {
	    return str.replace(/[^\u0000-\u007E]/g, function(a){
	       return diacriticsMap[a] || a;
	    });
	};
	// Link to prototype
	$.fn = Dom7.prototype;
	
	// Plugins
	$.fn.scrollTo = function (left, top, duration, easing, callback) {
	    if (arguments.length === 4 && typeof easing === 'function') {
	        callback = easing;
	        easing = undefined;
	    }
	    return this.each(function () {
	        var el = this;
	        var currentTop, currentLeft, maxTop, maxLeft, newTop, newLeft, scrollTop, scrollLeft;
	        var animateTop = top > 0 || top === 0;
	        var animateLeft = left > 0 || left === 0;
	        if (typeof easing === 'undefined') {
	            easing = 'swing';
	        }
	        if (animateTop) {
	            currentTop = el.scrollTop;
	            if (!duration) {
	                el.scrollTop = top;
	            }
	        }
	        if (animateLeft) {
	            currentLeft = el.scrollLeft;
	            if (!duration) {
	                el.scrollLeft = left;
	            }
	        }
	        if (!duration) return;
	        if (animateTop) {
	            maxTop = el.scrollHeight - el.offsetHeight;
	            newTop = Math.max(Math.min(top, maxTop), 0);
	        }
	        if (animateLeft) {
	            maxLeft = el.scrollWidth - el.offsetWidth;
	            newLeft = Math.max(Math.min(left, maxLeft), 0);
	        }
	        var startTime = null;
	        if (animateTop && newTop === currentTop) animateTop = false;
	        if (animateLeft && newLeft === currentLeft) animateLeft = false;
	        function render(time) {
	            if (time === undefined) {
	                time = new Date().getTime();
	            }
	            if (startTime === null) {
	                startTime = time;
	            }
	            var done;
	            var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
	            var easeProgress = easing === 'linear' ? progress : (0.5 - Math.cos( progress * Math.PI ) / 2);
	            if (animateTop) scrollTop = currentTop + (easeProgress * (newTop - currentTop));
	            if (animateLeft) scrollLeft = currentLeft + (easeProgress * (newLeft - currentLeft));
	            if (animateTop && newTop > currentTop && scrollTop >= newTop)  {
	                el.scrollTop = newTop;
	                done = true;
	            }
	            if (animateTop && newTop < currentTop && scrollTop <= newTop)  {
	                el.scrollTop = newTop;
	                done = true;
	            }
	
	            if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft)  {
	                el.scrollLeft = newLeft;
	                done = true;
	            }
	            if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft)  {
	                el.scrollLeft = newLeft;
	                done = true;
	            }
	
	            if (done) {
	                if (callback) callback();
	                return;
	            }
	            if (animateTop) el.scrollTop = scrollTop;
	            if (animateLeft) el.scrollLeft = scrollLeft;
	            $.requestAnimationFrame(render);
	        }
	        $.requestAnimationFrame(render);
	    });
	};
	$.fn.scrollTop = function (top, duration, easing, callback) {
	    if (arguments.length === 3 && typeof easing === 'function') {
	        callback = easing;
	        easing = undefined;
	    }
	    var dom = this;
	    if (typeof top === 'undefined') {
	        if (dom.length > 0) return dom[0].scrollTop;
	        else return null;
	    }
	    return dom.scrollTo(undefined, top, duration, easing, callback);
	};
	$.fn.scrollLeft = function (left, duration, easing, callback) {
	    if (arguments.length === 3 && typeof easing === 'function') {
	        callback = easing;
	        easing = undefined;
	    }
	    var dom = this;
	    if (typeof left === 'undefined') {
	        if (dom.length > 0) return dom[0].scrollLeft;
	        else return null;
	    }
	    return dom.scrollTo(left, undefined, duration, easing, callback);
	};
	// Global Ajax Setup
	var globalAjaxOptions = {};
	$.ajaxSetup = function (options) {
	    if (options.type) options.method = options.type;
	    $.each(options, function (optionName, optionValue) {
	        globalAjaxOptions[optionName]  = optionValue;
	    });
	};
	
	// Ajax
	var _jsonpRequests = 0;
	$.ajax = function (options) {
	    var defaults = {
	        method: 'GET',
	        data: false,
	        async: true,
	        cache: true,
	        user: '',
	        password: '',
	        headers: {},
	        xhrFields: {},
	        statusCode: {},
	        processData: true,
	        dataType: 'text',
	        contentType: 'application/x-www-form-urlencoded',
	        timeout: 0
	    };
	    var callbacks = ['beforeSend', 'error', 'complete', 'success', 'statusCode'];
	
	
	    //For jQuery guys
	    if (options.type) options.method = options.type;
	
	    // Merge global and defaults
	    $.each(globalAjaxOptions, function (globalOptionName, globalOptionValue) {
	        if (callbacks.indexOf(globalOptionName) < 0) defaults[globalOptionName] = globalOptionValue;
	    });
	
	    // Function to run XHR callbacks and events
	    function fireAjaxCallback (eventName, eventData, callbackName) {
	        var a = arguments;
	        if (eventName) $(document).trigger(eventName, eventData);
	        if (callbackName) {
	            // Global callback
	            if (callbackName in globalAjaxOptions) globalAjaxOptions[callbackName](a[3], a[4], a[5], a[6]);
	            // Options callback
	            if (options[callbackName]) options[callbackName](a[3], a[4], a[5], a[6]);
	        }
	    }
	
	    // Merge options and defaults
	    $.each(defaults, function (prop, defaultValue) {
	        if (!(prop in options)) options[prop] = defaultValue;
	    });
	
	    // Default URL
	    if (!options.url) {
	        options.url = window.location.toString();
	    }
	    // Parameters Prefix
	    var paramsPrefix = options.url.indexOf('?') >= 0 ? '&' : '?';
	
	    // UC method
	    var _method = options.method.toUpperCase();
	    // Data to modify GET URL
	    if ((_method === 'GET' || _method === 'HEAD' || _method === 'OPTIONS' || _method === 'DELETE') && options.data) {
	        var stringData;
	        if (typeof options.data === 'string') {
	            // Should be key=value string
	            if (options.data.indexOf('?') >= 0) stringData = options.data.split('?')[1];
	            else stringData = options.data;
	        }
	        else {
	            // Should be key=value object
	            stringData = $.serializeObject(options.data);
	        }
	        if (stringData.length) {
	            options.url += paramsPrefix + stringData;
	            if (paramsPrefix === '?') paramsPrefix = '&';
	        }
	    }
	    // JSONP
	    if (options.dataType === 'json' && options.url.indexOf('callback=') >= 0) {
	
	        var callbackName = 'f7jsonp_' + Date.now() + (_jsonpRequests++);
	        var abortTimeout;
	        var callbackSplit = options.url.split('callback=');
	        var requestUrl = callbackSplit[0] + 'callback=' + callbackName;
	        if (callbackSplit[1].indexOf('&') >= 0) {
	            var addVars = callbackSplit[1].split('&').filter(function (el) { return el.indexOf('=') > 0; }).join('&');
	            if (addVars.length > 0) requestUrl += '&' + addVars;
	        }
	
	        // Create script
	        var script = document.createElement('script');
	        script.type = 'text/javascript';
	        script.onerror = function() {
	            clearTimeout(abortTimeout);
	            fireAjaxCallback(undefined, undefined, 'error', null, 'scripterror');
	            fireAjaxCallback('ajaxComplete ajax:complete', {scripterror: true}, 'complete', null, 'scripterror');
	        };
	        script.src = requestUrl;
	
	        // Handler
	        window[callbackName] = function (data) {
	            clearTimeout(abortTimeout);
	            fireAjaxCallback(undefined, undefined, 'success', data);
	            script.parentNode.removeChild(script);
	            script = null;
	            delete window[callbackName];
	        };
	        document.querySelector('head').appendChild(script);
	
	        if (options.timeout > 0) {
	            abortTimeout = setTimeout(function () {
	                script.parentNode.removeChild(script);
	                script = null;
	                fireAjaxCallback(undefined, undefined, 'error', null, 'timeout');
	            }, options.timeout);
	        }
	
	        return;
	    }
	
	    // Cache for GET/HEAD requests
	    if (_method === 'GET' || _method === 'HEAD' || _method === 'OPTIONS' || _method === 'DELETE') {
	        if (options.cache === false) {
	            options.url += (paramsPrefix + '_nocache=' + Date.now());
	        }
	    }
	
	    // Create XHR
	    var xhr = new XMLHttpRequest();
	
	    // Save Request URL
	    xhr.requestUrl = options.url;
	    xhr.requestParameters = options;
	
	    // Open XHR
	    xhr.open(_method, options.url, options.async, options.user, options.password);
	
	    // Create POST Data
	    var postData = null;
	
	    if ((_method === 'POST' || _method === 'PUT' || _method === 'PATCH') && options.data) {
	        if (options.processData) {
	            var postDataInstances = [ArrayBuffer, Blob, Document, FormData];
	            // Post Data
	            if (postDataInstances.indexOf(options.data.constructor) >= 0) {
	                postData = options.data;
	            }
	            else {
	                // POST Headers
	                var boundary = '---------------------------' + Date.now().toString(16);
	
	                if (options.contentType === 'multipart\/form-data') {
	                    xhr.setRequestHeader('Content-Type', 'multipart\/form-data; boundary=' + boundary);
	                }
	                else {
	                    xhr.setRequestHeader('Content-Type', options.contentType);
	                }
	                postData = '';
	                var _data = $.serializeObject(options.data);
	                if (options.contentType === 'multipart\/form-data') {
	                    boundary = '---------------------------' + Date.now().toString(16);
	                    _data = _data.split('&');
	                    var _newData = [];
	                    for (var i = 0; i < _data.length; i++) {
	                        _newData.push('Content-Disposition: form-data; name="' + _data[i].split('=')[0] + '"\r\n\r\n' + _data[i].split('=')[1] + '\r\n');
	                    }
	                    postData = '--' + boundary + '\r\n' + _newData.join('--' + boundary + '\r\n') + '--' + boundary + '--\r\n';
	                }
	                else {
	                    postData = _data;
	                }
	            }
	        }
	        else {
	            postData = options.data;
	        }
	
	    }
	
	    // Additional headers
	    if (options.headers) {
	        $.each(options.headers, function (headerName, headerCallback) {
	            xhr.setRequestHeader(headerName, headerCallback);
	        });
	    }
	
	    // Check for crossDomain
	    if (typeof options.crossDomain === 'undefined') {
	        options.crossDomain = /^([\w-]+:)?\/\/([^\/]+)/.test(options.url) && RegExp.$2 !== window.location.host;
	    }
	
	    if (!options.crossDomain) {
	        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	    }
	
	    if (options.xhrFields) {
	        $.each(options.xhrFields, function (fieldName, fieldValue) {
	            xhr[fieldName] = fieldValue;
	        });
	    }
	
	    var xhrTimeout;
	    // Handle XHR
	    xhr.onload = function (e) {
	        if (xhrTimeout) clearTimeout(xhrTimeout);
	        if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 0) {
	            var responseData;
	            if (options.dataType === 'json') {
	                try {
	                    responseData = JSON.parse(xhr.responseText);
	                    fireAjaxCallback('ajaxSuccess ajax:success', {xhr: xhr}, 'success', responseData, xhr.status, xhr);
	                }
	                catch (err) {
	                    fireAjaxCallback('ajaxError ajax:error', {xhr: xhr, parseerror: true}, 'error', xhr, 'parseerror');
	                }
	            }
	            else {
	                responseData = xhr.responseType === 'text' || xhr.responseType === '' ? xhr.responseText : xhr.response;
	                fireAjaxCallback('ajaxSuccess ajax:success', {xhr: xhr}, 'success', responseData, xhr.status, xhr);
	            }
	        }
	        else {
	            fireAjaxCallback('ajaxError ajax:error', {xhr: xhr}, 'error', xhr, xhr.status);
	        }
	        if (options.statusCode) {
	            if (globalAjaxOptions.statusCode && globalAjaxOptions.statusCode[xhr.status]) globalAjaxOptions.statusCode[xhr.status](xhr);
	            if (options.statusCode[xhr.status]) options.statusCode[xhr.status](xhr);
	        }
	        fireAjaxCallback('ajaxComplete ajax:complete', {xhr: xhr}, 'complete', xhr, xhr.status);
	    };
	
	    xhr.onerror = function (e) {
	        if (xhrTimeout) clearTimeout(xhrTimeout);
	        fireAjaxCallback('ajaxError ajax:error', {xhr: xhr}, 'error', xhr, xhr.status);
	        fireAjaxCallback('ajaxComplete ajax:complete', {xhr: xhr}, 'complete', xhr, xhr.status);
	    };
	
	    // Ajax start callback
	    fireAjaxCallback('ajaxStart ajax:start', {xhr: xhr}, 'start', xhr);
	    fireAjaxCallback(undefined, undefined, 'beforeSend', xhr);
	
	    // Timeout
	    if (options.timeout > 0) {
	        xhr.onabort = function () {
	            if (xhrTimeout) clearTimeout(xhrTimeout);
	        };
	        xhrTimeout = setTimeout(function () {
	            xhr.abort();
	            fireAjaxCallback('ajaxError ajax:error', {xhr: xhr, timeout: true}, 'error', xhr, 'timeout');
	            fireAjaxCallback('ajaxComplete ajax:complete', {xhr: xhr, timeout: true}, 'complete', xhr, 'timeout');
	        }, options.timeout);
	    }
	
	    // Send XHR
	    xhr.send(postData);
	
	    // Return XHR object
	    return xhr;
	};
	// Shrotcuts
	(function () {
	    var methods = ('get post getJSON').split(' ');
	    function createMethod(method) {
	        $[method] = function (url, data, success, error) {
	            return $.ajax({
	                url: url,
	                method: method === 'post' ? 'POST' : 'GET',
	                data: typeof data === 'function' ? undefined : data,
	                success: typeof data === 'function' ? data : success,
	                error: typeof data === 'function' ? success : error,
	                dataType: method === 'getJSON' ? 'json' : undefined
	            });
	        };
	    }
	    for (var i = 0; i < methods.length; i++) {
	        createMethod(methods[i]);
	    }
	})();
	
	    return $;
	})();
	
	// Export Dom7 to Framework7
	Framework7.$ = Dom7;
	
	// Export to local scope
	var $ = Dom7;
	
	// Export to Window
	window.Dom7 = module.exports.Dom7 = Dom7;
	
	/*========================
	Animate7 Animate Engine
	==========================*/
	var Animate7 = function (elements, props, params) {
	    props = props || {};
	    params = params || {};
	    var defaults = {
	        duration: 300,
	        easing: 'swing', // or 'linear'
	        /* Callbacks
	        begin(elements)
	        complete(elements)
	        progress(elements, complete, remaining, start, tweenValue)
	        */
	    };
	
	    for (var def in defaults) {
	        if (typeof params[def] === 'undefined') {
	            params[def] = defaults[def];
	        }
	    }
	
	    var a = this;
	    a.params = params;
	    a.props = props;
	    a.elements = $(elements);
	    if (a.elements.length === 0) {
	        return a;
	    }
	
	    a.easingProgress = function (easing, progress) {
	        if (easing === 'swing') {
	            return 0.5 - Math.cos( progress * Math.PI ) / 2;
	        }
	        if (typeof easing === 'function') {
	            return easing(progress);
	        }
	        return progress;
	    };
	
	    a.stop = function () {
	        if (a.frameId) {
	            $.cancelAnimationFrame(a.frameId);
	        }
	        a.animating = false;
	        a.elements.each(function (index, el) {
	            delete el.animate7Instance;
	        });
	        a.que = [];
	    };
	    a.done = function (complete) {
	        a.animating = false;
	        a.elements.each(function (index, el) {
	            delete el.animate7Instance;
	        });
	        if (complete) complete(elements);
	        if (a.que.length > 0) {
	            var que = a.que.shift();
	            a.animate(que[0], que[1]);
	        }
	    };
	    a.animating = false;
	    a.que = [];
	    a.animate = function (props, params) {
	        if (a.animating) {
	            a.que.push([props, params]);
	            return a;
	        }
	        a.params = params;
	
	        var _elements = [];
	
	        // Define & Cache Initials & Units
	        a.elements.each(function (index, el) {
	            var initialFullValue, initialValue, unit, finalValue, finalFullValue;
	
	            _elements[index] = {
	                _container: el
	            };
	
	            for (var prop in props) {
	                initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
	                initialValue = parseFloat(initialFullValue);
	                unit = initialFullValue.replace(initialValue, '');
	                finalValue = props[prop];
	                finalFullValue = props[prop] + unit;
	                _elements[index][prop] = {
	                    initialFullValue: initialFullValue,
	                    initialValue: initialValue,
	                    unit: unit,
	                    finalValue: finalValue,
	                    finalFullValue: finalFullValue,
	                    currentValue: initialValue
	                };
	
	            }
	        });
	
	        var startTime = null,
	            time,
	            elementsDone = 0,
	            propsDone = 0,
	            done,
	            began = false;
	
	        a.animating = true;
	
	        function render() {
	            time = new Date().getTime();
	            var progress, easeProgress, el;
	            if (!began) {
	                began = true;
	                if (params.begin) params.begin(elements);
	            }
	            if (startTime === null) {
	                startTime = time;
	            }
	            if (params.progress) {
	                params.progress(
	                    a.elements,
	                    Math.max(Math.min((time - startTime) / params.duration, 1), 0),
	                    ((startTime + params.duration) - time < 0 ? 0 : (startTime + params.duration) - time),
	                    startTime
	                );
	            }
	
	            for (var i = 0; i < _elements.length; i++) {
	                if (done) continue;
	                el = _elements[i];
	                if (el.done) continue;
	
	                for (var prop in props) {
	                    progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
	                    easeProgress = a.easingProgress(params.easing, progress);
	
	                    el[prop].currentValue = el[prop].initialValue + easeProgress * (el[prop].finalValue - el[prop].initialValue);
	
	                    if (el[prop].finalValue > el[prop].initialValue && el[prop].currentValue >= el[prop].finalValue || el[prop].finalValue < el[prop].initialValue && el[prop].currentValue <= el[prop].finalValue)  {
	                        el._container.style[prop] = el[prop].finalValue + el[prop].unit;
	                        propsDone ++;
	                        if (propsDone === Object.keys(props).length) {
	                            el.done = true;
	                            elementsDone++;
	                        }
	                        if (elementsDone === _elements.length) {
	                            done = true;
	                        }
	                    }
	                    if (done) {
	                        a.done(params.complete);
	                        return a;
	                    }
	                    el._container.style[prop] = el[prop].currentValue + el[prop].unit;
	                }
	            }
	
	            // Then call
	            a.frameId = $.requestAnimationFrame(render);
	        }
	        a.frameId = $.requestAnimationFrame(render);
	        return a;
	    };
	    var foundInstance;
	    for (var i = 0; i < a.elements.length; i++) {
	        if (a.elements[i].animate7Instance) {
	            foundInstance = a.elements[i].animate7Instance;
	        }
	        else a.elements[i].animate7Instance = a;
	    }
	    if (foundInstance) {
	        return foundInstance.animate(props, params);
	    }
	    else a.animate(props, params);
	    return a;
	};
	window.Animate7 = function (elements, props, params){
	    return new Animate7(elements, props, params);
	};
	Dom7.fn.animate = function (props, params) {
	    new Animate7(this, props, params);
	    return this;
	};
	/*===========================
	Features Support Detection
	===========================*/
	Framework7.prototype.support = (function () {
	    var support = {
	        touch: !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch),
	        passiveListener: (function () {
	            var supportsPassive = false;
	            try {
	                var opts = Object.defineProperty({}, 'passive', {
	                    get: function() {
	                        supportsPassive = true;
	                    }
	                });
	                window.addEventListener('testPassiveListener', null, opts);
	            } catch (e) {}
	            return supportsPassive;
	        })()
	    };
	
	    // Export object
	    return support;
	})();
	
	/*===========================
	Device/OS Detection
	===========================*/
	Framework7.prototype.device = (function () {
	    var device = {};
	    var ua = navigator.userAgent;
	    var $ = Dom7;
	
	    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
	    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
	
	    device.ios = device.android = device.iphone = device.ipod = device.ipad = device.androidChrome = false;
	    
	    // Android
	    if (android) {
	        device.os = 'android';
	        device.osVersion = android[2];
	        device.android = true;
	        device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
	    }
	    if (ipad || iphone || ipod) {
	        device.os = 'ios';
	        device.ios = true;
	    }
	    // iOS
	    if (iphone && !ipod) {
	        device.osVersion = iphone[2].replace(/_/g, '.');
	        device.iphone = true;
	    }
	    if (ipad) {
	        device.osVersion = ipad[2].replace(/_/g, '.');
	        device.ipad = true;
	    }
	    if (ipod) {
	        device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
	        device.iphone = true;
	    }
	    // iOS 8+ changed UA
	    if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
	        if (device.osVersion.split('.')[0] === '10') {
	            device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
	        }
	    }
	
	    // Webview
	    device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);
	        
	    // Minimal UI
	    if (device.os && device.os === 'ios') {
	        var osVersionArr = device.osVersion.split('.');
	        device.minimalUi = !device.webView &&
	                            (ipod || iphone) &&
	                            (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7) &&
	                            $('meta[name="viewport"]').length > 0 && $('meta[name="viewport"]').attr('content').indexOf('minimal-ui') >= 0;
	    }
	
	    // Check for status bar and fullscreen app mode
	    var windowWidth = $(window).width();
	    var windowHeight = $(window).height();
	
	    device.needsStatusBar = function () {
	        if (device.webView && (windowWidth * windowHeight === screen.width * screen.height)) {
	            return true;
	        }
	        return false;
	    };
	    device.statusBar = device.needsStatusBar();
	
	    // Classes
	    var classNames = [];
	
	    // Pixel Ratio
	    device.pixelRatio = window.devicePixelRatio || 1;
	    classNames.push('pixel-ratio-' + Math.floor(device.pixelRatio));
	    if (device.pixelRatio >= 2) {
	        classNames.push('retina');
	    }
	
	    // OS classes
	    if (device.os) {
	        classNames.push(device.os, device.os + '-' + device.osVersion.split('.')[0], device.os + '-' + device.osVersion.replace(/\./g, '-'));
	        if (device.os === 'ios') {
	            var major = parseInt(device.osVersion.split('.')[0], 10);
	            for (var i = major - 1; i >= 6; i--) {
	                classNames.push('ios-gt-' + i);
	            }
	        }
	        
	    }
	    // Status bar classes
	    if (device.statusBar) {
	        classNames.push('with-statusbar-overlay');
	    }
	    else {
	        $('html').removeClass('with-statusbar-overlay');
	    }
	
	    // Add html classes
	    if (classNames.length > 0) $('html').addClass(classNames.join(' '));
	
	    // Export object
	    return device;
	})();
	
	/*===========================
	Plugins prototype
	===========================*/
	Framework7.prototype.plugins = {};
	
	/*===========================
	Template7 Template engine
	===========================*/
	window.Template7 = module.exports.Template7 = (function () {
	    'use strict';
	    function isArray(arr) {
	        return Object.prototype.toString.apply(arr) === '[object Array]';
	    }
	    function isObject(obj) {
	        return obj instanceof Object;
	    }
	    function isFunction(func) {
	        return typeof func === 'function';
	    }
	    function _escape(string) {
	        return typeof window !== 'undefined' && window.escape ? window.escape(string) : string
	            .replace(/&/g, '&amp;')
	            .replace(/</g, '&lt;')
	            .replace(/>/g, '&gt;')
	            .replace(/"/g, '&quot;');
	    }
	    var cache = {};
	    var quoteSingleRexExp = new RegExp('\'', 'g');
	    var quoteDoubleRexExp = new RegExp('"', 'g');
	    function helperToSlices(string) {
	        var helperParts = string.replace(/[{}#}]/g, '').split(' ');
	        var slices = [];
	        var shiftIndex, i, j;
	        for (i = 0; i < helperParts.length; i++) {
	            var part = helperParts[i];
	            var blockQuoteRegExp, openingQuote;
	            if (i === 0) slices.push(part);
	            else {
	                if (part.indexOf('"') === 0 || part.indexOf('\'') === 0) {
	                    blockQuoteRegExp = part.indexOf('"') === 0 ? quoteDoubleRexExp : quoteSingleRexExp;
	                    openingQuote = part.indexOf('"') === 0 ? '"' : '\'';
	                    // Plain String
	                    if (part.match(blockQuoteRegExp).length === 2) {
	                        // One word string
	                        slices.push(part);
	                    }
	                    else {
	                        // Find closed Index
	                        shiftIndex = 0;
	                        for (j = i + 1; j < helperParts.length; j++) {
	                            part += ' ' + helperParts[j];
	                            if (helperParts[j].indexOf(openingQuote) >= 0) {
	                                shiftIndex = j;
	                                slices.push(part);
	                                break;
	                            }
	                        }
	                        if (shiftIndex) i = shiftIndex;
	                    }
	                }
	                else {
	                    if (part.indexOf('=') > 0) {
	                        // Hash
	                        var hashParts = part.split('=');
	                        var hashName = hashParts[0];
	                        var hashContent = hashParts[1];
	                        if (!blockQuoteRegExp) {
	                            blockQuoteRegExp = hashContent.indexOf('"') === 0 ? quoteDoubleRexExp : quoteSingleRexExp;
	                            openingQuote = hashContent.indexOf('"') === 0 ? '"' : '\'';
	                        }
	                        if (hashContent.match(blockQuoteRegExp).length !== 2) {
	                            shiftIndex = 0;
	                            for (j = i + 1; j < helperParts.length; j++) {
	                                hashContent += ' ' + helperParts[j];
	                                if (helperParts[j].indexOf(openingQuote) >= 0) {
	                                    shiftIndex = j;
	                                    break;
	                                }
	                            }
	                            if (shiftIndex) i = shiftIndex;
	                        }
	                        var hash = [hashName, hashContent.replace(blockQuoteRegExp,'')];
	                        slices.push(hash);
	                    }
	                    else {
	                        // Plain variable
	                        slices.push(part);
	                    }
	                }
	            }
	        }
	        return slices;
	    }
	    function stringToBlocks(string) {
	        var blocks = [], i, j, k;
	        if (!string) return [];
	        var _blocks = string.split(/({{[^{^}]*}})/);
	        for (i = 0; i < _blocks.length; i++) {
	            var block = _blocks[i];
	            if (block === '') continue;
	            if (block.indexOf('{{') < 0) {
	                blocks.push({
	                    type: 'plain',
	                    content: block
	                });
	            }
	            else {
	                if (block.indexOf('{/') >= 0) {
	                    continue;
	                }
	                if (block.indexOf('{#') < 0 && block.indexOf(' ') < 0 && block.indexOf('else') < 0) {
	                    // Simple variable
	                    blocks.push({
	                        type: 'variable',
	                        contextName: block.replace(/[{}]/g, '')
	                    });
	                    continue;
	                }
	                // Helpers
	                var helperSlices = helperToSlices(block);
	                var helperName = helperSlices[0];
	                var isPartial = helperName === '>';
	                var helperContext = [];
	                var helperHash = {};
	                for (j = 1; j < helperSlices.length; j++) {
	                    var slice = helperSlices[j];
	                    if (isArray(slice)) {
	                        // Hash
	                        helperHash[slice[0]] = slice[1] === 'false' ? false : slice[1];
	                    }
	                    else {
	                        helperContext.push(slice);
	                    }
	                }
	
	                if (block.indexOf('{#') >= 0) {
	                    // Condition/Helper
	                    var helperStartIndex = i;
	                    var helperContent = '';
	                    var elseContent = '';
	                    var toSkip = 0;
	                    var shiftIndex;
	                    var foundClosed = false, foundElse = false, foundClosedElse = false, depth = 0;
	                    for (j = i + 1; j < _blocks.length; j++) {
	                        if (_blocks[j].indexOf('{{#') >= 0) {
	                            depth ++;
	                        }
	                        if (_blocks[j].indexOf('{{/') >= 0) {
	                            depth --;
	                        }
	                        if (_blocks[j].indexOf('{{#' + helperName) >= 0) {
	                            helperContent += _blocks[j];
	                            if (foundElse) elseContent += _blocks[j];
	                            toSkip ++;
	                        }
	                        else if (_blocks[j].indexOf('{{/' + helperName) >= 0) {
	                            if (toSkip > 0) {
	                                toSkip--;
	                                helperContent += _blocks[j];
	                                if (foundElse) elseContent += _blocks[j];
	                            }
	                            else {
	                                shiftIndex = j;
	                                foundClosed = true;
	                                break;
	                            }
	                        }
	                        else if (_blocks[j].indexOf('else') >= 0 && depth === 0) {
	                            foundElse = true;
	                        }
	                        else {
	                            if (!foundElse) helperContent += _blocks[j];
	                            if (foundElse) elseContent += _blocks[j];
	                        }
	
	                    }
	                    if (foundClosed) {
	                        if (shiftIndex) i = shiftIndex;
	                        blocks.push({
	                            type: 'helper',
	                            helperName: helperName,
	                            contextName: helperContext,
	                            content: helperContent,
	                            inverseContent: elseContent,
	                            hash: helperHash
	                        });
	                    }
	                }
	                else if (block.indexOf(' ') > 0) {
	                    if (isPartial) {
	                        helperName = '_partial';
	                        if (helperContext[0]) helperContext[0] = '"' + helperContext[0].replace(/"|'/g, '') + '"';
	                    }
	                    blocks.push({
	                        type: 'helper',
	                        helperName: helperName,
	                        contextName: helperContext,
	                        hash: helperHash
	                    });
	                }
	            }
	        }
	        return blocks;
	    }
	    var Template7 = function (template, options) {
	        var t = this;
	        t.template = template;
	
	        function getCompileFn(block, depth) {
	            if (block.content) return compile(block.content, depth);
	            else return function () {return ''; };
	        }
	        function getCompileInverse(block, depth) {
	            if (block.inverseContent) return compile(block.inverseContent, depth);
	            else return function () {return ''; };
	        }
	        function getCompileVar(name, ctx) {
	            var variable, parts, levelsUp = 0, initialCtx = ctx;
	            if (name.indexOf('../') === 0) {
	                levelsUp = name.split('../').length - 1;
	                var newDepth = ctx.split('_')[1] - levelsUp;
	                ctx = 'ctx_' + (newDepth >= 1 ? newDepth : 1);
	                parts = name.split('../')[levelsUp].split('.');
	            }
	            else if (name.indexOf('@global') === 0) {
	                ctx = 'Template7.global';
	                parts = name.split('@global.')[1].split('.');
	            }
	            else if (name.indexOf('@root') === 0) {
	                ctx = 'root';
	                parts = name.split('@root.')[1].split('.');
	            }
	            else {
	                parts = name.split('.');
	            }
	            variable = ctx;
	            for (var i = 0; i < parts.length; i++) {
	                var part = parts[i];
	                if (part.indexOf('@') === 0) {
	                    if (i > 0) {
	                        variable += '[(data && data.' + part.replace('@', '') + ')]';
	                    }
	                    else {
	                        variable = '(data && data.' + name.replace('@', '') + ')';
	                    }
	                }
	                else {
	                    if (isFinite(part)) {
	                        variable += '[' + part + ']';
	                    }
	                    else {
	                        if (part === 'this' || part.indexOf('this.') >= 0 || part.indexOf('this[') >= 0 || part.indexOf('this(') >= 0) {
	                            variable = part.replace('this', ctx);
	                        }
	                        else {
	                            variable += '.' + part;
	                        }
	                    }
	                }
	            }
	
	            return variable;
	        }
	        function getCompiledArguments(contextArray, ctx) {
	            var arr = [];
	            for (var i = 0; i < contextArray.length; i++) {
	                if (/^['"]/.test(contextArray[i])) arr.push(contextArray[i]);
	                else if (/^(true|false|\d+)$/.test(contextArray[i])) arr.push(contextArray[i]);
	                else {
	                    arr.push(getCompileVar(contextArray[i], ctx));
	                }
	            }
	
	            return arr.join(', ');
	        }
	        function compile(template, depth) {
	            depth = depth || 1;
	            template = template || t.template;
	            if (typeof template !== 'string') {
	                throw new Error('Template7: Template must be a string');
	            }
	            var blocks = stringToBlocks(template);
	            if (blocks.length === 0) {
	                return function () { return ''; };
	            }
	            var ctx = 'ctx_' + depth;
	            var resultString = '';
	            if (depth === 1) {
	                resultString += '(function (' + ctx + ', data, root) {\n';
	            }
	            else {
	                resultString += '(function (' + ctx + ', data) {\n';
	            }
	            if (depth === 1) {
	                resultString += 'function isArray(arr){return Object.prototype.toString.apply(arr) === \'[object Array]\';}\n';
	                resultString += 'function isFunction(func){return (typeof func === \'function\');}\n';
	                resultString += 'function c(val, ctx) {if (typeof val !== "undefined" && val !== null) {if (isFunction(val)) {return val.call(ctx);} else return val;} else return "";}\n';
	                resultString += 'root = root || ctx_1 || {};\n';
	            }
	            resultString += 'var r = \'\';\n';
	            var i, j, context;
	            for (i = 0; i < blocks.length; i++) {
	                var block = blocks[i];
	                // Plain block
	                if (block.type === 'plain') {
	                    resultString += 'r +=\'' + (block.content).replace(/\r/g, '\\r').replace(/\n/g, '\\n').replace(/'/g, '\\' + '\'') + '\';';
	                    continue;
	                }
	                var variable, compiledArguments;
	                // Variable block
	                if (block.type === 'variable') {
	                    variable = getCompileVar(block.contextName, ctx);
	                    resultString += 'r += c(' + variable + ', ' + ctx + ');';
	                }
	                // Helpers block
	                if (block.type === 'helper') {
	                    if (block.helperName in t.helpers) {
	                        compiledArguments = getCompiledArguments(block.contextName, ctx);
	
	                        resultString += 'r += (Template7.helpers.' + block.helperName + ').call(' + ctx + ', ' + (compiledArguments && (compiledArguments + ', ')) +'{hash:' + JSON.stringify(block.hash) + ', data: data || {}, fn: ' + getCompileFn(block, depth + 1) + ', inverse: ' + getCompileInverse(block, depth + 1) + ', root: root});';
	
	                    }
	                    else {
	                        if (block.contextName.length > 0) {
	                            throw new Error('Template7: Missing helper: "' + block.helperName + '"');
	                        }
	                        else {
	                            variable = getCompileVar(block.helperName, ctx);
	                            resultString += 'if (' + variable + ') {';
	                            resultString += 'if (isArray(' + variable + ')) {';
	                            resultString += 'r += (Template7.helpers.each).call(' + ctx + ', ' + variable + ', {hash:' + JSON.stringify(block.hash) + ', data: data || {}, fn: ' + getCompileFn(block, depth+1) + ', inverse: ' + getCompileInverse(block, depth+1) + ', root: root});';
	                            resultString += '}else {';
	                            resultString += 'r += (Template7.helpers.with).call(' + ctx + ', ' + variable + ', {hash:' + JSON.stringify(block.hash) + ', data: data || {}, fn: ' + getCompileFn(block, depth+1) + ', inverse: ' + getCompileInverse(block, depth+1) + ', root: root});';
	                            resultString += '}}';
	                        }
	                    }
	                }
	            }
	            resultString += '\nreturn r;})';
	            return eval.call(window, resultString);
	        }
	        t.compile = function (template) {
	            if (!t.compiled) {
	                t.compiled = compile(template);
	            }
	            return t.compiled;
	        };
	    };
	    Template7.prototype = {
	        options: {},
	        partials: {},
	        helpers: {
	            '_partial' : function (partialName, options) {
	                var p = Template7.prototype.partials[partialName];
	                if (!p || (p && !p.template)) return '';
	                if (!p.compiled) {
	                    p.compiled = new Template7(p.template).compile();
	                }
	                var ctx = this;
	                for (var hashName in options.hash) {
	                    ctx[hashName] = options.hash[hashName];
	                }
	                return p.compiled(ctx, options.data, options.root);
	            },
	            'escape': function (context, options) {
	                if (typeof context !== 'string') {
	                    throw new Error('Template7: Passed context to "escape" helper should be a string');
	                }
	                return _escape(context);
	            },
	            'if': function (context, options) {
	                if (isFunction(context)) { context = context.call(this); }
	                if (context) {
	                    return options.fn(this, options.data);
	                }
	                else {
	                    return options.inverse(this, options.data);
	                }
	            },
	            'unless': function (context, options) {
	                if (isFunction(context)) { context = context.call(this); }
	                if (!context) {
	                    return options.fn(this, options.data);
	                }
	                else {
	                    return options.inverse(this, options.data);
	                }
	            },
	            'each': function (context, options) {
	                var ret = '', i = 0;
	                if (isFunction(context)) { context = context.call(this); }
	                if (isArray(context)) {
	                    if (options.hash.reverse) {
	                        context = context.reverse();
	                    }
	                    for (i = 0; i < context.length; i++) {
	                        ret += options.fn(context[i], {first: i === 0, last: i === context.length - 1, index: i});
	                    }
	                    if (options.hash.reverse) {
	                        context = context.reverse();
	                    }
	                }
	                else {
	                    for (var key in context) {
	                        i++;
	                        ret += options.fn(context[key], {key: key});
	                    }
	                }
	                if (i > 0) return ret;
	                else return options.inverse(this);
	            },
	            'with': function (context, options) {
	                if (isFunction(context)) { context = context.call(this); }
	                return options.fn(context);
	            },
	            'join': function (context, options) {
	                if (isFunction(context)) { context = context.call(this); }
	                return context.join(options.hash.delimiter || options.hash.delimeter);
	            },
	            'js': function (expression, options) {
	                var func;
	                if (expression.indexOf('return')>=0) {
	                    func = '(function(){'+expression+'})';
	                }
	                else {
	                    func = '(function(){return ('+expression+')})';
	                }
	                return eval.call(this, func).call(this);
	            },
	            'js_compare': function (expression, options) {
	                var func;
	                if (expression.indexOf('return')>=0) {
	                    func = '(function(){'+expression+'})';
	                }
	                else {
	                    func = '(function(){return ('+expression+')})';
	                }
	                var condition = eval.call(this, func).call(this);
	                if (condition) {
	                    return options.fn(this, options.data);
	                }
	                else {
	                    return options.inverse(this, options.data);
	                }
	            }
	        }
	    };
	    var t7 = function (template, data) {
	        if (arguments.length === 2) {
	            var instance = new Template7(template);
	            var rendered = instance.compile()(data);
	            instance = null;
	            return (rendered);
	        }
	        else return new Template7(template);
	    };
	    t7.registerHelper = function (name, fn) {
	        Template7.prototype.helpers[name] = fn;
	    };
	    t7.unregisterHelper = function (name) {
	        Template7.prototype.helpers[name] = undefined;
	        delete Template7.prototype.helpers[name];
	    };
	    t7.registerPartial = function (name, template) {
	        Template7.prototype.partials[name] = {template: template};
	    };
	    t7.unregisterPartial = function (name, template) {
	        if (Template7.prototype.partials[name]) {
	            Template7.prototype.partials[name] = undefined;
	            delete Template7.prototype.partials[name];
	        }
	    };
	    t7.compile = function (template, options) {
	        var instance = new Template7(template, options);
	        return instance.compile();
	    };
	
	    t7.options = Template7.prototype.options;
	    t7.helpers = Template7.prototype.helpers;
	    t7.partials = Template7.prototype.partials;
	    return t7;
	})();
	})();


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var EventPluginRegistry = __webpack_require__(48);
	var ReactEventEmitterMixin = __webpack_require__(295);
	var ViewportMetrics = __webpack_require__(102);
	
	var getVendorPrefixedEventName = __webpack_require__(328);
	var isEventSupported = __webpack_require__(59);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(33);
	var ViewportMetrics = __webpack_require__(102);
	
	var getEventModifierState = __webpack_require__(57);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(3);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 38 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	var DOMNamespaces = __webpack_require__(47);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(55);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(10);
	var normalizeHeaderName = __webpack_require__(133);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(65);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(65);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)))

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	exports.no = exports.noCase = __webpack_require__(15)
	exports.dot = exports.dotCase = __webpack_require__(151)
	exports.swap = exports.swapCase = __webpack_require__(346)
	exports.path = exports.pathCase = __webpack_require__(264)
	exports.upper = exports.upperCase = __webpack_require__(18)
	exports.lower = exports.lowerCase = __webpack_require__(29)
	exports.camel = exports.camelCase = __webpack_require__(70)
	exports.snake = exports.snakeCase = __webpack_require__(116)
	exports.title = exports.titleCase = __webpack_require__(347)
	exports.param = exports.paramCase = __webpack_require__(262)
	exports.header = exports.headerCase = __webpack_require__(255)
	exports.pascal = exports.pascalCase = __webpack_require__(263)
	exports.constant = exports.constantCase = __webpack_require__(150)
	exports.sentence = exports.sentenceCase = __webpack_require__(345)
	exports.isUpper = exports.isUpperCase = __webpack_require__(257)
	exports.isLower = exports.isLowerCase = __webpack_require__(256)
	exports.ucFirst = exports.upperCaseFirst = __webpack_require__(64)
	exports.lcFirst = exports.lowerCaseFirst = __webpack_require__(258)


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Badge = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueBadge,
	    tag: 'f7-badge'
	});
	
	//# sourceMappingURL=Badge.js.map


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Icon = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueIcon,
	    tag: 'f7-icon'
	});
	
	//# sourceMappingURL=Icon.js.map


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	var Badge_1 = __webpack_require__(42);
	var Icon_1 = __webpack_require__(43);
	var framework7_vue_2 = __webpack_require__(1);
	exports.Link = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueLink,
	    tag: 'f7-link',
	    events: [
	        'click'
	    ],
	    instantiatedComponents: [
	        Badge_1.Badge,
	        Icon_1.Icon
	    ],
	    mixin: framework7_vue_2.VueLinkMixin
	});
	
	//# sourceMappingURL=Link.js.map


/***/ },
/* 45 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(20);
	var Danger = __webpack_require__(272);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactInstrumentation = __webpack_require__(13);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(55);
	var setInnerHTML = __webpack_require__(39);
	var setTextContent = __webpack_require__(109);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 47 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactErrorUtils = __webpack_require__(53);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 50 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var React = __webpack_require__(23);
	var ReactPropTypesSecret = __webpack_require__(301);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: React.PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(3);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      // $FlowFixMe https://github.com/facebook/flow/issues/2336
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactInstanceMap = __webpack_require__(32);
	var ReactInstrumentation = __webpack_require__(13);
	var ReactUpdates = __webpack_require__(14);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 55 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 56 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 57 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 58 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 60 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var emptyFunction = __webpack_require__(12);
	var warning = __webpack_require__(4);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var ReactNoopUpdateQueue = __webpack_require__(63);
	
	var canDefineProperty = __webpack_require__(114);
	var emptyObject = __webpack_require__(27);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(4);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(18)
	
	/**
	 * Upper case the first character of a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  if (str == null) {
	    return ''
	  }
	
	  str = String(str)
	
	  return upperCase(str.charAt(0), locale) + str.substr(1)
	}


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(10);
	var settle = __webpack_require__(125);
	var buildURL = __webpack_require__(128);
	var parseHeaders = __webpack_require__(134);
	var isURLSameOrigin = __webpack_require__(132);
	var createError = __webpack_require__(68);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(127);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(130);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        if (request.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 66 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 67 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(124);
	
	/**
	 * Create an Error with the specified message, config, error code, and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, response);
	};


/***/ },
/* 69 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(18)
	var noCase = __webpack_require__(15)
	
	/**
	 * Camel case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale, mergeNumbers) {
	  var result = noCase(value, locale)
	
	  // Replace periods between numeric entities with an underscore.
	  if (!mergeNumbers) {
	    result = result.replace(/ (?=\d)/g, '_')
	  }
	
	  // Replace spaces between words with an upper cased character.
	  return result.replace(/ (.)/g, function (m, $1) {
	    return upperCase($1, locale)
	  })
	}


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(12);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 72 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 73 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.CardContent = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueCardContent,
	    tag: 'f7-card-content'
	});
	
	//# sourceMappingURL=CardContent.js.map


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.CardFooter = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueCardFooter,
	    tag: 'f7-card-footer'
	});
	
	//# sourceMappingURL=CardFooter.js.map


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.CardHeader = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueCardHeader,
	    tag: 'f7-card-header'
	});
	
	//# sourceMappingURL=CardHeader.js.map


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.FormRange = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueFormRange,
	    tag: 'f7-range',
	    events: [
	        'input',
	        'change',
	        'click'
	    ]
	});
	
	//# sourceMappingURL=FormRange.js.map


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.FormSwitch = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueFormSwitch,
	    tag: 'f7-switch',
	    events: [
	        'input',
	        'change',
	        'click'
	    ]
	});
	
	//# sourceMappingURL=FormSwitch.js.map


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	var Badge_1 = __webpack_require__(42);
	exports.ListItemContent = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueListItemContent,
	    tag: 'f7-list-item-content',
	    events: [
	        'click',
	        'change'
	    ],
	    instantiatedComponents: [
	        Badge_1.Badge
	    ]
	});
	
	//# sourceMappingURL=ListItemContent.js.map


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.NavCenter = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueNavCenter,
	    tag: 'f7-nav-center'
	});
	
	//# sourceMappingURL=NavCenter.js.map


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	var Link_1 = __webpack_require__(44);
	exports.NavLeft = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueNavLeft,
	    tag: 'f7-nav-left',
	    events: [
	        'back-click',
	        'click:back'
	    ],
	    instantiatedComponents: [
	        Link_1.Link
	    ]
	});
	
	//# sourceMappingURL=NavLeft.js.map


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	var NavLeft_1 = __webpack_require__(81);
	var NavCenter_1 = __webpack_require__(80);
	exports.Navbar = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueNavbar,
	    tag: 'f7-navbar',
	    events: [
	        'navbar:beforeinit',
	        'navbar:init',
	        'navbar:reinit',
	        'navbar:beforeremove',
	        'back-click',
	        'click:back'
	    ],
	    instantiatedComponents: [
	        NavLeft_1.NavLeft,
	        NavCenter_1.NavCenter
	    ],
	    slots: [
	        'before-inner',
	        'after-inner'
	    ]
	});
	
	//# sourceMappingURL=Navbar.js.map


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Pages = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VuePages,
	    tag: 'f7-pages'
	});
	
	//# sourceMappingURL=Pages.js.map


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shallowEqual = __webpack_require__(28);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _omit = __webpack_require__(87);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mainStyle = {
	  width: '100%',
	  height: '100%',
	  left: 0,
	  top: 0,
	  margin: 0,
	  padding: 0,
	  position: 'absolute'
	};
	
	var style = {
	  width: 0,
	  height: 0,
	  left: 0,
	  top: 0,
	  backgroundColor: 'transparent',
	  position: 'absolute'
	};
	
	var GoogleMapMarkers = function (_Component) {
	  _inherits(GoogleMapMarkers, _Component);
	
	  function GoogleMapMarkers(props) {
	    _classCallCheck(this, GoogleMapMarkers);
	
	    var _this = _possibleConstructorReturn(this, (GoogleMapMarkers.__proto__ || Object.getPrototypeOf(GoogleMapMarkers)).call(this, props));
	
	    _this._getState = function () {
	      return {
	        children: _this.props.dispatcher.getChildren(),
	        updateCounter: _this.props.dispatcher.getUpdateCounter()
	      };
	    };
	
	    _this._onChangeHandler = function () {
	      if (!_this.dimesionsCache_) {
	        return;
	      }
	
	      var prevChildCount = (_this.state.children || []).length;
	      var state = _this._getState();
	
	      _this.setState(state, function () {
	        return (state.children || []).length !== prevChildCount && _this._onMouseChangeHandler();
	      });
	    };
	
	    _this._onChildClick = function () {
	      if (_this.props.onChildClick) {
	        if (_this.hoverChildProps_) {
	          var hoverKey = _this.hoverKey_;
	          var childProps = _this.hoverChildProps_;
	          // click works only on hovered item
	          _this.props.onChildClick(hoverKey, childProps);
	        }
	      }
	    };
	
	    _this._onChildMouseDown = function () {
	      if (_this.props.onChildMouseDown) {
	        if (_this.hoverChildProps_) {
	          var hoverKey = _this.hoverKey_;
	          var childProps = _this.hoverChildProps_;
	          // works only on hovered item
	          _this.props.onChildMouseDown(hoverKey, childProps);
	        }
	      }
	    };
	
	    _this._onChildMouseEnter = function (hoverKey, childProps) {
	      if (!_this.dimesionsCache_) {
	        return;
	      }
	
	      if (_this.props.onChildMouseEnter) {
	        _this.props.onChildMouseEnter(hoverKey, childProps);
	      }
	
	      _this.hoverChildProps_ = childProps;
	      _this.hoverKey_ = hoverKey;
	      _this.setState({ hoverKey: hoverKey });
	    };
	
	    _this._onChildMouseLeave = function () {
	      if (!_this.dimesionsCache_) {
	        return;
	      }
	
	      var hoverKey = _this.hoverKey_;
	      var childProps = _this.hoverChildProps_;
	
	      if (hoverKey !== undefined && hoverKey !== null) {
	        if (_this.props.onChildMouseLeave) {
	          _this.props.onChildMouseLeave(hoverKey, childProps);
	        }
	
	        _this.hoverKey_ = null;
	        _this.hoverChildProps_ = null;
	        _this.setState({ hoverKey: null });
	      }
	    };
	
	    _this._onMouseAllow = function (value) {
	      if (!value) {
	        _this._onChildMouseLeave();
	      }
	
	      _this.allowMouse_ = value;
	    };
	
	    _this._onMouseChangeHandler = function () {
	      if (_this.allowMouse_) {
	        _this._onMouseChangeHandler_raf();
	      }
	    };
	
	    _this._onMouseChangeHandler_raf = function () {
	      // eslint-disable-line
	      if (!_this.dimesionsCache_) {
	        return;
	      }
	
	      var mp = _this.props.dispatcher.getMousePosition();
	
	      if (mp) {
	        (function () {
	          var distances = [];
	          var hoverDistance = _this.props.getHoverDistance();
	
	          _react2.default.Children.forEach(_this.state.children, function (child, childIndex) {
	            if (!child) return;
	            // layers
	            if (child.props.latLng === undefined && child.props.lat === undefined && child.props.lng === undefined) {
	              return;
	            }
	
	            var childKey = child.key !== undefined && child.key !== null ? child.key : childIndex;
	            var dist = _this.props.distanceToMouse(_this.dimesionsCache_[childKey], mp, child.props);
	            if (dist < hoverDistance) {
	              distances.push({
	                key: childKey,
	                dist: dist,
	                props: child.props
	              });
	            }
	          });
	
	          if (distances.length) {
	            distances.sort(function (a, b) {
	              return a.dist - b.dist;
	            });
	            var hoverKey = distances[0].key;
	            var childProps = distances[0].props;
	
	            if (_this.hoverKey_ !== hoverKey) {
	              _this._onChildMouseLeave();
	
	              _this._onChildMouseEnter(hoverKey, childProps);
	            }
	          } else {
	            _this._onChildMouseLeave();
	          }
	        })();
	      } else {
	        _this._onChildMouseLeave();
	      }
	    };
	
	    _this._getDimensions = function (key) {
	      var childKey = key;
	      return _this.dimesionsCache_[childKey];
	    };
	
	    _this.props.dispatcher.on('kON_CHANGE', _this._onChangeHandler);
	    _this.props.dispatcher.on('kON_MOUSE_POSITION_CHANGE', _this._onMouseChangeHandler);
	    _this.props.dispatcher.on('kON_CLICK', _this._onChildClick);
	    _this.props.dispatcher.on('kON_MDOWN', _this._onChildMouseDown);
	
	    _this.dimesionsCache_ = {};
	    _this.hoverKey_ = null;
	    _this.hoverChildProps_ = null;
	    _this.allowMouse_ = true;
	
	    _this.state = _extends({}, _this._getState(), { hoverKey: null });
	    return _this;
	  }
	
	  _createClass(GoogleMapMarkers, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (this.props.experimental === true) {
	        return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)((0, _omit2.default)(this.state, ['hoverKey']), (0, _omit2.default)(nextState, ['hoverKey']));
	      }
	
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.dispatcher.removeListener('kON_CHANGE', this._onChangeHandler);
	      this.props.dispatcher.removeListener('kON_MOUSE_POSITION_CHANGE', this._onMouseChangeHandler);
	      this.props.dispatcher.removeListener('kON_CLICK', this._onChildClick);
	      this.props.dispatcher.removeListener('kON_MDOWN', this._onChildMouseDown);
	
	      this.dimesionsCache_ = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var mainElementStyle = this.props.style || mainStyle;
	      this.dimesionsCache_ = {};
	
	      var markers = _react2.default.Children.map(this.state.children, function (child, childIndex) {
	        if (!child) return undefined;
	        if (child.props.latLng === undefined && child.props.lat === undefined && child.props.lng === undefined) {
	          return _react2.default.cloneElement(child, {
	            $geoService: _this2.props.geoService,
	            $onMouseAllow: _this2._onMouseAllow,
	            $prerender: _this2.props.prerender
	          });
	        }
	
	        var latLng = child.props.latLng !== undefined ? child.props.latLng : { lat: child.props.lat, lng: child.props.lng };
	
	        var pt = _this2.props.geoService.project(latLng, _this2.props.projectFromLeftTop);
	
	        var stylePtPos = {
	          left: pt.x,
	          top: pt.y
	        };
	
	        var dx = 0;
	        var dy = 0;
	
	        if (!_this2.props.projectFromLeftTop) {
	          // center projection
	          if (_this2.props.geoService.hasSize()) {
	            dx = _this2.props.geoService.getWidth() / 2;
	            dy = _this2.props.geoService.getHeight() / 2;
	          }
	        }
	
	        // to prevent rerender on child element i need to pass
	        // const params $getDimensions and $dimensionKey instead of dimension object
	        var childKey = child.key !== undefined && child.key !== null ? child.key : childIndex;
	
	        _this2.dimesionsCache_[childKey] = _extends({
	          x: pt.x + dx,
	          y: pt.y + dy
	        }, latLng);
	
	        return _react2.default.createElement(
	          'div',
	          {
	            key: childKey,
	            style: _extends({}, style, stylePtPos),
	            className: child.props.$markerHolderClassName
	          },
	          _react2.default.cloneElement(child, {
	            $hover: childKey === _this2.state.hoverKey,
	            $getDimensions: _this2._getDimensions,
	            $dimensionKey: childKey,
	            $geoService: _this2.props.geoService,
	            $onMouseAllow: _this2._onMouseAllow,
	            $prerender: _this2.props.prerender
	          })
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: mainElementStyle },
	        markers
	      );
	    }
	  }]);
	
	  return GoogleMapMarkers;
	}(_react.Component);
	
	GoogleMapMarkers.propTypes = {
	  geoService: _react.PropTypes.any,
	  style: _react.PropTypes.any,
	  distanceToMouse: _react.PropTypes.func,
	  dispatcher: _react.PropTypes.any,
	  onChildClick: _react.PropTypes.func,
	  onChildMouseDown: _react.PropTypes.func,
	  onChildMouseLeave: _react.PropTypes.func,
	  onChildMouseEnter: _react.PropTypes.func,
	  getHoverDistance: _react.PropTypes.func,
	  projectFromLeftTop: _react.PropTypes.bool,
	  prerender: _react.PropTypes.bool
	};
	GoogleMapMarkers.defaultProps = {
	  projectFromLeftTop: false,
	  prerender: false
	};
	exports.default = GoogleMapMarkers;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _wrap2 = __webpack_require__(86);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LatLng = function () {
	  function LatLng(lat, lng) {
	    _classCallCheck(this, LatLng);
	
	    if (isNaN(lat) || isNaN(lng)) {
	      throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
	    }
	    this.lat = +lat;
	    this.lng = +lng;
	  }
	
	  _createClass(LatLng, [{
	    key: 'wrap',
	    value: function wrap() {
	      return new LatLng(this.lat, (0, _wrap2.wrap)(this.lng, -180, 180));
	    }
	  }]);
	
	  return LatLng;
	}();
	
	LatLng.convert = function (a) {
	  if (a instanceof LatLng) {
	    return a;
	  }
	
	  if (Array.isArray(a)) {
	    return new LatLng(a[0], a[1]);
	  }
	
	  if ('lng' in a && 'lat' in a) {
	    return new LatLng(a.lat, a.lng);
	  }
	
	  return a;
	};
	
	exports.default = LatLng;

/***/ },
/* 86 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.wrap = wrap;
	function wrap(n, min, max) {
	  var d = max - min;
	  return n === max ? n : ((n - min) % d + d) % d + min;
	}

/***/ },
/* 87 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// https://github.com/acdlite/recompose/blob/master/src/packages/recompose/utils/omit.js
	var omit = function omit(obj, keys) {
	  var rest = _objectWithoutProperties(obj, []);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (rest.hasOwnProperty(key)) {
	      delete rest[key];
	    }
	  }
	  return rest;
	};
	
	exports.default = omit;

/***/ },
/* 88 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = Point;
	
	function Point(x, y) {
	    this.x = x;
	    this.y = y;
	}
	
	Point.prototype = {
	    clone: function() { return new Point(this.x, this.y); },
	
	    add:     function(p) { return this.clone()._add(p);     },
	    sub:     function(p) { return this.clone()._sub(p);     },
	    mult:    function(k) { return this.clone()._mult(k);    },
	    div:     function(k) { return this.clone()._div(k);     },
	    rotate:  function(a) { return this.clone()._rotate(a);  },
	    matMult: function(m) { return this.clone()._matMult(m); },
	    unit:    function() { return this.clone()._unit(); },
	    perp:    function() { return this.clone()._perp(); },
	    round:   function() { return this.clone()._round(); },
	
	    mag: function() {
	        return Math.sqrt(this.x * this.x + this.y * this.y);
	    },
	
	    equals: function(p) {
	        return this.x === p.x &&
	               this.y === p.y;
	    },
	
	    dist: function(p) {
	        return Math.sqrt(this.distSqr(p));
	    },
	
	    distSqr: function(p) {
	        var dx = p.x - this.x,
	            dy = p.y - this.y;
	        return dx * dx + dy * dy;
	    },
	
	    angle: function() {
	        return Math.atan2(this.y, this.x);
	    },
	
	    angleTo: function(b) {
	        return Math.atan2(this.y - b.y, this.x - b.x);
	    },
	
	    angleWith: function(b) {
	        return this.angleWithSep(b.x, b.y);
	    },
	
	    // Find the angle of the two vectors, solving the formula for the cross product a x b = |a||b|sin(θ) for θ.
	    angleWithSep: function(x, y) {
	        return Math.atan2(
	            this.x * y - this.y * x,
	            this.x * x + this.y * y);
	    },
	
	    _matMult: function(m) {
	        var x = m[0] * this.x + m[1] * this.y,
	            y = m[2] * this.x + m[3] * this.y;
	        this.x = x;
	        this.y = y;
	        return this;
	    },
	
	    _add: function(p) {
	        this.x += p.x;
	        this.y += p.y;
	        return this;
	    },
	
	    _sub: function(p) {
	        this.x -= p.x;
	        this.y -= p.y;
	        return this;
	    },
	
	    _mult: function(k) {
	        this.x *= k;
	        this.y *= k;
	        return this;
	    },
	
	    _div: function(k) {
	        this.x /= k;
	        this.y /= k;
	        return this;
	    },
	
	    _unit: function() {
	        this._div(this.mag());
	        return this;
	    },
	
	    _perp: function() {
	        var y = this.y;
	        this.y = this.x;
	        this.x = -y;
	        return this;
	    },
	
	    _rotate: function(angle) {
	        var cos = Math.cos(angle),
	            sin = Math.sin(angle),
	            x = cos * this.x - sin * this.y,
	            y = sin * this.x + cos * this.y;
	        this.x = x;
	        this.y = y;
	        return this;
	    },
	
	    _round: function() {
	        this.x = Math.round(this.x);
	        this.y = Math.round(this.y);
	        return this;
	    }
	};
	
	// constructs Point from an array if necessary
	Point.convert = function (a) {
	    if (a instanceof Point) {
	        return a;
	    }
	    if (Array.isArray(a)) {
	        return new Point(a[0], a[1]);
	    }
	    return a;
	};


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(117);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(280);


/***/ },
/* 91 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(19);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(21);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactInstrumentation = __webpack_require__(13);
	
	var quoteAttributeValueForBrowser = __webpack_require__(329);
	var warning = __webpack_require__(4);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 94 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var LinkedValueUtils = __webpack_require__(51);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(14);
	
	var warning = __webpack_require__(4);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 96 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 97 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(3);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(288);
	
	var containsNode = __webpack_require__(159);
	var focusNode = __webpack_require__(72);
	var getActiveElement = __webpack_require__(73);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var DOMLazyTree = __webpack_require__(20);
	var DOMProperty = __webpack_require__(21);
	var React = __webpack_require__(23);
	var ReactBrowserEventEmitter = __webpack_require__(35);
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDOMContainerInfo = __webpack_require__(282);
	var ReactDOMFeatureFlags = __webpack_require__(284);
	var ReactFeatureFlags = __webpack_require__(97);
	var ReactInstanceMap = __webpack_require__(32);
	var ReactInstrumentation = __webpack_require__(13);
	var ReactMarkupChecksum = __webpack_require__(298);
	var ReactReconciler = __webpack_require__(22);
	var ReactUpdateQueue = __webpack_require__(54);
	var ReactUpdates = __webpack_require__(14);
	
	var emptyObject = __webpack_require__(27);
	var instantiateReactComponent = __webpack_require__(107);
	var invariant = __webpack_require__(3);
	var setInnerHTML = __webpack_require__(39);
	var shouldUpdateReactComponent = __webpack_require__(60);
	var warning = __webpack_require__(4);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var React = __webpack_require__(23);
	
	var invariant = __webpack_require__(3);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 102 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 104 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(101);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(7);
	
	var ReactCompositeComponent = __webpack_require__(279);
	var ReactEmptyComponent = __webpack_require__(96);
	var ReactHostComponent = __webpack_require__(98);
	
	var getNextDebugID = __webpack_require__(326);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 108 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	var escapeTextContentForBrowser = __webpack_require__(38);
	var setInnerHTML = __webpack_require__(39);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var REACT_ELEMENT_TYPE = __webpack_require__(294);
	
	var getIteratorFn = __webpack_require__(325);
	var invariant = __webpack_require__(3);
	var KeyEscapeUtils = __webpack_require__(50);
	var warning = __webpack_require__(4);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var ReactCurrentOwner = __webpack_require__(17);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 112 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 115 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(15)
	
	/**
	 * Snake case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale, '_')
	}


/***/ },
/* 117 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(119);

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(10);
	var bind = __webpack_require__(69);
	var Axios = __webpack_require__(121);
	var defaults = __webpack_require__(40);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(66);
	axios.CancelToken = __webpack_require__(120);
	axios.isCancel = __webpack_require__(67);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(135);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(66);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(40);
	var utils = __webpack_require__(10);
	var InterceptorManager = __webpack_require__(122);
	var dispatchRequest = __webpack_require__(123);
	var isAbsoluteURL = __webpack_require__(131);
	var combineURLs = __webpack_require__(129);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(10);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(10);
	var transformData = __webpack_require__(126);
	var isCancel = __webpack_require__(67);
	var defaults = __webpack_require__(40);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 124 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.response = response;
	  return error;
	};


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(68);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response
	    ));
	  }
	};


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(10);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 127 */
/***/ function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(10);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 129 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(10);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 131 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(10);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(10);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(10);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 135 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BuildingDetail = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var React = _interopRequireWildcard(_react);
	
	var _framework7React = __webpack_require__(11);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/// Displays information about the Building.
	///
	/// Shows the name, address, description, and architect, as well as an image
	/// of the building and an audio tour (if available).
	var BuildingDetail = exports.BuildingDetail = function (_React$Component) {
	    _inherits(BuildingDetail, _React$Component);
	
	    function BuildingDetail(props, context) {
	        _classCallCheck(this, BuildingDetail);
	
	        var _this = _possibleConstructorReturn(this, (BuildingDetail.__proto__ || Object.getPrototypeOf(BuildingDetail)).call(this, props, context));
	
	        _this.onClickAudio = function (url) {
	            if (url === '') {
	                return;
	            }
	
	            if (_this.state.playingAudio) {
	                _this.audio.pause();
	                _this.setState(function (prevState) {
	                    return { playingAudio: false };
	                });
	            } else {
	                _this.audio.src = url;
	                _this.audio.play();
	                _this.setState(function (prevState) {
	                    return { playingAudio: true };
	                });
	            }
	        };
	
	        _this.state = {
	            playingAudio: false
	        };
	        _this.audio = new Audio();
	        return _this;
	    }
	
	    _createClass(BuildingDetail, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.playingAudio && !nextProps.isVisible) {
	                this.audio.pause();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var playClassName = 'active audio-button';
	            var playText = 'Listen';
	            var playIcon = 'play_fill';
	            if (this.props.building.audio === '') {
	                playClassName += ' disabled color-gray';
	                playText = 'No audio available';
	                playIcon = '';
	            } else {
	                if (this.state.playingAudio) {
	                    playIcon = 'pause_fill';
	                }
	                if (this.state.playingAudio) {
	                    playClassName += ' color-green';
	                    playText = 'Pause';
	                }
	            }
	
	            var architectDisplay = this.props.building.architect === '' ? 'none' : '';
	            return React.createElement(
	                _framework7React.ContentBlock,
	                { className: 'building-detail-content' },
	                React.createElement(
	                    'h3',
	                    { className: 'building-header' },
	                    this.props.building.name
	                ),
	                React.createElement(
	                    'p',
	                    null,
	                    this.props.building.address
	                ),
	                React.createElement(
	                    'p',
	                    { style: { display: architectDisplay } },
	                    'Architect: ',
	                    React.createElement('span', { dangerouslySetInnerHTML: {
	                            __html: this.props.building.architectName
	                        } })
	                ),
	                React.createElement('div', { className: 'building-detail-image', style: {
	                        backgroundImage: 'url(' + this.props.building.image + ')'
	                    } }),
	                React.createElement(
	                    _framework7React.Button,
	                    { className: playClassName, onClick: function onClick(event) {
	                            return _this2.onClickAudio(_this2.props.building.audio);
	                        } },
	                    React.createElement(
	                        'i',
	                        { className: 'icon f7-icons play-icon' },
	                        playIcon
	                    ),
	                    playText
	                ),
	                React.createElement('div', { className: 'building-description', dangerouslySetInnerHTML: {
	                        __html: this.props.building.description
	                    } }),
	                React.createElement(
	                    'a',
	                    { href: '#', className: 'close-popup' },
	                    'Close'
	                ),
	                React.createElement(
	                    'i',
	                    { className: 'close-popup building-detail-upper-close f7-icons ' },
	                    'close_round'
	                )
	            );
	        }
	    }]);
	
	    return BuildingDetail;
	}(React.Component);

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BuildingDetailPopup = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var React = _interopRequireWildcard(_react);
	
	var _BuildingDetail = __webpack_require__(136);
	
	var _framework7React = __webpack_require__(11);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BuildingDetailPopup = exports.BuildingDetailPopup = function (_React$Component) {
	    _inherits(BuildingDetailPopup, _React$Component);
	
	    function BuildingDetailPopup(props, context) {
	        _classCallCheck(this, BuildingDetailPopup);
	
	        var _this = _possibleConstructorReturn(this, (BuildingDetailPopup.__proto__ || Object.getPrototypeOf(BuildingDetailPopup)).call(this, props, context));
	
	        _this.state = {
	            isOpen: false
	        };
	        return _this;
	    }
	
	    _createClass(BuildingDetailPopup, [{
	        key: 'onPopupClose',
	        value: function onPopupClose() {
	            this.setState({ isOpen: false });
	        }
	    }, {
	        key: 'onPopupOpen',
	        value: function onPopupOpen() {
	            this.setState({ isOpen: true });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return React.createElement(
	                _framework7React.Popup,
	                { className: this.props.slug,
	                    tabletFullscreen: 'true',
	                    onPopupOpen: this.onPopupOpen.bind(this),
	                    onPopupClose: this.onPopupClose.bind(this) },
	                React.createElement(_BuildingDetail.BuildingDetail, { building: this.props.building, isVisible: this.state.isOpen })
	            );
	        }
	    }]);
	
	    return BuildingDetailPopup;
	}(React.Component);

/***/ },
/* 138 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// Base-64 encoded images for the IAF icon used in the about tab.
	// The original images can be found in src/assets
	
	var IAF_ICON = exports.IAF_ICON = {
	    ACTIVE: "data:image/png;base64,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",
	    INACTIVE: "data:image/png;base64,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"
	};

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _framework7React = __webpack_require__(11);
	
	var _App = __webpack_require__(26);
	
	var _About = __webpack_require__(145);
	
	var _ToursList = __webpack_require__(148);
	
	var _Map = __webpack_require__(146);
	
	var _BuildingDetailPopup = __webpack_require__(137);
	
	var _Search = __webpack_require__(147);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _axios = __webpack_require__(118);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _EncodedIAFIcons = __webpack_require__(138);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainViews = function (_Component) {
		_inherits(MainViews, _Component);
	
		function MainViews(props, context) {
			_classCallCheck(this, MainViews);
	
			var _this2 = _possibleConstructorReturn(this, (MainViews.__proto__ || Object.getPrototypeOf(MainViews)).call(this, props, context));
	
			_this2.getBuildingForSlug = function (buildingSlug) {
				return _this2.state.buildings.find(function (b) {
					return b.slug === buildingSlug;
				});
			};
	
			_this2.state = {
				buildings: [],
				tours: [],
				architects: [],
				activeRoute: '#map',
				activeTour: null
			};
			var _this = _this2;
			_axios2.default.get('https://www.iowaarchfoundation.org/wp-json/appData?r=' + Date.now()).then(function (res) {
				_this.setState(function (prevState) {
					return {
						buildings: res.data.buildings,
						tours: res.data.tours,
						architects: res.data.architects,
						config: res.data.config,
						remoteContent: res.data.pages
					};
				});
	
				// preload the building images
				res.data.buildings.forEach(function (b) {
					return new Image().src = b.image;
				});
			}).catch(function (_) {
				// alert('Unable to Reach IAF Server. Please check your connection.');
			});
	
			_this2.openMap = _this2.openMap.bind(_this2);
			_this2.openTour = _this2.openTour.bind(_this2);
			_this2.setTour = _this2.setTour.bind(_this2);
			return _this2;
		}
	
		_createClass(MainViews, [{
			key: 'onClick',
			value: function onClick(route) {
				this.setState({
					activeRoute: route
				});
			}
		}, {
			key: 'getLinkClass',
			value: function getLinkClass(route) {
				return route === this.state.activeRoute ? 'active' : '';
			}
		}, {
			key: 'setTour',
			value: function setTour(tour) {
				this.setState({
					activeTour: tour
				});
			}
		}, {
			key: 'openTour',
			value: function openTour() {
				(0, _App.getFramework7)().mainView.router.loadPage("#tour");
				this.setState({
					activeRoute: "#tour"
				});
			}
		}, {
			key: 'openMap',
			value: function openMap() {
				(0, _App.getFramework7)().mainView.router.loadPage("#map");
				this.setState({
					activeRoute: "#map"
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var popups = [];
				this.state.buildings.forEach(function (building) {
					popups.push(_react2.default.createElement(_BuildingDetailPopup.BuildingDetailPopup, { key: building.slug, building: building, slug: 'popup-' + building.slug }));
				});
	
				var mapBuildings = [];
				if (this.state.activeTour != null) {
	
					this.state.activeTour.buildings.forEach(function (buildingSlug) {
						return mapBuildings.push(_this3.getBuildingForSlug(buildingSlug));
					});
				} else {
					mapBuildings = this.state.buildings;
				}
	
				var aboutIcon = '#about' === this.state.activeRoute ? _EncodedIAFIcons.IAF_ICON.ACTIVE : _EncodedIAFIcons.IAF_ICON.INACTIVE;
	
				return _react2.default.createElement(
					_framework7React.Views,
					null,
					_react2.default.createElement(
						_framework7React.View,
						{ name: 'home', main: true, url: '/' },
						this.context.framework7AppContext.theme.ios ? _react2.default.createElement(
							_framework7React.Toolbar,
							{ className: 'tabbar tabbar-labels' },
							_react2.default.createElement(
								_framework7React.Link,
								{ href: '#map', iconF7: 'compass_fill',
									onClick: function onClick(event) {
										return _this3.onClick('#map');
									},
									className: this.getLinkClass('#map') },
								'Explore'
							),
							_react2.default.createElement(
								_framework7React.Link,
								{ href: '#tour', iconF7: 'navigation_fill',
									onClick: function onClick(event) {
										return _this3.onClick('#tour');
									},
									className: this.getLinkClass('#tour') },
								'Tours'
							),
							_react2.default.createElement(
								_framework7React.Link,
								{ iconF7: 'search_fill', href: '#search',
									onClick: function onClick(event) {
										return _this3.onClick('#search');
									},
									className: this.getLinkClass('#search') },
								'Buildings'
							),
							_react2.default.createElement(
								_framework7React.Link,
								{ href: '#about',
									onClick: function onClick(event) {
										return _this3.onClick('#about');
									},
									className: this.getLinkClass('#about') },
								_react2.default.createElement('img', { src: aboutIcon,
									alt: 'About Icon',
									role: 'presentation',
									className: 'about-toolbar-icon' }),
								'About'
							)
						) : null,
						_react2.default.createElement(
							_framework7React.Pages,
							null,
							_react2.default.createElement(
								_framework7React.Page,
								{ name: 'map', className: 'page-on-center explore-page' },
								_react2.default.createElement(_Map.MapPage, { buildings: mapBuildings, tour: this.state.activeTour, config: this.state.config, openTour: this.openTour, cancelTour: function cancelTour() {
										_this3.setTour(null);
									} })
							),
							_react2.default.createElement(
								_framework7React.Page,
								{ className: 'about-page', name: 'about', cached: 'true' },
								_react2.default.createElement(_About.About, { content: this.state.remoteContent !== undefined ? this.state.remoteContent.about : null })
							),
							_react2.default.createElement(
								_framework7React.Page,
								{ name: 'tour', cached: 'true' },
								_react2.default.createElement(_ToursList.ToursList, { tour: this.state.activeTour, buildings: this.state.buildings, tours: this.state.tours, openMap: this.openMap, setTour: this.setTour })
							),
							_react2.default.createElement(
								_framework7React.Page,
								{ className: 'search-page', name: 'search', cached: 'true' },
								_react2.default.createElement(_Search2.default, { buildings: this.state.buildings })
							)
						)
					),
					_react2.default.createElement(
						'div',
						null,
						popups
					)
				);
			}
		}]);
	
		return MainViews;
	}(_react.Component);
	
	exports.default = MainViews;
	
	
	MainViews.contextTypes = {
		framework7AppContext: _react.PropTypes.object
	};

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
					value: true
	});
	exports.MapDisplay = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var React = _interopRequireWildcard(_react);
	
	var _googleMapReact = __webpack_require__(242);
	
	var _googleMapReact2 = _interopRequireDefault(_googleMapReact);
	
	var _App = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactMapIcon = React.createClass({
					displayName: 'ReactMapIcon',
	
					render: function render() {
									return React.createElement(
													'div',
													{ style: { position: 'relative', left: "-15px", top: "-40px" } },
													React.createElement(
																	'svg',
																	{ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 48 48', className: 'building-icon', onClick: this.props.clickHandler },
																	React.createElement('path', { fill: '#606162',
																					d: 'M24 0c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z' }),
																	React.createElement('circle', { fill: '#FFFFFF', cx: '24', cy: '20', r: '10' })
													),
													React.createElement(
																	'label',
																	{ style: { textAlign: 'center', top: '11px', width: '40px', position: 'absolute', pointerEvents: 'none' } },
																	this.props.index
													)
									);
					}
	});
	
	var UsrIcon = function UsrIcon() {
					return React.createElement(
									'div',
									{ style: { position: 'relative', left: "-5px", top: "-5px" } },
									React.createElement(
													'svg',
													{ xmlns: 'http://www.w3.org/2000/svg', width: '10', height: '10', viewBox: '0 0 10 10' },
													React.createElement('circle', { fill: '#007aff', cx: '5', cy: '5', r: '5' })
									)
					);
	};
	
	var MapDisplay = exports.MapDisplay = function (_React$Component) {
					_inherits(MapDisplay, _React$Component);
	
					function MapDisplay(props) {
									_classCallCheck(this, MapDisplay);
	
									var _this = _possibleConstructorReturn(this, (MapDisplay.__proto__ || Object.getPrototypeOf(MapDisplay)).call(this, props));
	
									_this.state = {
													startingPositionSet: false,
													startingLat: 41.585013,
													startingLng: -93.624471
									};
									return _this;
					}
	
					_createClass(MapDisplay, [{
									key: 'componentDidMount',
									value: function componentDidMount() {
													var locationWatch = navigator.geolocation.watchPosition(this.onUserPositionChanged.bind(this), this.onUserPositionError.bind(this), { timeout: 30000, enableHighAccuracy: true });
	
													this.setState({ locationWatch: locationWatch });
									}
					}, {
									key: 'componentWillUnmount',
									value: function componentWillUnmount() {
													if (this.state.locationWatch != null) {
																	navigator.geolocation.clearWatch(this.state.locationWatch);
													}
									}
					}, {
									key: 'onUserPositionChanged',
									value: function onUserPositionChanged(position) {
													if (!this.state.startingPositionSet) {
																	this.setState({
																					startinglat: position.coords.latitude,
																					startingLng: position.coords.longitude,
																					startingPositionSet: true
																	});
													}
													this.setState({
																	userLat: position.coords.latitude,
																	userLng: position.coords.longitude
													});
									}
					}, {
									key: 'onUserPositionError',
									value: function onUserPositionError(error) {
													// alert('code: ' + error.code + '\n' + 'message: ' + error.message + '\n');
									}
					}, {
									key: 'render',
									value: function render() {
													if (this.props.config === undefined) {
																	return React.createElement('div', null);
													}
	
													var icons = [];
													var showNumbers = this.props.showNumbers;
	
													this.props.buildings.forEach(function (building, index) {
																	icons.push(React.createElement(ReactMapIcon, {
																					key: building.slug + '-icon',
																					lat: building.lat,
																					lng: building.lng,
																					index: showNumbers ? index + 1 : "",
																					clickHandler: function clickHandler(_) {
																									(0, _App.getFramework7)().popup(".popup-" + building.slug);
																					}
																	}));
													});
	
													icons.push(React.createElement(UsrIcon, { key: 'userIcon', lat: this.state.userLat, lng: this.state.userLng }));
	
													return React.createElement(
																	_googleMapReact2.default,
																	{
																					key: 'mapDisplay',
																					bootstrapURLKeys: { key: this.props.config.mapApiKey },
																					center: { lat: this.state.startingLat, lng: this.state.startingLng },
																					zoom: 16,
																					style: this.props.style },
																	icons
													);
									}
					}]);
	
					return MapDisplay;
	}(React.Component);

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _framework7React = __webpack_require__(11);
	
	var _SearchRow = __webpack_require__(142);
	
	var _SearchRow2 = _interopRequireDefault(_SearchRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/// Search results from the Buildings tab.
	///
	/// This component renders a SearchRow for each building that matches
	/// the current search text.
	var SearchResult = function (_Component) {
	    _inherits(SearchResult, _Component);
	
	    function SearchResult() {
	        _classCallCheck(this, SearchResult);
	
	        return _possibleConstructorReturn(this, (SearchResult.__proto__ || Object.getPrototypeOf(SearchResult)).apply(this, arguments));
	    }
	
	    _createClass(SearchResult, [{
	        key: 'render',
	        value: function render() {
	            var buildings = this.props.buildings;
	            var search = new RegExp('.*' + this.props.searchTerm + '.*', 'im');
	            var buildingItems = [];
	            var matchBuildings = [];
	
	            buildings.forEach(function (item) {
	                if (item.name.match(search) || item.architect.match(search)) {
	                    matchBuildings.push(item);
	                }
	            });
	
	            if (matchBuildings.length === 0) {
	                buildings.forEach(function (item) {
	                    if (item.description.match(search)) {
	                        matchBuildings.push(item);
	                    }
	                });
	            }
	
	            matchBuildings.forEach(function (item) {
	                buildingItems.push(_react2.default.createElement(
	                    _framework7React.ListItem,
	                    { key: item.slug },
	                    _react2.default.createElement(_SearchRow2.default, { building: item })
	                ));
	            });
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _framework7React.List,
	                    { className: 'remove-top-margin', form: true },
	                    buildingItems
	                )
	            );
	        }
	    }]);
	
	    return SearchResult;
	}(_react.Component);
	
	exports.default = SearchResult;
	;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _framework7React = __webpack_require__(11);
	
	var _App = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/// Allows us to handle HTML content retrieved from Wordpress.
	function createMarkup(markup) {
	    return { __html: markup };
	}
	
	/// A search result representing a building.
	///
	/// The buildings tab displays a list of SearchRow components which makes
	/// up the search results.
	
	var SearchRow = function (_Component) {
	    _inherits(SearchRow, _Component);
	
	    /// Setup this component to handle opening the corresponding popup.
	    function SearchRow(props, context) {
	        _classCallCheck(this, SearchRow);
	
	        var _this = _possibleConstructorReturn(this, (SearchRow.__proto__ || Object.getPrototypeOf(SearchRow)).call(this, props, context));
	
	        _this.showDetail = function () {
	            (0, _App.getFramework7)().popup('.popup-' + _this.props.building.slug);
	        };
	
	        _this.showDetail = _this.showDetail.bind(_this);
	        return _this;
	    }
	
	    /// Open the BuildingDetailPopup showing more information about the building.
	
	
	    _createClass(SearchRow, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'search-row', onClick: this.showDetail },
	                _react2.default.createElement(
	                    _framework7React.Card,
	                    null,
	                    _react2.default.createElement(
	                        _framework7React.CardHeader,
	                        null,
	                        this.props.building.name,
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'chevron_right f7-icons' },
	                            'chevron_right'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _framework7React.CardContent,
	                        null,
	                        _react2.default.createElement('div', { dangerouslySetInnerHTML: createMarkup(this.props.building.description) })
	                    ),
	                    _react2.default.createElement(
	                        _framework7React.CardFooter,
	                        null,
	                        _react2.default.createElement(
	                            _framework7React.Button,
	                            null,
	                            'View More'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SearchRow;
	}(_react.Component);
	
	exports.default = SearchRow;
	;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Tour = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var React = _interopRequireWildcard(_react);
	
	var _framework7React = __webpack_require__(11);
	
	var _TourTimeline = __webpack_require__(144);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tour = exports.Tour = function (_React$Component) {
	    _inherits(Tour, _React$Component);
	
	    function Tour(props, context) {
	        _classCallCheck(this, Tour);
	
	        var _this = _possibleConstructorReturn(this, (Tour.__proto__ || Object.getPrototypeOf(Tour)).call(this, props, context));
	
	        _this.getBuildingForSlug = function (buildingSlug) {
	            return _this.props.buildings.find(function (b) {
	                return b.slug === buildingSlug;
	            });
	        };
	
	        _this.state = {
	            isListActive: true
	        };
	        return _this;
	    }
	
	    _createClass(Tour, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var tourBuildings = [];
	
	            this.props.tour.buildings.forEach(function (buildingSlug) {
	                return tourBuildings.push(_this2.getBuildingForSlug(buildingSlug));
	            });
	
	            return React.createElement(
	                'div',
	                { style: { paddingBottom: 60 } },
	                React.createElement(
	                    _framework7React.ContentBlockTitle,
	                    null,
	                    this.props.tour.name
	                ),
	                React.createElement(
	                    _framework7React.ContentBlock,
	                    { className: 'tour-map-button' },
	                    React.createElement(
	                        _framework7React.Button,
	                        { className: 'active', onClick: function onClick() {
	                                return _this2.props.openMap();
	                            }, style: { margin: '0 auto', width: 115 } },
	                        'View On Map'
	                    )
	                ),
	                React.createElement(_TourTimeline.TourTimeline, { tour: this.props.tour, buildings: this.props.buildings }),
	                React.createElement(
	                    'i',
	                    { onClick: this.props.onClose, className: 'building-detail-upper-close f7-icons ' },
	                    'close_round'
	                )
	            );
	        }
	    }]);
	
	    return Tour;
	}(React.Component);

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TourTimeline = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var React = _interopRequireWildcard(_react);
	
	var _framework7React = __webpack_require__(11);
	
	var _App = __webpack_require__(26);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TourTimeline = exports.TourTimeline = function (_React$Component) {
	    _inherits(TourTimeline, _React$Component);
	
	    function TourTimeline(props, context) {
	        _classCallCheck(this, TourTimeline);
	
	        var _this = _possibleConstructorReturn(this, (TourTimeline.__proto__ || Object.getPrototypeOf(TourTimeline)).call(this, props, context));
	
	        _this.createTimelineItem = function (buildingSlug) {
	            var building = _this.props.buildings.find(function (b) {
	                return b.slug === buildingSlug;
	            });
	
	            var playIcon = void 0;
	            if (building.audio !== '') {
	                var thisBuildingPlaying = _this.state.isPlaying && _this.state.selectedTrack === building.audio;
	                var playClass = "timeline-play-button f7-icons ";
	                if (thisBuildingPlaying) {
	                    playClass += "color-green";
	                } else {
	                    playClass += "color-blue";
	                }
	                playIcon = React.createElement(
	                    'i',
	                    { onClick: _this.handlePlayClicked.bind({ myThis: _this, building: building }),
	                        className: playClass },
	                    thisBuildingPlaying ? 'pause_round_fill' : 'play_round_fill'
	                );
	            } else {
	                playIcon = React.createElement(
	                    'i',
	                    { onClick: function onClick() {
	                            (0, _App.getFramework7)().alert('Sorry, we do not have an audio track available for this site at this time.', 'No Track Available');
	                        }, className: 'timeline-play-button f7-icons color-gray' },
	                    'play_round'
	                );
	            }
	
	            return React.createElement(
	                'div',
	                { className: 'timeline-item', key: buildingSlug },
	                React.createElement(
	                    'div',
	                    { className: 'timeline-item-date' },
	                    playIcon
	                ),
	                React.createElement('div', { className: 'timeline-item-divider' }),
	                React.createElement(
	                    'div',
	                    { className: 'timeline-item-content tour-building-card' },
	                    React.createElement(
	                        _framework7React.Card,
	                        null,
	                        React.createElement(
	                            'div',
	                            { className: 'timeline-item-title', onClick: function onClick() {
	                                    return (0, _App.getFramework7)().popup('.popup-' + building.slug);
	                                } },
	                            React.createElement(
	                                _framework7React.CardHeader,
	                                null,
	                                building.name,
	                                React.createElement(
	                                    'i',
	                                    { className: 'chevron_right f7-icons' },
	                                    'chevron_right'
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        };
	
	        _this.audio = new Audio();
	        _this.state = {
	            selectedTrack: '',
	            isPlaying: false
	        };
	        return _this;
	    }
	
	    _createClass(TourTimeline, [{
	        key: 'handlePlayClicked',
	        value: function handlePlayClicked() {
	            var _this2 = this;
	
	            if (this.myThis.state.selectedTrack === this.building.audio) {
	                if (this.myThis.state.isPlaying) {
	                    this.myThis.audio.pause();
	                } else {
	                    this.myThis.audio.play();
	                }
	                this.myThis.setState(function (prevState) {
	                    return { isPlaying: !_this2.myThis.state.isPlaying };
	                });
	            } else {
	                this.myThis.audio.src = this.building.audio;
	                this.myThis.audio.play();
	                this.myThis.setState(function (prevState) {
	                    return { selectedTrack: _this2.building.audio };
	                });
	                this.myThis.setState(function (prevState) {
	                    return { isPlaying: true };
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return React.createElement(
	                _framework7React.Timeline,
	                null,
	                this.props.tour.buildings.map(this.createTimelineItem)
	            );
	        }
	    }]);
	
	    return TourTimeline;
	}(React.Component);

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.About = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _framework7React = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/// Displays basic information about the Iowa Architecture Foundation.
	var About = exports.About = function (_Component) {
	    _inherits(About, _Component);
	
	    function About() {
	        _classCallCheck(this, About);
	
	        return _possibleConstructorReturn(this, (About.__proto__ || Object.getPrototypeOf(About)).apply(this, arguments));
	    }
	
	    _createClass(About, [{
	        key: 'render',
	        value: function render() {
	            if (this.props.content === null) {
	                return _react2.default.createElement(
	                    _framework7React.Page,
	                    null,
	                    _react2.default.createElement(
	                        _framework7React.ContentBlockTitle,
	                        null,
	                        'Welcome to IAF Tours!'
	                    )
	                );
	            }
	
	            return _react2.default.createElement(
	                _framework7React.Page,
	                null,
	                _react2.default.createElement(
	                    _framework7React.ContentBlockTitle,
	                    null,
	                    this.props.content.title
	                ),
	                _react2.default.createElement(
	                    _framework7React.ContentBlock,
	                    { inner: true },
	                    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.props.content.content } })
	                )
	            );
	        }
	    }]);

	    return About;
	}(_react.Component);

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MapPage = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var React = _interopRequireWildcard(_react);
	
	var _framework7React = __webpack_require__(11);
	
	var _MapDisplay = __webpack_require__(140);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/// Page container for the MapDisplay shown on the Explore tab.
	var MapPage = exports.MapPage = function (_React$Component) {
	    _inherits(MapPage, _React$Component);
	
	    function MapPage() {
	        _classCallCheck(this, MapPage);
	
	        return _possibleConstructorReturn(this, (MapPage.__proto__ || Object.getPrototypeOf(MapPage)).apply(this, arguments));
	    }
	
	    _createClass(MapPage, [{
	        key: 'render',
	        value: function render() {
	            var buttons;
	            if (this.props.tour != null) {
	                buttons = React.createElement(
	                    'div',
	                    null,
	                    React.createElement(
	                        _framework7React.Button,
	                        { onClick: this.props.cancelTour, className: 'active', id: 'tour-x' },
	                        'X'
	                    ),
	                    React.createElement(
	                        _framework7React.Button,
	                        { onClick: this.props.openTour, className: 'active', id: 'active-tour' },
	                        this.props.tour.name
	                    )
	                );
	            }
	
	            return React.createElement(
	                _framework7React.Page,
	                { 'class': 'map-page' },
	                buttons,
	                React.createElement(_MapDisplay.MapDisplay, { buildings: this.props.buildings, config: this.props.config, showNumbers: this.props.tour != null })
	            );
	        }
	    }]);
	
	    return MapPage;
	}(React.Component);
	
	;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _framework7React = __webpack_require__(11);
	
	var _SearchResult = __webpack_require__(141);
	
	var _SearchResult2 = _interopRequireDefault(_SearchResult);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/// Displays a searchable list of buildings.
	var Search = function (_Component) {
	    _inherits(Search, _Component);
	
	    function Search(props, context) {
	        _classCallCheck(this, Search);
	
	        var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props, context));
	
	        _this.handleInput = function (e) {
	            if (e.key === 'Enter') {
	                e.preventDefault();
	            }
	
	            var value = document.querySelector('#search input').value;
	            _this.setState(function (prevState) {
	                return { searchTerm: value };
	            });
	        };
	
	        _this.state = {
	            searchTerm: ''
	        };
	        return _this;
	    }
	
	    _createClass(Search, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _framework7React.Page,
	                null,
	                _react2.default.createElement(_framework7React.Searchbar, { id: 'search', onInput: this.handleInput }),
	                _react2.default.createElement('div', { className: 'statusbar-overlay' }),
	                _react2.default.createElement(_SearchResult2.default, { buildings: this.props.buildings, searchTerm: this.state.searchTerm })
	            );
	        }
	    }]);
	
	    return Search;
	}(_react.Component);
	
	exports.default = Search;
	;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ToursList = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var React = _interopRequireWildcard(_react);
	
	var _framework7React = __webpack_require__(11);
	
	var _Tour = __webpack_require__(143);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var divStyle = {
	    display: "flex",
	    justifyContent: "space-between",
	    padding: "10px"
	};
	
	function isEmptyObject(obj) {
	    for (var key in obj) {
	        if (obj.hasOwnProperty(key)) return false;
	    }
	    return true;
	};
	
	/// Display a list of Tours.
	///
	/// Clicking a tour list item will open the corresponding TourPopup containing
	/// a list and map view of the tour.
	
	var ToursList = exports.ToursList = function (_React$Component) {
	    _inherits(ToursList, _React$Component);
	
	    function ToursList(props) {
	        _classCallCheck(this, ToursList);
	
	        var _this = _possibleConstructorReturn(this, (ToursList.__proto__ || Object.getPrototypeOf(ToursList)).call(this, props));
	
	        _this.state = {};
	
	        _this.selectTour = _this.selectTour.bind(_this);
	        _this.createTourCard = _this.createTourCard.bind(_this);
	        return _this;
	    }
	
	    _createClass(ToursList, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (!this.state.buildingsMap || isEmptyObject(this.state.buildingsMap)) {
	                this.constructBuildingsMap(this.props.buildings);
	            }
	        }
	    }, {
	        key: 'constructBuildingsMap',
	        value: function constructBuildingsMap(buildings) {
	            var buildingsMap = {};
	            this.props.buildings.forEach(function (b) {
	                buildingsMap[b.slug] = b;
	            });
	
	            this.setState(function (prevState) {
	                return { buildingsMap: buildingsMap };
	            });
	        }
	    }, {
	        key: 'selectTour',
	        value: function selectTour(t) {
	            this.props.setTour(t);
	        }
	    }, {
	        key: 'createTourCard',
	        value: function createTourCard(t) {
	            var _this2 = this;
	
	            return React.createElement(
	                'div',
	                { className: 'tour-card', key: t.slug },
	                React.createElement(
	                    _framework7React.Card,
	                    null,
	                    React.createElement(
	                        'div',
	                        { onClick: function onClick() {
	                                _this2.selectTour(t);
	                            } },
	                        React.createElement(
	                            _framework7React.CardHeader,
	                            null,
	                            t.name,
	                            React.createElement(
	                                'i',
	                                { className: 'chevron_right f7-icons' },
	                                'chevron_right'
	                            )
	                        ),
	                        React.createElement(
	                            _framework7React.CardContent,
	                            null,
	                            t.buildings.length > 0 && React.createElement(
	                                'div',
	                                { style: divStyle },
	                                t.buildings.length,
	                                ' ',
	                                t.buildings.length === 1 ? " building" : " buildings"
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            if (this.props.tour != null) {
	                return React.createElement(
	                    _framework7React.Page,
	                    { style: { background: "white" }, key: 'white' },
	                    React.createElement(_Tour.Tour, {
	                        openMap: this.props.openMap,
	                        tour: this.props.tour,
	                        buildings: this.props.buildings,
	                        onClose: function onClose() {
	                            _this3.selectTour(null);
	                        } })
	                );
	            }
	            var tours = this.props.tours.map(this.createTourCard);
	            return React.createElement(
	                _framework7React.Page,
	                { className: 'tour-list-page' },
	                React.createElement(
	                    _framework7React.ContentBlockTitle,
	                    null,
	                    'Tours'
	                ),
	                React.createElement(
	                    _framework7React.List,
	                    null,
	                    tours
	                )
	            );
	        }
	    }]);
	
	    return ToursList;
	}(React.Component);

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(155);
	
	__webpack_require__(154);
	
	__webpack_require__(153);
	
	__webpack_require__(156);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(90);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* OR for Material Theme:
	import 'framework7/dist/css/framework7.material.min.css'
	import 'framework7/dist/css/framework7.material.colors.min.css'
	*/
	
	window.renderApp = function () {
		_reactDom2.default.render(_react2.default.createElement(_App.App, null), document.getElementById('root'));
	};

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(18)
	var snakeCase = __webpack_require__(116)
	
	/**
	 * Constant case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return upperCase(snakeCase(value, locale), locale)
	}


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(15)
	
	/**
	 * Dot case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale, '.')
	}


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	//
	// We store our EE objects in a plain object whose properties are event names.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// `~` to make sure that the built-in object properties are not overridden or
	// used as an attack vector.
	// We also assume that `Object.create(null)` is available when the event name
	// is an ES6 Symbol.
	//
	var prefix = typeof Object.create !== 'function' ? '~' : false;
	
	/**
	 * Representation of a single EventEmitter function.
	 *
	 * @param {Function} fn Event handler to be called.
	 * @param {Mixed} context Context for function execution.
	 * @param {Boolean} [once=false] Only emit once
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal EventEmitter interface that is molded against the Node.js
	 * EventEmitter interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() { /* Nothing to set */ }
	
	/**
	 * Hold the assigned EventEmitters by name.
	 *
	 * @type {Object}
	 * @private
	 */
	EventEmitter.prototype._events = undefined;
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var events = this._events
	    , names = []
	    , name;
	
	  if (!events) return names;
	
	  for (name in events) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return a list of assigned event listeners.
	 *
	 * @param {String} event The events that should be listed.
	 * @param {Boolean} exists We only need to know if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events && this._events[evt];
	
	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];
	
	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Emit an event to all registered event listeners.
	 *
	 * @param {String} event The name of the event.
	 * @returns {Boolean} Indication if we've emitted an event.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if ('function' === typeof listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Register a new EventListener for the given event.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} [context=this] The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Add an EventListener that's only called once.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} [context=this] The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Remove event listeners.
	 *
	 * @param {String} event The event we want to remove.
	 * @param {Function} fn The listener that we need to find.
	 * @param {Mixed} context Only remove listeners matching this context.
	 * @param {Boolean} once Only remove once listeners.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return this;
	
	  var listeners = this._events[evt]
	    , events = [];
	
	  if (fn) {
	    if (listeners.fn) {
	      if (
	           listeners.fn !== fn
	        || (once && !listeners.once)
	        || (context && listeners.context !== context)
	      ) {
	        events.push(listeners);
	      }
	    } else {
	      for (var i = 0, length = listeners.length; i < length; i++) {
	        if (
	             listeners[i].fn !== fn
	          || (once && !listeners[i].once)
	          || (context && listeners[i].context !== context)
	        ) {
	          events.push(listeners[i]);
	        }
	      }
	    }
	  }
	
	  //
	  // Reset the array, or remove it completely if we have no more listeners.
	  //
	  if (events.length) {
	    this._events[evt] = events.length === 1 ? events[0] : events;
	  } else {
	    delete this._events[evt];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners or only the listeners for the specified event.
	 *
	 * @param {String} event The event want to remove all listeners for.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  if (!this._events) return this;
	
	  if (event) delete this._events[prefix ? prefix + event : event];
	  else this._events = prefix ? {} : Object.create(null);
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ },
/* 153 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 154 */
153,
/* 155 */
153,
/* 156 */
153,
/* 157 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(157);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(167);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var createArrayFromMixed = __webpack_require__(160);
	var getMarkupWrap = __webpack_require__(162);
	var invariant = __webpack_require__(3);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 163 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 164 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(164);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 166 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(166);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 168 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Accordion = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueAccordion,
	    tag: 'f7-accordion'
	});
	
	//# sourceMappingURL=Accordion.js.map


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.AccordionContent = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueAccordionContent,
	    tag: 'f7-accordion-content'
	});
	
	//# sourceMappingURL=AccordionContent.js.map


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.AccordionItem = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueAccordionItem,
	    tag: 'f7-accordion-item',
	    events: [
	        'accordion:open',
	        'accordion:opened',
	        'accordion:close',
	        'accordion:closed'
	    ]
	});
	
	//# sourceMappingURL=AccordionItem.js.map


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.AccordionToggle = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueAccordionToggle,
	    tag: 'f7-accordion-toggle'
	});
	
	//# sourceMappingURL=AccordionToggle.js.map


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Actions = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueActions,
	    tag: 'f7-actions',
	    events: [
	        'actions:open',
	        'actions:opened',
	        'actions:close',
	        'actions:closed'
	    ]
	});
	
	//# sourceMappingURL=Actions.js.map


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.ActionsButton = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueActionsButton,
	    tag: 'f7-actions-button',
	    events: [
	        'click'
	    ]
	});
	
	//# sourceMappingURL=ActionsButton.js.map


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.ActionsGroup = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueActionsGroup,
	    tag: 'f7-actions-group'
	});
	
	//# sourceMappingURL=ActionsGroup.js.map


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.ActionsLabel = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueActionsLabel,
	    tag: 'f7-actions-label',
	    events: [
	        'click'
	    ]
	});
	
	//# sourceMappingURL=ActionsLabel.js.map


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	var Icon_1 = __webpack_require__(43);
	var framework7_vue_2 = __webpack_require__(1);
	exports.Button = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueButton,
	    tag: 'f7-button',
	    events: [
	        'click'
	    ],
	    instantiatedComponents: [
	        Icon_1.Icon
	    ],
	    mixin: framework7_vue_2.VueLinkMixin
	});
	
	//# sourceMappingURL=Button.js.map


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.ButtonsSegmented = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueButtonsSegmented,
	    tag: 'f7-segmented'
	});
	
	//# sourceMappingURL=ButtonsSegmented.js.map


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	var CardHeader_1 = __webpack_require__(76);
	var CardFooter_1 = __webpack_require__(75);
	var CardContent_1 = __webpack_require__(74);
	exports.Card = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueCard,
	    tag: 'f7-card',
	    instantiatedComponents: [
	        CardHeader_1.CardHeader,
	        CardFooter_1.CardFooter,
	        CardContent_1.CardContent
	    ]
	});
	
	//# sourceMappingURL=Card.js.map


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Chip = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueChip,
	    tag: 'f7-chip',
	    events: [
	        'click',
	        'delete'
	    ]
	});
	
	//# sourceMappingURL=Chip.js.map


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.ContentBlock = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueContentBlock,
	    tag: 'f7-block',
	    events: [
	        'tab:show',
	        'tab:hide'
	    ]
	});
	
	//# sourceMappingURL=ContentBlock.js.map


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.ContentBlockTitle = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueContentBlockTitle,
	    tag: 'f7-list-block-title'
	});
	
	//# sourceMappingURL=ContentBlockTitle.js.map


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Fab = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueFab,
	    tag: 'f7-fab',
	    events: [
	        'click'
	    ]
	});
	
	//# sourceMappingURL=Fab.js.map


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.FabSpeedDial = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueFabSpeedDial,
	    tag: 'f7-fab-speed-dial'
	});
	
	//# sourceMappingURL=FabSpeedDial.js.map


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.FabSpeedDialAction = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueFabSpeedDialAction,
	    tag: 'undefined',
	    events: [
	        'click'
	    ]
	});
	
	//# sourceMappingURL=FabSpeedDialAction.js.map


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.FabSpeedDialActions = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueFabSpeedDialActions,
	    tag: 'undefined'
	});
	
	//# sourceMappingURL=FabSpeedDialActions.js.map


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	var FormSwitch_1 = __webpack_require__(78);
	var FormRange_1 = __webpack_require__(77);
	exports.FormInput = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueFormInput,
	    tag: 'f7-input',
	    events: [
	        'input',
	        'focus',
	        'blur',
	        'change',
	        'click',
	        'keypress',
	        'keyup',
	        'keydown',
	        'beforeinput',
	        'compositionstart',
	        'compositionupdate',
	        'compositionend',
	        'focusin',
	        'focusout',
	        'dblclick',
	        'mousedown',
	        'mouseenter',
	        'mouseleave',
	        'mousemove',
	        'mouseout',
	        'mouseover',
	        'mouseup',
	        'wheel',
	        'select'
	    ],
	    instantiatedComponents: [
	        FormSwitch_1.FormSwitch,
	        FormRange_1.FormRange
	    ]
	});
	
	//# sourceMappingURL=FormInput.js.map


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.FormLabel = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueFormLabel,
	    tag: 'f7-label'
	});
	
	//# sourceMappingURL=FormLabel.js.map


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.GridCol = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueGridCol,
	    tag: 'f7-col'
	});
	
	//# sourceMappingURL=GridCol.js.map


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.GridRow = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueGridRow,
	    tag: 'f7-grid'
	});
	
	//# sourceMappingURL=GridRow.js.map


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.List = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueList,
	    tag: 'f7-list',
	    events: [
	        'sortable:open',
	        'sortable:close',
	        'sortable:sort',
	        'tab:show',
	        'tab:hide',
	        'virtual:itembeforeinsert',
	        'virtual:beforeclear',
	        'virtual:itemsbeforeinsert',
	        'virtual:itemsafterinsert'
	    ]
	});
	
	//# sourceMappingURL=List.js.map


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.ListButton = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueListButton,
	    tag: 'f7-list-button',
	    events: [
	        'click'
	    ]
	});
	
	//# sourceMappingURL=ListButton.js.map


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.ListGroup = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueListGroup,
	    tag: 'f7-list-group'
	});
	
	//# sourceMappingURL=ListGroup.js.map


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	var ListItemContent_1 = __webpack_require__(79);
	exports.ListItem = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueListItem,
	    tag: 'f7-list-item',
	    events: [
	        'click',
	        'swipeout:deleted',
	        'swipeout:delete',
	        'swipeout:close',
	        'swipeout:closed',
	        'swipeout:open',
	        'swipeout:opened',
	        'swipeout',
	        'accordion:close',
	        'accordion:closed',
	        'accordion:open',
	        'accordion:opened',
	        'input',
	        'change'
	    ],
	    instantiatedComponents: [
	        ListItemContent_1.ListItemContent
	    ],
	    slots: [
	        'content-start',
	        'media-start',
	        'inner-start',
	        'after-start',
	        'root-start',
	        'content',
	        'media',
	        'inner',
	        'after',
	        'root'
	    ]
	});
	
	//# sourceMappingURL=ListItem.js.map


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.ListItemSwipeoutActions = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueListItemSwipeoutActions,
	    tag: 'f7-swipeout-actions'
	});
	
	//# sourceMappingURL=ListItemSwipeoutActions.js.map


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.ListItemSwipeoutButton = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueListItemSwipeoutButton,
	    tag: 'f7-swipeout-button',
	    events: [
	        'click'
	    ]
	});
	
	//# sourceMappingURL=ListItemSwipeoutButton.js.map


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.ListLabel = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueListLabel,
	    tag: 'f7-list-label'
	});
	
	//# sourceMappingURL=ListLabel.js.map


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.LoginScreen = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueLoginScreen,
	    tag: 'f7-login-screen',
	    events: [
	        'loginscreen:open',
	        'loginscreen:opened',
	        'loginscreen:close',
	        'loginscreen:closed'
	    ]
	});
	
	//# sourceMappingURL=LoginScreen.js.map


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.LoginScreenTitle = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueLoginScreenTitle,
	    tag: 'f7-login-screen-title'
	});
	
	//# sourceMappingURL=LoginScreenTitle.js.map


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Message = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueMessage,
	    tag: 'f7-message',
	    events: [
	        'click',
	        'click:name',
	        'click:text',
	        'click:avatar'
	    ],
	    slots: [
	        'start',
	        'end'
	    ]
	});
	
	//# sourceMappingURL=Message.js.map


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	var Link_1 = __webpack_require__(44);
	exports.Messagebar = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueMessagebar,
	    tag: 'f7-messagebar',
	    events: [
	        'change',
	        'input',
	        'focus',
	        'blur',
	        'submit',
	        'click'
	    ],
	    instantiatedComponents: [
	        Link_1.Link
	    ],
	    slots: [
	        'before-inner',
	        'before-textarea',
	        'after-textarea',
	        'after-inner'
	    ]
	});
	
	//# sourceMappingURL=Messagebar.js.map


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Messages = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueMessages,
	    tag: 'f7-messages'
	});
	
	//# sourceMappingURL=Messages.js.map


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.NavRight = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueNavRight,
	    tag: 'f7-nav-right'
	});
	
	//# sourceMappingURL=NavRight.js.map


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Page = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VuePage,
	    tag: 'f7-page',
	    events: [
	        'ptr:pullstart',
	        'ptr:pullmove',
	        'ptr:pullend',
	        'ptr:refresh',
	        'ptr:done',
	        'infinite',
	        'page:beforeinit',
	        'page:init',
	        'page:reinit',
	        'page:beforeanimation',
	        'page:afteranimation',
	        'page:beforeremove',
	        'page:back',
	        'page:afterback'
	    ],
	    slots: [
	        'static',
	        'fixed'
	    ]
	});
	
	//# sourceMappingURL=Page.js.map


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.PageContent = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VuePageContent,
	    tag: 'f7-page-content',
	    events: [
	        'tab:show',
	        'tab:hide'
	    ]
	});
	
	//# sourceMappingURL=PageContent.js.map


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Panel = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VuePanel,
	    tag: 'f7-panel',
	    events: [
	        'panel:open',
	        'panel:opened',
	        'panel:closed',
	        'panel:overlay-click',
	        'panel:swipe'
	    ]
	});
	
	//# sourceMappingURL=Panel.js.map


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.PhotoBrowser = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VuePhotoBrowser,
	    tag: 'f7-photo-browser',
	    events: [
	        'open',
	        'close',
	        'swipeToClose',
	        'slideChangeStart',
	        'slideChangeEnd',
	        'transitionStart',
	        'transitionEnd',
	        'click',
	        'tap',
	        'doubleTap',
	        'lazyImageLoad',
	        'lazyImageReady'
	    ]
	});
	
	//# sourceMappingURL=PhotoBrowser.js.map


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.PickerModal = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VuePickerModal,
	    tag: 'f7-picker-modal',
	    events: [
	        'picker:open',
	        'picker:opened',
	        'picker:close',
	        'picker:closed'
	    ]
	});
	
	//# sourceMappingURL=PickerModal.js.map


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Popover = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VuePopover,
	    tag: 'f7-popover',
	    events: [
	        'popover:open',
	        'popover:opened',
	        'popover:close',
	        'popover:closed'
	    ]
	});
	
	//# sourceMappingURL=Popover.js.map


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Popup = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VuePopup,
	    tag: 'f7-popup',
	    events: [
	        'popup:open',
	        'popup:opened',
	        'popup:close',
	        'popup:closed'
	    ]
	});
	
	//# sourceMappingURL=Popup.js.map


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Preloader = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VuePreloader,
	    tag: 'f7-preloader'
	});
	
	//# sourceMappingURL=Preloader.js.map


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Progressbar = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueProgressbar,
	    tag: 'f7-progressbar'
	});
	
	//# sourceMappingURL=Progressbar.js.map


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Searchbar = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueSearchbar,
	    tag: 'f7-searchbar',
	    events: [
	        'change',
	        'input',
	        'focus',
	        'blur',
	        'submit',
	        'searchbar:search',
	        'searchbar:clear',
	        'searchbar:enable',
	        'searchbar:disable',
	        'click:clear',
	        'click:cancel'
	    ],
	    slots: [
	        'before-input',
	        'after-input'
	    ]
	});
	
	//# sourceMappingURL=Searchbar.js.map


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Statusbar = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueStatusbar,
	    tag: 'undefined'
	});
	
	//# sourceMappingURL=Statusbar.js.map


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Subnavbar = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueSubnavbar,
	    tag: 'f7-subnavbar'
	});
	
	//# sourceMappingURL=Subnavbar.js.map


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Swiper = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueSwiper,
	    tag: 'f7-swiper'
	});
	
	//# sourceMappingURL=Swiper.js.map


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.SwiperSlide = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueSwiperSlide,
	    tag: 'f7-swiper-slide'
	});
	
	//# sourceMappingURL=SwiperSlide.js.map


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Tab = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueTab,
	    tag: 'f7-tab',
	    events: [
	        'tab:show',
	        'tab:hide'
	    ]
	});
	
	//# sourceMappingURL=Tab.js.map


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Tabs = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueTabs,
	    tag: 'f7-tabs'
	});
	
	//# sourceMappingURL=Tabs.js.map


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Template7Template = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueTemplate7Template,
	    tag: 'undefined'
	});
	
	//# sourceMappingURL=Template7Template.js.map


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Timeline = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueTimeline,
	    tag: 'f7-timeline'
	});
	
	//# sourceMappingURL=Timeline.js.map


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.TimelineItem = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueTimelineItem,
	    tag: 'f7-timeline-item'
	});
	
	//# sourceMappingURL=TimelineItem.js.map


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.TimelineItemChild = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueTimelineItemChild,
	    tag: 'f7-timeline-item-child'
	});
	
	//# sourceMappingURL=TimelineItemChild.js.map


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.TimelineMonth = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueTimelineMonth,
	    tag: 'f7-timeline-month'
	});
	
	//# sourceMappingURL=TimelineMonth.js.map


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.TimelineYear = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueTimelineYear,
	    tag: 'f7-timeline-year'
	});
	
	//# sourceMappingURL=TimelineYear.js.map


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Toolbar = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueToolbar,
	    tag: 'f7-toolbar',
	    slots: [
	        'before-inner',
	        'after-inner'
	    ]
	});
	
	//# sourceMappingURL=Toolbar.js.map


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	var Pages_1 = __webpack_require__(83);
	var Navbar_1 = __webpack_require__(82);
	exports.View = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueView,
	    tag: 'f7-view',
	    events: [
	        'swipeback:move',
	        'swipeback:beforechange',
	        'swipeback:afterchange',
	        'swipeback:beforereset',
	        'swipeback:afterreset',
	        'tab:show',
	        'tab:hide'
	    ],
	    instantiatedComponents: [
	        Pages_1.Pages,
	        Navbar_1.Navbar
	    ]
	});
	
	//# sourceMappingURL=View.js.map


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ReactifyF7Vue_1 = __webpack_require__(2);
	var framework7_vue_1 = __webpack_require__(1);
	exports.Views = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueViews,
	    tag: 'f7-views'
	});
	
	//# sourceMappingURL=Views.js.map


/***/ },
/* 229 */
/***/ function(module, exports) {

	"use strict";
	var combinePaths = function () {
	    var paths = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        paths[_i] = arguments[_i];
	    }
	    return paths.join('/').replace(/\/+/g, '/');
	};
	var flattenTabNestedRoutes = function (pageRoute, tabRoute, tabNestedRoutes) {
	    return tabNestedRoutes.map(function (tabNestedRoute) {
	        return {
	            path: combinePaths(pageRoute.path, tabRoute.path, tabNestedRoute.path),
	            pagePath: pageRoute.path,
	            component: pageRoute.component,
	            tab: {
	                tabId: tabRoute.tabId,
	                component: tabNestedRoute.component
	            }
	        };
	    });
	};
	var flattenTabRoutes = function (pageRoute, tabRoutes) {
	    return tabRoutes.reduce(function (accumulatedFlattenedRoutes, nextTabRoute) {
	        var flattenedTabRoutes;
	        if (nextTabRoute.routes) {
	            flattenedTabRoutes = flattenTabNestedRoutes(pageRoute, nextTabRoute, nextTabRoute.routes);
	        }
	        else {
	            flattenedTabRoutes = [{
	                    path: combinePaths(pageRoute.path, nextTabRoute.path),
	                    pagePath: pageRoute.path,
	                    component: pageRoute.component,
	                    tab: {
	                        tabId: nextTabRoute.tabId,
	                        component: nextTabRoute.component
	                    }
	                }];
	        }
	        return accumulatedFlattenedRoutes.concat(flattenedTabRoutes);
	    }, []);
	};
	var flattenRoutes = function (routes) {
	    return routes.reduce(function (accumulatedFlattenedRoutes, nextRoute) {
	        var flattenedNextRoute;
	        if (nextRoute.tabs) {
	            flattenedNextRoute = flattenTabRoutes(nextRoute, nextRoute.tabs);
	        }
	        else {
	            flattenedNextRoute = [Object.assign({}, nextRoute, {
	                    pagePath: nextRoute.path
	                })];
	        }
	        return accumulatedFlattenedRoutes.concat(flattenedNextRoute);
	    }, []);
	};
	var parseRoute = function (str) {
	    var parts = [];
	    str.split('/').forEach(function (part) {
	        if (part !== '') {
	            if (part.indexOf(':') === 0) {
	                parts.push({ name: part.replace(':', '') });
	            }
	            else
	                parts.push(part);
	        }
	    });
	    return parts;
	};
	function handleRouteChangeFromFramework7(view, options, changeRouteCallback) {
	    if (!view.allowPageChange)
	        return false;
	    var url = options.url;
	    var pageElement = options.pageElement;
	    if (url && pageElement || !url || url === '#') {
	        return true;
	    }
	    var inHistory = view.history.indexOf(url) >= 0;
	    var inDomCache = view.pagesCache[url];
	    if (inHistory && inDomCache)
	        return true;
	    return changeRouteCallback(url, view, options);
	}
	var Framework7Router = (function () {
	    function Framework7Router(originalRoutes, framework7, dom7) {
	        var _this = this;
	        this.routeChangeHandler = null;
	        this.routes = flattenRoutes(originalRoutes);
	        this.framework7 = framework7;
	        this.dom7 = dom7;
	        //Hook router into Framework7 routing events
	        var initialPreroute = framework7.params.preroute;
	        framework7.params.routes = originalRoutes;
	        framework7.params.routerRemoveTimeout = true;
	        framework7.params.preroute = function (view, options) {
	            var passToVueRouter = true;
	            if (initialPreroute) {
	                passToVueRouter = initialPreroute(view, options);
	            }
	            if (passToVueRouter) {
	                return handleRouteChangeFromFramework7(view, options, _this.changeRoute.bind(_this));
	            }
	            else {
	                return false;
	            }
	        };
	    }
	    Framework7Router.prototype.setRouteChangeHandler = function (routeChangeHandler) {
	        this.routeChangeHandler = routeChangeHandler;
	    };
	    Framework7Router.prototype.changeRoute = function (url, view, options) {
	        var _this = this;
	        if (view === void 0) { view = null; }
	        var getMainView = function () { return _this.framework7.views && _this.framework7.views.reduce(function (mainView, nextView) {
	            if (nextView.main) {
	                return nextView;
	            }
	            else {
	                return mainView;
	            }
	        }, null); };
	        var matchingRoute = this.findMatchingRoute(url);
	        if (!matchingRoute)
	            return true;
	        return this.routeChangeHandler(Object.assign({}, matchingRoute, {
	            view: view || getMainView(),
	            options: options,
	            router: this
	        }));
	    };
	    Framework7Router.prototype.findMatchingRoute = function (url) {
	        var matchingRoute;
	        if (!url)
	            return matchingRoute;
	        var routes = this.routes;
	        var query = this.dom7.parseUrlQuery(url);
	        var hash = url.split('#')[1];
	        var params = {};
	        var path = url.split('#')[0].split('?')[0];
	        var urlParts = path.split('/').filter(function (part) {
	            if (part !== '')
	                return part;
	        });
	        var i, j, k;
	        for (i = 0; i < routes.length; i++) {
	            if (matchingRoute)
	                continue;
	            var route = routes[i];
	            var parsedRoute = parseRoute(route.path);
	            if (parsedRoute.length !== urlParts.length)
	                continue;
	            var matchedParts = 0;
	            for (j = 0; j < parsedRoute.length; j++) {
	                if (typeof parsedRoute[j] === 'string' && urlParts[j] === parsedRoute[j])
	                    matchedParts++;
	                if (typeof parsedRoute[j] === 'object') {
	                    params[parsedRoute[j].name] = urlParts[j];
	                    matchedParts++;
	                }
	            }
	            if (matchedParts === urlParts.length) {
	                matchingRoute = {
	                    query: query,
	                    hash: hash,
	                    params: params,
	                    url: url,
	                    path: path,
	                    route: route
	                };
	            }
	        }
	        return matchingRoute;
	    };
	    return Framework7Router;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = Framework7Router;
	
	//# sourceMappingURL=router.js.map


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var React = __webpack_require__(6);
	var router_1 = __webpack_require__(229);
	var Framework7_1 = __webpack_require__(34);
	var OverscrollFix_1 = __webpack_require__(232);
	var Framework7App = (function (_super) {
	    __extends(Framework7App, _super);
	    function Framework7App() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.framework7 = null;
	        _this.framework7InitCallbacks = [];
	        _this.routeChangeCallbacks = {};
	        return _this;
	    }
	    Framework7App.prototype.getChildContext = function () {
	        var _this = this;
	        return {
	            framework7AppContext: {
	                getFramework7: this.getFramework7.bind(this),
	                theme: {
	                    ios: this.props.themeType === 'ios',
	                    material: this.props.themeType === 'material'
	                },
	                onRouteChange: this.onRouteChange.bind(this),
	                unregisterRouteChange: this.unregisterRouteChange.bind(this),
	                getCurrentRoute: function () { return _this.currentRoute; },
	                getRouter: function () { return _this.router; }
	            }
	        };
	    };
	    Framework7App.prototype.render = function () {
	        return React.createElement("span", null, this.props.children);
	    };
	    Framework7App.prototype.componentDidMount = function () {
	        this.handleOverscrollFix();
	        this.initFramework7();
	    };
	    Framework7App.prototype.handleOverscrollFix = function () {
	        if (this.props.applyOverscrollFix) {
	            OverscrollFix_1.applyOverscrollFix();
	        }
	    };
	    Framework7App.prototype.initFramework7 = function () {
	        var _this = this;
	        this.framework7 = new Framework7_1.Framework7(__assign({ material: this.props.themeType === 'material' }, this.props));
	        var router = this.router = new router_1.default(this.props.routes, this.framework7, Framework7_1.Dom7);
	        router.setRouteChangeHandler(function (route) {
	            _this.currentRoute = route;
	            if (_this.props.onRouteChange) {
	                _this.props.onRouteChange(route);
	            }
	            Object.keys(_this.routeChangeCallbacks).forEach(function (componentId) {
	                //Need this if statement in case a component gets unregistered during this forEach                
	                if (_this.routeChangeCallbacks[componentId]) {
	                    _this.routeChangeCallbacks[componentId](route);
	                }
	            });
	        });
	        if (this.props.onFramework7Init) {
	            this.props.onFramework7Init(this.framework7);
	        }
	        this.framework7InitCallbacks.forEach(function (callback) {
	            callback(_this.framework7);
	        });
	        if (this.props.stateKernel) {
	            this.props.stateKernel.setFramework7(this.framework7);
	            this.props.stateKernel.setRouter(this.router);
	        }
	    };
	    Framework7App.prototype.getFramework7 = function (callback) {
	        if (this.framework7) {
	            callback(this.framework7);
	        }
	        else {
	            this.framework7InitCallbacks.push(callback);
	        }
	    };
	    Framework7App.prototype.onRouteChange = function (componentId, callback) {
	        this.routeChangeCallbacks[componentId] = callback;
	    };
	    Framework7App.prototype.unregisterRouteChange = function (componentId) {
	        delete this.routeChangeCallbacks[componentId];
	    };
	    return Framework7App;
	}(React.Component));
	Framework7App.childContextTypes = {
	    framework7AppContext: React.PropTypes.object
	};
	exports.Framework7App = Framework7App;
	;
	
	//# sourceMappingURL=Framework7App.js.map


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var React = __webpack_require__(6);
	var ManagedFormInput = (function (_super) {
	    __extends(ManagedFormInput, _super);
	    function ManagedFormInput(props) {
	        var _this = _super.call(this, props) || this;
	        _this.state = {
	            currentValue: _this.props.value || ""
	        };
	        return _this;
	    }
	    ManagedFormInput.prototype.render = function () {
	        return (React.createElement("input", __assign({}, this.props, { onChange: this.onInput.bind(this), value: this.state.currentValue })));
	    };
	    ManagedFormInput.prototype.onInput = function (event) {
	        if (this.props.type === "radio" || this.props.type === "checkbox") {
	            this.props.onChange();
	        }
	        else {
	            this.setState({
	                currentValue: event.target.value
	            });
	        }
	    };
	    return ManagedFormInput;
	}(React.Component));
	exports.ManagedFormInput = ManagedFormInput;
	;
	
	//# sourceMappingURL=ManagedFormInput.js.map


/***/ },
/* 232 */
/***/ function(module, exports) {

	"use strict";
	exports.applyOverscrollFix = function () {
	    var touchTarget, touchScreenX, touchScreenY, conditionParentUntilTrue, disableScroll, scrollMap;
	    conditionParentUntilTrue = function (element, condition) {
	        var outcome = false;
	        if (element === document.body) {
	            return false;
	        }
	        outcome = condition(element);
	        if (outcome) {
	            return true;
	        }
	        else {
	            return conditionParentUntilTrue(element.parentNode, condition);
	        }
	    };
	    window.addEventListener('touchstart', function (e) {
	        touchTarget = e.targetTouches[0].target;
	        // a boolean map indicating if the element (or either of element parents, excluding the document.body) can be scrolled to the X direction.
	        scrollMap = {};
	        scrollMap.left = conditionParentUntilTrue(touchTarget, function (element) {
	            return element.scrollLeft > 0 &&
	                (window.getComputedStyle(element).overflow !== "hidden") &&
	                (window.getComputedStyle(element).overflowX !== "hidden");
	        });
	        scrollMap.top = conditionParentUntilTrue(touchTarget, function (element) {
	            return element.scrollTop > 0 &&
	                (window.getComputedStyle(element).overflow !== "hidden") &&
	                (window.getComputedStyle(element).overflowY !== "hidden");
	        });
	        scrollMap.right = conditionParentUntilTrue(touchTarget, function (element) {
	            return element.scrollWidth > element.clientWidth &&
	                element.scrollWidth - element.clientWidth > element.scrollLeft &&
	                (window.getComputedStyle(element).overflow !== "hidden") &&
	                (window.getComputedStyle(element).overflowX !== "hidden");
	        });
	        scrollMap.bottom = conditionParentUntilTrue(touchTarget, function (element) {
	            return element.scrollHeight > element.clientHeight &&
	                element.scrollHeight - element.clientHeight > element.scrollTop &&
	                (window.getComputedStyle(element).overflow !== "hidden") &&
	                (window.getComputedStyle(element).overflowY !== "hidden");
	        });
	        touchScreenX = e.targetTouches[0].screenX;
	        touchScreenY = e.targetTouches[0].screenY;
	        disableScroll = false;
	    });
	    window.addEventListener('touchmove', function (e) {
	        var moveScreenX, moveScreenY;
	        if (disableScroll) {
	            e.preventDefault();
	            return;
	        }
	        moveScreenX = e.targetTouches[0].screenX;
	        moveScreenY = e.targetTouches[0].screenY;
	        if (moveScreenX > touchScreenX && scrollMap.left ||
	            moveScreenY < touchScreenY && scrollMap.bottom ||
	            moveScreenX < touchScreenX && scrollMap.right ||
	            moveScreenY > touchScreenY && scrollMap.top) {
	        }
	        else {
	            // This will affect document.body scroll.
	            e.preventDefault();
	            disableScroll = true;
	        }
	    });
	};
	
	//# sourceMappingURL=OverscrollFix.js.map


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var GenerateReactClass_1 = __webpack_require__(234);
	exports.reactifyVue = function (reactifyVueArgs) {
	    return GenerateReactClass_1.generateReactClass(reactifyVueArgs.instantiatedComponents, reactifyVueArgs.component, reactifyVueArgs.slots, reactifyVueArgs.tag, reactifyVueArgs.mixin, reactifyVueArgs.args);
	};
	
	//# sourceMappingURL=ReactifyVue.js.map


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var _this = this;
	var React = __webpack_require__(6);
	var VueComponentClass_1 = __webpack_require__(236);
	var ReactClassRuntime_1 = __webpack_require__(235);
	exports.generateReactClass = function (instantiatedComponents, vueComponent, slots, tag, mixin, args) {
	    var vueComponentClass = VueComponentClass_1.convertVueComponentToClass(vueComponent);
	    ReactClassRuntime_1.copyMethodsToVueComponent(vueComponent);
	    ReactClassRuntime_1.copyArgsToVueComponent(vueComponent, args);
	    var reactClass = React.createClass({
	        getInitialState: function () {
	            this.vueComponent = new vueComponentClass(this.props, this);
	            this.createElement = ReactClassRuntime_1.generateCreateElementFunctionForClass(this.vueComponent, instantiatedComponents, this.vueComponent);
	            ReactClassRuntime_1.copyPropsToVueComponent(this.vueComponent, this.props);
	            ReactClassRuntime_1.copySlotsToVueComponent(this.vueComponent, slots, this.props);
	            var state = ReactClassRuntime_1.initData(this.vueComponent);
	            ReactClassRuntime_1.handleComputedProperties(this.vueComponent);
	            ReactClassRuntime_1.addCompiledTemplateFunctionsToVueComponent(this.vueComponent, this.createElement);
	            if (this.props.__onInit) {
	                this.props.__onInit(this);
	            }
	            return state;
	        },
	        componentWillUpdate: function () {
	            if (this.vueComponent.beforeUpdate)
	                this.vueComponent.beforeUpdate();
	        },
	        componentDidUpdate: function () {
	            if (this.vueComponent.updated)
	                this.vueComponent.updated();
	        },
	        componentDidMount: function () {
	            if (this.vueComponent.mounted)
	                this.vueComponent.mounted();
	            if (this.props.__onMount)
	                this.props.__onMount(this);
	            this.didMount = true;
	        },
	        componentWillUnmount: function () {
	            if (vueComponent.beforeDestroy)
	                vueComponent.beforeDestroy();
	        },
	        componentWillReceiveProps: function (nextProps) {
	            ReactClassRuntime_1.handleWatchedProperties(this.vueComponent, this.props, nextProps);
	        },
	        render: function () {
	            if (this.hasRendered) {
	                //Only do this after the first render, since it happens in getInitialState the first time
	                ReactClassRuntime_1.copyPropsToVueComponent(this.vueComponent, this.props);
	                ReactClassRuntime_1.copySlotsToVueComponent(this.vueComponent, slots, this.props);
	                ReactClassRuntime_1.handleComputedProperties(this.vueComponent);
	            }
	            var reactElement = this.vueComponent.render(this.createElement.bind(this));
	            this.hasRendered = true;
	            if (reactElement) {
	                return ReactClassRuntime_1.applyPropOverridesToTopLevelElement(reactElement, tag, this);
	            }
	            else {
	                return null;
	            }
	        },
	        callVueMethod: function (methodName) {
	            var args = [];
	            for (var _i = 1; _i < arguments.length; _i++) {
	                args[_i - 1] = arguments[_i];
	            }
	            return this.vueComponent[methodName](args);
	        }
	    });
	    reactClass.tag = tag;
	    reactClass.vueComponent = vueComponent;
	    reactClass.getVueComponentInstance = function () { return _this.vueComponent; };
	    var defaultProps = ReactClassRuntime_1.getDefaultProps(vueComponent);
	    if (defaultProps)
	        reactClass.defaultProps = defaultProps;
	    return reactClass;
	};
	
	//# sourceMappingURL=GenerateReactClass.js.map


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var _this = this;
	var React = __webpack_require__(6);
	var change_case_1 = __webpack_require__(41);
	var CreateReactElements_1 = __webpack_require__(237);
	exports.copyMethodsToVueComponent = function (vueComponent) {
	    if (vueComponent.methods) {
	        Object.keys(vueComponent.methods)
	            .forEach(function (methodName) { return vueComponent[methodName] = vueComponent.methods[methodName]; });
	        delete vueComponent.methods;
	    }
	};
	exports.copyPropsToVueComponent = function (vueComponent, props) {
	    if (props) {
	        Object.keys(props)
	            .forEach(function (propName) {
	            if (typeof vueComponent[propName] !== 'function' || typeof vueComponent[propName] === 'function' && !vueComponent[propName]) {
	                vueComponent[propName] = props[propName];
	            }
	        });
	    }
	};
	exports.getComponentTag = function (component) {
	    if (component.type && component.type.tag) {
	        return component.type.tag;
	    }
	    else if (component.type && typeof component.type === 'string') {
	        return component.type;
	    }
	    else {
	        return undefined;
	    }
	};
	exports.copySlotsToVueComponent = function (vueComponent, slotMapping, props) {
	    var reactChildrenArray = props && props.children && React.Children.toArray(props.children);
	    var slots = {
	        default: (reactChildrenArray && reactChildrenArray.length) ? reactChildrenArray : null
	    };
	    if (slotMapping && props) {
	        Object.keys(slotMapping)
	            .forEach(function (slotName) {
	            slots[slotName] = props[slotMapping[slotName]] || [];
	        });
	    }
	    Object.keys(slots)
	        .forEach(function (slotName) {
	        var slot = slots[slotName];
	        if (Array.isArray(slot)) {
	            slot.forEach(function (slotChild, index) {
	                if (typeof slotChild !== 'string') {
	                    slots[slotName][index] = __assign({}, slotChild, { tag: exports.getComponentTag(slotChild) });
	                }
	            });
	        }
	    });
	    vueComponent.$slots = slots;
	};
	exports.copyArgsToVueComponent = function (vueComponent, args) {
	    if (args) {
	        Object.keys(args)
	            .forEach(function (argName) { return vueComponent[argName] = args[argName]; });
	    }
	};
	exports.handleWatchedProperties = function (vueComponent, currentProps, nextProps) {
	    if (vueComponent.watch) {
	        exports.copyPropsToVueComponent(vueComponent, nextProps);
	        exports.handleComputedProperties(vueComponent);
	        Object.keys(vueComponent.watch)
	            .forEach(function (watchedProperty) {
	            if (currentProps[watchedProperty] !== nextProps[watchedProperty]) {
	                vueComponent.watch[watchedProperty].apply(vueComponent, [nextProps[watchedProperty]]);
	            }
	        });
	    }
	};
	exports.handleComputedProperties = function (vueComponent) {
	    if (vueComponent.computed) {
	        Object.keys(vueComponent.computed)
	            .forEach(function (propertyName) {
	            vueComponent[propertyName] = vueComponent.computed[propertyName].apply(vueComponent, []);
	        });
	    }
	};
	exports.getDefaultProps = function (vueComponent) {
	    if (vueComponent.props) {
	        var defaultProps = Object.keys(vueComponent.props).reduce(function (defaultProps, propName) {
	            var propDef = vueComponent.props[propName];
	            if (propDef.default) {
	                return __assign({}, defaultProps, (_a = {}, _a[change_case_1.camelCase(propName)] = propDef.default, _a));
	            }
	            else {
	                return defaultProps;
	            }
	            var _a;
	        }, {});
	        return Object.keys(defaultProps).length ? defaultProps : null;
	    }
	    else {
	        return null;
	    }
	};
	exports.addCompiledTemplateFunctionsToVueComponent = function (vueComponent, createElement) {
	    vueComponent._self = { _c: createElement.bind(vueComponent) };
	    vueComponent._t = function (slotName, fallback) {
	        var slotValue = vueComponent.$slots[slotName];
	        if (fallback && (!slotValue || !slotValue.length)) {
	            return fallback;
	        }
	        else {
	            return slotValue;
	        }
	    };
	    vueComponent._v = function (text) { return text || ''; };
	    vueComponent._s = function (text) { return text || ''; };
	    vueComponent._e = function () { return null; };
	};
	exports.generateCreateElementFunctionForClass = function (classVueComponentInstance, instantiatedComponents, vueComponent) {
	    return function (element, args, children) {
	        if (typeof args !== 'object' || Array.isArray(args)) {
	            //Children passed in as second argument
	            return CreateReactElements_1.createReactElement(element, {}, args, instantiatedComponents, vueComponent);
	        }
	        else {
	            return CreateReactElements_1.createReactElement(element, args, children, instantiatedComponents, vueComponent);
	        }
	    };
	};
	exports.applyPropOverridesToTopLevelElement = function (reactElement, tag, self) {
	    var refFunc = function (e) {
	        reactElement.ref(e);
	        self.element = e;
	        self.nextTickCallbacks.forEach(function (callback) { return callback.apply(_this.vueComponent, []); });
	        self.nextTickCallbacks = [];
	        self.hasUnrenderedStateChanges = false;
	    };
	    var elementWithPropOverrides = __assign({}, reactElement, { props: __assign({}, reactElement.props), tag: tag, ref: refFunc });
	    if (self.vueComponent.className) {
	        var existingClassName = elementWithPropOverrides.props.className || '';
	        elementWithPropOverrides.props.className = [existingClassName, ' ', self.vueComponent.className].join('');
	    }
	    if (self.vueComponent.style) {
	        var existingStyles = elementWithPropOverrides.props.style || {};
	        elementWithPropOverrides.props.style = __assign({}, existingStyles, self.vueComponent.style);
	    }
	    if (self.vueComponent.id) {
	        elementWithPropOverrides.props.id = self.vueComponent.id;
	    }
	    return elementWithPropOverrides;
	};
	exports.initData = function (vueComponent) {
	    var state = null;
	    if (vueComponent.data) {
	        state = vueComponent.data();
	        Object.keys(state).forEach(function (stateKey) {
	            vueComponent[stateKey] = state[stateKey];
	        });
	    }
	    return state;
	};
	
	//# sourceMappingURL=ReactClassRuntime.js.map


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var React = __webpack_require__(6);
	var change_case_1 = __webpack_require__(41);
	var handleStateSet = function (stateObject, key, value, vueComponent, self) {
	    var stateKey = Object.keys(self.state).reduce(function (macthingStateKey, nextKey) {
	        if (self.state[nextKey] === stateObject) {
	            return nextKey;
	        }
	        else {
	            return macthingStateKey;
	        }
	    }, null);
	    var newState = __assign({}, self.state, (_a = {}, _a[stateKey] = __assign({}, self.state[stateKey], (_b = {}, _b[key] = value, _b)), _a));
	    vueComponent[stateKey] = newState[stateKey];
	    self.setState(newState);
	    var _a, _b;
	};
	var callPropOnEvent = function (eventName, eventArgs, props) {
	    var eventNameCamelCase = change_case_1.camelCase('on-' + eventName.split(':').join('-'));
	    if (props[eventNameCamelCase]) {
	        props[eventNameCamelCase].apply(props, eventArgs);
	    }
	};
	exports.convertVueComponentToClass = function (vueComponentObject) {
	    var vueComponentClass = function (reactComponentProps, reactComponentInstance) {
	        this.reactComponentProps = reactComponentProps;
	        this.reactComponentInstance = reactComponentInstance;
	        this.reactComponentInstance.nextTickCallbacks = [];
	    };
	    vueComponentClass.prototype = vueComponentObject;
	    if (vueComponentObject.mixins) {
	        vueComponentObject.mixins.forEach(function (mixin) {
	            Object.keys(mixin).forEach(function (prop) {
	                vueComponentClass.prototype[prop] = mixin[prop];
	            });
	        });
	    }
	    vueComponentClass.prototype.$emit = function (eventName) {
	        var eventArgs = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            eventArgs[_i - 1] = arguments[_i];
	        }
	        callPropOnEvent(eventName, eventArgs, this.reactComponentProps);
	    };
	    Object.defineProperty(vueComponentClass.prototype, '$el', {
	        get: function () { return this.reactComponentInstance.element; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(vueComponentClass.prototype, '$parent', {
	        get: function () { return this.reactComponentProps.parentVueComponent; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(vueComponentClass.prototype, '$children', {
	        get: function () {
	            var parentElement = this.$el;
	            return React.Children.toArray(this.children).map(function (element, index) {
	                return __assign({}, element, { $el: parentElement.children[index] });
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(vueComponentClass.prototype, '$options', {
	        get: function () {
	            return {
	                propsData: this.reactComponentProps
	            };
	        },
	        enumerable: true,
	        configurable: true
	    });
	    vueComponentClass.prototype.$nextTick = function (func) {
	        if (this.reactComponentInstance.hasUnrenderedStateChanges) {
	            this.reactComponentInstance.nextTickCallbacks.push(func);
	        }
	        else {
	            func();
	        }
	    };
	    vueComponentClass.prototype.$set = function (stateObject, key, value) {
	        this.reactComponentInstance.hasUnrenderedStateChanges = true;
	        handleStateSet(stateObject, key, value, this, this.reactComponentInstance);
	    };
	    return vueComponentClass;
	};
	
	//# sourceMappingURL=VueComponentClass.js.map


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var React = __webpack_require__(6);
	var PropsProcessor_1 = __webpack_require__(238);
	var ManagedFormInput_1 = __webpack_require__(231);
	var propsProcessor = new PropsProcessor_1.PropsProcessor();
	var formElements = ['input'];
	var resolveDependencyComponent = function (instantiatedComponents, componentToResolve) {
	    if (instantiatedComponents && componentToResolve.indexOf('f7-') > -1) {
	        //Is a Vue component that React does not know what to do with, so search for it by tag name so that we can pass the actual React component for rendering.
	        var results = instantiatedComponents
	            .filter(function (instantiatedComponent) {
	            if (instantiatedComponent.tag) {
	                return instantiatedComponent.tag === componentToResolve;
	            }
	            else {
	                return false;
	            }
	        });
	        if (results.length) {
	            return results[0];
	        }
	    }
	    else if (formElements.indexOf(componentToResolve) > -1) {
	        //Is an input that we need to manage to control state 
	        return ManagedFormInput_1.ManagedFormInput;
	    }
	    else {
	        //Is just a plain html element like div, etc. so just return it.
	        return componentToResolve;
	    }
	};
	var flattenNestedArrayOfChildren = function (children, finalArray) {
	    if (finalArray === void 0) { finalArray = []; }
	    if (children && Array.isArray(children)) {
	        for (var i = 0; i < children.length; i++) {
	            if (children[i] && children[i].constructor === Array) {
	                flattenNestedArrayOfChildren(children[i], finalArray);
	            }
	            else {
	                if (finalArray.indexOf(children[i]) === -1) {
	                    finalArray.push(children[i]);
	                }
	            }
	        }
	        return finalArray;
	    }
	    else {
	        return children;
	    }
	};
	exports.createReactElement = function (componentOrComponentName, args, children, instantiatedComponents, vueComponent) {
	    var reactElement;
	    if (!componentOrComponentName)
	        return null;
	    var resolvedComponent;
	    if (args.tag !== 'component') {
	        resolvedComponent = resolveDependencyComponent(instantiatedComponents, componentOrComponentName);
	    }
	    children = flattenNestedArrayOfChildren(children);
	    if (!resolvedComponent)
	        resolvedComponent = componentOrComponentName;
	    var props = propsProcessor.getProps(args, children, componentOrComponentName, resolvedComponent, vueComponent);
	    reactElement = React.createElement(resolvedComponent, props);
	    return reactElement;
	};
	
	//# sourceMappingURL=CreateReactElements.js.map


/***/ },
/* 238 */
/***/ function(module, exports) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var camelCase = function (str) {
	    camelCase.replacement = camelCase.replacement || {};
	    if (!camelCase.replacement[str]) {
	        camelCase.replacement[str] = str.replace(/-([a-z])/g, function (m, w) {
	            return w.toUpperCase();
	        });
	    }
	    return camelCase.replacement[str];
	};
	var hasOwn = {}.hasOwnProperty;
	var classNames = function () {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var classes = [];
	    var length = args.length;
	    while (length--) {
	        var arg = args[length];
	        if (!arg)
	            continue;
	        var argType = typeof arg;
	        if (argType === 'string' || argType === 'number') {
	            classes.push(arg);
	        }
	        else if (Array.isArray(arg)) {
	            classes.push(classNames.apply(null, arg));
	        }
	        else if (argType === 'object') {
	            var keys = Object.keys(arg);
	            var length_1 = keys.length;
	            while (length_1--) {
	                var key = keys[length_1];
	                if (hasOwn.call(arg, key) && arg[key]) {
	                    classes.push(key);
	                }
	            }
	        }
	    }
	    return classes.join(' ');
	};
	var renameEvent = function (eventName) {
	    switch (eventName) {
	        case 'keypress':
	            return 'keyPress';
	        case 'keyup':
	            return 'keyUp';
	        case 'keydown':
	            return 'keyDown';
	        case 'beforeinput':
	            return 'beforeInput';
	        case 'compositionstart':
	            return 'compositionStart';
	        case 'compositionupdate':
	            return 'compositionUpdate';
	        case 'compositionend':
	            return 'compositionEnd';
	        case 'dblclick':
	            return 'doubleClick';
	        case 'mousedown':
	            return 'mouseDown';
	        case 'mouseenter':
	            return 'mouseEnter';
	        case 'mouseleave':
	            return 'mouseLeave';
	        case 'mousemove':
	            return 'mouseMove';
	        case 'mouseout':
	            return 'mouseOut';
	        case 'mouseover':
	            return 'mouseOver';
	        case 'mouseup':
	            return 'mouseUp';
	        case 'focusin':
	            return 'focus';
	        case 'focusout':
	            return 'blur';
	        default:
	            return eventName;
	    }
	};
	var attributeMap = {
	    autocapitalize: {
	        componentNames: ['input', 'textarea', 'select'],
	        renameTo: 'autoCapitalize'
	    },
	    autocomplete: {
	        componentNames: ['input', 'textarea', 'select'],
	        renameTo: 'autoComplete'
	    },
	    autocorrect: {
	        componentNames: ['input', 'textarea', 'select'],
	        renameTo: 'autoCorrect'
	    },
	    autofocus: {
	        componentNames: ['input', 'textarea', 'select'],
	        renameTo: 'autoFocus'
	    },
	    autosave: {
	        componentNames: ['input', 'textarea', 'select'],
	        renameTo: 'autoSave'
	    },
	    maxlength: {
	        componentNames: ['input', 'textarea', 'select'],
	        renameTo: 'maxLength'
	    },
	    minlength: {
	        componentNames: ['input', 'textarea', 'select'],
	        renameTo: 'minLength'
	    },
	    readonly: {
	        componentNames: ['input', 'textarea', 'select'],
	        renameTo: 'readOnly'
	    },
	    spellcheck: {
	        componentNames: ['input', 'textarea', 'select'],
	        renameTo: 'spellCheck'
	    }
	};
	var handleRefs = function (element, vueComponent, events, props) {
	    if (events) {
	        var _loop_1 = function (eventName) {
	            if (element && element.addEventListener && !(element.vueListeners && element.vueListeners[eventName])) {
	                element.addEventListener(eventName, function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    var eventHandler = events[eventName];
	                    eventHandler.apply(vueComponent, args);
	                }, true);
	                element.vueListeners = element.vueListeners || {};
	                element.vueListeners[eventName] = true;
	            }
	        };
	        for (var eventName in events) {
	            _loop_1(eventName);
	        }
	    }
	    if (props['data-vue-ref']) {
	        var vueRef = props['data-vue-ref'];
	        vueRef.vueComponentInstance.$refs[vueRef.refName] = element;
	    }
	};
	var renameAttribute = function (componentName, attribute) {
	    var attributeMapForAttribute = attributeMap[attribute];
	    if (attributeMapForAttribute && attributeMapForAttribute.componentNames.indexOf(componentName) > -1) {
	        attribute = attributeMapForAttribute.renameTo;
	    }
	    return attribute;
	};
	var renameStyleProperties = function (stylesObject) {
	    for (var property in stylesObject) {
	        if (stylesObject.hasOwnProperty(property) && property.indexOf('-') !== -1) {
	            var newPropertyName = camelCase(property);
	            stylesObject[newPropertyName] = stylesObject[property];
	            delete stylesObject[property];
	        }
	    }
	    return stylesObject;
	};
	var PropsProcessor = (function () {
	    function PropsProcessor() {
	        this.handleEvents = function (resolvedComponent, eventHandlers, parentVueComponentInstance, props) {
	            if (typeof resolvedComponent === 'string') {
	            }
	            else {
	                if (eventHandlers) {
	                    var _loop_2 = function (eventName) {
	                        var camelCasedEventName = "" + camelCase('on-' + renameEvent(eventName));
	                        props[camelCasedEventName] = function () {
	                            var eventArgs = [];
	                            for (var _i = 0; _i < arguments.length; _i++) {
	                                eventArgs[_i] = arguments[_i];
	                            }
	                            eventHandlers[eventName].apply(parentVueComponentInstance, eventArgs);
	                        };
	                    };
	                    for (var eventName in eventHandlers) {
	                        _loop_2(eventName);
	                    }
	                }
	            }
	        };
	    }
	    PropsProcessor.prototype.getProps = function (args, children, componentOrComponentName, resolvedComponent, vueComponentInstance) {
	        this.addCurrentComponentAsParentOfChildren(children, vueComponentInstance);
	        var props = {};
	        this.getClasses(args, vueComponentInstance, props);
	        this.getStyle(args, vueComponentInstance, props);
	        this.getRef(args, vueComponentInstance, resolvedComponent, props);
	        this.getPropsFromArgs(args, props);
	        this.getChildren(children, args, props);
	        this.convertAttrsToProps(args, componentOrComponentName, resolvedComponent, props);
	        this.getInnerHTML(args, props);
	        this.handleEvents(resolvedComponent, args.on, vueComponentInstance, props);
	        this.handleRef(args.ref, vueComponentInstance, props);
	        return props;
	    };
	    PropsProcessor.prototype.getClasses = function (args, vueComponent, props) {
	        var classObject = {};
	        if (args.class && typeof args.class === 'string') {
	            classObject[args.class] = true;
	        }
	        else if (args.class) {
	            classObject = args.class;
	        }
	        if (args.staticClass) {
	            classObject[args.staticClass] = true;
	        }
	        var classes = [];
	        for (var key in classObject) {
	            if (classObject[key]) {
	                classes.push(key);
	            }
	        }
	        props.className = classes.join(' ');
	    };
	    PropsProcessor.prototype.getStyle = function (args, vueComponent, props) {
	        var style;
	        if (args.style) {
	            if (typeof args.style === 'object') {
	                style = args.style;
	            }
	            else {
	                throw new Error('ReactifyVue only supports style attributes that are of type object');
	            }
	        }
	        if (style) {
	            props.style = renameStyleProperties(style);
	        }
	    };
	    PropsProcessor.prototype.getRef = function (args, vueComponent, resolvedComponent, props) {
	        props.ref = (function (events, vueComponent) {
	            return function (element) {
	                var events = args.on;
	                handleRefs(element, vueComponent, events, props);
	            };
	        })(args.on, vueComponent);
	    };
	    PropsProcessor.prototype.getPropsFromArgs = function (args, props) {
	        if (args.props) {
	            for (var prop in args.props) {
	                props[camelCase(prop)] = args.props[prop];
	            }
	        }
	    };
	    PropsProcessor.prototype.getChildren = function (children, args, props) {
	        if (children && !(args.domProps && args.domProps.innerHTML)) {
	            props.children = children;
	        }
	    };
	    PropsProcessor.prototype.convertAttrsToProps = function (args, componentOrComponentName, resolvedComponent, props) {
	        if (args.attrs) {
	            for (var attr in args.attrs) {
	                attr = renameAttribute(componentOrComponentName, attr);
	                var resolvedVueComponent = resolvedComponent.vueComponent;
	                var attrValue = args.attrs[attr];
	                if (attrValue !== undefined || attrValue !== false) {
	                    var camelCasedAttrName = camelCase(attr);
	                    var vueComponentProp = resolvedVueComponent && resolvedVueComponent.props && resolvedVueComponent.props[camelCasedAttrName];
	                    if (vueComponentProp) {
	                        if (vueComponentProp === Boolean && attrValue !== false) {
	                            props[camelCasedAttrName] = true;
	                        }
	                        else {
	                            props[camelCasedAttrName] = attrValue;
	                        }
	                    }
	                    else {
	                        props[attr] = attrValue;
	                    }
	                }
	            }
	        }
	    };
	    PropsProcessor.prototype.getInnerHTML = function (args, props) {
	        var dangerouslySetInnerHTML;
	        if (args.domProps && args.domProps.innerHTML)
	            dangerouslySetInnerHTML = { __html: args.domProps.innerHTML };
	        if (dangerouslySetInnerHTML) {
	            props.dangerouslySetInnerHTML = dangerouslySetInnerHTML;
	        }
	    };
	    PropsProcessor.prototype.addCurrentComponentAsParentOfChildren = function (children, vueComponent) {
	        var length = children && children.length;
	        if (children && length && Array.isArray(children)) {
	            for (var i = 0, length_2 = children.length; i < length_2; i++) {
	                var child = children[i];
	                if (child && child.tag && child.tag.indexOf('f7-') !== -1) {
	                    child.props = __assign({}, child.props, { parentVueComponent: vueComponent });
	                }
	            }
	        }
	    };
	    PropsProcessor.prototype.handleRef = function (refName, vueComponentInstance, props) {
	        if (refName) {
	            if (!vueComponentInstance.$refs)
	                vueComponentInstance.$refs = {};
	            props['data-vue-ref'] = {
	                refName: refName,
	                vueComponentInstance: vueComponentInstance
	            };
	        }
	    };
	    return PropsProcessor;
	}());
	exports.PropsProcessor = PropsProcessor;
	
	//# sourceMappingURL=PropsProcessor.js.map


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(90);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(28);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _marker_dispatcher = __webpack_require__(243);
	
	var _marker_dispatcher2 = _interopRequireDefault(_marker_dispatcher);
	
	var _google_map_map = __webpack_require__(240);
	
	var _google_map_map2 = _interopRequireDefault(_google_map_map);
	
	var _google_map_markers = __webpack_require__(84);
	
	var _google_map_markers2 = _interopRequireDefault(_google_map_markers);
	
	var _google_map_markers_prerender = __webpack_require__(241);
	
	var _google_map_markers_prerender2 = _interopRequireDefault(_google_map_markers_prerender);
	
	var _google_map_loader = __webpack_require__(251);
	
	var _google_map_loader2 = _interopRequireDefault(_google_map_loader);
	
	var _detect = __webpack_require__(245);
	
	var _detect2 = _interopRequireDefault(_detect);
	
	var _geo = __webpack_require__(247);
	
	var _geo2 = _interopRequireDefault(_geo);
	
	var _array_helper = __webpack_require__(244);
	
	var _array_helper2 = _interopRequireDefault(_array_helper);
	
	var _is_plain_object = __webpack_require__(249);
	
	var _is_plain_object2 = _interopRequireDefault(_is_plain_object);
	
	var _pick = __webpack_require__(253);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _raf = __webpack_require__(254);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _log = __webpack_require__(252);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _isNumber = __webpack_require__(248);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _omit = __webpack_require__(87);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _detectElementResize = __webpack_require__(246);
	
	var _detectElementResize2 = _interopRequireDefault(_detectElementResize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var kEPS = 0.00001;
	var K_GOOGLE_TILE_SIZE = 256;
	// real minZoom calculated here _getMinZoom
	var K_IDLE_TIMEOUT = 100;
	var K_IDLE_CLICK_TIMEOUT = 300;
	var DEFAULT_MIN_ZOOM = 3;
	
	function defaultOptions_() /* maps */{
	  return {
	    overviewMapControl: false,
	    streetViewControl: false,
	    rotateControl: true,
	    mapTypeControl: false,
	    // disable poi
	    styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }],
	    minZoom: DEFAULT_MIN_ZOOM };
	}
	
	var latLng2Obj = function latLng2Obj(latLng) {
	  return (0, _is_plain_object2.default)(latLng) ? latLng : { lat: latLng[0], lng: latLng[1] };
	};
	
	var GoogleMap = function (_Component) {
	  _inherits(GoogleMap, _Component);
	
	  // eslint-disable-line
	
	  function GoogleMap(props) {
	    _classCallCheck(this, GoogleMap);
	
	    var _this = _possibleConstructorReturn(this, (GoogleMap.__proto__ || Object.getPrototypeOf(GoogleMap)).call(this, props));
	
	    _this._getMinZoom = function () {
	      if (_this.geoService_.getWidth() > 0 || _this.geoService_.getHeight() > 0) {
	        var tilesPerWidth = Math.ceil(_this.geoService_.getWidth() / K_GOOGLE_TILE_SIZE) + 2;
	        var tilesPerHeight = Math.ceil(_this.geoService_.getHeight() / K_GOOGLE_TILE_SIZE) + 2;
	        var maxTilesPerDim = Math.max(tilesPerWidth, tilesPerHeight);
	        return Math.ceil((0, _log2.default)(maxTilesPerDim));
	      }
	      return DEFAULT_MIN_ZOOM;
	    };
	
	    _this._computeMinZoom = function (minZoomOverride, minZoom) {
	      if (minZoomOverride) {
	        return minZoom || DEFAULT_MIN_ZOOM;
	      }
	      return _this._getMinZoom();
	    };
	
	    _this._mapDomResizeCallback = function () {
	      _this.resetSizeOnIdle_ = true;
	      if (_this.maps_) {
	        var originalCenter = _this.map_.getCenter();
	        _this.maps_.event.trigger(_this.map_, 'resize');
	        _this.map_.setCenter(originalCenter);
	      }
	    };
	
	    _this._setLayers = function (layerTypes) {
	      layerTypes.forEach(function (layerType) {
	        _this.layers_[layerType] = new _this.maps_[layerType]();
	        _this.layers_[layerType].setMap(_this.map_);
	      });
	    };
	
	    _this._initMap = function () {
	      // only initialize the map once
	      if (_this.initialized_) {
	        return;
	      }
	      _this.initialized_ = true;
	
	      var propsCenter = latLng2Obj(_this.props.center || _this.props.defaultCenter);
	      _this.geoService_.setView(propsCenter, _this.props.zoom || _this.props.defaultZoom, 0);
	
	      _this._onBoundsChanged(); // now we can calculate map bounds center etc...
	
	      var bootstrapURLKeys = _extends({}, _this.props.apiKey && { key: _this.props.apiKey }, _this.props.bootstrapURLKeys);
	
	      _this.props.googleMapLoader(bootstrapURLKeys).then(function (maps) {
	        if (!_this.mounted_) {
	          return;
	        }
	
	        var centerLatLng = _this.geoService_.getCenter();
	
	        var propsOptions = {
	          zoom: _this.props.zoom || _this.props.defaultZoom,
	          center: new maps.LatLng(centerLatLng.lat, centerLatLng.lng)
	        };
	
	        // prevent to exapose full api
	        // next props must be exposed (console.log(Object.keys(pick(maps, isPlainObject))))
	        // "Animation", "ControlPosition", "MapTypeControlStyle", "MapTypeId",
	        // "NavigationControlStyle", "ScaleControlStyle", "StrokePosition",
	        // "SymbolPath", "ZoomControlStyle",
	        // "event", "DirectionsStatus", "DirectionsTravelMode", "DirectionsUnitSystem",
	        // "DistanceMatrixStatus",
	        // "DistanceMatrixElementStatus", "ElevationStatus", "GeocoderLocationType",
	        // "GeocoderStatus", "KmlLayerStatus",
	        // "MaxZoomStatus", "StreetViewStatus", "TransitMode", "TransitRoutePreference",
	        // "TravelMode", "UnitSystem"
	        var mapPlainObjects = (0, _pick2.default)(maps, _is_plain_object2.default);
	        var options = typeof _this.props.options === 'function' ? _this.props.options(mapPlainObjects) : _this.props.options;
	        var defaultOptions = defaultOptions_(mapPlainObjects);
	
	        var draggableOptions = _this.props.draggable !== undefined && { draggable: _this.props.draggable };
	
	        var minZoom = _this._computeMinZoom(options.minZoomOverride, options.minZoom);
	        _this.minZoom_ = minZoom;
	
	        var preMapOptions = _extends({}, defaultOptions, {
	          minZoom: minZoom
	        }, options, propsOptions);
	
	        _this.defaultDraggableOption_ = preMapOptions.draggable !== undefined ? preMapOptions.draggable : _this.defaultDraggableOption_;
	
	        var mapOptions = _extends({}, preMapOptions, draggableOptions);
	
	        mapOptions.minZoom = _this._checkMinZoom(mapOptions.minZoom, minZoom);
	
	        var map = new maps.Map(_reactDom2.default.findDOMNode(_this.refs.google_map_dom), mapOptions);
	
	        _this.map_ = map;
	        _this.maps_ = maps;
	
	        _this._setLayers(_this.props.layerTypes);
	
	        // render in overlay
	        var this_ = _this;
	        var overlay = _this.overlay_ = Object.assign(new maps.OverlayView(), {
	          onAdd: function onAdd() {
	            var K_MAX_WIDTH = typeof screen !== 'undefined' ? screen.width + 'px' : '2000px';
	            var K_MAX_HEIGHT = typeof screen !== 'undefined' ? screen.height + 'px' : '2000px';
	
	            var div = document.createElement('div');
	            this.div = div;
	            div.style.backgroundColor = 'transparent';
	            div.style.position = 'absolute';
	            div.style.left = '0px';
	            div.style.top = '0px';
	            div.style.width = K_MAX_WIDTH; // prevents some chrome draw defects
	            div.style.height = K_MAX_HEIGHT;
	
	            var panes = this.getPanes();
	            panes.overlayMouseTarget.appendChild(div);
	
	            _reactDom2.default.unstable_renderSubtreeIntoContainer(this_, _react2.default.createElement(_google_map_markers2.default, {
	              experimental: this_.props.experimental,
	              onChildClick: this_._onChildClick,
	              onChildMouseDown: this_._onChildMouseDown,
	              onChildMouseEnter: this_._onChildMouseEnter,
	              onChildMouseLeave: this_._onChildMouseLeave,
	              geoService: this_.geoService_,
	              projectFromLeftTop: true,
	              distanceToMouse: this_.props.distanceToMouse,
	              getHoverDistance: this_._getHoverDistance,
	              dispatcher: this_.markersDispatcher_
	            }), div,
	            // remove prerendered markers
	            function () {
	              return this_.setState({ overlayCreated: true });
	            });
	          },
	          onRemove: function onRemove() {
	            _reactDom2.default.unmountComponentAtNode(this.div);
	          },
	          draw: function draw() {
	            var div = overlay.div;
	            var overlayProjection = overlay.getProjection();
	            var bounds = map.getBounds();
	            var ne = bounds.getNorthEast();
	            var sw = bounds.getSouthWest();
	            var ptx = overlayProjection.fromLatLngToDivPixel(new maps.LatLng(ne.lat(), sw.lng()));
	
	            // need round for safari still can't find what need for firefox
	            var ptxRounded = (0, _detect2.default)().isSafari ? { x: Math.round(ptx.x), y: Math.round(ptx.y) } : { x: ptx.x, y: ptx.y };
	
	            this_.updateCounter_++;
	            this_._onBoundsChanged(map, maps, !this_.props.debounced);
	
	            if (!this_.googleApiLoadedCalled_) {
	              this_._onGoogleApiLoaded({ map: map, maps: maps });
	              this_.googleApiLoadedCalled_ = true;
	            }
	
	            div.style.left = ptxRounded.x + 'px';
	            div.style.top = ptxRounded.y + 'px';
	            if (this_.markersDispatcher_) {
	              this_.markersDispatcher_.emit('kON_CHANGE');
	            }
	          }
	        });
	
	        overlay.setMap(map);
	
	        maps.event.addListener(map, 'zoom_changed', function () {
	          // recalc position at zoom start
	          if (this_.geoService_.getZoom() !== map.getZoom()) {
	            if (!this_.zoomAnimationInProgress_) {
	              this_.zoomAnimationInProgress_ = true;
	              this_._onZoomAnimationStart();
	            }
	
	            var TIMEOUT_ZOOM = 300;
	
	            if (new Date().getTime() - _this.zoomControlClickTime_ < TIMEOUT_ZOOM) {
	              // there is strange Google Map Api behavior in chrome when zoom animation of map
	              // is started only on second raf call, if was click on zoom control
	              // or +- keys pressed, so i wait for two rafs before change state
	
	              // this does not fully prevent animation jump
	              // but reduce it's occurence probability
	              (0, _raf2.default)(function () {
	                return (0, _raf2.default)(function () {
	                  this_.updateCounter_++;
	                  this_._onBoundsChanged(map, maps);
	                });
	              });
	            } else {
	              this_.updateCounter_++;
	              this_._onBoundsChanged(map, maps);
	            }
	          }
	        });
	
	        maps.event.addListener(map, 'idle', function () {
	          if (_this.resetSizeOnIdle_) {
	            _this._setViewSize();
	            var currMinZoom = _this._computeMinZoom(_this.props.options.minZoomOverride, _this.props.options.minZoom);
	
	            if (currMinZoom !== _this.minZoom_) {
	              _this.minZoom_ = currMinZoom;
	              map.setOptions({ minZoom: currMinZoom });
	            }
	
	            _this.resetSizeOnIdle_ = false;
	          }
	
	          if (this_.zoomAnimationInProgress_) {
	            this_.zoomAnimationInProgress_ = false;
	            this_._onZoomAnimationEnd();
	          }
	
	          var div = overlay.div;
	          var overlayProjection = overlay.getProjection();
	          var bounds = map.getBounds();
	          var ne = bounds.getNorthEast();
	          var sw = bounds.getSouthWest();
	          var ptx = overlayProjection.fromLatLngToDivPixel(new maps.LatLng(ne.lat(), sw.lng()));
	          // need round for safari still can't find what need for firefox
	          var ptxRounded = (0, _detect2.default)().isSafari ? { x: Math.round(ptx.x), y: Math.round(ptx.y) } : { x: ptx.x, y: ptx.y };
	
	          this_.updateCounter_++;
	          this_._onBoundsChanged(map, maps);
	
	          if (_this.mouse_) {
	            var latLng = _this.geoService_.unproject(_this.mouse_, true);
	            _this.mouse_.lat = latLng.lat;
	            _this.mouse_.lng = latLng.lng;
	          }
	
	          _this._onChildMouseMove();
	
	          this_.dragTime_ = 0;
	          div.style.left = ptxRounded.x + 'px';
	          div.style.top = ptxRounded.y + 'px';
	          if (this_.markersDispatcher_) {
	            this_.markersDispatcher_.emit('kON_CHANGE');
	            if (this_.fireMouseEventOnIdle_) {
	              this_.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
	            }
	          }
	        });
	
	        maps.event.addListener(map, 'mouseover', function () {
	          // has advantage over div MouseLeave
	          this_.mouseInMap_ = true;
	        });
	
	        maps.event.addListener(map, 'mouseout', function () {
	          // has advantage over div MouseLeave
	          this_.mouseInMap_ = false;
	          this_.mouse_ = null;
	          this_.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
	        });
	
	        maps.event.addListener(map, 'drag', function () {
	          this_.dragTime_ = new Date().getTime();
	          this_._onDrag();
	        });
	        // user choosing satellite vs roads, etc
	        maps.event.addListener(map, 'maptypeid_changed', function () {
	          this_._onMapTypeIdChange(map.getMapTypeId());
	        });
	      }).catch(function (e) {
	        console.error(e); // eslint-disable-line no-console
	        throw e;
	      });
	    };
	
	    _this._onGoogleApiLoaded = function () {
	      if (_this.props.onGoogleApiLoaded) {
	        var _this$props;
	
	        if (false) {
	          console.warn('GoogleMap: ' + // eslint-disable-line
	          'Usage of internal api objects is dangerous ' + 'and can cause a lot of issues.\n' + 'To hide this warning add yesIWantToUseGoogleMapApiInternals={true} ' + 'to <GoogleMap instance');
	        }
	
	        (_this$props = _this.props).onGoogleApiLoaded.apply(_this$props, arguments);
	      }
	    };
	
	    _this._getHoverDistance = function () {
	      return _this.props.hoverDistance;
	    };
	
	    _this._onDrag = function () {
	      var _this$props2;
	
	      return _this.props.onDrag && (_this$props2 = _this.props).onDrag.apply(_this$props2, arguments);
	    };
	
	    _this._onMapTypeIdChange = function () {
	      var _this$props3;
	
	      return _this.props.onMapTypeIdChange && (_this$props3 = _this.props).onMapTypeIdChange.apply(_this$props3, arguments);
	    };
	
	    _this._onZoomAnimationStart = function () {
	      var _this$props4;
	
	      return _this.props.onZoomAnimationStart && (_this$props4 = _this.props).onZoomAnimationStart.apply(_this$props4, arguments);
	    };
	
	    _this._onZoomAnimationEnd = function () {
	      var _this$props5;
	
	      return _this.props.onZoomAnimationEnd && (_this$props5 = _this.props).onZoomAnimationEnd.apply(_this$props5, arguments);
	    };
	
	    _this._onChildClick = function () {
	      if (_this.props.onChildClick) {
	        var _this$props6;
	
	        return (_this$props6 = _this.props).onChildClick.apply(_this$props6, arguments);
	      }
	      return undefined;
	    };
	
	    _this._onChildMouseDown = function (hoverKey, childProps) {
	      _this.childMouseDownArgs_ = [hoverKey, childProps];
	      if (_this.props.onChildMouseDown) {
	        _this.props.onChildMouseDown(hoverKey, childProps, _extends({}, _this.mouse_));
	      }
	    };
	
	    _this._onChildMouseUp = function () {
	      if (_this.childMouseDownArgs_) {
	        if (_this.props.onChildMouseUp) {
	          var _this$props7;
	
	          (_this$props7 = _this.props).onChildMouseUp.apply(_this$props7, _toConsumableArray(_this.childMouseDownArgs_).concat([_extends({}, _this.mouse_)]));
	        }
	        _this.childMouseDownArgs_ = null;
	        _this.childMouseUpTime_ = new Date().getTime();
	      }
	    };
	
	    _this._onChildMouseMove = function () {
	      if (_this.childMouseDownArgs_) {
	        if (_this.props.onChildMouseMove) {
	          var _this$props8;
	
	          (_this$props8 = _this.props).onChildMouseMove.apply(_this$props8, _toConsumableArray(_this.childMouseDownArgs_).concat([_extends({}, _this.mouse_)]));
	        }
	      }
	    };
	
	    _this._onChildMouseEnter = function () {
	      if (_this.props.onChildMouseEnter) {
	        var _this$props9;
	
	        return (_this$props9 = _this.props).onChildMouseEnter.apply(_this$props9, arguments);
	      }
	      return undefined;
	    };
	
	    _this._onChildMouseLeave = function () {
	      if (_this.props.onChildMouseLeave) {
	        var _this$props10;
	
	        return (_this$props10 = _this.props).onChildMouseLeave.apply(_this$props10, arguments);
	      }
	      return undefined;
	    };
	
	    _this._setViewSize = function () {
	      if (!_this.mounted_) return;
	
	      var mapDom = _reactDom2.default.findDOMNode(_this.refs.google_map_dom);
	      _this.geoService_.setViewSize(mapDom.clientWidth, mapDom.clientHeight);
	      _this._onBoundsChanged();
	    };
	
	    _this._onWindowResize = function () {
	      _this.resetSizeOnIdle_ = true;
	    };
	
	    _this._onMapMouseMove = function (e) {
	      if (!_this.mouseInMap_) return;
	
	      var currTime = new Date().getTime();
	      var K_RECALC_CLIENT_RECT_MS = 50;
	
	      if (currTime - _this.mouseMoveTime_ > K_RECALC_CLIENT_RECT_MS) {
	        _this.boundingRect_ = e.currentTarget.getBoundingClientRect();
	      }
	      _this.mouseMoveTime_ = currTime;
	
	      var mousePosX = e.clientX - _this.boundingRect_.left;
	      var mousePosY = e.clientY - _this.boundingRect_.top;
	
	      if (!_this.mouse_) {
	        _this.mouse_ = { x: 0, y: 0, lat: 0, lng: 0 };
	      }
	
	      _this.mouse_.x = mousePosX;
	      _this.mouse_.y = mousePosY;
	
	      var latLng = _this.geoService_.unproject(_this.mouse_, true);
	      _this.mouse_.lat = latLng.lat;
	      _this.mouse_.lng = latLng.lng;
	
	      _this._onChildMouseMove();
	
	      if (currTime - _this.dragTime_ < K_IDLE_TIMEOUT) {
	        _this.fireMouseEventOnIdle_ = true;
	      } else {
	        _this.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
	        _this.fireMouseEventOnIdle_ = false;
	      }
	    };
	
	    _this._onClick = function () {
	      var _this$props11;
	
	      return _this.props.onClick && !_this.childMouseDownArgs_ && new Date().getTime() - _this.childMouseUpTime_ > K_IDLE_CLICK_TIMEOUT && _this.dragTime_ === 0 && (_this$props11 = _this.props).onClick.apply(_this$props11, arguments);
	    };
	
	    _this._onMapClick = function (event) {
	      if (_this.markersDispatcher_) {
	        // support touch events and recalculate mouse position on click
	        _this._onMapMouseMove(event);
	        var currTime = new Date().getTime();
	        if (currTime - _this.dragTime_ > K_IDLE_TIMEOUT) {
	          if (_this.mouse_) {
	            _this._onClick(_extends({}, _this.mouse_, {
	              event: event
	            }));
	          }
	
	          _this.markersDispatcher_.emit('kON_CLICK', event);
	        }
	      }
	    };
	
	    _this._onMapMouseDownNative = function (event) {
	      if (!_this.mouseInMap_) return;
	
	      _this._onMapMouseDown(event);
	    };
	
	    _this._onMapMouseDown = function (event) {
	      if (_this.markersDispatcher_) {
	        var currTime = new Date().getTime();
	        if (currTime - _this.dragTime_ > K_IDLE_TIMEOUT) {
	          // Hovered marker detected at mouse move could be deleted at mouse down time
	          // so it will be good to force hovered marker recalculation
	          _this._onMapMouseMove(event);
	          _this.markersDispatcher_.emit('kON_MDOWN', event);
	        }
	      }
	    };
	
	    _this._onMapMouseDownCapture = function () {
	      if ((0, _detect2.default)().isChrome) {
	        // to fix strange zoom in chrome
	        if (!_this.mouse_) {
	          _this.zoomControlClickTime_ = new Date().getTime();
	        }
	      }
	    };
	
	    _this._onKeyDownCapture = function () {
	      if ((0, _detect2.default)().isChrome) {
	        _this.zoomControlClickTime_ = new Date().getTime();
	      }
	    };
	
	    _this._onTouchMove = function (event) {
	      if (_this.refs.google_map_dom) {
	        var mapDom = _reactDom2.default.findDOMNode(_this.refs.google_map_dom);
	        if (mapDom.contains(event.target)) {
	          event.preventDefault();
	        }
	      }
	    };
	
	    _this._isCenterDefined = function (center) {
	      return center && ((0, _is_plain_object2.default)(center) && (0, _isNumber2.default)(center.lat) && (0, _isNumber2.default)(center.lng) || center.length === 2 && (0, _isNumber2.default)(center[0]) && (0, _isNumber2.default)(center[1]));
	    };
	
	    _this._onBoundsChanged = function (map, maps, callExtBoundsChange) {
	      if (map) {
	        var gmC = map.getCenter();
	        _this.geoService_.setView([gmC.lat(), gmC.lng()], map.getZoom(), 0);
	      }
	
	      if ((_this.props.onChange || _this.props.onBoundsChange) && _this.geoService_.canProject()) {
	        var zoom = _this.geoService_.getZoom();
	        var bounds = _this.geoService_.getBounds();
	        var centerLatLng = _this.geoService_.getCenter();
	
	        if (!(0, _array_helper2.default)(bounds, _this.prevBounds_, kEPS)) {
	          if (callExtBoundsChange !== false) {
	            var marginBounds = _this.geoService_.getBounds(_this.props.margin);
	            if (_this.props.onBoundsChange) {
	              _this.props.onBoundsChange(_this.centerIsObject_ ? _extends({}, centerLatLng) : [centerLatLng.lat, centerLatLng.lng], zoom, bounds, marginBounds);
	            }
	
	            if (_this.props.onChange) {
	              _this.props.onChange({
	                center: _extends({}, centerLatLng),
	                zoom: zoom,
	                bounds: {
	                  nw: {
	                    lat: bounds[0],
	                    lng: bounds[1]
	                  },
	                  se: {
	                    lat: bounds[2],
	                    lng: bounds[3]
	                  },
	                  sw: {
	                    lat: bounds[4],
	                    lng: bounds[5]
	                  },
	                  ne: {
	                    lat: bounds[6],
	                    lng: bounds[7]
	                  }
	                },
	                marginBounds: {
	                  nw: {
	                    lat: marginBounds[0],
	                    lng: marginBounds[1]
	                  },
	                  se: {
	                    lat: marginBounds[2],
	                    lng: marginBounds[3]
	                  },
	                  sw: {
	                    lat: marginBounds[4],
	                    lng: marginBounds[5]
	                  },
	                  ne: {
	                    lat: marginBounds[6],
	                    lng: marginBounds[7]
	                  }
	                },
	
	                size: _this.geoService_.hasSize() ? {
	                  width: _this.geoService_.getWidth(),
	                  height: _this.geoService_.getHeight()
	                } : {
	                  width: 0,
	                  height: 0
	                }
	              });
	            }
	
	            _this.prevBounds_ = bounds;
	          }
	        }
	      }
	    };
	
	    _this.mounted_ = false;
	    _this.initialized_ = false;
	    _this.googleApiLoadedCalled_ = false;
	
	    _this.map_ = null;
	    _this.maps_ = null;
	    _this.prevBounds_ = null;
	
	    _this.layers_ = {};
	
	    _this.mouse_ = null;
	    _this.mouseMoveTime_ = 0;
	    _this.boundingRect_ = null;
	    _this.mouseInMap_ = true;
	
	    _this.dragTime_ = 0;
	    _this.fireMouseEventOnIdle_ = false;
	    _this.updateCounter_ = 0;
	
	    _this.markersDispatcher_ = new _marker_dispatcher2.default(_this);
	    _this.geoService_ = new _geo2.default(K_GOOGLE_TILE_SIZE);
	    _this.centerIsObject_ = (0, _is_plain_object2.default)(_this.props.center);
	
	    _this.minZoom_ = DEFAULT_MIN_ZOOM;
	    _this.defaultDraggableOption_ = true;
	
	    _this.zoomControlClickTime_ = 0;
	
	    _this.childMouseDownArgs_ = null;
	    _this.childMouseUpTime_ = 0;
	
	    if (false) {
	      if (_this.props.apiKey) {
	        console.warn('GoogleMap: ' + // eslint-disable-line no-console
	        'apiKey is deprecated, use ' + 'bootstrapURLKeys={{key: YOUR_API_KEY}} instead.');
	      }
	
	      if (_this.props.onBoundsChange) {
	        console.warn('GoogleMap: ' + // eslint-disable-line no-console
	        'onBoundsChange is deprecated, use ' + 'onChange({center, zoom, bounds, ...other}) instead.');
	      }
	
	      if (_this.props.center === undefined && _this.props.defaultCenter === undefined) {
	        console.warn('GoogleMap: center or defaultCenter' + // eslint-disable-line no-console
	        'property must be defined');
	      }
	
	      if (_this.props.zoom === undefined && _this.props.defaultZoom === undefined) {
	        console.warn('GoogleMap: zoom or defaultZoom' + // eslint-disable-line no-console
	        'property must be defined');
	      }
	    }
	
	    if (_this._isCenterDefined(_this.props.center || _this.props.defaultCenter)) {
	      var propsCenter = latLng2Obj(_this.props.center || _this.props.defaultCenter);
	      _this.geoService_.setView(propsCenter, _this.props.zoom || _this.props.defaultZoom, 0);
	    }
	
	    _this.zoomAnimationInProgress_ = false;
	
	    _this.state = {
	      overlayCreated: false
	    };
	    return _this;
	  }
	
	  _createClass(GoogleMap, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.mounted_ = true;
	      window.addEventListener('resize', this._onWindowResize);
	      window.addEventListener('keydown', this._onKeyDownCapture, true);
	
	      // prevent touch devices from moving the entire browser window on drag
	      window.addEventListener('touchmove', this._onTouchMove);
	
	      var mapDom = _reactDom2.default.findDOMNode(this.refs.google_map_dom);
	      // gmap can't prevent map drag if mousedown event already occured
	      // the only workaround I find is prevent mousedown native browser event
	      _reactDom2.default.findDOMNode(this.refs.google_map_dom).addEventListener('mousedown', this._onMapMouseDownNative, true);
	
	      window.addEventListener('mouseup', this._onChildMouseUp, false);
	
	      var bootstrapURLKeys = _extends({}, this.props.apiKey && { key: this.props.apiKey }, this.props.bootstrapURLKeys);
	
	      this.props.googleMapLoader(bootstrapURLKeys); // we can start load immediatly
	
	      setTimeout(function () {
	        // to detect size
	        _this2._setViewSize();
	        if (_this2._isCenterDefined(_this2.props.center || _this2.props.defaultCenter)) {
	          _this2._initMap();
	        }
	      }, 0, this);
	      if (this.props.resetBoundsOnResize) {
	        var that = this;
	        _detectElementResize2.default.addResizeListener(mapDom, that._mapDomResizeCallback);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      if (false) {
	        if (this.props.defaultCenter !== nextProps.defaultCenter) {
	          console.warn('GoogleMap: defaultCenter prop changed. ' + // eslint-disable-line
	          'You can\'t change default props.');
	        }
	
	        if (this.props.defaultZoom !== nextProps.defaultZoom) {
	          console.warn('GoogleMap: defaultZoom prop changed. ' + // eslint-disable-line
	          'You can\'t change default props.');
	        }
	      }
	
	      if (!this._isCenterDefined(this.props.center) && this._isCenterDefined(nextProps.center)) {
	        setTimeout(function () {
	          return _this3._initMap();
	        }, 0);
	      }
	
	      if (this.map_) {
	        var centerLatLng = this.geoService_.getCenter();
	        if (this._isCenterDefined(nextProps.center)) {
	          var nextPropsCenter = latLng2Obj(nextProps.center);
	          var currCenter = this._isCenterDefined(this.props.center) ? latLng2Obj(this.props.center) : null;
	
	          if (!currCenter || Math.abs(nextPropsCenter.lat - currCenter.lat) + Math.abs(nextPropsCenter.lng - currCenter.lng) > kEPS) {
	            if (Math.abs(nextPropsCenter.lat - centerLatLng.lat) + Math.abs(nextPropsCenter.lng - centerLatLng.lng) > kEPS) {
	              this.map_.panTo({ lat: nextPropsCenter.lat, lng: nextPropsCenter.lng });
	            }
	          }
	        }
	
	        if (nextProps.zoom !== undefined) {
	          // if zoom chaged by user
	          if (Math.abs(nextProps.zoom - this.props.zoom) > 0) {
	            this.map_.setZoom(nextProps.zoom);
	          }
	        }
	
	        if (this.props.draggable !== undefined && nextProps.draggable === undefined) {
	          // reset to default
	          this.map_.setOptions({ draggable: this.defaultDraggableOption_ });
	        } else if (this.props.draggable !== nextProps.draggable) {
	          // also prevent this on window 'mousedown' event to prevent map move
	          this.map_.setOptions({ draggable: nextProps.draggable });
	        }
	
	        // use shallowEqual to try avoid calling map._setOptions if only the ref changes
	        if (nextProps.options !== undefined && !(0, _shallowEqual2.default)(this.props.options, nextProps.options)) {
	          var mapPlainObjects = (0, _pick2.default)(this.maps_, _is_plain_object2.default);
	          var options = typeof nextProps.options === 'function' ? nextProps.options(mapPlainObjects) : nextProps.options;
	          // remove zoom, center and draggable options as these are managed by google-maps-react
	          options = (0, _omit2.default)(options, ['zoom', 'center', 'draggable']);
	
	          if (options.hasOwnProperty('minZoom')) {
	            var minZoom = this._computeMinZoom(options.minZoomOverride, options.minZoom);
	            options.minZoom = this._checkMinZoom(options.minZoom, minZoom);
	          }
	
	          this.map_.setOptions(options);
	        }
	
	        if (nextProps.layerTypes !== this.props.layerTypes) {
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = Object.keys(this.layers_)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var layerKey = _step.value;
	
	              this.layers_[layerKey].setMap(null);
	              delete this.layers_[layerKey];
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          this._setLayers(nextProps.layerTypes);
	        }
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      // draggable does not affect inner components
	      return !(0, _shallowEqual2.default)((0, _omit2.default)(this.props, ['draggable']), (0, _omit2.default)(nextProps, ['draggable'])) || !(0, _shallowEqual2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      this.markersDispatcher_.emit('kON_CHANGE');
	
	      if (this.props.hoverDistance !== prevProps.hoverDistance) {
	        this.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted_ = false;
	      var mapDom = _reactDom2.default.findDOMNode(this.refs.google_map_dom);
	      window.removeEventListener('resize', this._onWindowResize);
	      window.removeEventListener('keydown', this._onKeyDownCapture);
	      mapDom.removeEventListener('mousedown', this._onMapMouseDownNative, true);
	      window.removeEventListener('mouseup', this._onChildMouseUp, false);
	      window.removeEventListener('touchmove', this._onTouchMove);
	      if (this.props.resetBoundsOnResize) {
	        _detectElementResize2.default.removeResizeListener(mapDom, this._mapDomResizeCallback);
	      }
	
	      if (this.overlay_) {
	        // this triggers overlay_.onRemove(), which will unmount the <GoogleMapMarkers/>
	        this.overlay_.setMap(null);
	      }
	
	      if (this.maps_ && this.map_) {
	        // fix google, as otherwise listeners works even without map
	        this.map_.setOptions({ scrollwheel: false });
	        this.maps_.event.clearInstanceListeners(this.map_);
	      }
	
	      this.map_ = null;
	      this.maps_ = null;
	      this.markersDispatcher_.dispose();
	
	      this.resetSizeOnIdle_ = false;
	
	      delete this.map_;
	      delete this.markersDispatcher_;
	    }
	    // calc minZoom if map size available
	    // it's better to not set minZoom less than this calculation gives
	    // otherwise there is no homeomorphism between screen coordinates and map
	    // (one map coordinate can have different screen coordinates)
	
	  }, {
	    key: '_checkMinZoom',
	    value: function _checkMinZoom(zoom, minZoom) {
	      if (false) {
	        if (zoom < minZoom) {
	          console.warn('GoogleMap: ' + // eslint-disable-line
	          'minZoom option is less than recommended ' + 'minZoom option for your map sizes.\n' + 'overrided to value ' + minZoom);
	        }
	      }
	
	      if (minZoom < zoom) {
	        return zoom;
	      }
	      return minZoom;
	    }
	
	    // this method works only if this.props.onChildMouseDown was called
	
	
	    // this method works only if this.props.onChildMouseDown was called
	
	
	    // K_IDLE_CLICK_TIMEOUT - looks like 300 is enough
	
	
	    // gmap can't prevent map drag if mousedown event already occured
	    // the only workaround I find is prevent mousedown native browser event
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var mapMarkerPrerender = !this.state.overlayCreated ? _react2.default.createElement(_google_map_markers_prerender2.default, {
	        experimental: this.props.experimental,
	        onChildClick: this._onChildClick,
	        onChildMouseDown: this._onChildMouseDown,
	        onChildMouseEnter: this._onChildMouseEnter,
	        onChildMouseLeave: this._onChildMouseLeave,
	        geoService: this.geoService_,
	        projectFromLeftTop: false,
	        distanceToMouse: this.props.distanceToMouse,
	        getHoverDistance: this._getHoverDistance,
	        dispatcher: this.markersDispatcher_
	      }) : null;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: this.props.style,
	          onMouseMove: this._onMapMouseMove,
	          onMouseDownCapture: this._onMapMouseDownCapture,
	          onClick: this._onMapClick
	        },
	        _react2.default.createElement(_google_map_map2.default, { ref: 'google_map_dom' }),
	        mapMarkerPrerender
	      );
	    }
	  }]);
	
	  return GoogleMap;
	}(_react.Component);
	
	GoogleMap.propTypes = {
	  apiKey: _react.PropTypes.string,
	  bootstrapURLKeys: _react.PropTypes.any,
	
	  defaultCenter: _react2.default.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.shape({
	    lat: _react.PropTypes.number,
	    lng: _react.PropTypes.number
	  })]),
	  center: _react2.default.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.shape({
	    lat: _react.PropTypes.number,
	    lng: _react.PropTypes.number
	  })]),
	  defaultZoom: _react.PropTypes.number,
	  zoom: _react.PropTypes.number,
	  onBoundsChange: _react.PropTypes.func,
	  onChange: _react.PropTypes.func,
	  onClick: _react.PropTypes.func,
	  onChildClick: _react.PropTypes.func,
	  onChildMouseDown: _react.PropTypes.func,
	  onChildMouseUp: _react.PropTypes.func,
	  onChildMouseMove: _react.PropTypes.func,
	  onChildMouseEnter: _react.PropTypes.func,
	  onChildMouseLeave: _react.PropTypes.func,
	  onZoomAnimationStart: _react.PropTypes.func,
	  onZoomAnimationEnd: _react.PropTypes.func,
	  onDrag: _react.PropTypes.func,
	  onMapTypeIdChange: _react.PropTypes.func,
	  options: _react.PropTypes.any,
	  distanceToMouse: _react.PropTypes.func,
	  hoverDistance: _react.PropTypes.number,
	  debounced: _react.PropTypes.bool,
	  margin: _react.PropTypes.array,
	  googleMapLoader: _react.PropTypes.any,
	  onGoogleApiLoaded: _react.PropTypes.func,
	  yesIWantToUseGoogleMapApiInternals: _react.PropTypes.bool,
	  draggable: _react.PropTypes.bool,
	  style: _react.PropTypes.any,
	  resetBoundsOnResize: _react.PropTypes.bool,
	  layerTypes: _react.PropTypes.arrayOf(_react.PropTypes.string) };
	GoogleMap.defaultProps = {
	  distanceToMouse: function distanceToMouse(pt, mousePos /* , markerProps */) {
	    return Math.sqrt((pt.x - mousePos.x) * (pt.x - mousePos.x) + (pt.y - mousePos.y) * (pt.y - mousePos.y));
	  },
	
	  hoverDistance: 30,
	  debounced: true,
	  options: defaultOptions_,
	  googleMapLoader: _google_map_loader2.default,
	  yesIWantToUseGoogleMapApiInternals: false,
	  style: {
	    width: '100%',
	    height: '100%',
	    margin: 0,
	    padding: 0,
	    position: 'relative'
	  },
	  layerTypes: []
	};
	GoogleMap.googleMapLoader = _google_map_loader2.default;
	exports.default = GoogleMap;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var style = {
	  width: '100%',
	  height: '100%',
	  left: 0,
	  top: 0,
	  margin: 0,
	  padding: 0,
	  position: 'absolute'
	};
	
	var GoogleMapMap = function (_Component) {
	  _inherits(GoogleMapMap, _Component);
	
	  function GoogleMapMap() {
	    _classCallCheck(this, GoogleMapMap);
	
	    return _possibleConstructorReturn(this, (GoogleMapMap.__proto__ || Object.getPrototypeOf(GoogleMapMap)).apply(this, arguments));
	  }
	
	  _createClass(GoogleMapMap, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return false; // disable react on this div
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', { style: style });
	    }
	  }]);
	
	  return GoogleMapMap;
	}(_react.Component);
	
	exports.default = GoogleMapMap;

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    { style: style },
	    _react2.default.createElement(_google_map_markers2.default, _extends({}, props, { prerender: true }))
	  );
	};
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _google_map_markers = __webpack_require__(84);
	
	var _google_map_markers2 = _interopRequireDefault(_google_map_markers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = {
	  width: '50%',
	  height: '50%',
	  left: '50%',
	  top: '50%',
	  // backgroundColor: 'red',
	  margin: 0,
	  padding: 0,
	  position: 'absolute'
	};

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _google_map = __webpack_require__(239);
	
	var _google_map2 = _interopRequireDefault(_google_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _google_map2.default;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _eventemitter = __webpack_require__(152);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarkerDispatcher = function (_EventEmitter) {
	  _inherits(MarkerDispatcher, _EventEmitter);
	
	  function MarkerDispatcher(gmapInstance) {
	    _classCallCheck(this, MarkerDispatcher);
	
	    var _this = _possibleConstructorReturn(this, (MarkerDispatcher.__proto__ || Object.getPrototypeOf(MarkerDispatcher)).call(this));
	
	    _this.gmapInstance = gmapInstance;
	    return _this;
	  }
	
	  _createClass(MarkerDispatcher, [{
	    key: 'getChildren',
	    value: function getChildren() {
	      return this.gmapInstance.props.children;
	    }
	  }, {
	    key: 'getMousePosition',
	    value: function getMousePosition() {
	      return this.gmapInstance.mouse_;
	    }
	  }, {
	    key: 'getUpdateCounter',
	    value: function getUpdateCounter() {
	      return this.gmapInstance.updateCounter_;
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      this.gmapInstance = null;
	      this.removeAllListeners();
	    }
	  }]);
	
	  return MarkerDispatcher;
	}(_eventemitter2.default);
	
	exports.default = MarkerDispatcher;

/***/ },
/* 244 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isArraysEqualEps;
	function isArraysEqualEps(arrayA, arrayB, eps) {
	  if (arrayA && arrayB) {
	    for (var i = 0; i !== arrayA.length; ++i) {
	      if (Math.abs(arrayA[i] - arrayB[i]) > eps) {
	        return false;
	      }
	    }
	    return true;
	  }
	  return false;
	}

/***/ },
/* 245 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = detectBrowser;
	// http://stackoverflow.com/questions/5899783/detect-safari-chrome-ie-firefox-opera-with-user-agent
	var detectBrowserResult_ = null;
	
	function detectBrowser() {
	  if (detectBrowserResult_) {
	    return detectBrowserResult_;
	  }
	
	  if (typeof navigator !== 'undefined') {
	    var isExplorer = navigator.userAgent.indexOf('MSIE') > -1;
	    var isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
	    var isOpera = navigator.userAgent.toLowerCase().indexOf('op') > -1;
	
	    var isChrome = navigator.userAgent.indexOf('Chrome') > -1;
	    var isSafari = navigator.userAgent.indexOf('Safari') > -1;
	
	    if (isChrome && isSafari) {
	      isSafari = false;
	    }
	
	    if (isChrome && isOpera) {
	      isChrome = false;
	    }
	
	    detectBrowserResult_ = { isExplorer: isExplorer, isFirefox: isFirefox, isOpera: isOpera, isChrome: isChrome, isSafari: isSafari };
	    return detectBrowserResult_;
	  }
	
	  detectBrowserResult_ = {
	    isChrome: true,
	    isExplorer: false,
	    isFirefox: false,
	    isOpera: false,
	    isSafari: false
	  };
	
	  return detectBrowserResult_;
	}

/***/ },
/* 246 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable */
	/**
	* Detect Element Resize.
	* Forked in order to guard against unsafe 'window' and 'document' references.
	*
	* https://github.com/sdecima/javascript-detect-element-resize
	* Sebastian Decima
	*
	* version: 0.5.3
	**/
	
	// Reliable `window` and `document` detection
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	// Check `document` and `window` in case of server-side rendering
	var _window;
	if (canUseDOM) {
	  _window = window;
	} else if (typeof self !== 'undefined') {
	  _window = self;
	} else {
	  _window = undefined;
	}
	
	var attachEvent = typeof document !== 'undefined' && document.attachEvent;
	var stylesCreated = false;
	
	if (canUseDOM && !attachEvent) {
	  var requestFrame = function () {
	    var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
	      return _window.setTimeout(fn, 20);
	    };
	    return function (fn) {
	      return raf(fn);
	    };
	  }();
	
	  var cancelFrame = function () {
	    var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
	    return function (id) {
	      return cancel(id);
	    };
	  }();
	
	  var resetTriggers = function resetTriggers(element) {
	    var triggers = element.__resizeTriggers__,
	        expand = triggers.firstElementChild,
	        contract = triggers.lastElementChild,
	        expandChild = expand.firstElementChild;
	    contract.scrollLeft = contract.scrollWidth;
	    contract.scrollTop = contract.scrollHeight;
	    expandChild.style.width = expand.offsetWidth + 1 + 'px';
	    expandChild.style.height = expand.offsetHeight + 1 + 'px';
	    expand.scrollLeft = expand.scrollWidth;
	    expand.scrollTop = expand.scrollHeight;
	  };
	
	  var checkTriggers = function checkTriggers(element) {
	    return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
	  };
	
	  var scrollListener = function scrollListener(e) {
	    var element = this;
	    resetTriggers(this);
	    if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
	    this.__resizeRAF__ = requestFrame(function () {
	      if (checkTriggers(element)) {
	        element.__resizeLast__.width = element.offsetWidth;
	        element.__resizeLast__.height = element.offsetHeight;
	        element.__resizeListeners__.forEach(function (fn) {
	          fn.call(element, e);
	        });
	      }
	    });
	  };
	
	  /* Detect CSS Animations support to detect element display/re-attach */
	  var animation = false,
	      animationstring = 'animation',
	      keyframeprefix = '',
	      animationstartevent = 'animationstart',
	      domPrefixes = 'Webkit Moz O ms'.split(' '),
	      startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
	      pfx = '';
	
	  if (canUseDOM) {
	    var elm = document.createElement('fakeelement');
	    if (elm.style.animationName !== undefined) {
	      animation = true;
	    }
	
	    if (animation === false) {
	      for (var i = 0; i < domPrefixes.length; i++) {
	        if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
	          pfx = domPrefixes[i];
	          animationstring = pfx + 'Animation';
	          keyframeprefix = '-' + pfx.toLowerCase() + '-';
	          animationstartevent = startEvents[i];
	          animation = true;
	          break;
	        }
	      }
	    }
	  }
	
	  var animationName = 'resizeanim';
	  var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
	  var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
	}
	
	var createStyles = function createStyles() {
	  if (!stylesCreated) {
	    //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
	    var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: \" \"; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
	        head = document.head || document.getElementsByTagName('head')[0],
	        style = document.createElement('style');
	
	    style.type = 'text/css';
	    if (style.styleSheet) {
	      style.styleSheet.cssText = css;
	    } else {
	      style.appendChild(document.createTextNode(css));
	    }
	
	    head.appendChild(style);
	    stylesCreated = true;
	  }
	};
	
	var addResizeListener = function addResizeListener(element, fn) {
	  if (element.parentNode === undefined) {
	    var tempParentDiv = document.createElement('div');
	    element.parentNode = tempParentDiv;
	  }
	  element = element.parentNode;
	  if (attachEvent) element.attachEvent('onresize', fn);else {
	    if (!element.__resizeTriggers__) {
	      if (getComputedStyle(element).position == 'static') element.style.position = 'relative';
	      createStyles();
	      element.__resizeLast__ = {};
	      element.__resizeListeners__ = [];
	      (element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
	      element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
	      element.appendChild(element.__resizeTriggers__);
	      resetTriggers(element);
	      element.addEventListener('scroll', scrollListener, true);
	
	      /* Listen for a css animation to detect element display/re-attach */
	      animationstartevent && element.__resizeTriggers__.addEventListener(animationstartevent, function (e) {
	        if (e.animationName == animationName) resetTriggers(element);
	      });
	    }
	    element.__resizeListeners__.push(fn);
	  }
	};
	
	var removeResizeListener = function removeResizeListener(element, fn) {
	  element = element.parentNode;
	  if (attachEvent) element.detachEvent('onresize', fn);else {
	    element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
	    if (!element.__resizeListeners__.length) {
	      element.removeEventListener('scroll', scrollListener);
	      element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
	    }
	  }
	};
	
	module.exports = {
	  addResizeListener: addResizeListener,
	  removeResizeListener: removeResizeListener
	};

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lat_lng = __webpack_require__(85);
	
	var _lat_lng2 = _interopRequireDefault(_lat_lng);
	
	var _pointGeometry = __webpack_require__(88);
	
	var _pointGeometry2 = _interopRequireDefault(_pointGeometry);
	
	var _transform = __webpack_require__(250);
	
	var _transform2 = _interopRequireDefault(_transform);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Geo = function () {
	  function Geo(tileSize) {
	    _classCallCheck(this, Geo);
	
	    // left_top view пользует гугл
	    // super();
	    this.hasSize_ = false;
	    this.hasView_ = false;
	    this.transform_ = new _transform2.default(tileSize || 512);
	  }
	
	  _createClass(Geo, [{
	    key: 'setView',
	    value: function setView(center, zoom, bearing) {
	      this.transform_.center = _lat_lng2.default.convert(center);
	      this.transform_.zoom = +zoom;
	      this.transform_.bearing = +bearing;
	      this.hasView_ = true;
	    }
	  }, {
	    key: 'setViewSize',
	    value: function setViewSize(width, height) {
	      this.transform_.width = width;
	      this.transform_.height = height;
	      this.hasSize_ = true;
	    }
	  }, {
	    key: 'canProject',
	    value: function canProject() {
	      return this.hasSize_ && this.hasView_;
	    }
	  }, {
	    key: 'hasSize',
	    value: function hasSize() {
	      return this.hasSize_;
	    }
	  }, {
	    key: 'unproject',
	    value: function unproject(ptXY, viewFromLeftTop) {
	      var ptRes = void 0;
	      if (viewFromLeftTop) {
	        var ptxy = _extends({}, ptXY);
	        ptxy.x -= this.transform_.width / 2;
	        ptxy.y -= this.transform_.height / 2;
	        ptRes = this.transform_.pointLocation(_pointGeometry2.default.convert(ptxy));
	      } else {
	        ptRes = this.transform_.pointLocation(_pointGeometry2.default.convert(ptXY));
	      }
	
	      ptRes.lng -= 360 * Math.round(ptRes.lng / 360); // convert 2 google format
	      return ptRes;
	    }
	  }, {
	    key: 'project',
	    value: function project(ptLatLng, viewFromLeftTop) {
	      if (viewFromLeftTop) {
	        var pt = this.transform_.locationPoint(_lat_lng2.default.convert(ptLatLng));
	        pt.x -= this.transform_.worldSize * Math.round(pt.x / this.transform_.worldSize);
	
	        pt.x += this.transform_.width / 2;
	        pt.y += this.transform_.height / 2;
	
	        return pt;
	      }
	
	      return this.transform_.locationPoint(_lat_lng2.default.convert(ptLatLng));
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth() {
	      return this.transform_.width;
	    }
	  }, {
	    key: 'getHeight',
	    value: function getHeight() {
	      return this.transform_.height;
	    }
	  }, {
	    key: 'getZoom',
	    value: function getZoom() {
	      return this.transform_.zoom;
	    }
	  }, {
	    key: 'getCenter',
	    value: function getCenter() {
	      var ptRes = this.transform_.pointLocation({ x: 0, y: 0 });
	
	      return ptRes;
	    }
	  }, {
	    key: 'getBounds',
	    value: function getBounds(margins, roundFactor) {
	      var bndT = margins && margins[0] || 0;
	      var bndR = margins && margins[1] || 0;
	      var bndB = margins && margins[2] || 0;
	      var bndL = margins && margins[3] || 0;
	
	      if (this.getWidth() - bndR - bndL > 0 && this.getHeight() - bndT - bndB > 0) {
	        var topLeftCorner = this.unproject({
	          x: bndL - this.getWidth() / 2,
	          y: bndT - this.getHeight() / 2
	        });
	        var bottomRightCorner = this.unproject({
	          x: this.getWidth() / 2 - bndR,
	          y: this.getHeight() / 2 - bndB
	        });
	
	        var res = [topLeftCorner.lat, topLeftCorner.lng, // NW
	        bottomRightCorner.lat, bottomRightCorner.lng, // SE
	        bottomRightCorner.lat, topLeftCorner.lng, // SW
	        topLeftCorner.lat, bottomRightCorner.lng];
	
	        if (roundFactor) {
	          res = res.map(function (r) {
	            return Math.round(r * roundFactor) / roundFactor;
	          });
	        }
	        return res;
	      }
	
	      return [0, 0, 0, 0];
	    }
	  }]);
	
	  return Geo;
	}();
	
	exports.default = Geo;

/***/ },
/* 248 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isNumber;
	
	function isObjectLike(value) {
	  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
	}
	
	var objectToString = Object.prototype.toString;
	
	function isNumber(value) {
	  var numberTag = '[object Number]';
	  return typeof value === 'number' || isObjectLike(value) && objectToString.call(value) === numberTag;
	}

/***/ },
/* 249 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isPlainObject;
	// source taken from https://github.com/rackt/redux/blob/master/src/utils/isPlainObject.js
	var fnToString = function fnToString(fn) {
	  return Function.prototype.toString.call(fn);
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (!obj || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
	    return false;
	  }
	
	  var proto = typeof obj.constructor === 'function' ? Object.getPrototypeOf(obj) : Object.prototype;
	
	  if (proto === null) {
	    return true;
	  }
	
	  var constructor = proto.constructor;
	
	  return typeof constructor === 'function' && constructor instanceof constructor && fnToString(constructor) === fnToString(Object);
	}

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lat_lng = __webpack_require__(85);
	
	var _lat_lng2 = _interopRequireDefault(_lat_lng);
	
	var _pointGeometry = __webpack_require__(88);
	
	var _pointGeometry2 = _interopRequireDefault(_pointGeometry);
	
	var _wrap = __webpack_require__(86);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// A single transform, generally used for a single tile to be scaled, rotated, and zoomed.
	var Transform = function () {
	  function Transform(tileSize, minZoom, maxZoom) {
	    _classCallCheck(this, Transform);
	
	    this.tileSize = tileSize || 512; // constant
	
	    this._minZoom = minZoom || 0;
	    this._maxZoom = maxZoom || 52;
	
	    this.latRange = [-85.05113, 85.05113];
	
	    this.width = 0;
	    this.height = 0;
	    this.zoom = 0;
	    this.center = new _lat_lng2.default(0, 0);
	    this.angle = 0;
	  }
	
	  _createClass(Transform, [{
	    key: 'zoomScale',
	    value: function zoomScale(zoom) {
	      return Math.pow(2, zoom);
	    }
	  }, {
	    key: 'scaleZoom',
	    value: function scaleZoom(scale) {
	      return Math.log(scale) / Math.LN2;
	    }
	  }, {
	    key: 'project',
	    value: function project(latlng, worldSize) {
	      return new _pointGeometry2.default(this.lngX(latlng.lng, worldSize), this.latY(latlng.lat, worldSize));
	    }
	  }, {
	    key: 'unproject',
	    value: function unproject(point, worldSize) {
	      return new _lat_lng2.default(this.yLat(point.y, worldSize), this.xLng(point.x, worldSize));
	    }
	  }, {
	    key: 'lngX',
	
	
	    // lat/lon <-> absolute pixel coords convertion
	    value: function lngX(lon, worldSize) {
	      return (180 + lon) * (worldSize || this.worldSize) / 360;
	    }
	
	    // latitude to absolute y coord
	
	  }, {
	    key: 'latY',
	    value: function latY(lat, worldSize) {
	      var y = 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360));
	      return (180 - y) * (worldSize || this.worldSize) / 360;
	    }
	  }, {
	    key: 'xLng',
	    value: function xLng(x, worldSize) {
	      return x * 360 / (worldSize || this.worldSize) - 180;
	    }
	  }, {
	    key: 'yLat',
	    value: function yLat(y, worldSize) {
	      var y2 = 180 - y * 360 / (worldSize || this.worldSize);
	      return 360 / Math.PI * Math.atan(Math.exp(y2 * Math.PI / 180)) - 90;
	    }
	  }, {
	    key: 'locationPoint',
	    value: function locationPoint(latlng) {
	      var p = this.project(latlng);
	      return this.centerPoint._sub(this.point._sub(p)._rotate(this.angle));
	    }
	  }, {
	    key: 'pointLocation',
	    value: function pointLocation(p) {
	      var p2 = this.centerPoint._sub(p)._rotate(-this.angle);
	      return this.unproject(this.point.sub(p2));
	    }
	  }, {
	    key: 'minZoom',
	    get: function get() {
	      return this._minZoom;
	    },
	    set: function set(zoom) {
	      this._minZoom = zoom;
	      this.zoom = Math.max(this.zoom, zoom);
	    }
	  }, {
	    key: 'maxZoom',
	    get: function get() {
	      return this._maxZoom;
	    },
	    set: function set(zoom) {
	      this._maxZoom = zoom;
	      this.zoom = Math.min(this.zoom, zoom);
	    }
	  }, {
	    key: 'worldSize',
	    get: function get() {
	      return this.tileSize * this.scale;
	    }
	  }, {
	    key: 'centerPoint',
	    get: function get() {
	      return new _pointGeometry2.default(0, 0); // this.size._div(2);
	    }
	  }, {
	    key: 'size',
	    get: function get() {
	      return new _pointGeometry2.default(this.width, this.height);
	    }
	  }, {
	    key: 'bearing',
	    get: function get() {
	      return -this.angle / Math.PI * 180;
	    },
	    set: function set(bearing) {
	      this.angle = -(0, _wrap.wrap)(bearing, -180, 180) * Math.PI / 180;
	    }
	  }, {
	    key: 'zoom',
	    get: function get() {
	      return this._zoom;
	    },
	    set: function set(zoom) {
	      var zoomV = Math.min(Math.max(zoom, this.minZoom), this.maxZoom);
	      this._zoom = zoomV;
	      this.scale = this.zoomScale(zoomV);
	      this.tileZoom = Math.floor(zoomV);
	      this.zoomFraction = zoomV - this.tileZoom;
	    }
	  }, {
	    key: 'x',
	    get: function get() {
	      return this.lngX(this.center.lng);
	    }
	  }, {
	    key: 'y',
	    get: function get() {
	      return this.latY(this.center.lat);
	    }
	  }, {
	    key: 'point',
	    get: function get() {
	      return new _pointGeometry2.default(this.x, this.y);
	    }
	  }]);
	
	  return Transform;
	}();
	
	exports.default = Transform;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = googleMapLoader;
	var $script_ = null;
	
	var loadPromise_ = void 0;
	
	var resolveCustomPromise_ = void 0;
	var _customPromise = new Promise(function (resolve) {
	  resolveCustomPromise_ = resolve;
	});
	
	// TODO add libraries language and other map options
	function googleMapLoader(bootstrapURLKeys) {
	  if (!$script_) {
	    $script_ = __webpack_require__(344); // eslint-disable-line
	  }
	
	  // call from outside google-map-react
	  // will be as soon as loadPromise_ resolved
	  if (!bootstrapURLKeys) {
	    return _customPromise;
	  }
	
	  if (loadPromise_) {
	    return loadPromise_;
	  }
	
	  loadPromise_ = new Promise(function (resolve, reject) {
	    if (typeof window === 'undefined') {
	      reject(new Error('google map cannot be loaded outside browser env'));
	      return;
	    }
	
	    if (window.google && window.google.maps) {
	      resolve(window.google.maps);
	      return;
	    }
	
	    if (typeof window._$_google_map_initialize_$_ !== 'undefined') {
	      reject(new Error('google map initialization error'));
	    }
	
	    window._$_google_map_initialize_$_ = function () {
	      delete window._$_google_map_initialize_$_;
	      resolve(window.google.maps);
	    };
	
	    if (false) {
	      if (Object.keys(bootstrapURLKeys).indexOf('callback') > -1) {
	        console.error('"callback" key in bootstrapURLKeys is not allowed, ' + // eslint-disable-line
	        'use onGoogleApiLoaded property instead');
	        throw new Error('"callback" key in bootstrapURLKeys is not allowed, ' + 'use onGoogleApiLoaded property instead');
	      }
	    }
	
	    var queryString = Object.keys(bootstrapURLKeys).reduce(function (r, key) {
	      return r + '&' + key + '=' + bootstrapURLKeys[key];
	    }, '');
	
	    $script_('https://maps.googleapis.com/maps/api/js?callback=_$_google_map_initialize_$_' + queryString, function () {
	      return typeof window.google === 'undefined' && reject(new Error('google map initialization error (not loaded)'));
	    });
	  });
	
	  resolveCustomPromise_(loadPromise_);
	
	  return loadPromise_;
	}

/***/ },
/* 252 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var log2 = Math.log2 ? Math.log2 : function (x) {
	  return Math.log(x) / Math.LN2;
	};
	
	exports.default = log2;

/***/ },
/* 253 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = pick;
	// source taken from https://github.com/rackt/redux/blob/master/src/utils/pick.js
	
	function pick(obj, fn) {
	  return Object.keys(obj).reduce(function (result, key) {
	    if (fn(obj[key])) {
	      result[key] = obj[key]; // eslint-disable-line
	    }
	    return result;
	  }, {});
	}

/***/ },
/* 254 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = raf;
	function raf(callback) {
	  if (window.requestAnimationFrame) {
	    return window.requestAnimationFrame(callback);
	  }
	
	  var nativeRaf = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
	
	  return nativeRaf ? nativeRaf(callback) : window.setTimeout(callback, 1e3 / 60);
	}

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(15)
	var upperCase = __webpack_require__(18)
	
	/**
	 * Header case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale, '-').replace(/^.|\-./g, function (m) {
	    return upperCase(m, locale)
	  })
	}


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	var lowerCase = __webpack_require__(29)
	
	/**
	 * Check if a string is lower case.
	 *
	 * @param  {String}  string
	 * @param  {String}  [locale]
	 * @return {Boolean}
	 */
	module.exports = function (string, locale) {
	  return lowerCase(string, locale) === string
	}


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(18)
	
	/**
	 * Check if a string is upper case.
	 *
	 * @param  {String}  string
	 * @param  {String}  [locale]
	 * @return {Boolean}
	 */
	module.exports = function (string, locale) {
	  return upperCase(string, locale) === string
	}


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	var lowerCase = __webpack_require__(29)
	
	/**
	 * Lower case the first character of a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  if (str == null) {
	    return ''
	  }
	
	  str = String(str)
	
	  return lowerCase(str.charAt(0), locale) + str.substr(1)
	}


/***/ },
/* 259 */
/***/ function(module, exports) {

	module.exports = /([a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19])([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A])/g


/***/ },
/* 260 */
/***/ function(module, exports) {

	module.exports = /([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A]+)([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A][a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A])/g


/***/ },
/* 261 */
/***/ function(module, exports) {

	module.exports = /[^A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+/g


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(15)
	
	/**
	 * Param case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale, '-')
	}


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	var camelCase = __webpack_require__(70)
	var upperCaseFirst = __webpack_require__(64)
	
	/**
	 * Pascal case a string.
	 *
	 * @param  {string}  value
	 * @param  {string}  [locale]
	 * @param  {boolean} [mergeNumbers]
	 * @return {string}
	 */
	module.exports = function (value, locale, mergeNumbers) {
	  return upperCaseFirst(camelCase(value, locale, mergeNumbers), locale)
	}


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(15)
	
	/**
	 * Path case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale, '/')
	}


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(89);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(89);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 267 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(8);
	
	var focusNode = __webpack_require__(72);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(31);
	var ExecutionEnvironment = __webpack_require__(9);
	var FallbackCompositionState = __webpack_require__(275);
	var SyntheticCompositionEvent = __webpack_require__(312);
	var SyntheticInputEvent = __webpack_require__(315);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(91);
	var ExecutionEnvironment = __webpack_require__(9);
	var ReactInstrumentation = __webpack_require__(13);
	
	var camelizeStyleName = __webpack_require__(158);
	var dangerousStyleValue = __webpack_require__(321);
	var hyphenateStyleName = __webpack_require__(165);
	var memoizeStringOnly = __webpack_require__(168);
	var warning = __webpack_require__(4);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(30);
	var EventPropagators = __webpack_require__(31);
	var ExecutionEnvironment = __webpack_require__(9);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(14);
	var SyntheticEvent = __webpack_require__(16);
	
	var getEventTarget = __webpack_require__(58);
	var isEventSupported = __webpack_require__(59);
	var isTextInputElement = __webpack_require__(108);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var DOMLazyTree = __webpack_require__(20);
	var ExecutionEnvironment = __webpack_require__(9);
	
	var createNodesFromMarkup = __webpack_require__(161);
	var emptyFunction = __webpack_require__(12);
	var invariant = __webpack_require__(3);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 273 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(31);
	var ReactDOMComponentTree = __webpack_require__(8);
	var SyntheticMouseEvent = __webpack_require__(36);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(19);
	
	var getTextContentAccessor = __webpack_require__(106);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(21);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(22);
	
	var instantiateReactComponent = __webpack_require__(107);
	var KeyEscapeUtils = __webpack_require__(50);
	var shouldUpdateReactComponent = __webpack_require__(60);
	var traverseAllChildren = __webpack_require__(110);
	var warning = __webpack_require__(4);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"/IAFTours"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(111);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)))

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(46);
	var ReactDOMIDOperations = __webpack_require__(285);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(7);
	
	var React = __webpack_require__(23);
	var ReactComponentEnvironment = __webpack_require__(52);
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactErrorUtils = __webpack_require__(53);
	var ReactInstanceMap = __webpack_require__(32);
	var ReactInstrumentation = __webpack_require__(13);
	var ReactNodeTypes = __webpack_require__(101);
	var ReactReconciler = __webpack_require__(22);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(27);
	var invariant = __webpack_require__(3);
	var shallowEqual = __webpack_require__(28);
	var shouldUpdateReactComponent = __webpack_require__(60);
	var warning = __webpack_require__(4);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'childContext');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDefaultInjection = __webpack_require__(293);
	var ReactMount = __webpack_require__(100);
	var ReactReconciler = __webpack_require__(22);
	var ReactUpdates = __webpack_require__(14);
	var ReactVersion = __webpack_require__(306);
	
	var findDOMNode = __webpack_require__(322);
	var getHostComponentFromComposite = __webpack_require__(105);
	var renderSubtreeIntoContainer = __webpack_require__(330);
	var warning = __webpack_require__(4);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(7);
	
	var AutoFocusUtils = __webpack_require__(268);
	var CSSPropertyOperations = __webpack_require__(270);
	var DOMLazyTree = __webpack_require__(20);
	var DOMNamespaces = __webpack_require__(47);
	var DOMProperty = __webpack_require__(21);
	var DOMPropertyOperations = __webpack_require__(93);
	var EventPluginHub = __webpack_require__(30);
	var EventPluginRegistry = __webpack_require__(48);
	var ReactBrowserEventEmitter = __webpack_require__(35);
	var ReactDOMComponentFlags = __webpack_require__(94);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDOMInput = __webpack_require__(286);
	var ReactDOMOption = __webpack_require__(287);
	var ReactDOMSelect = __webpack_require__(95);
	var ReactDOMTextarea = __webpack_require__(290);
	var ReactInstrumentation = __webpack_require__(13);
	var ReactMultiChild = __webpack_require__(299);
	var ReactServerRenderingTransaction = __webpack_require__(304);
	
	var emptyFunction = __webpack_require__(12);
	var escapeTextContentForBrowser = __webpack_require__(38);
	var invariant = __webpack_require__(3);
	var isEventSupported = __webpack_require__(59);
	var shallowEqual = __webpack_require__(28);
	var validateDOMNesting = __webpack_require__(61);
	var warning = __webpack_require__(4);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(61);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var DOMLazyTree = __webpack_require__(20);
	var ReactDOMComponentTree = __webpack_require__(8);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 284 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(46);
	var ReactDOMComponentTree = __webpack_require__(8);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(7);
	
	var DOMPropertyOperations = __webpack_require__(93);
	var LinkedValueUtils = __webpack_require__(51);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(14);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var React = __webpack_require__(23);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDOMSelect = __webpack_require__(95);
	
	var warning = __webpack_require__(4);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var getNodeForCharacterOffset = __webpack_require__(327);
	var getTextContentAccessor = __webpack_require__(106);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(7);
	
	var DOMChildrenOperations = __webpack_require__(46);
	var DOMLazyTree = __webpack_require__(20);
	var ReactDOMComponentTree = __webpack_require__(8);
	
	var escapeTextContentForBrowser = __webpack_require__(38);
	var invariant = __webpack_require__(3);
	var validateDOMNesting = __webpack_require__(61);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(7);
	
	var LinkedValueUtils = __webpack_require__(51);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(14);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactUpdates = __webpack_require__(14);
	var Transaction = __webpack_require__(37);
	
	var emptyFunction = __webpack_require__(12);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(267);
	var BeforeInputEventPlugin = __webpack_require__(269);
	var ChangeEventPlugin = __webpack_require__(271);
	var DefaultEventPluginOrder = __webpack_require__(273);
	var EnterLeaveEventPlugin = __webpack_require__(274);
	var HTMLDOMPropertyConfig = __webpack_require__(276);
	var ReactComponentBrowserEnvironment = __webpack_require__(278);
	var ReactDOMComponent = __webpack_require__(281);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDOMEmptyComponent = __webpack_require__(283);
	var ReactDOMTreeTraversal = __webpack_require__(291);
	var ReactDOMTextComponent = __webpack_require__(289);
	var ReactDefaultBatchingStrategy = __webpack_require__(292);
	var ReactEventListener = __webpack_require__(296);
	var ReactInjection = __webpack_require__(297);
	var ReactReconcileTransaction = __webpack_require__(302);
	var SVGDOMPropertyConfig = __webpack_require__(307);
	var SelectEventPlugin = __webpack_require__(308);
	var SimpleEventPlugin = __webpack_require__(309);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 294 */
112,
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(30);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var EventListener = __webpack_require__(71);
	var ExecutionEnvironment = __webpack_require__(9);
	var PooledClass = __webpack_require__(19);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(14);
	
	var getEventTarget = __webpack_require__(58);
	var getUnboundedScrollPosition = __webpack_require__(163);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(21);
	var EventPluginHub = __webpack_require__(30);
	var EventPluginUtils = __webpack_require__(49);
	var ReactComponentEnvironment = __webpack_require__(52);
	var ReactEmptyComponent = __webpack_require__(96);
	var ReactBrowserEventEmitter = __webpack_require__(35);
	var ReactHostComponent = __webpack_require__(98);
	var ReactUpdates = __webpack_require__(14);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(320);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactComponentEnvironment = __webpack_require__(52);
	var ReactInstanceMap = __webpack_require__(32);
	var ReactInstrumentation = __webpack_require__(13);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactReconciler = __webpack_require__(22);
	var ReactChildReconciler = __webpack_require__(277);
	
	var emptyFunction = __webpack_require__(12);
	var flattenChildren = __webpack_require__(323);
	var invariant = __webpack_require__(3);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 301 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var CallbackQueue = __webpack_require__(92);
	var PooledClass = __webpack_require__(19);
	var ReactBrowserEventEmitter = __webpack_require__(35);
	var ReactInputSelection = __webpack_require__(99);
	var ReactInstrumentation = __webpack_require__(13);
	var Transaction = __webpack_require__(37);
	var ReactUpdateQueue = __webpack_require__(54);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(300);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(19);
	var Transaction = __webpack_require__(37);
	var ReactInstrumentation = __webpack_require__(13);
	var ReactServerUpdateQueue = __webpack_require__(305);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(54);
	
	var warning = __webpack_require__(4);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 306 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.4.2';

/***/ },
/* 307 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(31);
	var ExecutionEnvironment = __webpack_require__(9);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactInputSelection = __webpack_require__(99);
	var SyntheticEvent = __webpack_require__(16);
	
	var getActiveElement = __webpack_require__(73);
	var isTextInputElement = __webpack_require__(108);
	var shallowEqual = __webpack_require__(28);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var EventListener = __webpack_require__(71);
	var EventPropagators = __webpack_require__(31);
	var ReactDOMComponentTree = __webpack_require__(8);
	var SyntheticAnimationEvent = __webpack_require__(310);
	var SyntheticClipboardEvent = __webpack_require__(311);
	var SyntheticEvent = __webpack_require__(16);
	var SyntheticFocusEvent = __webpack_require__(314);
	var SyntheticKeyboardEvent = __webpack_require__(316);
	var SyntheticMouseEvent = __webpack_require__(36);
	var SyntheticDragEvent = __webpack_require__(313);
	var SyntheticTouchEvent = __webpack_require__(317);
	var SyntheticTransitionEvent = __webpack_require__(318);
	var SyntheticUIEvent = __webpack_require__(33);
	var SyntheticWheelEvent = __webpack_require__(319);
	
	var emptyFunction = __webpack_require__(12);
	var getEventCharCode = __webpack_require__(56);
	var invariant = __webpack_require__(3);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(16);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(16);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(16);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(36);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(33);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(16);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(33);
	
	var getEventCharCode = __webpack_require__(56);
	var getEventKey = __webpack_require__(324);
	var getEventModifierState = __webpack_require__(57);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(33);
	
	var getEventModifierState = __webpack_require__(57);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(16);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(36);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 320 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(91);
	var warning = __webpack_require__(4);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactInstanceMap = __webpack_require__(32);
	
	var getHostComponentFromComposite = __webpack_require__(105);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(50);
	var traverseAllChildren = __webpack_require__(110);
	var warning = __webpack_require__(4);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"/IAFTours"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(111);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)))

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(56);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 325 */
115,
/* 326 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 327 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(38);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(100);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(266).enable();
	  window.Promise = __webpack_require__(265);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(332);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(7);


/***/ },
/* 332 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 333 */
50,
/* 334 */
[348, 25],
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(334);
	var ReactElement = __webpack_require__(24);
	
	var emptyFunction = __webpack_require__(12);
	var traverseAllChildren = __webpack_require__(343);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25),
	    _assign = __webpack_require__(7);
	
	var ReactComponent = __webpack_require__(62);
	var ReactElement = __webpack_require__(24);
	var ReactPropTypeLocationNames = __webpack_require__(113);
	var ReactNoopUpdateQueue = __webpack_require__(63);
	
	var emptyObject = __webpack_require__(27);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(24);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(24);
	var ReactPropTypeLocationNames = __webpack_require__(113);
	var ReactPropTypesSecret = __webpack_require__(339);
	
	var emptyFunction = __webpack_require__(12);
	var getIteratorFn = __webpack_require__(115);
	var warning = __webpack_require__(4);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	/**
	 * We use an Error-like object for backward compatibility as people may call
	 * PropTypes directly and inspect their output. However we don't use real
	 * Errors anymore. We don't inspect their stack anyway, and creating them
	 * is prohibitively expensive if they are created too often, such as what
	 * happens in oneOfType() for any type before the one that matched.
	 */
	function PropTypeError(message) {
	  this.message = message;
	  this.stack = '';
	}
	// Make `instanceof Error` still work for returned errors.
	PropTypeError.prototype = Error.prototype;
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in production with the next major version. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        if (props[propName] === null) {
	          return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	        }
	        return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 339 */
301,
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactComponent = __webpack_require__(62);
	var ReactNoopUpdateQueue = __webpack_require__(63);
	
	var emptyObject = __webpack_require__(27);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 341 */
306,
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var ReactElement = __webpack_require__(24);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(25);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var REACT_ELEMENT_TYPE = __webpack_require__(112);
	
	var getIteratorFn = __webpack_require__(115);
	var invariant = __webpack_require__(3);
	var KeyEscapeUtils = __webpack_require__(333);
	var warning = __webpack_require__(4);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  * $script.js JS loader & dependency manager
	  * https://github.com/ded/script.js
	  * (c) Dustin Diaz 2014 | License MIT
	  */
	
	(function (name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else this[name] = definition()
	})('$script', function () {
	  var doc = document
	    , head = doc.getElementsByTagName('head')[0]
	    , s = 'string'
	    , f = false
	    , push = 'push'
	    , readyState = 'readyState'
	    , onreadystatechange = 'onreadystatechange'
	    , list = {}
	    , ids = {}
	    , delay = {}
	    , scripts = {}
	    , scriptpath
	    , urlArgs
	
	  function every(ar, fn) {
	    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
	    return 1
	  }
	  function each(ar, fn) {
	    every(ar, function (el) {
	      return !fn(el)
	    })
	  }
	
	  function $script(paths, idOrDone, optDone) {
	    paths = paths[push] ? paths : [paths]
	    var idOrDoneIsDone = idOrDone && idOrDone.call
	      , done = idOrDoneIsDone ? idOrDone : optDone
	      , id = idOrDoneIsDone ? paths.join('') : idOrDone
	      , queue = paths.length
	    function loopFn(item) {
	      return item.call ? item() : list[item]
	    }
	    function callback() {
	      if (!--queue) {
	        list[id] = 1
	        done && done()
	        for (var dset in delay) {
	          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
	        }
	      }
	    }
	    setTimeout(function () {
	      each(paths, function loading(path, force) {
	        if (path === null) return callback()
	        
	        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
	          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
	        }
	        
	        if (scripts[path]) {
	          if (id) ids[id] = 1
	          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
	        }
	
	        scripts[path] = 1
	        if (id) ids[id] = 1
	        create(path, callback)
	      })
	    }, 0)
	    return $script
	  }
	
	  function create(path, fn) {
	    var el = doc.createElement('script'), loaded
	    el.onload = el.onerror = el[onreadystatechange] = function () {
	      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
	      el.onload = el[onreadystatechange] = null
	      loaded = 1
	      scripts[path] = 2
	      fn()
	    }
	    el.async = 1
	    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
	    head.insertBefore(el, head.lastChild)
	  }
	
	  $script.get = create
	
	  $script.order = function (scripts, id, done) {
	    (function callback(s) {
	      s = scripts.shift()
	      !scripts.length ? $script(s, id, done) : $script(s, callback)
	    }())
	  }
	
	  $script.path = function (p) {
	    scriptpath = p
	  }
	  $script.urlArgs = function (str) {
	    urlArgs = str;
	  }
	  $script.ready = function (deps, ready, req) {
	    deps = deps[push] ? deps : [deps]
	    var missing = [];
	    !each(deps, function (dep) {
	      list[dep] || missing[push](dep);
	    }) && every(deps, function (dep) {return list[dep]}) ?
	      ready() : !function (key) {
	      delay[key] = delay[key] || []
	      delay[key][push](ready)
	      req && req(missing)
	    }(deps.join('|'))
	    return $script
	  }
	
	  $script.done = function (idOrDone) {
	    $script([null], idOrDone)
	  }
	
	  return $script
	});


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(15)
	var upperCaseFirst = __webpack_require__(64)
	
	/**
	 * Sentence case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return upperCaseFirst(noCase(value, locale), locale)
	}


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(18)
	var lowerCase = __webpack_require__(29)
	
	/**
	 * Swap the case of a string. Manually iterate over every character and check
	 * instead of replacing certain characters for better unicode support.
	 *
	 * @param  {String} str
	 * @param  {String} [locale]
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  if (str == null) {
	    return ''
	  }
	
	  var result = ''
	
	  for (var i = 0; i < str.length; i++) {
	    var c = str[i]
	    var u = upperCase(c, locale)
	
	    result += u === c ? lowerCase(c, locale) : u
	  }
	
	  return result
	}


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(15)
	var upperCase = __webpack_require__(18)
	
	/**
	 * Title case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale).replace(/^.| ./g, function (m) {
	    return upperCase(m, locale)
	  })
	}


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.c63be10c.js